webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/object.js
var object = __webpack_require__("/CDJ");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/lodash.startcase/index.js
var lodash_startcase = __webpack_require__("peot");
var lodash_startcase_default = /*#__PURE__*/__webpack_require__.n(lodash_startcase);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/table/table.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function table_toString(v) {
  if (!v) {
    return '';
  }
  if (v instanceof Object) {
    return Object(object["e" /* keys */])(v).map(function (k) {
      return table_toString(v[k]);
    }).join(' ');
  }
  return String(v);
}

function recToString(obj) {
  if (!(obj instanceof Object)) {
    return '';
  }
  return table_toString(Object(object["e" /* keys */])(obj).reduce(function (o, k) {
    // Ignore fields that start with _
    if (!/^_/.test(k)) {
      o[k] = obj[k];
    }
    return o;
  }, {}));
}

function defaultSortCompare(a, b, sortBy) {
  if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
    return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
  }
  return table_toString(a[sortBy]).localeCompare(table_toString(b[sortBy]), undefined, {
    numeric: true
  });
}

function processField(key, value) {
  var field = null;
  if (typeof value === 'string') {
    // Label shortcut
    field = { key: key, label: value };
  } else if (typeof value === 'function') {
    // Formatter shortcut
    field = { key: key, formatter: value };
  } else if ((typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object') {
    field = Object(object["a" /* assign */])({}, value);
    field.key = field.key || key;
  } else if (value !== false) {
    // Fallback to just key
    field = { key: key };
  }
  return field;
}

/* harmony default export */ var table = ({
  mixins: [mixins["j" /* listenOnRootMixin */]],
  render: function render(h) {
    var t = this;
    var $slots = t.$slots;
    var $scoped = t.$scopedSlots;
    var fields = t.computedFields;
    var items = t.computedItems;

    // Build the caption
    var caption = h(false);
    if (t.caption || $slots['table-caption']) {
      var data = { style: t.captionStyles };
      if (!$slots['table-caption']) {
        data.domProps = { innerHTML: t.caption };
      }
      caption = h('caption', data, $slots['table-caption']);
    }

    // Build the colgroup
    var colgroup = $slots['table-colgroup'] ? h('colgroup', {}, $slots['table-colgroup']) : h(false);

    // Build the thead
    var ths = fields.map(function (field) {
      var data = {
        key: field.key,
        class: t.fieldClasses(field),
        style: field.thStyle || {},
        attrs: {
          'tabindex': field.sortable ? '0' : null,
          'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
          'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
        },
        on: {
          click: function click(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            t.headClicked(evt, field);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === utils["a" /* KeyCodes */].ENTER || keyCode === utils["a" /* KeyCodes */].SPACE) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            }
          }
        }
      };
      var slot = $scoped['HEAD_' + field.key];
      if (slot) {
        slot = slot({ label: field.label, column: field.key, field: field });
      } else {
        data.domProps = { innerHTML: field.label };
      }
      return h('th', data, slot);
    });
    var thead = h('thead', { class: t.headClasses }, [h('tr', {}, ths)]);

    // Build the tfoot
    var tfoot = h(false);
    if (t.footClone) {
      var _ths = fields.map(function (field) {
        var data = {
          key: field.key,
          class: t.fieldClasses(field),
          style: field.thStyle || {},
          attrs: {
            'tabindex': field.sortable ? '0' : null,
            'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
            'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
          },
          on: {
            click: function click(evt) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            },
            keydown: function keydown(evt) {
              var keyCode = evt.keyCode;
              if (keyCode === utils["a" /* KeyCodes */].ENTER || keyCode === utils["a" /* KeyCodes */].SPACE) {
                evt.stopPropagation();
                evt.preventDefault();
                t.headClicked(evt, field);
              }
            }
          }
        };
        var slot = $scoped['FOOT_' + field.key] ? $scoped['FOOT_' + field.key] : $scoped['HEAD_' + field.key];
        if (slot) {
          slot = [slot({ label: field.label, column: field.key, field: field })];
        } else {
          data.domProps = { innerHTML: field.label };
        }
        return h('th', data, slot);
      });
      tfoot = h('tfoot', { class: t.footClasses }, [h('tr', {}, _ths)]);
    }

    var rows = [];

    // Add static Top Row slot
    if ($scoped['top-row']) {
      rows.push(h('tr', {}, [$scoped['top-row']({ coloumns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Add the body rows
    items.forEach(function (item, index) {
      var detailsSlot = $scoped['row-details'];
      // For Each Row
      var tds = fields.map(function (field) {
        // Foe Each field in the row
        var data = {
          key: field.key,
          class: t.tdClasses(field, item),
          attrs: field.tdAttr || {}
        };
        var childNodes = void 0;
        if ($scoped[field.key]) {
          childNodes = [$scoped[field.key]({
            item: item,
            index: index,
            unformatted: item[field.key],
            value: t.getFormattedValue(item, field)
          })];
        } else {
          data.domProps = { innerHTML: t.getFormattedValue(item, field) };
        }
        return h('td', data, childNodes);
      });
      // Assemble and add the row
      rows.push(h('tr', {
        key: index,
        class: [t.rowClasses(item), item._showDetails && detailsSlot ? 'b-table-has-details' : ''],
        on: {
          click: function click(evt) {
            t.rowClicked(evt, item, index);
          },
          dblclick: function dblclick(evt) {
            t.rowDblClicked(evt, item, index);
          },
          mouseenter: function mouseenter(evt) {
            t.rowHovered(evt, item, index);
          }
        }
      }, tds));
      // Row Details slot
      if (item._showDetails && detailsSlot) {
        var details = h('td', { attrs: { colspan: String(fields.length) } }, [detailsSlot({ item: item, index: index, fields: fields })]);
        rows.push(h('tr', { key: index + '-details', class: ['b-table-details'] }, [details]));
      } else {
        rows.push(h(false));
      }
    });

    // Empty Items / Empty Filtered Row slot
    if (t.showEmpty && (!items || items.length === 0)) {
      var inner = t.filter ? $slots['emptyfiltered'] : $slots['empty'];
      if (!inner) {
        inner = h('div', {
          class: ['text-center', 'my-2'],
          domProps: { innerHTML: t.filter ? t.emptyFilteredText : t.emptyText }
        });
      }
      var content = h('div', { attrs: { role: 'alert', 'aria-live': 'polite' } }, [inner]);
      rows.push(h('tr', [h('td', { attrs: { colspan: String(fields.length) } }, [content])]));
    } else {
      rows.push(h(false));
    }

    // Static bottom row slot
    if ($scoped['bottom-row']) {
      rows.push(h('tr', {}, [$scoped['bottom-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Assemble the rows into the tbody
    var tbody = h('tbody', {}, rows);

    // Return the assembled table
    return h('table', {
      class: t.tableClasses,
      attrs: { id: t.id || null, 'aria-busy': t.computedBusy ? 'true' : 'false' }
    }, [caption, colgroup, thead, tfoot, tbody]);
  },
  data: function data() {
    return {
      localSortBy: this.sortBy || '',
      localSortDesc: this.sortDesc || false,
      localItems: [],
      // Note: filteredItems only used to determine if # of items changed
      filteredItems: [],
      localBusy: this.busy
    };
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: null
    },
    captionTop: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: [Object, Array],
      default: null
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: function _default() {
        if (this && typeof this.inverse === 'boolean') {
          // Deprecate inverse
          Object(utils["n" /* warn */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
          return this.dark;
        }
        return false;
      }
    },
    inverse: {
      // Deprecated in v1.0.0.beta.10 in favor of `dark`
      type: Boolean,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: ''
    },
    footVariant: {
      type: String,
      default: ''
    },
    perPage: {
      type: Number,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    },
    filter: {
      type: [String, RegExp, Function],
      default: null
    },
    sortCompare: {
      type: Function,
      default: null
    },
    noLocalSorting: {
      type: Boolean,
      default: false
    },
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footClone: {
      type: Boolean,
      default: false
    },
    labelSortAsc: {
      type: String,
      default: 'Click to sort Ascending'
    },
    labelSortDesc: {
      type: String,
      default: 'Click to sort Descending'
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    emptyFilteredText: {
      type: String,
      default: 'There are no records matching your request'
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      if (oldVal !== newVal) {
        this._providerUpdate();
      }
    },
    context: function context(newVal, oldVal) {
      if (!Object(utils["c" /* looseEqual */])(newVal, oldVal)) {
        this.$emit('context-changed', newVal);
      }
    },
    filteredItems: function filteredItems(newVal, oldVal) {
      if (this.localFiltering && newVal.length !== oldVal.length) {
        // Emit a filtered notification event, as number of filtered items has changed
        this.$emit('filtered', newVal);
      }
    },
    sortDesc: function sortDesc(newVal, oldVal) {
      if (newVal === this.localSortDesc) {
        return;
      }
      this.localSortDesc = newVal || false;
    },
    localSortDesc: function localSortDesc(newVal, oldVal) {
      // Emit update to sort-desc.sync
      if (newVal !== oldVal) {
        this.$emit('update:sortDesc', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (newVal === this.localSortBy) {
        return;
      }
      this.localSortBy = newVal || null;
    },
    localSortBy: function localSortBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortBy', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    perPage: function perPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    filter: function filter(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderFiltering) {
        this._providerUpdate();
      }
    },
    localBusy: function localBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:busy', newVal);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.localSortBy = this.sortBy;
    this.localSortDesc = this.sortDesc;
    this.localBusy = this.busy;
    if (this.hasProvider) {
      this._providerUpdate();
    }
    this.listenOnRoot('bv::refresh::table', function (id) {
      if (id === _this.id || id === _this) {
        _this._providerUpdate();
      }
    });
  },

  computed: {
    tableClasses: function tableClasses() {
      var responsive = this.responsive === '' ? true : this.responsive;
      return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', responsive === true ? 'table-responsive' : Boolean(responsive) ? 'table-responsive-' + responsive : '', this.fixed ? 'table-fixed' : '', this.small ? 'table-sm' : ''];
    },
    headClasses: function headClasses() {
      return this.headVariant ? 'thead-' + this.headVariant : '';
    },
    footClasses: function footClasses() {
      var variant = this.footVariant || this.headVariant || null;
      return variant ? 'thead-' + variant : '';
    },
    captionStyles: function captionStyles() {
      // Move caption to top
      return this.captionTop ? { captionSide: 'top' } : {};
    },
    hasProvider: function hasProvider() {
      return this.items instanceof Function;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? this.noProviderFiltering : true;
    },
    localSorting: function localSorting() {
      return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
    },
    localPaging: function localPaging() {
      return this.hasProvider ? this.noProviderPaging : true;
    },
    context: function context() {
      return {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter: this.filter,
        apiUrl: this.apiUrl,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc
      };
    },
    computedFields: function computedFields() {
      var _this2 = this;

      // We normalize fields into an array of objects
      // [ { key:..., label:..., ...}, {...}, ..., {..}]
      var fields = [];
      if (Object(array["d" /* isArray */])(this.fields)) {
        // Normalize array Form
        this.fields.filter(function (f) {
          return f;
        }).forEach(function (f) {
          if (typeof f === 'string') {
            fields.push({ key: f, label: lodash_startcase_default()(f) });
          } else if ((typeof f === 'undefined' ? 'undefined' : typeof_default()(f)) === 'object' && f.key && typeof f.key === 'string') {
            // Full object definition. We use assign so that we don't mutate the original
            fields.push(Object(object["a" /* assign */])({}, f));
          } else if ((typeof f === 'undefined' ? 'undefined' : typeof_default()(f)) === 'object' && Object(object["e" /* keys */])(f).length === 1) {
            // Shortcut object (i.e. { 'foo_bar': 'This is Foo Bar' }
            var key = Object(object["e" /* keys */])(f)[0];
            var field = processField(key, f[key]);
            if (field) {
              fields.push(field);
            }
          }
        });
      } else if (this.fields && typeof_default()(this.fields) === 'object' && Object(object["e" /* keys */])(this.fields).length > 0) {
        // Normalize object Form
        Object(object["e" /* keys */])(this.fields).forEach(function (key) {
          var field = processField(key, _this2.fields[key]);
          if (field) {
            fields.push(field);
          }
        });
      }
      // If no field provided, take a sample from first record (if exits)
      if (fields.length === 0 && this.computedItems.length > 0) {
        var sample = this.computedItems[0];
        Object(object["e" /* keys */])(sample).forEach(function (k) {
          fields.push({ key: k, label: lodash_startcase_default()(k) });
        });
      }
      // Ensure we have a unique array of fields and that they have labels
      var memo = {};
      return fields.filter(function (f) {
        if (!memo[f.key]) {
          memo[f.key] = true;
          f.label = f.label || lodash_startcase_default()(f.key);
          return true;
        }
        return false;
      });
    },
    computedItems: function computedItems() {
      // Grab some props/data to ensure reactivity
      var perPage = this.perPage;
      var currentPage = this.currentPage;
      var filter = this.filter;
      var sortBy = this.localSortBy;
      var sortDesc = this.localSortDesc;
      var sortCompare = this.sortCompare;
      var localFiltering = this.localFiltering;
      var localSorting = this.localSorting;
      var localPaging = this.localPaging;
      var items = this.hasProvider ? this.localItems : this.items;
      if (!items) {
        this.$nextTick(this._providerUpdate);
        return [];
      }
      // Array copy for sorting, filtering, etc.
      items = items.slice();
      // Apply local filter
      if (filter && localFiltering) {
        if (filter instanceof Function) {
          items = items.filter(filter);
        } else {
          var regex = void 0;
          if (filter instanceof RegExp) {
            regex = filter;
          } else {
            regex = new RegExp('.*' + filter + '.*', 'ig');
          }
          items = items.filter(function (item) {
            var test = regex.test(recToString(item));
            regex.lastIndex = 0;
            return test;
          });
        }
      }
      if (localFiltering) {
        // Make a local copy of filtered items to trigger filtered event
        this.filteredItems = items.slice();
      }
      // Apply local Sort
      if (sortBy && localSorting) {
        items = items.sort(function sortItemsFn(a, b) {
          var ret = null;
          if (typeof sortCompare === 'function') {
            // Call user provided sortCompare routine
            ret = sortCompare(a, b, sortBy);
          }
          if (ret === null || ret === undefined) {
            // Fallback to defaultSortCompare if sortCompare not defined or returns null
            ret = defaultSortCompare(a, b, sortBy);
          }
          // Handle sorting direction
          return (ret || 0) * (sortDesc ? -1 : 1);
        });
      }
      // Apply local pagination
      if (Boolean(perPage) && localPaging) {
        // Grab the current page of data (which may be past filtered items)
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      }
      // Update the value model with the filtered/sorted/paginated data set
      this.$emit('input', items);
      return items;
    },
    computedBusy: function computedBusy() {
      return this.busy || this.localBusy;
    }
  },
  methods: {
    keys: object["e" /* keys */],
    fieldClasses: function fieldClasses(field) {
      return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    tdClasses: function tdClasses(field, item) {
      var cellVariant = '';
      if (item._cellVariants && item._cellVariants[field.key]) {
        cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
      }
      return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', field.tdClass ? field.tdClass : ''];
    },
    rowClasses: function rowClasses(item) {
      return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : ''];
    },
    rowClicked: function rowClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-clicked', item, index, e);
    },
    rowDblClicked: function rowDblClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-dblclicked', item, index, e);
    },
    rowHovered: function rowHovered(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-hovered', item, index, e);
    },
    headClicked: function headClicked(e, field) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      var sortChanged = false;
      if (field.sortable) {
        if (field.key === this.localSortBy) {
          // Change sorting direction on current column
          this.localSortDesc = !this.localSortDesc;
        } else {
          // Start sorting this column ascending
          this.localSortBy = field.key;
          this.localSortDesc = false;
        }
        sortChanged = true;
      } else if (this.localSortBy) {
        this.localSortBy = null;
        this.localSortDesc = false;
        sortChanged = true;
      }
      this.$emit('head-clicked', field.key, field, e);
      if (sortChanged) {
        // Sorting parameters changed
        this.$emit('sort-changed', this.context);
      }
    },
    stopIfBusy: function stopIfBusy(evt) {
      if (this.computedBusy) {
        // If table is busy (via provider) then don't propagate
        evt.preventDefault();
        evt.stopPropagation();
        return true;
      }
      return false;
    },
    refresh: function refresh() {
      // Expose refresh method
      if (this.hasProvider) {
        this._providerUpdate();
      }
    },
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = items && items.length > 0 ? items.slice() : [];
      this.localBusy = false;
      this.$emit('refreshed');
      this.emitOnRoot('table::refreshed', this.id);
    },
    _providerUpdate: function _providerUpdate() {
      var _this3 = this;

      // Refresh the provider items
      if (this.computedBusy || !this.hasProvider) {
        // Don't refresh remote data if we are 'busy' or if no provider
        return;
      }
      // Set internal busy state
      this.localBusy = true;
      // Call provider function with context and optional callback
      var data = this.items(this.context, this._providerSetLocal);
      if (data) if (data.then && typeof data.then === 'function') {
        // Provider returned Promise
        data.then(function (items) {
          _this3._providerSetLocal(items);
        });
      } else {
        // Provider returned Array data
        this._providerSetLocal(data);
      }
    },
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = field.formatter;
      var parent = this.$parent;
      var value = item[key];
      if (formatter) {
        if (typeof formatter === 'function') {
          value = formatter(value, key, item);
        } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
          value = parent[formatter](value, key, item);
        }
      }
      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/table/table.vue
function injectStyle (ssrContext) {
  __webpack_require__("X4qH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  table,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var table_table = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2L7A":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIi8+DQogICAgICAgIDxwYXRoIGQ9Ik05IDV2OE01IDloOCIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "2gfX":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIi8+DQogICAgICAgIDxwYXRoIGQ9Ik05IDVMOSAxM001IDlMMTMgOSIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "2rBp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzkzOUNBQSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8Y2lyY2xlIGN4PSI2LjY2NyIgY3k9IjYuNjY3IiByPSI2LjY2NyIvPg0KICAgICAgICA8cGF0aCBkPSJNMTUgMTVsLTMuNjI1LTMuNjI1Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "3gCU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8ZyBmaWxsPSIjQjBCNUMxIj4NCiAgICAgICAgICAgIDxnPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMiAwYzYuNjI3IDAgMTIgNS4zNzMgMTIgMTJzLTUuMzczIDEyLTEyIDEyUzAgMTguNjI3IDAgMTIgNS4zNzMgMCAxMiAwem03LjMyIDYuNzkzYy0uNTg1LS41ODYtMS41MzUtLjU4Ni0yLjEyIDBsLTcuMDY1IDcuMDYzLTIuODE0LTIuODE0LS4xMTQtLjEwM2MtLjU5LS40OC0xLjQ1OC0uNDQ2LTIuMDA4LjEwMy0uNTg1LjU4NS0uNTg1IDEuNTM1IDAgMi4xMjFsNC45MzcgNC45MzYgOS4xODUtOS4xODUuMTAzLS4xMTRjLjQ4LS41ODkuNDQ2LTEuNDU4LS4xMDMtMi4wMDd6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTYyIC0zOSkgdHJhbnNsYXRlKDU2MiAzOSkiLz4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "3o1N":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, "table.b-table.table-fixed{table-layout:fixed}table.b-table[aria-busy=false]{opacity:1}table.b-table[aria-busy=true]{opacity:.6}table.b-table>tbody>tr.b-table-has-details>td{border-bottom:none}table.b-table>tbody>tr.b-table-details>td{border-top:none;padding-top:0}table.b-table>tfoot>tr>th,table.b-table>thead>tr>th{position:relative}table.b-table>tfoot>tr>th.sorting,table.b-table>thead>tr>th.sorting{padding-right:1.5em;cursor:pointer}table.b-table tfoot>tr>th.sorting:after,table.b-table tfoot>tr>th.sorting:before,table.b-table thead>tr>th.sorting:after,table.b-table thead>tr>th.sorting:before{position:absolute;bottom:0;display:block;opacity:.4;padding-bottom:inherit;font-size:inherit;line-height:180%}table.b-table>tfoot>tr>th.sorting:before,table.b-table>thead>tr>th.sorting:before{right:.75em;content:\"\\2191\"}table.b-table>tfoot>tr>th.sorting:after,table.b-table>thead>tr>th.sorting:after{right:.25em;content:\"\\2193\"}table.b-table>tfoot>tr>th.sorting_asc:after,table.b-table>tfoot>tr>th.sorting_desc:before,table.b-table>thead>tr>th.sorting_asc:after,table.b-table>thead>tr>th.sorting_desc:before{opacity:1}", ""]);

// exports


/***/ }),

/***/ "3zvM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("KMIa");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("95b6bc7a", content, true);

/***/ }),

/***/ "53Vg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cGF0aCBkPSJNMTUgMTh2LTJhNCA0IDAgMCAwLTQtNEg0YTQgNCAwIDAgMC00IDR2MiIvPg0KICAgICAgICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSI0IiByPSI0Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik0xOSA1djZNMjIgOGgtNiIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "6InJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Oogi");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("dafdbbd6", content, true);

/***/ }),

/***/ "7sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-timepicker/src/vue-timepicker.vue
var vue_timepicker = __webpack_require__("gCMD");
var vue_timepicker_default = /*#__PURE__*/__webpack_require__.n(vue_timepicker);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4648f1d1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-timepicker/src/vue-timepicker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTime),expression:"displayTime"}],staticClass:"display-time",attrs:{"id":_vm.id,"type":"text","readonly":""},domProps:{"value":(_vm.displayTime)},on:{"click":function($event){$event.stopPropagation();_vm.toggleDropdown($event)},"input":function($event){if($event.target.composing){ return; }_vm.displayTime=$event.target.value}}}),_vm._v(" "),(!_vm.hideClearButton)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDropdown && _vm.showClearBtn),expression:"!showDropdown && showClearBtn"}],staticClass:"clear-btn",on:{"click":function($event){$event.stopPropagation();_vm.clearTime($event)}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",on:{"click":function($event){$event.stopPropagation();_vm.toggleDropdown($event)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown"},[_c('div',{staticClass:"select-list"},[_c('ul',{staticClass:"hours"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourType)}}),_vm._v(" "),_vm._l((_vm.hours),function(hr){return _c('li',{class:{active: _vm.hour === hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){$event.stopPropagation();_vm.select('hour', hr)}}})})],2),_vm._v(" "),_c('ul',{staticClass:"minutes"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteType)}}),_vm._v(" "),_vm._l((_vm.minutes),function(m){return _c('li',{class:{active: _vm.minute === m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){$event.stopPropagation();_vm.select('minute', m)}}})})],2),_vm._v(" "),(_vm.secondType)?_c('ul',{staticClass:"seconds"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondType)}}),_vm._v(" "),_vm._l((_vm.seconds),function(s){return _c('li',{class:{active: _vm.second === s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){$event.stopPropagation();_vm.select('second', s)}}})})],2):_vm._e(),_vm._v(" "),(_vm.apmType)?_c('ul',{staticClass:"apms"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmType)}}),_vm._v(" "),_vm._l((_vm.apms),function(a){return _c('li',{class:{active: _vm.apm === a},domProps:{"textContent":_vm._s(a)},on:{"click":function($event){$event.stopPropagation();_vm.select('apm', a)}}})})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_vue_timepicker = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-timepicker/src/vue-timepicker.vue
function injectStyle (ssrContext) {
  __webpack_require__("dKw+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  vue_timepicker_default.a,
  src_vue_timepicker,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue2_timepicker_src_vue_timepicker = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8vQW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzMzMzMzRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMTcgMUwxIDE3TTEgMWwxNiAxNiIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "8va9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8ZyBzdHJva2U9IiNCMEI1QzEiIHN0cm9rZS13aWR0aD0iMyI+DQogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTYyIC0zOSkgdHJhbnNsYXRlKDU2MiAzOSkiPg0KICAgICAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgeD0iMS41IiB5PSIxLjUiIHJ4PSIxMC41Ii8+DQogICAgICAgICAgICA8L2c+DQogICAgICAgIDwvZz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AJtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/object.js
var object = __webpack_require__("/CDJ");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/link/link.js
var link_link = __webpack_require__("etPs");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/pagination-nav/pagination-nav.vue

//
//
//
//
//
//
//
//
//
//
//






// Props needed for router links
var routerProps = Object(link_link["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

// Props object
var pagination_nav_props = Object(object["a" /* assign */])(
// pagination-nav specific props
{
  numberOfPages: {
    type: Number,
    default: 1
  },
  baseUrl: {
    type: String,
    default: '/'
  },
  useRouter: {
    type: Boolean,
    default: false
  },
  linkGen: {
    type: Function,
    default: null
  },
  pageGen: {
    type: Function,
    default: null
  }
},
// Router specific props
routerProps);

// Our render function is brought in via the pagination mixin
/* harmony default export */ var pagination_nav = ({
  mixins: [mixins["k" /* paginationMixin */]],
  props: pagination_nav_props,
  computed: {
    // Used by render function to trigger wraping in '<nav>' element
    isNav: function isNav() {
      return true;
    }
  },
  methods: {
    onClick: function onClick(pageNum, evt) {
      this.currentPage = pageNum;
    },
    makePage: function makePage(pagenum) {
      if (this.pageGen && typeof this.pageGen === 'function') {
        return this.pageGen(pagenum);
      }
      return pagenum;
    },
    makeLink: function makeLink(pagenum) {
      if (this.linkGen && typeof this.linkGen === 'function') {
        return this.linkGen(pagenum);
      }
      var link = '' + this.baseUrl + pagenum;
      return this.useRouter ? { path: link } : link;
    },
    linkProps: function linkProps(pagenum) {
      var link = this.makeLink(pagenum);
      var props = {
        href: typeof link === 'string' ? link : void 0,
        target: this.target || null,
        rel: this.rel || null,
        disabled: this.disabled
      };
      if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : typeof_default()(link)) === 'object') {
        props = Object(object["a" /* assign */])(props, {
          to: link,
          exact: this.exact,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      }
      return props;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/pagination-nav/pagination-nav.vue
function injectStyle (ssrContext) {
  __webpack_require__("3zvM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pagination_nav,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pagination_nav_pagination_nav = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AN+Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNNSA4VjFoMTJ2N001IDE3SDNhMiAyIDAgMCAxLTItMnYtNWEyIDIgMCAwIDEgMi0yaDE2YTIgMiAwIDAgMSAyIDJ2NWEyIDIgMCAwIDEtMiAyaC0yIi8+DQogICAgICAgIDxwYXRoIGQ9Ik01IDEzaDEydjhINXoiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "Abw3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDI4IDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIuNSI+DQogICAgICAgIDxwYXRoIGQ9Ik0yNiAxMUgyTTExIDIwbC05LTkgOS05Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "B4c4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".b-form-group.form-group.is-invalid .invalid-feedback{display:block!important}.b-form-group.form-group.is-valid .invalid-feedback{display:none!important}.b-form-group.form-group.is-valid .valid-feedback{display:block!important}.b-form-group.form-group.is-invalid .valid-feedback{display:none!important}", ""]);

// exports


/***/ }),

/***/ "CO9d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".Shade_x0020_6[data-v-73730bd6]{opacity:.1}.Highligh_x0020_6[data-v-73730bd6]{fill:#fff}.Shade_x0020_7[data-v-73730bd6]{opacity:.1}.Highligh_x0020_7[data-v-73730bd6]{fill:#fff}.Shade_x0020_9[data-v-73730bd6],.Shade_x0020_10[data-v-73730bd6]{opacity:.1}.Highligh_x0020_9[data-v-73730bd6]{fill:#fff}.Shade_x0020_11[data-v-73730bd6]{opacity:.1}.Highligh_x0020_10[data-v-73730bd6]{fill:#fff}.st0[data-v-73730bd6]{fill:url(#SVGID_1_)}.st1[data-v-73730bd6]{fill:none;stroke:#99a0b5;stroke-miterlimit:10}.st2[data-v-73730bd6]{fill:url(#SVGID_2_)}.st3[data-v-73730bd6]{fill:url(#SVGID_3_)}.st4[data-v-73730bd6]{fill:url(#SVGID_4_)}.st5[data-v-73730bd6]{fill:url(#SVGID_5_)}.st6[data-v-73730bd6]{fill:url(#SVGID_6_)}.st7[data-v-73730bd6]{fill:url(#SVGID_7_)}.st8[data-v-73730bd6]{fill:url(#SVGID_8_)}.st9[data-v-73730bd6]{fill:url(#SVGID_9_)}.st10[data-v-73730bd6]{fill:#99a0b5}.st11[data-v-73730bd6]{fill:url(#SVGID_10_)}.st12[data-v-73730bd6]{fill:url(#SVGID_11_)}.st13[data-v-73730bd6]{fill:url(#SVGID_12_)}.st14[data-v-73730bd6]{fill:url(#SVGID_13_)}.st15[data-v-73730bd6]{fill:url(#SVGID_14_)}.st16[data-v-73730bd6]{fill:url(#SVGID_15_)}.st17[data-v-73730bd6]{fill:url(#SVGID_16_)}.st18[data-v-73730bd6]{fill:url(#SVGID_17_)}.st19[data-v-73730bd6]{fill:url(#SVGID_18_)}.st20[data-v-73730bd6]{fill:none;stroke:red;stroke-width:.25;stroke-miterlimit:10}.st21[data-v-73730bd6]{fill:url(#SVGID_19_)}.st22[data-v-73730bd6]{fill:url(#SVGID_20_)}.st23[data-v-73730bd6]{fill:url(#SVGID_21_)}.st24[data-v-73730bd6]{fill:url(#SVGID_22_)}.st25[data-v-73730bd6]{fill:url(#SVGID_23_)}.st26[data-v-73730bd6]{fill:url(#SVGID_24_)}.st27[data-v-73730bd6]{fill:url(#SVGID_25_)}.st28[data-v-73730bd6]{fill:url(#SVGID_26_)}.st29[data-v-73730bd6]{opacity:1e-02}.st30[data-v-73730bd6]{fill:url(#SVGID_27_)}.st31[data-v-73730bd6]{fill:url(#SVGID_28_)}.st32[data-v-73730bd6]{fill:url(#SVGID_29_)}.st33[data-v-73730bd6]{fill:url(#SVGID_30_)}.st34[data-v-73730bd6]{fill:url(#SVGID_31_)}.st35[data-v-73730bd6]{fill:url(#SVGID_32_)}.st36[data-v-73730bd6]{fill:url(#SVGID_33_)}.st37[data-v-73730bd6]{fill:url(#SVGID_34_)}.st38[data-v-73730bd6]{fill:url(#g48_1_)}.st39[data-v-73730bd6]{fill:url(#g47_1_)}.st40[data-v-73730bd6]{fill:url(#g46_1_)}.st41[data-v-73730bd6]{fill:url(#g45_1_)}.st42[data-v-73730bd6]{fill:url(#g44_1_)}.st43[data-v-73730bd6]{fill:url(#g43_1_)}.st44[data-v-73730bd6]{fill:url(#g42_1_)}.st45[data-v-73730bd6]{fill:url(#g41_1_)}.st46[data-v-73730bd6]{fill:url(#g38_1_)}.st47[data-v-73730bd6]{fill:url(#g37_1_)}.st48[data-v-73730bd6]{fill:url(#g36_1_)}.st49[data-v-73730bd6]{fill:url(#g35_1_)}.st50[data-v-73730bd6]{fill:url(#g34_1_)}.st51[data-v-73730bd6]{fill:url(#g33_1_)}.st52[data-v-73730bd6]{fill:url(#g32_1_)}.st53[data-v-73730bd6]{fill:url(#g31_1_)}.st54[data-v-73730bd6]{fill:url(#g28_1_)}.st55[data-v-73730bd6]{fill:url(#g27_1_)}.st56[data-v-73730bd6]{fill:url(#g26_1_)}.st57[data-v-73730bd6]{fill:url(#g25_1_)}.st58[data-v-73730bd6]{fill:url(#g24_1_)}.st59[data-v-73730bd6]{fill:url(#g23_1_)}.st60[data-v-73730bd6]{fill:url(#g22_1_)}.st61[data-v-73730bd6]{fill:url(#g21_1_)}.st62[data-v-73730bd6]{fill:url(#g18_1_)}.st63[data-v-73730bd6]{fill:url(#g17_1_)}.st64[data-v-73730bd6]{fill:url(#g16_1_)}.st65[data-v-73730bd6]{fill:url(#g15_1_)}.st66[data-v-73730bd6]{fill:url(#g14_1_)}.st67[data-v-73730bd6]{fill:url(#g13_1_)}.st68[data-v-73730bd6]{fill:url(#g12_1_)}.st69[data-v-73730bd6]{fill:url(#g11_1_)}.st70[data-v-73730bd6]{opacity:1e-02}.st71[data-v-73730bd6]{fill:#f4f4f4;stroke:#99a0b5;stroke-miterlimit:10}.st72[data-v-73730bd6]{opacity:.2}.st73[data-v-73730bd6]{opacity:.7;fill:#fff}.st74[data-v-73730bd6]{fill:#f4f4f4;stroke:#99a0b5;stroke-linejoin:round;stroke-miterlimit:10}.st75[data-v-73730bd6]{opacity:.15}.st76[data-v-73730bd6]{fill:#fff}.st77[data-v-73730bd6]{opacity:1e-02}.st78[data-v-73730bd6]{opacity:.5;fill:#fff}.st79[data-v-73730bd6]{opacity:.1}.st80[data-v-73730bd6]{fill:#828799}.st81[data-v-73730bd6]{fill:none;stroke:#cfd4e6;stroke-miterlimit:10}.st82[data-v-73730bd6]{opacity:.5}.st83[data-v-73730bd6]{fill-rule:evenodd;clip-rule:evenodd;fill:#cfd3d8}.st84[data-v-73730bd6]{fill-rule:evenodd;clip-rule:evenodd;fill:#02bc78}.st82[data-v-73730bd6]{opacity:0;fill:#0aa1e6}.st82[data-v-73730bd6]:hover{opacity:.3}.st82.active[data-v-73730bd6]{opacity:.5}.st83[data-v-73730bd6]:hover{fill:#02bc78;cursor:pointer}.st76.active[data-v-73730bd6]{cursor:pointer}.st83.active[data-v-73730bd6]{fill:#02bc78}", ""]);

// exports


/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-awesome/components/Icon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ var Icon = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d0258de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome/components/Icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-awesome/components/Icon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Emu3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Icon,
  components_Icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_awesome_components_Icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Emu3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Ibjv");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3c727273", content, true);

/***/ }),

/***/ "FHvo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".b-pagination .page-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.b-pagination .page-item .page-link.active:focus{-webkit-box-shadow:0 0 0 3px rgba(0,123,255,.5);box-shadow:0 0 0 3px rgba(0,123,255,.5);z-index:1}", ""]);

// exports


/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Valid supported input types
var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ var form_input = ({
    mixins: [mixins["i" /* idMixin */], mixins["d" /* formMixin */], mixins["g" /* formSizeMixin */], mixins["h" /* formStateMixin */]],
    render: function render(h) {
        var t = this;
        return h('input', {
            ref: 'input',
            class: t.inputClass,
            domProps: { value: t.localValue },
            attrs: {
                id: t.safeId(),
                name: t.name,
                type: t.localType,
                disabled: t.disabled,
                required: t.required,
                readonly: t.readonly || t.plaintext,
                placeholder: t.placeholder,
                autocomplete: t.autocomplete || null,
                'aria-required': t.required ? 'true' : null,
                'aria-invalid': t.computedAriaInvalid
            },
            on: {
                input: t.onInput,
                change: t.onChange
            }
        });
    },
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            default: null
        },
        type: {
            type: String,
            default: 'text',
            validator: function validator(type) {
                return Object(array["a" /* arrayIncludes */])(TYPES, type);
            }
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        formatter: {
            type: Function
        },
        lazyFormatter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localType: function localType() {
            // We only allow certain types
            return Object(array["a" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control',
            // Fix missing width:100% in Bootstrap V4.beta.2
            this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                // this.ariaInvalid is null or false or 'false'
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                // User wants explicit aria-invalid=true
                return 'true';
            }
            // Most likely a string value (which could be 'true')
            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        format: function format(value, e) {
            if (this.formatter) {
                var formattedValue = this.formatter(value, e);
                if (formattedValue !== value) {
                    return formattedValue;
                }
            }
            return value;
        },
        onInput: function onInput(evt) {
            var value = evt.target.value;
            if (this.lazyFormatter) {
                // Update the model with the current unformated value
                this.localValue = value;
            } else {
                this.localValue = this.format(value, evt);
            }
        },
        onChange: function onChange(evt) {
            this.localValue = this.format(evt.target.value, evt);
            this.$emit('change', this.localValue);
        },
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
function injectStyle (ssrContext) {
  __webpack_require__("Qc8t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_input_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ibjv":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".fa-icon{display:inline-block;fill:currentColor}.fa-flip-horizontal{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-webkit-transform:scaleY(-1);transform:scaleY(-1)}.fa-spin{-webkit-animation:fa-spin 1s 0s infinite linear;animation:fa-spin 1s 0s infinite linear}.fa-inverse{color:#fff}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/button/button.js
var button_button = __webpack_require__("E8q/");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/button/button-close.js
var button_close = __webpack_require__("NCKu");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/bv-event.class.js
var bv_event_class = __webpack_require__("5mWU");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Selectors for padding/margin adjustments
var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};

// ObserveDom config
var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

/* harmony default export */ var modal = ({
    mixins: [mixins["i" /* idMixin */], mixins["j" /* listenOnRootMixin */]],
    components: { bBtn: button_button["a" /* default */], bBtnClose: button_close["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Modal Header
        var header = h(false);
        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: { click: function click(evt) {
                                t.hide('header-close');
                            } }
                    }, [$slots['modal-header-close']]);
                }
                modalHeader = [h(t.titleTag, { class: ['modal-title'] }, [$slots['modal-title'] || t.title]), closeButton];
            }
            header = h('header', {
                ref: 'header',
                class: t.headerClasses,
                attrs: { id: t.safeId('__BV_modal_header_') }
            }, [modalHeader]);
        }

        // Modal Body
        var body = h('div', {
            ref: 'body',
            class: t.bodyClasses,
            attrs: { id: t.safeId('__BV_modal_body_') }
        }, [$slots.default]);

        // Modal Footer
        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: { click: function click(evt) {
                                t.hide('cancel');
                            } }

                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: { click: function click(evt) {
                            t.hide('ok');
                        } }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                class: t.footerClasses,
                attrs: { id: t.safeId('__BV_modal_footer_') }
            }, [modalFooter]);
        }

        // Assemble Modal Content
        var modalContent = h('div', {
            ref: 'content',
            class: ['modal-content'],
            attrs: {
                tabindex: '-1',
                role: 'document',
                'aria-labelledby': t.hideHeader ? null : t.safeId('__BV_modal_header_'),
                'aria-describedby': t.safeId('__BV_modal_body_')
            },
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        // Modal Dialog wrapper
        var modalDialog = h('div', { class: t.dialogClasses }, [modalContent]);

        // Modal
        var modal = h('div', {
            ref: 'modal',
            class: t.modalClasses,
            directives: [{ name: 'show', rawName: 'v-show', value: t.is_visible, expression: 'is_visible' }],
            attrs: {
                id: t.safeId(),
                role: 'dialog',
                'aria-hidden': t.is_visible ? null : 'true'
            },
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);
        // Wrap modal in transition
        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);

        // Modal Backdrop
        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', { class: t.backdropClasses, attrs: { id: t.safeId('__BV_modal_backdrop_') } });
        }

        // Assemble modal and backdrop
        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', { attrs: { id: t.safeId('__BV_modal_outer_') } }, [modal, backdrop]);
        }

        // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        titleTag: {
            type: String,
            default: 'h5'
        },
        size: {
            type: String,
            default: 'md'
        },
        centered: {
            type: Boolean,
            default: false
        },
        buttonSize: {
            type: String,
            default: ''
        },
        noFade: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false
        },
        noEnforceFocus: {
            type: Boolean,
            default: false
        },
        headerBgVariant: {
            type: String,
            default: null
        },
        headerBorderVariant: {
            type: String,
            default: null
        },
        headerTextVariant: {
            type: String,
            default: null
        },
        bodyBgVariant: {
            type: String,
            default: null
        },
        bodyTextVariant: {
            type: String,
            default: null
        },
        footerBgVariant: {
            type: String,
            default: null
        },
        footerBorderVariant: {
            type: String,
            default: null
        },
        footerTextVariant: {
            type: String,
            default: null
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        okOnly: {
            type: Boolean,
            default: false
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        cancelDisabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        returnFocus: {
            default: null
        },
        headerCloseLabel: {
            type: String,
            default: 'Close'
        },
        cancelTitle: {
            type: String,
            default: 'Cancel'
        },
        okTitle: {
            type: String,
            default: 'OK'
        },
        cancelVariant: {
            type: String,
            default: 'secondary'
        },
        okVariant: {
            type: String,
            default: 'primary'
        },
        lazy: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        dialogClasses: function dialogClasses() {
            var _ref;

            return ['modal-dialog', (_ref = {}, defineProperty_default()(_ref, 'modal-' + this.size, Boolean(this.size)), defineProperty_default()(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2;

            return ['modal-header', (_ref2 = {
                'rounded-top': Boolean(this.headerBgVariant)
            }, defineProperty_default()(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), defineProperty_default()(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), defineProperty_default()(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2)];
        },
        bodyClasses: function bodyClasses() {
            var _ref3;

            return ['modal-body', (_ref3 = {}, defineProperty_default()(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), defineProperty_default()(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3)];
        },
        footerClasses: function footerClasses() {
            var _ref4;

            return ['modal-footer', (_ref4 = {
                'rounded-bottom': Boolean(this.footerBgVariant)
            }, defineProperty_default()(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), defineProperty_default()(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), defineProperty_default()(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4)];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        // Public Methods
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new bv_event_class["a" /* default */]('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                // Don't show if canceled
                return;
            }
            if (Object(dom["j" /* hasClass */])(document.body, 'modal-open')) {
                // If another modal is already open, wait for it to close
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                // Show the modal
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new bv_event_class["a" /* default */]('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                // this could be the trigger element/component reference
                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    // Backwards compatibility
                    Object(utils["n" /* warn */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);
            // Hide if not canceled
            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }
            // stop observing for content changes
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },

        // Private method to finish showing modal
        doShow: function doShow() {
            var _this = this;

            // Plce modal in DOM if lazy
            this.is_hidden = false;
            this.$nextTick(function () {
                // We do this in nextTick to ensure the modal is in DOM first before we show it
                _this.is_visible = true;
                _this.$emit('change', true);
                // Observe changes in modal content and adjust if necessary
                _this._observer = Object(utils["f" /* observeDom */])(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },

        // Transition Handlers
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            Object(dom["a" /* addClass */])(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new bv_event_class["a" /* default */]('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            // Remove the 'show' class
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            Object(dom["s" /* removeClass */])(document.body, 'modal-open');
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new bv_event_class["a" /* default */]('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },

        // Event emitter
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },

        // UI Event Handlers
        onClickOut: function onClickOut(evt) {
            // If backdrop clicked, hide modal
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            // If ESC pressed, hide modal
            if (evt.keyCode === utils["a" /* KeyCodes */].ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            // If focus leaves modal, bring it back
            // 'focusout' Event Listener bound on content
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },

        // Resize Listener
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    Object(dom["d" /* eventOn */])(window, evtName, _this4.adjustDialog);
                } else {
                    Object(dom["c" /* eventOff */])(window, evtName, _this4.adjustDialog);
                }
            });
        },

        // Root Listener handlers
        showHandler: function showHandler(id, triggerEl) {
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            // If another modal opens, close this one
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },

        // Focus control handlers
        focusFirst: function focusFirst() {
            // Don't try and focus if we are SSR
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {
                // If activeElement is child of content, no need to change focus
            } else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }
                // Focus the modal content wrapper
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            // Prefer returnFocus prop over event specified return_focus value
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                // CSS Selector
                el = Object(dom["t" /* select */])(el);
            }
            if (el) {
                el = el.$el || el;
                if (Object(dom["m" /* isVisible */])(el)) {
                    el.focus();
                }
            }
        },

        // Utility methods
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = Object(dom["f" /* getBCR */])(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;
                // Adjust fixed content padding
                Object(dom["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });
                // Adjust sticky content margin
                Object(dom["u" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });
                // Adjust navbar-toggler margin
                Object(dom["u" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });
                // Adjust body padding
                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                Object(dom["v" /* setAttr */])(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            // Restore fixed content padding
            Object(dom["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                if (Object(dom["i" /* hasAttr */])(el, 'data-padding-right')) {
                    el.style.paddingRight = Object(dom["e" /* getAttr */])(el, 'data-padding-right') || '';
                    Object(dom["r" /* removeAttr */])(el, 'data-padding-right');
                }
            });
            // Restore sticky content and navbar-toggler margin
            Object(dom["u" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if (Object(dom["i" /* hasAttr */])(el, 'data-margin-right')) {
                    el.style.marginRight = Object(dom["e" /* getAttr */])(el, 'data-margin-right') || '';
                    Object(dom["r" /* removeAttr */])(el, 'data-margin-right');
                }
            });
            // Restore body padding
            var body = document.body;
            if (Object(dom["i" /* hasAttr */])(body, 'data-padding-right')) {
                body.style.paddingRight = Object(dom["e" /* getAttr */])(body, 'data-padding-right') || '';
                Object(dom["r" /* removeAttr */])(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        // create non-reactive property
        this._observer = null;
    },
    mounted: function mounted() {
        // Measure scrollbar
        this.getScrollbarWidth();
        // Listen for events from others to either open or close ourselves
        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);
        // Listen for bv:modal::show events, and close ourselves if the opening modal not us
        this.listenOnRoot('bv::modal::show', this.modalListener);
        // Initially show modal?
        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Ensure everything is back to normal
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);
        // Re-adjust body/navbar/fixed padding/margins (if needed)
        Object(dom["s" /* removeClass */])(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("zEzL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-file/form-file.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var form_file = ({
    mixins: [mixins["i" /* idMixin */], mixins["d" /* formMixin */], mixins["h" /* formStateMixin */], mixins["c" /* formCustomMixin */]],
    render: function render(h) {
        var t = this;

        // Form Input
        var input = h('input', {
            ref: 'input',
            class: t.inputClasses,
            attrs: {
                type: 'file',
                id: t.safeId(),
                name: t.name,
                disabled: t.disabled,
                required: t.required,
                capture: t.capture || null,
                'aria-required': t.required ? 'true' : null,
                accept: t.accept || null,
                multiple: t.multiple,
                webkitdirectory: t.directory,
                'aria-describedby': t.plain ? null : t.safeId('_BV_file_control_')
            },
            on: {
                change: t.onFileChange,
                focusin: t.focusHandler,
                focusout: t.focusHandler
            }
        });

        if (t.plain) {
            return input;
        }

        // 'Drop Here' target
        var droptarget = h(false);
        if (t.dragging) {
            droptarget = h('span', {
                class: ['drop-here'],
                attrs: { 'data-drop': t.dropLabel },
                on: {
                    dragover: t.dragover,
                    drop: t.drop,
                    dragleave: t.dragleave
                }
            });
        }

        // Overlay Labels
        var labels = h('span', {
            class: ['custom-file-control', t.dragging ? 'dragging' : null],
            attrs: {
                id: t.safeId('_BV_file_control_'),
                'data-choose': t.computedChooseLabel,
                'data-selected': t.selectedLabel
            }
        });

        // Return rendered custom file input
        return h('label', {
            class: ['custom-file', 'b-form-file', t.stateClass, 'w-100', 'd-block'],
            attrs: { id: t.safeId('_BV_file_outer_') },
            on: { dragover: t.dragover }
        }, [droptarget, input, labels]);
    },
    data: function data() {
        return {
            selectedFile: null,
            dragging: false,
            hasFocus: false
        };
    },

    props: {
        accept: {
            type: String,
            default: ''
        },
        capture: {
            // Instruct input to capture from camera
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        chooseLabel: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        directory: {
            type: Boolean,
            default: false
        },
        noTraverse: {
            type: Boolean,
            default: false
        },
        selectedFormat: {
            type: String,
            default: ':count Files'
        },
        noDrop: {
            type: Boolean,
            default: false
        },
        dropLabel: {
            type: String,
            default: 'Drop files here'
        }
    },
    computed: {
        inputClasses: function inputClasses() {
            return [{
                'form-control-file': this.plain,
                'custom-file-input': this.custom,
                'w-100': true, // BS4 beta missing this
                'focus': this.custom && this.hasFocus
            }, this.stateClass];
        },
        selectedLabel: function selectedLabel() {
            if (!this.selectedFile || this.selectedFile.length === 0) {
                return this.placeholder || 'No file chosen';
            }
            if (this.multiple) {
                if (this.selectedFile.length === 1) {
                    return this.selectedFile[0].name;
                }
                return this.selectedFormat.replace(':names', this.selectedFile.map(function (file) {
                    return file.name;
                }).join(',')).replace(':count', this.selectedFile.length);
            }
            return this.selectedFile.name;
        },
        computedChooseLabel: function computedChooseLabel() {
            return this.chooseLabel || (this.multiple ? 'Choose Files' : 'Choose File');
        }
    },
    watch: {
        selectedFile: function selectedFile(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (!newVal && this.multiple) {
                this.$emit('input', []);
            } else {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focusHandler: function focusHandler(evt) {
            // Boostrap v4.beta doesn't have focus styling for custom file input
            // Firefox has a borked '[type=file]:focus ~ sibling' selector issue,
            // So we add a 'focus' class to get around these "bugs"
            if (this.plain || evt.type === 'focusout') {
                this.hasFocus = false;
            } else {
                // Add focus styling for custom file input
                this.hasFocus = true;
            }
        },
        reset: function reset() {
            try {
                // Wrapped in try in case IE < 11 craps out
                this.$refs.input.value = '';
            } catch (e) {}
            // IE < 11 doesn't support setting input.value to '' or null
            // So we use this little extra hack to reset the value, just in case
            // This also appears to work on modern browsers as well.
            this.$refs.input.type = '';
            this.$refs.input.type = 'file';
            this.selectedFile = this.multiple ? [] : null;
        },
        onFileChange: function onFileChange(evt) {
            var _this = this;

            // Always emit original event
            this.$emit('change', evt);
            // Check if special `items` prop is available on event (drop mode)
            // Can be disabled by setting no-traverse
            var items = evt.dataTransfer && evt.dataTransfer.items;
            if (items && !this.noTraverse) {
                var queue = [];
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].webkitGetAsEntry();
                    if (item) {
                        queue.push(this.traverseFileTree(item));
                    }
                }
                promise_default.a.all(queue).then(function (filesArr) {
                    _this.setFiles(Object(array["c" /* from */])(filesArr));
                });
                return;
            }
            // Normal handling
            this.setFiles(evt.target.files || evt.dataTransfer.files);
        },
        setFiles: function setFiles(files) {
            if (!files) {
                this.selectedFile = null;
                return;
            }
            if (!this.multiple) {
                this.selectedFile = files[0];
                return;
            }
            // Convert files to array
            var filesArray = [];
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(this.accept)) {
                    filesArray.push(files[i]);
                }
            }
            this.selectedFile = filesArray;
        },
        dragover: function dragover(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop || !this.custom) {
                return;
            }
            this.dragging = true;
            evt.dataTransfer.dropEffect = 'copy';
        },
        dragleave: function dragleave(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragging = false;
        },
        drop: function drop(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop) {
                return;
            }
            this.dragging = false;
            if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                this.onFileChange(evt);
            }
        },
        traverseFileTree: function traverseFileTree(item, path) {
            var _this2 = this;

            // Based on http://stackoverflow.com/questions/3590058
            return new promise_default.a(function (resolve) {
                path = path || '';
                if (item.isFile) {
                    // Get file
                    item.file(function (file) {
                        file.$path = path; // Inject $path to file obj
                        resolve(file);
                    });
                } else if (item.isDirectory) {
                    // Get folder contents
                    item.createReader().readEntries(function (entries) {
                        var queue = [];
                        for (var i = 0; i < entries.length; i++) {
                            queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
                        }
                        promise_default.a.all(queue).then(function (filesArr) {
                            resolve(Object(array["c" /* from */])(filesArr));
                        });
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
function injectStyle (ssrContext) {
  __webpack_require__("6InJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_file,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_file_form_file = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KMIa":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".b-pagination .page-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.b-pagination .page-item .page-link.active:focus{-webkit-box-shadow:0 0 0 3px rgba(0,123,255,.5);box-shadow:0 0 0 3px rgba(0,123,255,.5);z-index:1}", ""]);

// exports


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Header = ({
    name: 'Header',
    data: function data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        };
    },

    methods: {
        toggleMenu: function toggleMenu() {
            this.$store.commit('toggleMenu');
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['messageCount', 'taskCount', 'notificationCount', 'globals']), {
        to: function to() {
            var me = this;
            if (me.globals.acl.Patients.insertAction == 0 && me.globals.acl.DentalSolutions.instantiate == 1) {
                return '/dentalsolutions';
            } else {
                return '/patients';
            }
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9698d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-6 col-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"logo col-md-5 col-4"},[_c('router-link',{staticClass:"d-none d-sm-none d-md-none d-lg-block",attrs:{"to":_vm.to}},[_c('img',{attrs:{"src":__webpack_require__("NNP2"),"alt":""}})]),_vm._v(" "),_c('router-link',{staticClass:"d-sm-block d-md-none",attrs:{"to":"/patients"}},[_c('img',{attrs:{"src":__webpack_require__("rlmj"),"alt":""}})])],1),_vm._v(" "),_c('div',{staticClass:"icons col-md-7 col-8"},[(_vm.globals.auth != 9 && _vm.globals.auth != 10)?_c('router-link',{attrs:{"to":"/profile/tasks"}},[_c('img',{attrs:{"src":__webpack_require__("UyeT"),"alt":""}}),(_vm.taskCount > 0)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.taskCount))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":"/profile/chat"}},[_c('img',{attrs:{"src":__webpack_require__("vI8d"),"alt":""}}),(_vm.messageCount > 0)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.messageCount))]):_vm._e()]),_vm._v(" "),_c('router-link',{attrs:{"to":"/profile/notifications"}},[_c('img',{attrs:{"src":__webpack_require__("afNG"),"alt":""}}),(_vm.notificationCount > 0)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.notificationCount))]):_vm._e()])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-3 profile"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"d-none d-sm-none d-md-block profilename col-8"},[_c('router-link',{attrs:{"to":"/profile/user"}},[_vm._v(_vm._s(_vm.globals.username))]),_vm._v(" "),_c('router-link',{attrs:{"to":"/profile/user"}},[_vm._v(_vm._s(_vm.globals.companyName))])],1),_vm._v(" "),_c('div',{staticClass:"menuicon col-2"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_c('img',{attrs:{"src":__webpack_require__("XRQe"),"alt":""}})])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Header = (esExports);
// CONCATENATED MODULE: ./src/components/Header.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Header,
  components_Header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Menu.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Menu = ({
  name: 'Header',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals', 'menuActive'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['logout', 'fetchLanguage']), {
    toggleMenu: function toggleMenu() {
      var me = this;
      me.$store.commit('toggleMenu');
    },
    active: function active(route) {
      if (this.$route.name == route) return 'active';
      return '';
    },
    setLanguage: function setLanguage() {
      var me = this;
      var selectedLang = me.globals.langCode;
      me.fetchLanguage(selectedLang);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1658756","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
var Menu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menuActive)?_c('aside',[_c('div',{staticClass:"opacity"}),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.toggleMenu),expression:"toggleMenu"}],staticClass:"menu"},[_c('a',{staticClass:"pull-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_c('img',{attrs:{"src":__webpack_require__("8vQW"),"alt":""}})]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[(_vm.globals.acl.Patients.insertAction == 1)?_c('li',[_c('router-link',{class:_vm.active('Patients'),attrs:{"to":"/patients"},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_vm._v(_vm._s(_vm.$t('PACIENTS')))])],1):_vm._e(),_vm._v(" "),(_vm.globals.acl.Patients.insertAction == 1)?_c('li',[_c('router-link',{class:_vm.active('Tasks'),attrs:{"to":"/profile/tasks"},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_vm._v(_vm._s(_vm.$t('PROFILE')))])],1):_vm._e(),_vm._v(" "),(_vm.globals.acl.Patients.insertAction == 0 && _vm.globals.acl.DentalSolutions.instantiate == 1)?_c('li',[_c('router-link',{class:_vm.active('Tasks'),attrs:{"to":"/profile/chat"},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_vm._v(_vm._s(_vm.$t('PROFILE')))])],1):_vm._e(),_vm._v(" "),(_vm.globals.acl.User.insertAction == 1)?_c('li',{staticClass:"d-none d-md-block"},[_c('router-link',{class:_vm.active('Employees'),attrs:{"to":"/employees"},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_vm._v(_vm._s(_vm.$t('WORKERS')))])],1):_vm._e(),_vm._v(" "),(_vm.globals.acl.Protetics.insertAction == 1)?_c('li',{staticClass:"d-none d-md-block"},[_c('router-link',{class:_vm.active('Protetics'),attrs:{"to":"/protetics"},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_vm._v(_vm._s(_vm.$t('PRODUCTS')))])],1):_vm._e(),_vm._v(" "),(_vm.globals.acl.User_companies.updateAction == 1)?_c('li',{staticClass:"d-none d-md-block"},[_c('router-link',{class:_vm.active('ControlPanel'),attrs:{"to":"/controlpanel/basic"},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_vm._v(_vm._s(_vm.$t('CONTROLPANEL')))])],1):_vm._e(),_vm._v(" "),(_vm.globals.acl.Reports.instantiate == 1)?_c('li',{staticClass:"d-none d-md-block"},[_c('router-link',{class:_vm.active('Reports'),attrs:{"to":"/reports"},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMenu($event)}}},[_vm._v(_vm._s(_vm.$t('REPORTS')))])],1):_vm._e(),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_vm._v(_vm._s(_vm.$t('LOGOUT'))+" "),_c('img',{attrs:{"src":__webpack_require__("cCjy"),"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('LANGUAGE')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.globals.langCode),expression:"globals.langCode"}],staticClass:"form-control secondary",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.globals, "langCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.setLanguage]}},_vm._l((_vm.globals.languages),function(lang){return _c('option',{key:lang.langCode,domProps:{"value":lang.langCode}},[_vm._v(_vm._s(_vm.$t(lang.langName)))])}))])])]):_vm._e()}
var Menu_staticRenderFns = []
var Menu_esExports = { render: Menu_render, staticRenderFns: Menu_staticRenderFns }
/* harmony default export */ var components_Menu = (Menu_esExports);
// CONCATENATED MODULE: ./src/components/Menu.vue
var Menu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Menu___vue_template_functional__ = false
/* styles */
var Menu___vue_styles__ = null
/* scopeId */
var Menu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Menu___vue_module_identifier__ = null
var Menu_Component = Menu_normalizeComponent(
  Menu,
  components_Menu,
  Menu___vue_template_functional__,
  Menu___vue_styles__,
  Menu___vue_scopeId__,
  Menu___vue_module_identifier__
)

/* harmony default export */ var src_components_Menu = (Menu_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/lib/AxApi.js




var AxApi_client = function client() {
    var defaultOptions = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };

    return {
        get: function get(url) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return axios_default.a.get(url, extends_default()({}, defaultOptions, options));
        },
        post: function post(url, params) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var data = new FormData();
            for (var key in params) {
                if (params[key] == null) continue;
                var type = typeof_default()(params[key]);
                if (type.toLowerCase() == 'object' && typeof params[key].length != 'undefined') {
                    for (var i = 0; i < params[key].length; i++) {
                        data.append(key + '[]', params[key][i]); //, params[key][i].name);
                    }
                } else if (type.toLowerCase() == 'object') {
                    data.append(key, params[key], params[key].name);
                } else {
                    data.append(key, params[key]);
                }
            }
            return axios_default.a.post(url, data, extends_default()({}, defaultOptions, options));
        },
        put: function put(url, data) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return axios_default.a.put(url, data, extends_default()({}, defaultOptions, options));
        },
        delete: function _delete(url) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return axios_default.a.delete(url, extends_default()({}, defaultOptions, options));
        }
    };
};

/* harmony default export */ var AxApi = (AxApi_client());
// CONCATENATED MODULE: ./src/api/workordertalks.js


/* harmony default export */ var workordertalks = ({
    selectMyChats: function selectMyChats(params, cb) {
        AxApi.get('/rest/WorkOrderTalks/selectMyChats', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    selectChat: function selectChat(params, cb) {
        AxApi.get('/rest/WorkOrderTalks/selectChat', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    selectAllWorkOrderChats: function selectAllWorkOrderChats(params, cb) {
        AxApi.get('/rest/WorkOrderTalks/selectAllWorkOrderChats', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    insertTalk: function insertTalk(params, cb) {
        AxApi.post('/rest/WorkOrderTalks/insertRow', params).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    selectChatByDentalSolutionId: function selectChatByDentalSolutionId(params, cb) {
        AxApi.get('/rest/WorkOrderTalks/selectChatByDentalSolutionId', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    selectAllDentalSolutionChats: function selectAllDentalSolutionChats(params, cb) {
        AxApi.get('/rest/WorkOrderTalks/selectAllDentalSolutionChats', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Chat.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");

/* harmony default export */ var Chat = ({
  name: "Chat",
  data: function data() {
    return {
      chatMessage: "",
      messages: {
        root: [],
        totalCount: 0,
        basicData: {}
      },
      interval: false
    };
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["chatData", "globals"]), {
    reverseMessages: function reverseMessages() {
      return this.messages.root.slice().reverse();
    }
  }),
  watch: {
    chatData: function chatData() {
      var me = this;
      me.getChat();
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(["selectMyMessageCount"]), {
    formatDate: function formatDate(dateTime) {
      return moment(dateTime).format("DD.MM.YYYY HH:mm");
    },
    sendMessage: function sendMessage() {
      var me = this;

      var params = {
        toUserId: me.chatData.chatUserId,
        text: me.chatMessage
      };

      if (me.chatData.workOrderId) {
        params.workOrderId = me.chatData.workOrderId;
      }

      if (me.chatData.dentalSolutionId) {
        params.dentalSolutionId = me.chatData.dentalSolutionId;
      }

      workordertalks.insertTalk(params, function (data) {
        if (data.error && data.error == true) {
          me.$notify.error(data.notice);
          return;
        }
        me.getChat();
        me.chatMessage = "";
      });
    },
    getChat: function getChat() {
      var me = this;
      if (me.interval !== false) {
        clearInterval(me.interval);
      }

      if (me.chatData == false) return;

      me.interval = setInterval(function () {
        workordertalks.selectChat(me.chatData, function (data) {
          if (data.error && data.error == true) {
            me.$notify.error(data.notice);
            return;
          }
          me.messages = data;
          me.scrollToBottom();
          me.selectMyMessageCount();
        });
      }, 1000);
    },

    hideChatMenu: function hideChatMenu() {
      this.messages.root = [];
      this.messages.totalCount = 0;
      this.$store.commit("hideChatMenu");
    },
    scrollToBottom: function scrollToBottom() {
      var me = this;
      setTimeout(function () {
        var messageDisplay = me.$refs.messageDisplay;
        messageDisplay.scrollTop = messageDisplay.scrollHeight;
      }, 10);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d41104de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
var Chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chatData != false)?_c('aside',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideChatMenu),expression:"hideChatMenu"}]},[_c('div',{staticClass:"chat d-flex align-items-start flex-column"},[_c('div',{staticClass:"chat-header p-2"},[_c('span',[_vm._v(_vm._s(_vm.$t("TALK")))]),_vm._v(" "),_c('a',{staticClass:"pull-right",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.hideChatMenu($event)}}},[_c('img',{attrs:{"src":__webpack_require__("8vQW"),"alt":""}})])]),_vm._v(" "),_c('div',{ref:"messageDisplay",staticClass:"chat-container d-flex align-content-end mb-auto"},[_c('div',{staticClass:"inner"},_vm._l((_vm.reverseMessages),function(message){return _c('div',{staticClass:"row chat-single-message"},[_c('div',{staticClass:"col-md-6 users"},[_c('span',{class:_vm.globals.userId == message.userId ? 'green' : ''},[_vm._v(_vm._s(message.name)+" "+_vm._s(message.surname)+"\n              "),(_vm.globals.userId == message.userId)?_c('span',[_vm._v("("+_vm._s(_vm.$t("ME"))+")")]):_vm._e()]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zsfH"),"alt":""}}),_vm._v("\n            "+_vm._s(message.toName)+" "+_vm._s(message.toSurname)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 time"},[_vm._v(_vm._s(_vm.formatDate(message.dateTime)))]),_vm._v(" "),_c('div',{staticClass:"col-12 message"},[_vm._v(_vm._s(message.text))])])}))]),_vm._v(" "),_c('div',{staticClass:"chat-input"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.chatMessage),expression:"chatMessage"},{name:"focus",rawName:"v-focus"}],staticClass:"form-control secondary",domProps:{"value":(_vm.chatMessage)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.sendMessage($event)},"input":function($event){if($event.target.composing){ return; }_vm.chatMessage=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-12"},[_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.sendMessage}},[_vm._v(_vm._s(_vm.$t("SEND")))])])])])])]):_vm._e()}
var Chat_staticRenderFns = []
var Chat_esExports = { render: Chat_render, staticRenderFns: Chat_staticRenderFns }
/* harmony default export */ var components_Chat = (Chat_esExports);
// CONCATENATED MODULE: ./src/components/Chat.vue
var Chat_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Chat___vue_template_functional__ = false
/* styles */
var Chat___vue_styles__ = null
/* scopeId */
var Chat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chat___vue_module_identifier__ = null
var Chat_Component = Chat_normalizeComponent(
  Chat,
  components_Chat,
  Chat___vue_template_functional__,
  Chat___vue_styles__,
  Chat___vue_scopeId__,
  Chat___vue_module_identifier__
)

/* harmony default export */ var src_components_Chat = (Chat_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/api/globals.js


var _getGlobals$getGlobal;



/* harmony default export */ var globals = (_getGlobals$getGlobal = {
  getGlobals: function getGlobals(cb) {
    AxApi.get('/rest/Session/returnJsVars').then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
}, defineProperty_default()(_getGlobals$getGlobal, 'getGlobals', function getGlobals(cb) {
  AxApi.get('/rest/Session/returnJsVars').then(function (response) {
    cb(response.data);
  }).catch(function (e) {
    //TODO
  });
}), defineProperty_default()(_getGlobals$getGlobal, 'selectMyMessageCount', function selectMyMessageCount(cb) {
  AxApi.get('/rest/WorkOrderTalks/selectMyMessageCount').then(function (response) {
    cb(response.data);
  }).catch(function (e) {
    //TODO
  });
}), defineProperty_default()(_getGlobals$getGlobal, 'selectMyTasksCount', function selectMyTasksCount(cb) {
  AxApi.get('/rest/WorkOrderTasks/selectMyTasksCount').then(function (response) {
    cb(response.data);
  }).catch(function (e) {
    //TODO
  });
}), defineProperty_default()(_getGlobals$getGlobal, 'selectMyNotificationsCount', function selectMyNotificationsCount(cb) {
  AxApi.get('/rest/Notifications/selectMyNotificationsCount').then(function (response) {
    cb(response.data);
  }).catch(function (e) {
    //TODO
  });
}), defineProperty_default()(_getGlobals$getGlobal, 'login', function login(data, cb) {
  AxApi.post('/rest/Session/logginUser', data).then(function (response) {
    cb(response.data);
  }).catch(function (e) {
    //TODO
  });
}), defineProperty_default()(_getGlobals$getGlobal, 'logout', function logout(cb) {
  AxApi.post('/rest/Session/logOut', {}).then(function (response) {
    cb(response.data);
  }).catch(function (e) {
    //TODO
  });
}), defineProperty_default()(_getGlobals$getGlobal, 'fetchLanguage', function fetchLanguage(langCode, cb) {
  AxApi.get('/' + langCode + '/rest/Translator/getTranslationByLangCode', {
    params: {
      langCode: langCode
    }
  }).then(function (response) {
    cb(response.data);
  }).catch(function (e) {
    //TODO
  });
}), defineProperty_default()(_getGlobals$getGlobal, 'checkTrans', function checkTrans(key) {
  AxApi.post('/rest/Translator/checkTrans', { key: key });
}), _getGlobals$getGlobal);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var App = ({
    name: 'app',
    data: function data() {
        return {
            alertshown: false,
            positivefunc: function positivefunc() {},
            modaltext: '',
            negativefunc: function negativefunc() {}
        };
    },
    components: {
        'app-header': src_components_Header,
        'app-menu': src_components_Menu,
        'app-chat': src_components_Chat
    },
    methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['getGlobals', 'fetchLanguage', 'selectMyMessageCount', 'selectMyTasksCount', 'selectMyNotificationsCount']), {
        positiveModalFunc: function positiveModalFunc() {
            var me = this;
            me.positivefunc();
            me.alertshown = false;
            me.positivefunc = function () {};
        },
        negativeModalFunc: function negativeModalFunc() {
            var me = this;
            me.negativefunc();
            me.alertshown = false;
            me.negativefunc = function () {};
        }
    }),
    created: function created() {
        var me = this;
        me.getGlobals();
        me.selectMyMessageCount();
        me.selectMyTasksCount();
        me.selectMyNotificationsCount();

        setInterval(function () {
            me.selectMyMessageCount();
            me.selectMyTasksCount();
            me.selectMyNotificationsCount();
        }, 5000);
    },
    watch: {
        'globals.auth': function globalsAuth(value) {
            var me = this;
            me.fetchLanguage(me.globals.langCode);
            if ((value == 0 || value == 2) && this.$route.path.indexOf('/login') == -1) {
                this.$router.push('/login');
            } else if (this.$route.path.indexOf('/login') !== -1 && (value == 9 || value == 10)) {
                this.$router.push('/dentalsolutions');
            } else if (this.$route.path.indexOf('/login') !== -1) {
                this.$router.push('/patients');
            } else if (this.$route.path == '/') {
                if (value == 9 || value == 10) {
                    this.$router.push('/dentalsolutions');
                } else {
                    this.$router.push('/patients');
                }
            }
        },
        translation: function translation(value) {
            var me = this;
            me.$i18n.setLocaleMessage(me.globals.langCode, value);
            me.$i18n.locale = me.globals.langCode;
        },
        langInitialized: function langInitialized(value) {
            if (value) {
                this.$i18n.missing = function (handler, key, vueInst) {
                    // globals.checkTrans(key)
                };
            }
        },
        modalAlert: function modalAlert(val) {
            var me = this;
            me.alertshown = true;
            me.modaltext = val.text;
            me.positivefunc = val.btnAction;
            if (typeof val.btnNo != 'undefined') {
                me.negativefunc = val.btnNo;
            }
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals', 'modalAlert', 'translation', 'langInitialized']), {
        loggedIn: function loggedIn() {
            return this.globals.auth != 2 ? true : false;
        },
        initialized: function initialized() {
            return this.globals.auth != 0 ? true : false;
        },
        isLogin: function isLogin() {
            return this.$route.path.indexOf('/login') != -1;
        },
        isPrint: function isPrint() {
            return this.$route.path.indexOf('/printworkorder') != -1 || this.$route.path.indexOf('/printdsdailyreport') != -1 || this.$route.path.indexOf('/printdsmonthlyreport') != -1 || this.$route.path.indexOf('/printdsclientreport') != -1;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7751a962","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialized)?_c('div',{class:_vm.isPrint ? 'container' : (_vm.isLogin ? 'login container-fluid' : 'container-fluid')},[_c('div',{attrs:{"id":"app"}},[(_vm.loggedIn && !_vm.isPrint)?_c('app-header'):_vm._e(),_vm._v(" "),(_vm.loggedIn)?_c('app-menu'):_vm._e(),_vm._v(" "),(_vm.loggedIn)?_c('app-chat'):_vm._e(),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('b-modal',{ref:"modalalert",staticClass:"alertbox",attrs:{"centered":"","id":"modalalert","hide-footer":true,"hide-header":true},model:{value:(_vm.alertshown),callback:function ($$v) {_vm.alertshown=$$v},expression:"alertshown"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 center"},[_c('p',[_vm._v(_vm._s(_vm.modaltext))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 text-right"},[_c('a',{staticClass:"btn btn-third",on:{"click":function($event){$event.preventDefault();_vm.negativeModalFunc($event)}}},[_vm._v(_vm._s(_vm.$t('NO')))])]),_vm._v(" "),_c('div',{staticClass:"col-6 text-left"},[_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.positiveModalFunc($event)}}},[_vm._v(_vm._s(_vm.$t('YES')))])])])])],1):(!_vm.initialized)?_c('div',{staticClass:"loading-page"},[_c('icon',{attrs:{"name":"spinner","scale":"2","spin":""}})],1):_vm._e()}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/api/companydata.js


/* harmony default export */ var companydata = ({
  selectRow: function selectRow(params, cb) {
    AxApi.get('/rest/User_companies/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getCompanyData: function getCompanyData(params, cb) {
    AxApi.get('/rest/User_companies/getCompanyData', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveCompanyData: function saveCompanyData(params, cb) {
    AxApi.post('/rest/User_companies/updateRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ControlPanel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ControlPanel = ({
  name: 'ControlPanel',
  data: function data() {
    return {
      formData: {
        companyName: '',
        shortCompanyName: '',
        oib: '',
        address: '',
        postalNum: '',
        city: '',
        country: '',
        email: '',
        phone: '',
        mobilePhone: '',
        webPage: ''
      },
      formError: {}
    };
  },
  created: function created() {
    var me = this;
    me.getCompanyData();
  },
  methods: {
    getCompanyData: function getCompanyData() {
      var me = this;
      companydata.getCompanyData({}, function (data) {
        me.formData = data.root;
      });
    },
    saveCompanyData: function saveCompanyData() {
      var me = this;
      companydata.saveCompanyData(me.formData, function (val) {
        if (val.error) {
          me.formError = val;
        } else me.formError = {};
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799c126a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ControlPanel.vue
var ControlPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 title"},[_c('h1',{staticClass:"mrgn"},[_vm._v(_vm._s(_vm.$t('CONTROLPANEL')))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"active"},[_c('router-link',{attrs:{"to":"/controlpanel/basic"}},[_vm._v(_vm._s(_vm.$t('BASICDATA')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/controlpanel/connection"}},[_vm._v(_vm._s(_vm.$t('CONNECTINGTOOTHERCOMPANIES')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveCompanyData($event)}}},[_c('img',{attrs:{"src":__webpack_require__("T1Gp"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('SAVECHANGES')))])])])]),_vm._v(" "),_c('form',{staticClass:"onpage-form",attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row borderbottom"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.companyName) ? 'has-danger' :'',attrs:{"disabled":""}},[_c('label',[_vm._v(_vm._s(_vm.$t('COMPANYNAME')))]),_vm._v(" "),_c('div',{staticClass:"form-control secondary"},[_vm._v(_vm._s(_vm.formData.companyName))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.shortCompanyName) ? 'has-danger' :'',attrs:{"disabled":""}},[_c('label',[_vm._v(_vm._s(_vm.$t('SHORTCOMPANYNAME')))]),_vm._v(" "),_c('div',{staticClass:"form-control secondary"},[_vm._v(_vm._s(_vm.formData.shortCompanyName))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.oib) ? 'has-danger' :'',attrs:{"disabled":""}},[_c('label',[_vm._v(_vm._s(_vm.$t('OIB')))]),_vm._v(" "),_c('div',{staticClass:"form-control secondary"},[_vm._v(_vm._s(_vm.formData.oib))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.email) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('EMAIL')))]),_vm._v(" "),_c('div',{staticClass:"form-control secondary"},[_vm._v(_vm._s(_vm.formData.email))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.$t('LOCATION')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.address) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('ADDRESS')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.address),expression:"formData.address"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('ADDRESS')},domProps:{"value":(_vm.formData.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "address", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.address)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.address))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.postalNum) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('POSTALNUM')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.postalNum),expression:"formData.postalNum"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('POSTALNUM')},domProps:{"value":(_vm.formData.postalNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "postalNum", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.postalNum)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.postalNum))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.city) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('CITY')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.city),expression:"formData.city"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('CITY')},domProps:{"value":(_vm.formData.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "city", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.city)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.city))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.country) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('COUNTRY')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.country),expression:"formData.country"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('COUNTRY')},domProps:{"value":(_vm.formData.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "country", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.country)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.country))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.$t('CONTACT')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.phone) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('PHONE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('PHONE')},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.phone)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.phone))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.mobilePhone) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('MOBILEPHONE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.mobilePhone),expression:"formData.mobilePhone"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('MOBILEPHONE')},domProps:{"value":(_vm.formData.mobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "mobilePhone", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.mobilePhone)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.mobilePhone))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.webPage) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('WEBPAGE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.webPage),expression:"formData.webPage"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('WEBPAGE')},domProps:{"value":(_vm.formData.webPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "webPage", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.webPage)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.webPage))]):_vm._e()])])])])])}
var ControlPanel_staticRenderFns = []
var ControlPanel_esExports = { render: ControlPanel_render, staticRenderFns: ControlPanel_staticRenderFns }
/* harmony default export */ var components_ControlPanel = (ControlPanel_esExports);
// CONCATENATED MODULE: ./src/components/ControlPanel.vue
var ControlPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ControlPanel___vue_template_functional__ = false
/* styles */
var ControlPanel___vue_styles__ = null
/* scopeId */
var ControlPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ControlPanel___vue_module_identifier__ = null
var ControlPanel_Component = ControlPanel_normalizeComponent(
  ControlPanel,
  components_ControlPanel,
  ControlPanel___vue_template_functional__,
  ControlPanel___vue_styles__,
  ControlPanel___vue_scopeId__,
  ControlPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ControlPanel = (ControlPanel_Component.exports);

// CONCATENATED MODULE: ./src/api/partners.js


/* harmony default export */ var partners = ({
  getPartners: function getPartners(params, cb) {
    AxApi.get('/rest/Partners/getPartners', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  addPartner: function addPartner(params, cb) {
    AxApi.post('/rest/Partners/addPartner', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  deletePartnership: function deletePartnership(params, cb) {
    AxApi.post('/rest/Partners/deletePartnership', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  acceptPartner: function acceptPartner(params, cb) {
    AxApi.post('/rest/Partners/acceptPartner', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  declinePartner: function declinePartner(params, cb) {
    AxApi.post('/rest/Partners/declinePartner', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConnectionPanel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ConnectionPanel = ({
  name: 'ControlPanel',
  data: function data() {
    return {
      companyId: '',
      companies: {
        root: [],
        totalCount: 0
      },
      connectedPartners: {
        root: [],
        totalCount: 0
      },
      waitingpartners: {
        root: [],
        totalCount: 0
      },
      pendingPartners: {
        root: [],
        totalCount: 0
      }
    };
  },
  created: function created() {
    var me = this;
    me.getPartners();
  },
  methods: {
    getPartners: function getPartners() {
      var me = this;
      me.getWaitingPartners();
      me.getPendingPartners();
      me.getConnectedPartners();
    },
    setCompanyId: function setCompanyId(val) {
      var me = this;
      me.companyId = val;
    },

    getConnectedPartners: function getConnectedPartners() {
      var me = this;
      partners.getPartners({ connected: 1 }, function (data) {
        me.connectedPartners = data;
      });
    },
    getWaitingPartners: function getWaitingPartners() {
      var me = this;
      partners.getPartners({ connected: 0 }, function (data) {
        me.waitingpartners = data;
      });
    },
    getPendingPartners: function getPendingPartners() {
      var me = this;
      partners.getPartners({ pending: 1 }, function (data) {
        me.pendingPartners = data;
      });
    },
    getCompanies: function getCompanies(params) {
      var me = this;
      companydata.selectRow(params, function (data) {
        if (data.error) {
          me.$notify.error(data.notice);
        } else {
          me.companies = data;
        }
      });
    },
    addPartner: function addPartner() {
      var me = this;
      partners.addPartner({ companyId: me.companyId }, function (val) {
        if (val.error) {
          me.$notify.error(val.notice);
        }
        me.$notify.info(val.notice);
        me.getPartners();
      });
    },
    deletePartnership: function deletePartnership(companyId) {
      var me = this;
      partners.deletePartnership({ companyId: companyId }, function (val) {
        if (val.error) {
          me.$notify.error(val.notice);
        }
        me.getPartners();
      });
    },
    declinePartner: function declinePartner(companyId) {
      var me = this;
      partners.declinePartner({ companyId: companyId }, function (val) {
        if (val.error) {
          me.$notify.error(val.notice);
        }
        me.getPartners();
      });
    },
    acceptPartner: function acceptPartner(companyId) {
      var me = this;
      partners.acceptPartner({ companyId: companyId }, function (val) {
        if (val.error) {
          me.$notify.error(val.notice);
        }
        me.getPartners();
      });
    }
  },
  computed: {
    getCompaniesOptions: function getCompaniesOptions() {
      var me = this,
          options = [];

      for (var i = 0; i < me.companies.root.length; i++) {
        var company = me.companies.root[i];
        options.push({ value: company.companyId, text: company.companyName });
      }

      return options;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e9d86f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConnectionPanel.vue
var ConnectionPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 title"},[_c('h1',{staticClass:"mrgn"},[_vm._v(_vm._s(_vm.$t('CONTROLPANEL')))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('router-link',{attrs:{"to":"/controlpanel/basic"}},[_vm._v(_vm._s(_vm.$t('BASICDATA')))])],1),_vm._v(" "),_c('li',{staticClass:"active"},[_c('router-link',{attrs:{"to":"/controlpanel/connection"}},[_vm._v(_vm._s(_vm.$t('CONNECTINGTOOTHERCOMPANIES')))])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"grid-white-search"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col"},[_c('autocomplete',{attrs:{"setvalue":_vm.setCompanyId,"value":_vm.companyId,"placeholder":_vm.$t('COMPANY'),"values":_vm.getCompaniesOptions,"initdata":_vm.getCompanies}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4 col text-right"},[_c('a',{staticClass:"btn btn-green",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.addPartner($event)}}},[_c('img',{attrs:{"src":__webpack_require__("z4tm"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDPARTNER')))])])])]),_vm._v(" "),_c('div',{staticClass:"lower-page"},[(_vm.waitingpartners.totalCount > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t('WAITINGCONNECTIONS')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},_vm._l((_vm.waitingpartners.root),function(company){return _c('div',{staticClass:"row lower-item"},[_c('div',{staticClass:"col-md-8 company"},[_vm._v("\n              "+_vm._s(company.companyName)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-right"},[_c('a',{staticClass:"btn btn-red",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.declinePartner(company.companyId)}}},[_vm._v(_vm._s(_vm.$t('DECLINE')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-green",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.acceptPartner(company.companyId)}}},[_vm._v(_vm._s(_vm.$t('ACCEPT')))])])])}))]):_vm._e(),_vm._v(" "),(_vm.pendingPartners.totalCount > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t('PENDINGCONNECTIONS')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},_vm._l((_vm.pendingPartners.root),function(company){return _c('div',{staticClass:"row lower-item"},[_c('div',{staticClass:"col-12 company"},[_vm._v("\n              "+_vm._s(company.companyName)+"\n            ")])])}))]):_vm._e(),_vm._v(" "),(_vm.connectedPartners.totalCount > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v(_vm._s(_vm.$t('CONNECTEDPARTNERS')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},_vm._l((_vm.connectedPartners.root),function(company){return _c('div',{staticClass:"row lower-item"},[_c('div',{staticClass:"col-md-8 company"},[_vm._v("\n              "+_vm._s(company.companyName)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-right"},[_c('a',{staticClass:"btn btn-red",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deletePartnership(company.companyId)}}},[_vm._v(_vm._s(_vm.$t('DISCONNECT')))])])])}))]):_vm._e()])])}
var ConnectionPanel_staticRenderFns = []
var ConnectionPanel_esExports = { render: ConnectionPanel_render, staticRenderFns: ConnectionPanel_staticRenderFns }
/* harmony default export */ var components_ConnectionPanel = (ConnectionPanel_esExports);
// CONCATENATED MODULE: ./src/components/ConnectionPanel.vue
var ConnectionPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ConnectionPanel___vue_template_functional__ = false
/* styles */
var ConnectionPanel___vue_styles__ = null
/* scopeId */
var ConnectionPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ConnectionPanel___vue_module_identifier__ = null
var ConnectionPanel_Component = ConnectionPanel_normalizeComponent(
  ConnectionPanel,
  components_ConnectionPanel,
  ConnectionPanel___vue_template_functional__,
  ConnectionPanel___vue_styles__,
  ConnectionPanel___vue_scopeId__,
  ConnectionPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ConnectionPanel = (ConnectionPanel_Component.exports);

// CONCATENATED MODULE: ./src/api/users.js


/* harmony default export */ var users = ({
  getUsersByCompanyId: function getUsersByCompanyId(params, cb) {
    params.onlyActive = 1;
    AxApi.get('/rest/User_data/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  resetPassword: function resetPassword(params, cb) {
    AxApi.post('/rest/User/resetPassword', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  confirmPassword: function confirmPassword(params, cb) {
    AxApi.post('/rest/User/confirmPassword', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Login = ({
  name: 'Login',
  data: function data() {
    return {
      username: '',
      password: '',
      confirmpassword: '',
      rememberMe: '',
      forgot: 0,
      email: '',
      formError: {},
      loading: false
    };
  },
  created: function created() {
    var me = this;

    if (typeof me.$route.params.verifyCode != 'undefined') {
      me.forgot = 2;
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    actLogin: 'login',
    fetchLanguage: 'fetchLanguage'
  }), {
    setLanguage: function setLanguage() {
      var me = this;
      var selectedLang = me.globals.langCode;
      me.fetchLanguage(selectedLang);
    },

    login: function login() {
      this.actLogin({ username: this.username, password: this.password });
    },
    resetPassword: function resetPassword() {
      var me = this;

      me.loading = true;
      users.resetPassword({ email: me.email }, function (val) {
        me.loading = false;
        me.formError = val;
        if (!val.error) {
          me.email = '';
        }
      });
    },
    confirmPassword: function confirmPassword() {
      var me = this;

      me.loading = true;
      users.confirmPassword({ password: me.password, confirmpassword: me.confirmpassword, verifyCode: me.$route.params.verifyCode }, function (val) {
        me.loading = false;
        me.formError = val;
        if (!val.error) {
          me.email = '';
        }
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['loginResponse', 'globals']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ccdda4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"loginbox"},[_c('div',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),(_vm.forgot == 0)?_c('div',{staticClass:"col-md-6 secondcol"},[_c('div',[_c('div',{staticClass:"formcontent"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',[_vm._v(_vm._s(_vm.$t('LANGUAGE')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.globals.langCode),expression:"globals.langCode"}],staticClass:"form-control secondary",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.globals, "langCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.setLanguage]}},_vm._l((_vm.globals.languages),function(lang){return _c('option',{key:lang.langCode,domProps:{"value":lang.langCode}},[_vm._v(_vm._s(_vm.$t(lang.langName)))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',[_vm._v(_vm._s(_vm.$t('USERNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('USERNAME')},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',[_vm._v(_vm._s(_vm.$t('PASSWORD')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control secondary",attrs:{"type":"password","placeholder":_vm.$t('PASSWORD')},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('b-form-checkbox',{staticClass:"grey",model:{value:(_vm.rememberMe),callback:function ($$v) {_vm.rememberMe=$$v},expression:"rememberMe"}},[_vm._v(" "+_vm._s(_vm.$t('REMEBERME')))])],1)]),_vm._v(" "),(_vm.loginResponse.error && _vm.loginResponse.notice)?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.loginResponse.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.login($event)}}},[_vm._v(_vm._s(_vm.$t('LOGIN')))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"forgotpassword"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.forgot = 1}}},[_vm._v(_vm._s(_vm.$t('FORGOTPASSWORD')))])])])]):_vm._e(),_vm._v(" "),(_vm.forgot == 1)?_c('div',{staticClass:"col-md-6 secondcol"},[_c('div',[_c('div',{staticClass:"formcontent"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"col-12"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.forgot = 0}}},[_c('img',{attrs:{"src":__webpack_require__("Pt3z")}})])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('FORGOTPASSWORDDISCLAIMER')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',[_vm._v(_vm._s(_vm.$t('EMAIL')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('EMAIL')},domProps:{"value":(_vm.email)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.resetPassword($event)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),(_vm.formError.error && _vm.formError.notice)?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),(!_vm.formError.error && _vm.formError.notice)?_c('p',{staticClass:"bg-info"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.resetPassword($event)}}},[(_vm.loading)?_c('icon',{attrs:{"name":"refresh","scale":"2","spin":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('RESET')))],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]):_vm._e(),_vm._v(" "),(_vm.forgot == 2)?_c('div',{staticClass:"col-md-6 secondcol"},[_c('div',[_c('div',{staticClass:"formcontent"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"col-12"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.forgot = 0}}},[_c('img',{attrs:{"src":__webpack_require__("Pt3z")}})])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',[_vm._v(_vm._s(_vm.$t('ENTERANDCONFIRMPASSWORD')))])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',[_vm._v(_vm._s(_vm.$t('PASSWORD')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control secondary",attrs:{"type":"password","placeholder":_vm.$t('PASSWORD')},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',[_vm._v(_vm._s(_vm.$t('CONFIRMPASSWORD')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmpassword),expression:"confirmpassword"}],staticClass:"form-control secondary",attrs:{"type":"password","placeholder":_vm.$t('CONFIRMPASSWORD')},domProps:{"value":(_vm.confirmpassword)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.confirmPassword($event)},"input":function($event){if($event.target.composing){ return; }_vm.confirmpassword=$event.target.value}}})])]),_vm._v(" "),(_vm.formError.error && _vm.formError.notice)?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),(!_vm.formError.error && _vm.formError.notice)?_c('p',{staticClass:"bg-info"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.confirmPassword($event)}}},[(_vm.loading)?_c('icon',{attrs:{"name":"refresh","scale":"2","spin":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('RESET')))],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])]):_vm._e()])])])}
var Login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 firstcol"},[_c('div',[_c('div',{staticClass:"first"},[_c('img',{attrs:{"src":__webpack_require__("V0G1"),"alt":""}})])])])}]
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = null
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./src/api/patientsgallery.js


/* harmony default export */ var api_patientsgallery = ({
  getPatientsGallery: function getPatientsGallery(params, cb) {
    AxApi.get('/rest/PatientsGallery/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  savePatientsGallery: function savePatientsGallery(params, cb) {
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/PatientsGallery/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/PatientsGallery/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deletePatientsGallery: function deletePatientsGallery(params, cb) {
    AxApi.post('/rest/PatientsGallery/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  rotateImage: function rotateImage(params, cb) {
    AxApi.post('/rest/PatientsGallery/rotateImage', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PatientsGallery.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var PatientsGallery = ({
  name: 'PatientsGallery',
  props: { patientId: false },
  data: function data() {
    return {
      selectedimage: {},
      previousImage: null,
      saveLoading: false,
      patientdata: { name: '', surname: '' },
      formData: {
        id: '',
        patientId: '',
        description: '',
        imgSrc: ''
      },
      formError: {},
      pagination: {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    saveImageInit: 'savePatientsGallery',
    getPatientInit: 'getPatient',
    getPatientsGalleryInit: 'getPatientsGallery'
  }), {
    getRand: function getRand() {
      return '?rand=' + Math.random();
    },

    getPatient: function getPatient() {
      var me = this;
      this.getPatientInit({ id: me.patientId });
    },
    saveImage: function saveImage(bvEvt) {
      var me = this;
      bvEvt.preventDefault();
      me.saveLoading = true;
      me.saveImageInit(me.formData);
    },
    getPatientsGallery: function getPatientsGallery() {
      var me = this;
      me.getPatientsGalleryInit(me.getParams);
    },
    deleteImage: function deleteImage() {
      var me = this;
      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          api_patientsgallery.deletePatientsGallery({ id: me.selectedimage.patientGalleryId }, function (data) {
            if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
            me.$refs.patientgallery.show();
            me.getPatientsGallery();
          });
        }
      });
    },
    rotate: function rotate(direction) {
      var me = this;
      me.previousImage = me.selectedimage.patientGalleryId;
      api_patientsgallery.rotateImage({ id: me.selectedimage.patientGalleryId, direction: direction }, function (data) {
        if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
        me.$refs.patientgallery.show();
        me.getPatientsGallery();
      });
    }
  }),
  watch: {
    patientsgallery: function (_patientsgallery) {
      function patientsgallery(_x) {
        return _patientsgallery.apply(this, arguments);
      }

      patientsgallery.toString = function () {
        return _patientsgallery.toString();
      };

      return patientsgallery;
    }(function (val) {
      var me = this;

      if (typeof val.root[0] == 'undefined') me.selectedimage = {};else {
        if (me.previousImage) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = get_iterator_default()(patientsgallery.root), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var image = _step.value;

              if (image.id == me.previousImage) {
                me.selectedimage = image;
                break;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          me.selectedimage = val.root[0];
        }
      }
    }),
    patientId: function patientId(val) {
      var me = this;

      if (val != false) {
        me.formData.patientId = val;
        me.getPatient();
        me.getPatientsGallery();
      }
    },
    patient: function patient(val) {
      var me = this;
      me.patientdata = val.root;
      me.$refs.patientgallery.show();
    },
    savePatientsGalleryResponse: function savePatientsGalleryResponse(val) {
      var me = this;

      me.formError = {};

      me.saveLoading = false;

      if (val.error == true) {
        if (typeof_default()(val.notice) == 'object') {
          me.formError = val.notice;
          val.notice = '';
        }
      } else {
        this.$refs.newimage.hide();
        me.getPatientsGallery();
        me.$refs.patientgallery.show();
      }
    },
    'pagination.query': function paginationQuery() {
      var me = this;
      me.getPatientsGallery();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['modalAlert', 'patientsgallery', 'patient', 'savePatientsGalleryResponse']), {
    getParams: function getParams() {
      var me = this;
      var data = assign_default()({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      data.patientId = me.patientId;
      return data;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb3be2c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PatientsGallery.vue
var PatientsGallery_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"patientgallery",staticClass:"picturemodal modal-xl",attrs:{"centered":"","size":"lg","id":"patientgallery","hide-footer":true,"title":_vm.patientdata.name+' '+_vm.patientdata.surname+' '+_vm.$t('GALLERY')}},[_c('div',{staticClass:"d-flex align-items-end flex-column"},[_c('div',{staticClass:"links"},[((_vm.selectedimage.imgSrc))?_c('a',{staticClass:"d-none d-md-inline-block",on:{"click":_vm.deleteImage}},[_vm._v(_vm._s(_vm.$t('DELETE'))+" "),_c('img',{attrs:{"src":__webpack_require__("qmq2"),"alt":""}})]):_vm._e(),_vm._v(" "),((_vm.selectedimage.imgSrc))?_c('a',{staticClass:"d-none d-md-inline-block",attrs:{"href":_vm.selectedimage.imgSrc.replace('_90.', '_1024.'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('DOWNLOAD'))+" "),_c('img',{attrs:{"src":__webpack_require__("eNdh"),"alt":""}})]):_vm._e(),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('newimage'),expression:"'newimage'"}]},[_vm._v(_vm._s(_vm.$t('ADDNEWPHOTO'))+" "),_c('img',{attrs:{"src":__webpack_require__("phsg"),"alt":""}})])])]),_vm._v(" "),(_vm.patientsgallery.root.length == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._v(_vm._s(_vm.$t('NOPATIENTPICTURES')))])]):_vm._e(),_vm._v(" "),(_vm.patientsgallery.root.length > 0)?_c('div',{staticClass:"picturecontent"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"picturedesc"},[_c('span',{staticClass:"pictureby"},[_vm._v(_vm._s(_vm.$t('PICTUREBY')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedimage.name)+" "+_vm._s(_vm.selectedimage.surname))])]),_vm._v(" "),_c('div',{staticClass:"picturedesc"},[_c('span',{staticClass:"pictureby"},[_vm._v(_vm._s(_vm.$t('DATETIME')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedimage.updateDateTime))])]),_vm._v(" "),_c('div',{staticClass:"picturedesc"},[_c('span',{staticClass:"pictureby"},[_vm._v(_vm._s(_vm.$t('DESCRIPTION')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedimage.description))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"arrows"},[_c('img',{attrs:{"src":__webpack_require__("wa5x")},on:{"click":function($event){_vm.rotate('left')}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("b6QW")},on:{"click":function($event){_vm.rotate('right')}}})]),_vm._v(" "),_c('img',{staticClass:"img-fluid",staticStyle:{"max-height":"800px"},attrs:{"src":(_vm.selectedimage.imgSrc) ? _vm.selectedimage.imgSrc.replace('_90.', '_1024.')+_vm.getRand() : ''}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 pictures"},[_c('div',{staticClass:"subimages"},_vm._l((_vm.patientsgallery.root),function(image){return _c('div',{on:{"click":function($event){_vm.selectedimage = image}}},[_c('img',{staticClass:"img-responsive",class:(_vm.selectedimage.imgSrc == image.imgSrc) ? 'selected' : '',attrs:{"src":image.imgSrc+_vm.getRand()}})])}))])])]):_vm._e()]),_vm._v(" "),_c('b-modal',{ref:"newimage",attrs:{"centered":"","size":"lg","id":"newimage","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWIMAGE')},on:{"ok":_vm.saveImage}},[(_vm.saveLoading)?_c('div',{staticStyle:{"width":"100%","height":"100px","text-align":"center"}},[_c('icon',{attrs:{"name":"spinner","scale":"3","spin":""}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('LOADING')))])],1):_vm._e(),_vm._v(" "),(!_vm.saveLoading)?_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group",class:(_vm.formError.description) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('DESCRIPTION')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.description),expression:"formData.description"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('DESCRIPTION')},domProps:{"value":(_vm.formData.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "description", $event.target.value)}}}),_vm._v(" "),(_vm.formError.description)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.description))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group",class:(_vm.formError.imgSrc) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('FILE')))]),_vm._v(" "),_c('b-form-file',{attrs:{"multiple":true,"choose-label":_vm.$t('JPGORPNG')},model:{value:(_vm.formData.imgSrc),callback:function ($$v) {_vm.$set(_vm.formData, "imgSrc", $$v)},expression:"formData.imgSrc"}}),_vm._v(" "),(_vm.formError.imgSrc)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.imgSrc))]):_vm._e()],1)])]),_vm._v(" "),(_vm.savePatientsGalleryResponse.error && _vm.savePatientsGalleryResponse.notice)?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.savePatientsGalleryResponse.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)}
var PatientsGallery_staticRenderFns = []
var PatientsGallery_esExports = { render: PatientsGallery_render, staticRenderFns: PatientsGallery_staticRenderFns }
/* harmony default export */ var components_PatientsGallery = (PatientsGallery_esExports);
// CONCATENATED MODULE: ./src/components/PatientsGallery.vue
var PatientsGallery_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PatientsGallery___vue_template_functional__ = false
/* styles */
var PatientsGallery___vue_styles__ = null
/* scopeId */
var PatientsGallery___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PatientsGallery___vue_module_identifier__ = null
var PatientsGallery_Component = PatientsGallery_normalizeComponent(
  PatientsGallery,
  components_PatientsGallery,
  PatientsGallery___vue_template_functional__,
  PatientsGallery___vue_styles__,
  PatientsGallery___vue_scopeId__,
  PatientsGallery___vue_module_identifier__
)

/* harmony default export */ var src_components_PatientsGallery = (PatientsGallery_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Patients.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Patients = ({
  name: 'Patients',
  components: {
    'patientsgallery': src_components_PatientsGallery
  },
  data: function data() {
    return {
      galleryPatientId: false,
      formData: {
        id: '',
        name: '',
        surname: '',
        birthDate: '',
        ordinationId: '',
        technicalLabId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: 'technicallab'
      },
      formError: {},
      pagination: {
        showAll: false,
        query: '',
        currentPage: 1,
        limit: 20,
        type: 'patient'
      }
    };
  },
  created: function created() {
    this.$store.commit('hideMenu');
    this.getPatients();
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    savePatientInit: 'savePatient',
    getPatientsInit: 'getPatients',
    deletePatientInit: 'deletePatient',
    getOrdinations: 'getOrdinations',
    getTehnicalLabs: 'getTehnicalLabs'
  }), {
    getOrdinationsInit: function getOrdinationsInit() {
      var me = this;
      me.getOrdinations({ onlyConnected: 'true' });
    },
    getTehnicalLabsInit: function getTehnicalLabsInit() {
      var me = this;
      me.getTehnicalLabs({ onlyConnected: 'true' });
    },
    showPatientGallery: function showPatientGallery(patientId) {
      var me = this;
      me.galleryPatientId = false;
      vue_esm["default"].nextTick(function () {
        me.galleryPatientId = patientId;
      });
    },
    toWorkOrder: function toWorkOrder(patientId) {
      var me = this;
      me.$router.push('/patients/' + patientId);
    },
    savePatient: function savePatient(bvEvt) {
      var me = this;
      bvEvt.preventDefault();
      me.savePatientInit(me.formData);
    },
    getPatients: function getPatients() {
      var me = this;
      this.getPatientsInit(me.getParams);
    },
    deletePatient: function deletePatient(id) {
      var me = this;
      me.$store.commit('setModalAlert', { text: me.$i18n.t('AREYOUSHURE'), btnAction: function btnAction() {
          me.deletePatientInit({ id: id });
        } });
    },
    newPatient: function newPatient(data) {
      var me = this;
      me.formData = {
        id: '',
        name: '',
        surname: '',
        birthDate: '',
        ordinationId: '',
        technicalLabId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: 'technicallab'
      };
      me.$refs.newpatient.show();
    },
    editPatient: function editPatient(data) {
      var me = this;
      data = assign_default()({}, data, {});
      data.id = data.patientId;
      if (data.dummyPartner != '') data.partnerType = 'dummy';else data.partnerType = 'real';

      if (data.ordinationId != me.globals.companyId) data.companyType = 'ordination';else data.companyType = 'technicallab';

      me.formData = data;
      me.$refs.newpatient.show();
    },
    setOrdinationId: function setOrdinationId(data) {
      var me = this;
      me.formData.ordinationId = data;
    },
    setTechnicalLabId: function setTechnicalLabId(data) {
      var me = this;
      me.formData.technicalLabId = data;
    }
  }),
  watch: {
    savePatientResponse: function savePatientResponse(val) {
      var me = this;

      me.formError = {};

      if (val.error == true) {
        if (typeof_default()(val.notice) == 'object') {
          me.formError = val.notice;
          val.notice = '';
        }
      } else {
        this.$refs.newpatient.hide();
        me.$router.push('/patients/' + val.lastId);
        //me.getPatients();
        for (var key in me.formData) {
          me.formData[key] = '';
        }
      }
    },
    deletePatientResponse: function deletePatientResponse(val) {
      var me = this;
      me.getPatients();
    },
    'pagination.query': function paginationQuery() {
      var me = this;
      me.getPatients();
    },
    'pagination.type': function paginationType() {
      var me = this;
      me.getPatients();
    },
    'pagination.showAll': function paginationShowAll() {
      var me = this;
      me.getPatients();
    },
    'pagination.currentPage': function paginationCurrentPage(newValue, oldValue) {
      var me = this;
      me.getPatients();
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals', 'modalAlert', 'patients', 'ordinations', 'tehnicallabs', 'savePatientResponse', 'deletePatientResponse']), {
    selecttype: function selecttype() {
      var me = this;
      //'admin','ordination','technicallab','ordinationandlab'
      if (me.globals.companyType == 'ordination') {
        return 'technicallab';
      }

      if (me.globals.companyType == 'technicallab') {
        return 'ordination';
      }

      if (me.formData.companyType == 'ordination') {
        return 'ordination';
      }

      if (me.formData.companyType == 'technicallab') {
        return 'technicallab';
      }
    },
    getParams: function getParams() {
      var me = this;
      var data = assign_default()({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    },
    getOrdinationsOptions: function getOrdinationsOptions() {
      var me = this,
          options = [];

      for (var i = 0; i < me.ordinations.root.length; i++) {
        var ordination = me.ordinations.root[i];
        options.push({ value: ordination.companyId, text: ordination.companyName });
      }

      return options;
    },
    getTechnicalLabOptions: function getTechnicalLabOptions() {
      var me = this,
          options = [];

      for (var i = 0; i < me.tehnicallabs.root.length; i++) {
        var tehnicallab = me.tehnicallabs.root[i];
        options.push({ value: tehnicallab.companyId, text: tehnicallab.companyName });
      }

      return options;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a91e27","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patients.vue
var Patients_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-4 title"},[_c('h1',[_vm._v(_vm._s(_vm.$t('PATIENTS')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 search-form d-none d-md-block"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pagination.type),expression:"pagination.type"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pagination, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"patient"}},[_vm._v(_vm._s(_vm.$t('PATIENT')))]),_vm._v(" "),_c('option',{attrs:{"value":"company"}},[_vm._v(_vm._s(_vm.$t('COMPANY')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pagination.query),expression:"pagination.query"}],staticClass:"form-control",attrs:{"type":"text","placeholder":(_vm.pagination.type == 'patient') ? _vm.$t('PATIENTNAME') : _vm.$t('COMPANYNAME')},domProps:{"value":(_vm.pagination.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pagination, "query", $event.target.value)}}}),_vm._v(" "),(_vm.pagination.query == '')?_c('div',{staticClass:"input-group-addon"},[_c('img',{attrs:{"src":__webpack_require__("2rBp"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.pagination.query != '')?_c('div',{staticClass:"input-group-addon",on:{"click":function($event){_vm.pagination.query = ''}}},[_c('img',{staticClass:"emptysearch",attrs:{"src":__webpack_require__("8vQW"),"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"text-left"},[_c('b-form-checkbox',{staticClass:"grey",model:{value:(_vm.pagination.showAll),callback:function ($$v) {_vm.$set(_vm.pagination, "showAll", $$v)},expression:"pagination.showAll"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('SHOWALL')))])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action d-none d-md-block"},[_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.newPatient}},[_c('img',{attrs:{"src":__webpack_require__("53Vg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDPATIENT')))])])])]),_vm._v(" "),(!_vm.patients.root || _vm.patients.root.length == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 center nothing"},[_c('img',{attrs:{"src":__webpack_require__("UD2X"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('CURRENTLYNOPATIENS')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary d-none d-md-block",on:{"click":_vm.newPatient}},[_c('img',{attrs:{"src":__webpack_require__("53Vg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDPATIENT')))])])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('ORDINATION')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('TECHNICLAB')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('LASTOPENFORM')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('STATUS')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('ACTIONS')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.patients.root),function(patient){return _c('tr',[_c('td',{on:{"click":function($event){_vm.toWorkOrder(patient.patientId)}}},[_c('b',[_vm._v(_vm._s(patient.name)+" "+_vm._s(patient.surname))])]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showPatientGallery(patient.patientId)}}},[_c('img',{attrs:{"src":__webpack_require__("phsg"),"alt":""}})])]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toWorkOrder(patient.patientId)}}},[_vm._v(_vm._s(patient.ordination != null ? patient.ordination : patient.dummyPartner))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toWorkOrder(patient.patientId)}}},[_vm._v(_vm._s(patient.technicLab != null ? patient.technicLab : patient.dummyPartner))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toWorkOrder(patient.patientId)}}},[_vm._v(_vm._s(patient.openDateTime != null ? _vm.formatDate(patient.openDateTime) : _vm.$t('CURRENTLYNOWORKORDERS')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell status",class:patient.workStatus,on:{"click":function($event){_vm.toWorkOrder(patient.patientId)}}},[_vm._v(_vm._s(patient.statusOut))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deletePatient(patient.patientId)}}},[_c('img',{attrs:{"src":__webpack_require__("qmq2"),"alt":""}})]),_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.editPatient(patient)}}},[_c('img',{attrs:{"src":__webpack_require__("vCtq"),"alt":""}})])])])}))])])]),_vm._v(" "),(_vm.patients.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.patients.totalCount,"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"newpatient",attrs:{"centered":"","size":"lg","id":"newpatient","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWPATIENT')},on:{"ok":_vm.savePatient}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.name) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('NAME')},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}}),_vm._v(" "),(_vm.formError.name)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.surname) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('SURNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.surname),expression:"formData.surname"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('SURNAME')},domProps:{"value":(_vm.formData.surname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "surname", $event.target.value)}}}),_vm._v(" "),(_vm.formError.surname)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.surname))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.birthDate) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('BIRTHDATE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.birthDate),expression:"formData.birthDate"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('BIRTHDATE')},domProps:{"value":(_vm.formData.birthDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "birthDate", $event.target.value)}}}),_vm._v(" "),(_vm.formError.birthDate)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.birthDate))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"real"},model:{value:(_vm.formData.partnerType),callback:function ($$v) {_vm.$set(_vm.formData, "partnerType", $$v)},expression:"formData.partnerType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('REALPARTNER')))])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"dummy"},model:{value:(_vm.formData.partnerType),callback:function ($$v) {_vm.$set(_vm.formData, "partnerType", $$v)},expression:"formData.partnerType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('DUMMYPARTNER')))])])],1)])]),_vm._v(" "),(_vm.globals.companyType != 'ordination' && _vm.globals.companyType != 'technicallab')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"ordination"},model:{value:(_vm.formData.companyType),callback:function ($$v) {_vm.$set(_vm.formData, "companyType", $$v)},expression:"formData.companyType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('ORDINATION')))])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"technicallab"},model:{value:(_vm.formData.companyType),callback:function ($$v) {_vm.$set(_vm.formData, "companyType", $$v)},expression:"formData.companyType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('TECHNICALLAB')))])])],1)])]):_vm._e(),_vm._v(" "),(_vm.formData.partnerType == 'dummy')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",class:(_vm.formError.dummyPartner) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('PARTNERNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.dummyPartner),expression:"formData.dummyPartner"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('PARTNERNAME')},domProps:{"value":(_vm.formData.dummyPartner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "dummyPartner", $event.target.value)}}}),_vm._v(" "),(_vm.formError.dummyPartner)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.dummyPartner))]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.formData.partnerType == 'real')?_c('div',[_c('div',{staticClass:"row"},[(_vm.selecttype == 'ordination')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",class:(_vm.formError.ordinationId) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('ORDINATION')))]),_vm._v(" "),_c('autocomplete',{attrs:{"setvalue":_vm.setOrdinationId,"value":_vm.formData.ordinationId,"placeholder":_vm.$t('ORDINATION'),"values":_vm.getOrdinationsOptions,"initdata":_vm.getOrdinationsInit}}),_vm._v(" "),(_vm.formError.ordinationId)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.ordinationId))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.selecttype == 'technicallab')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",class:(_vm.formError.technicalLabId) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('TECHNICALLAB')))]),_vm._v(" "),_c('autocomplete',{attrs:{"setvalue":_vm.setTechnicalLabId,"value":_vm.formData.technicalLabId,"placeholder":_vm.$t('TECHNICALLAB'),"values":_vm.getTechnicalLabOptions,"initdata":_vm.getTehnicalLabsInit}}),_vm._v(" "),(_vm.formError.technicalLabId)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.technicalLabId))]):_vm._e()],1)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.savePatientResponse.error && _vm.savePatientResponse.notice)?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.savePatientResponse.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('patientsgallery',{attrs:{"patientId":_vm.galleryPatientId}})],1)}
var Patients_staticRenderFns = []
var Patients_esExports = { render: Patients_render, staticRenderFns: Patients_staticRenderFns }
/* harmony default export */ var components_Patients = (Patients_esExports);
// CONCATENATED MODULE: ./src/components/Patients.vue
var Patients_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Patients___vue_template_functional__ = false
/* styles */
var Patients___vue_styles__ = null
/* scopeId */
var Patients___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Patients___vue_module_identifier__ = null
var Patients_Component = Patients_normalizeComponent(
  Patients,
  components_Patients,
  Patients___vue_template_functional__,
  Patients___vue_styles__,
  Patients___vue_scopeId__,
  Patients___vue_module_identifier__
)

/* harmony default export */ var src_components_Patients = (Patients_Component.exports);

// CONCATENATED MODULE: ./src/api/ordinations.js


/* harmony default export */ var ordinations = ({
  getOrdinations: function getOrdinations(params, cb) {
    params.type = 'ordination';
    AxApi.get('/rest/User_companies/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveOrdination: function saveOrdination(params, cb) {
    params.type = 'ordination';
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/User_companies/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/User_companies/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deleteOrdination: function deleteOrdination(params, cb) {
    AxApi.post('/rest/User_companies/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Ordinations.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Ordinations = ({
  name: 'Ordinations',
  data: function data() {
    var me = this;
    return {
      query: '',
      ordinations: {},
      formData: {
        id: '',
        companyId: '',
        companyName: '',
        shortCompanyName: '',
        oib: '',
        address: '',
        postalNum: '',
        city: '',
        country: '',
        email: '',
        phone: '',
        mobilePhone: '',
        webPage: '',
        type: 'ordination'
      },
      formError: {},
      types: [{
        value: 'ordination',
        text: me.$i18n.t('ORDINATION')
      }, {
        value: 'technicallab',
        text: me.$i18n.t('TECHNICALLAB')
      }, {
        value: 'ordinationandlab',
        text: me.$i18n.t('ORDINATIONANDLAB')
      }],
      pagination: {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  created: function created() {
    this.getOrdinations();
  },
  methods: {
    newOrdination: function newOrdination() {
      var me = this;
      me.formData = {
        id: '',
        companyId: '',
        companyName: '',
        shortCompanyName: '',
        oib: '',
        address: '',
        postalNum: '',
        city: '',
        country: '',
        email: '',
        phone: '',
        mobilePhone: '',
        webPage: '',
        type: 'ordination'
      };
      me.$refs.newordination.show();
    },
    saveOrdination: function saveOrdination(bvEvt) {
      var me = this;

      bvEvt.preventDefault();

      ordinations.saveOrdination(me.formData, function (val) {
        if (val.error) {
          me.formError = val;
        } else {
          me.formError = {};
          me.formData = {
            id: '',
            companyId: '',
            companyName: '',
            address: '',
            oib: '',
            phone: ''
          };
          me.$refs.newordination.hide();
          me.getOrdinations();
        }
      });
    },
    getOrdinations: function getOrdinations() {
      var me = this;
      ordinations.getOrdinations(me.getParams, function (data) {
        if (data.error && data.error == true) {
          Vue.$notify.error(data.notice);
          return;
        }
        me.ordinations = data;
      });
    },
    deleteOrdination: function deleteOrdination(id) {
      var me = this;
      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          ordinations.deleteOrdination({ id: id }, function (data) {
            if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
            me.getOrdinations();
          });
        }
      });
    },
    editOrdination: function editOrdination(data) {
      var me = this;
      data = assign_default()({}, data, {});
      data.id = data.companyId;
      me.formData = data;
      me.$refs.newordination.show();
    }
  },
  watch: {
    'pagination.currentPage': function paginationCurrentPage(val) {
      var me = this;
      me.getOrdinations();
    },
    'pagination.query': function paginationQuery() {
      var me = this;
      me.getOrdinations();
    }
  },
  computed: {
    getParams: function getParams() {
      var me = this;
      var data = assign_default()({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f4e240","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ordinations.vue
var Ordinations_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-4 title"},[_c('h1',[_vm._v(_vm._s(_vm.$t('ORDINATIONSANDLABS')))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_c('router-link',{attrs:{"to":"/controlpanel/basic"}},[_vm._v(_vm._s(_vm.$t('BASICDATA')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/controlpanel/connection"}},[_vm._v(_vm._s(_vm.$t('CONNECTINGTOOTHERCOMPANIES')))])],1),_vm._v(" "),_c('li',{staticClass:"active"},[_c('router-link',{attrs:{"to":"/ordinationsandlabs"}},[_vm._v(_vm._s(_vm.$t('ORDINATIONSANDLABS')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('SEARCHORDINATIONSANDLABS')},domProps:{"value":(_vm.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(_vm.query == '')?_c('div',{staticClass:"input-group-addon"},[_c('img',{attrs:{"src":__webpack_require__("2rBp"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.query != '')?_c('div',{staticClass:"input-group-addon",on:{"click":function($event){_vm.query = ''}}},[_c('img',{staticClass:"emptysearch",attrs:{"src":__webpack_require__("8vQW"),"alt":""}})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"},[_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.newOrdination}},[_c('img',{attrs:{"src":__webpack_require__("53Vg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADD')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ADDRESS')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('OIB')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('PHONE')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('STATUS')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ACTIONS')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.ordinations.root),function(ordination){return _c('tr',[_c('td',[_vm._v(_vm._s(ordination.companyName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ordination.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ordination.oib))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ordination.phone))]),_vm._v(" "),_c('td',{staticClass:"status",class:ordination.status},[_vm._v(_vm._s(ordination.statusOut))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.editOrdination(ordination)}}},[_c('img',{attrs:{"src":__webpack_require__("vCtq"),"alt":""}})])])])}))])])]),_vm._v(" "),(_vm.ordinations.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":parseInt(_vm.ordinations.totalCount),"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"newordination",attrs:{"size":"lg","id":"newordination","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEW')},on:{"ok":_vm.saveOrdination}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('inputvalidation',{attrs:{"label":_vm.$t('TYPE'),"formerror":_vm.formError,"name":"type"}},[_c('b-form-select',{staticClass:"form-control secondary",attrs:{"options":_vm.types},model:{value:(_vm.formData.type),callback:function ($$v) {_vm.$set(_vm.formData, "type", $$v)},expression:"formData.type"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.companyName) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('COMPANYNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.companyName),expression:"formData.companyName"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('COMPANYNAME')},domProps:{"value":(_vm.formData.companyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "companyName", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.companyName)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.companyName))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.shortCompanyName) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('SHORTCOMPANYNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.shortCompanyName),expression:"formData.shortCompanyName"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('SHORTCOMPANYNAME')},domProps:{"value":(_vm.formData.shortCompanyName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "shortCompanyName", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.shortCompanyName)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.shortCompanyName))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.oib) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('OIB')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.oib),expression:"formData.oib"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('OIB')},domProps:{"value":(_vm.formData.oib)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "oib", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.oib)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.oib))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.$t('LOCATION')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.address) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('ADDRESS')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.address),expression:"formData.address"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('ADDRESS')},domProps:{"value":(_vm.formData.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "address", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.address)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.address))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.postalNum) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('POSTALNUM')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.postalNum),expression:"formData.postalNum"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('POSTALNUM')},domProps:{"value":(_vm.formData.postalNum)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "postalNum", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.postalNum)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.postalNum))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.city) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('CITY')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.city),expression:"formData.city"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('CITY')},domProps:{"value":(_vm.formData.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "city", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.city)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.city))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.country) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('COUNTRY')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.country),expression:"formData.country"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('COUNTRY')},domProps:{"value":(_vm.formData.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "country", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.country)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.country))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.$t('CONTACT')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.email) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('EMAIL')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.email),expression:"formData.email"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('EMAIL')},domProps:{"value":(_vm.formData.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "email", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.email)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.email))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.phone) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('PHONE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.phone),expression:"formData.phone"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('PHONE')},domProps:{"value":(_vm.formData.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "phone", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.phone)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.phone))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.mobilePhone) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('MOBILEPHONE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.mobilePhone),expression:"formData.mobilePhone"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('MOBILEPHONE')},domProps:{"value":(_vm.formData.mobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "mobilePhone", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.mobilePhone)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.mobilePhone))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.webPage) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('WEBPAGE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.webPage),expression:"formData.webPage"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('WEBPAGE')},domProps:{"value":(_vm.formData.webPage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "webPage", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.webPage)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.webPage))]):_vm._e()])])])])])],1)}
var Ordinations_staticRenderFns = []
var Ordinations_esExports = { render: Ordinations_render, staticRenderFns: Ordinations_staticRenderFns }
/* harmony default export */ var components_Ordinations = (Ordinations_esExports);
// CONCATENATED MODULE: ./src/components/Ordinations.vue
var Ordinations_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Ordinations___vue_template_functional__ = false
/* styles */
var Ordinations___vue_styles__ = null
/* scopeId */
var Ordinations___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Ordinations___vue_module_identifier__ = null
var Ordinations_Component = Ordinations_normalizeComponent(
  Ordinations,
  components_Ordinations,
  Ordinations___vue_template_functional__,
  Ordinations___vue_styles__,
  Ordinations___vue_scopeId__,
  Ordinations___vue_module_identifier__
)

/* harmony default export */ var src_components_Ordinations = (Ordinations_Component.exports);

// CONCATENATED MODULE: ./src/api/patients.js


/* harmony default export */ var patients = ({
  getPatient: function getPatient(params, cb) {
    AxApi.get('/rest/Patients/getPatient', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getPatients: function getPatients(params, cb) {
    AxApi.get('/rest/Patients/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  savePatient: function savePatient(params, cb) {
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/Patients/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/Patients/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deletePatient: function deletePatient(params, cb) {
    AxApi.post('/rest/Patients/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./src/api/workorders.js


/* harmony default export */ var workorders = ({
  getProtetics: function getProtetics(params, cb) {
    AxApi.get('/rest/WorkOrders/getProtetics', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  addProtetic: function addProtetic(params, cb) {
    AxApi.post('/rest/WorkOrders/addProtetic', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  deleteProtetic: function deleteProtetic(params, cb) {
    AxApi.post('/rest/WorkOrders/deleteProtetic', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  toogleSeparators: function toogleSeparators(params, cb) {
    AxApi.post('/rest/WorkOrders/toggleSeparators', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getSeparators: function getSeparators(params, cb) {
    AxApi.get('/rest/WorkOrders/getSeparators', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getWorkOrders: function getWorkOrders(params, cb) {
    AxApi.get('/rest/WorkOrders/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getWorkOrderPossibleUsers: function getWorkOrderPossibleUsers(params, cb) {
    AxApi.get('/rest/WorkOrders/getWorkOrderPossibleUsers', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveWorkOrder: function saveWorkOrder(params, cb) {
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/WorkOrders/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/WorkOrders/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deleteWorkOrder: function deleteWorkOrder(params, cb) {
    AxApi.post('/rest/WorkOrders/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getTasks: function getTasks(params, cb) {
    AxApi.get('/rest/WorkOrderTasks/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveTask: function saveTask(params, cb) {
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/WorkOrderTasks/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/WorkOrderTasks/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deleteTask: function deleteTask(params, cb) {
    AxApi.post('/rest/WorkOrderTasks/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getExpenses: function getExpenses(params, cb) {
    AxApi.get('/rest/WorkOrderExpenses/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveExpenses: function saveExpenses(params, cb) {
    AxApi.post('/rest/WorkOrderExpenses/insertRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  deleteExpenses: function deleteExpenses(params, cb) {
    AxApi.post('/rest/WorkOrderExpenses/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/WorkOrders.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var WorkOrders = ({
  name: 'WorkOrders',
  components: {
    'patientsgallery': src_components_PatientsGallery
  },
  data: function data() {
    var me = this;
    return {
      patientId: false,
      galleryPatientId: false,
      patientdata: {},
      ourUsers: [],
      ordinationUsers: [],
      tehnicianUsers: [],
      workorders: { root: [], totalCount: 0 },
      formData: {
        id: '',
        patientId: '',
        ordinationId: '',
        technicalLabId: '',
        ordinationUserId: '',
        tehnicianUserId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: '',
        ourUserId: ''
      },
      formError: {},
      pagination: {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  created: function created() {
    var me = this;

    me.patientId = me.$route.params.patientId;
    me.formData.patientId = me.patientId;
    this.getWorkOrders({ patientId: me.patientId });

    patients.getPatient({ id: me.patientId }, function (data) {
      if (data.error && data.error == true) {
        vue_esm["default"].$notify.error(data.notice);
        return;
      }
      me.patientdata = data.root;
      me.formData.ordinationId = me.patientdata.ordinationId;
      me.formData.technicalLabId = me.patientdata.technicalLabId;
      me.formData.dummyPartner = me.patientdata.dummyPartner;
      if (me.formData.dummyPartner != '') {
        me.formData.partnerType = 'dummy';
      }
    });

    me.getOurUsersInit({});

    if (me.globals.companyType == 'ordination') me.formData.companyType = 'technicallab';else me.formData.companyType = 'ordination';
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    getOrdinations: 'getOrdinations',
    getTehnicalLabs: 'getTehnicalLabs',
    getPatientInit: 'getPatient',
    getUsersByCompanyIdInit: 'getUsersByCompanyId'
  }), {
    getOurUsersInit: function getOurUsersInit(params) {
      var me = this,
          group = 'technicallab';

      if (me.selecttype == 'technicallab') group = 'ordination';

      users.getUsersByCompanyId(extends_default()({}, params, { companyId: me.globals.companyId, userGroup: group }), function (data) {
        me.ourUsers = data.root;
      });
    },

    getOrdinationsInit: function getOrdinationsInit() {
      var me = this;
      me.getOrdinations({ onlyConnected: 'true' });
    },
    getTehnicalLabsInit: function getTehnicalLabsInit() {
      var me = this;
      me.getTehnicalLabs({ onlyConnected: 'true' });
    },
    toWorkOrder: function toWorkOrder(workOrderId) {
      var me = this;
      me.$router.push('/workorders/' + workOrderId);
    },
    getPatient: function getPatient() {
      var me = this;
      this.getPatientInit({ id: me.patientId });
    },
    showPatientGallery: function showPatientGallery() {
      var me = this;
      me.galleryPatientId = false;
      vue_esm["default"].nextTick(function () {
        me.galleryPatientId = me.patientId;
      });
    },
    saveWorkOrder: function saveWorkOrder(bvEvt) {
      var me = this;
      bvEvt.preventDefault();

      workorders.saveWorkOrder(me.formData, function (val) {
        if (val.error) {
          if (typeof_default()(val.notice) == 'object') {
            var notice = '';
            for (var key in val.notice) {
              notice += val.notice[key];
            }
            val.notice = notice;
          }
          me.formError = val;
        } else {
          me.$refs.newworkorder.hide();
          me.$router.push('/workorders/' + val.lastId);
        }
      });
    },
    getWorkOrders: function getWorkOrders() {
      var me = this;
      workorders.getWorkOrders(me.getParams, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }
        me.workorders = data;
      });
    },
    deleteWorkOrder: function deleteWorkOrder(id) {
      var me = this;
      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          workorders.deleteWorkOrder({ id: id }, function (data) {
            if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
            me.getWorkOrders();
          });
        }
      });
    },
    addWorkOrder: function addWorkOrder() {
      var me = this;
      me.formData = {
        id: '',
        patientId: me.patientId,
        ordinationId: '',
        technicalLabId: '',
        ordinationUserId: '',
        tehnicianUserId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: me.globals.companyType == 'ordination' ? 'technicallab' : 'ordination',
        ourUserId: ''
      };

      me.formData.ordinationId = me.patientdata.ordinationId;
      me.formData.technicalLabId = me.patientdata.technicalLabId;
      me.formData.dummyPartner = me.patientdata.dummyPartner;
      if (me.formData.dummyPartner != '') {
        me.formData.partnerType = 'dummy';
      }

      me.$refs.newworkorder.show();
    },

    editWorkOrder: function editWorkOrder(data) {
      var me = this;
      data = assign_default()({}, data, {});
      data.id = data.workOrderId;
      if (data.dummyPartner != '') {
        data.partnerType = 'dummy';
      }

      if (data.ordinationId != '') {
        data.companyType = 'ordination';
      }

      if (data.ordinationId == me.globals.companyId) {
        data.ourUserId = data.ordinationUserId;
      } else {
        data.ourUserId = data.tehnicianUserId;
      }
      me.formData = data;
      me.$refs.newworkorder.show();
    },
    setOrdinationId: function setOrdinationId(data) {
      var me = this;
      me.formData.ordinationId = data;
      me.getOrdinationUsers({});
    },
    setTechnicalLabId: function setTechnicalLabId(data) {
      var me = this;
      me.formData.technicalLabId = data;
      me.getTechnicalLabUsers({});
    },
    setTechnicalLabUserId: function setTechnicalLabUserId(data) {
      var me = this;
      me.formData.tehnicianUserId = data;
    },
    getTechnicalLabUsers: function getTechnicalLabUsers(params) {
      var me = this;
      users.getUsersByCompanyId(extends_default()({}, params, { companyId: me.formData.technicalLabId, userGroup: 'technicallab' }), function (data) {
        me.tehnicianUsers = data.root;
      });
    },
    getOrdinationUsers: function getOrdinationUsers(params) {
      var me = this;
      users.getUsersByCompanyId(extends_default()({}, params, { companyId: me.formData.ordinationId, userGroup: 'ordination' }), function (data) {
        me.ordinationUsers = data.root;
      });
    }
  }),
  watch: {
    patient: function patient(val) {
      var me = this;
      me.$refs.patientgallery.show();
    },
    saveWorkOrderResponse: function saveWorkOrderResponse(val) {
      var me = this;

      me.formError = {};

      if (val.error == true) {
        if (typeof_default()(val.notice) == 'object') {
          me.formError = val.notice;
          val.notice = '';
        }
      } else {
        this.$refs.newworkorder.hide();
        me.getWorkOrders();
        for (var key in me.formData) {
          me.formData[key] = '';
        }
      }
    },
    'pagination.query': function paginationQuery() {
      var me = this;
      me.getWorkOrders();
    },
    'pagination.currentPage': function paginationCurrentPage(newValue, oldValue) {
      var me = this;
      me.getWorkOrders();
    },
    'formData.companyType': function formDataCompanyType() {
      var me = this;
      me.getOurUsersInit({});
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['modalAlert', 'ordinations', 'tehnicallabs', 'globals']), {
    selecttype: function selecttype() {
      var me = this;
      //'admin','ordination','technicallab','ordinationandlab'
      if (me.globals.companyType == 'ordination') {
        return 'technicallab';
      }

      if (me.globals.companyType == 'technicallab') {
        return 'ordination';
      }

      if (me.formData.companyType == 'ordination') {
        return 'ordination';
      }

      if (me.formData.companyType == 'technicallab') {
        return 'technicallab';
      }
    },
    getParams: function getParams() {
      var me = this;
      var data = assign_default()({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      data.patientId = me.patientId;
      return data;
    },
    getOrdinationsOptions: function getOrdinationsOptions() {
      var me = this,
          options = [];

      for (var i = 0; i < me.ordinations.root.length; i++) {
        var ordination = me.ordinations.root[i];
        options.push({ value: ordination.companyId, text: ordination.companyName });
      }

      return options;
    },
    getTechnicalLabOptions: function getTechnicalLabOptions() {
      var me = this,
          options = [];

      for (var i = 0; i < me.tehnicallabs.root.length; i++) {
        var tehnicallab = me.tehnicallabs.root[i];
        options.push({ value: tehnicallab.companyId, text: tehnicallab.companyName });
      }

      return options;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e04f73","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkOrders.vue
var WorkOrders_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-8 title"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 namescol"},[_c('a',{on:{"click":_vm.back}},[_c('img',{attrs:{"src":__webpack_require__("Abw3"),"alt":""}})]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.patientdata.name)+" "+_vm._s(_vm.patientdata.surname))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action d-none d-md-block"},[_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.addWorkOrder}},[_c('img',{attrs:{"src":__webpack_require__("2L7A"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDWORKORDER')))])])])]),_vm._v(" "),_c('div',{staticClass:"gridheader secondary"},[_c('div',{staticClass:"row d-none d-md-flex"},[_c('div',{staticClass:"col-md-8 title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('WORKORDERLIST')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showPatientGallery($event)}}},[_c('img',{attrs:{"src":__webpack_require__("m4mk"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('GALLERY')))])])]),_vm._v(" "),_c('div',{staticClass:"row d-md-none"},[_c('div',{staticClass:"col-10 title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('WORKORDERLIST')))])]),_vm._v(" "),_c('div',{staticClass:"col-2 action"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showPatientGallery($event)}}},[_c('img',{attrs:{"src":__webpack_require__("phsg"),"alt":""}})])])])]),_vm._v(" "),(_vm.workorders.root.length == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 center nothing"},[_c('img',{attrs:{"src":__webpack_require__("UD2X"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('CURRENTLYNOWORKORDERS')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.addWorkOrder}},[_c('img',{attrs:{"src":__webpack_require__("2L7A"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDWORKORDER')))])])]):_vm._e(),_vm._v(" "),(_vm.workorders.root.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('NUM')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('OPENEDBY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('DOCTOR')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('TECHNICIAN')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('OPENEDON')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('LASTCHANGE')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('STATUS')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('ACTIONS')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.workorders.root),function(workorder){return _c('tr',[_c('td',{on:{"click":function($event){_vm.toWorkOrder(workorder.workOrderId)}}},[_vm._v(_vm._s(workorder.workOrderId))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toWorkOrder(workorder.workOrderId)}}},[_vm._v(_vm._s(workorder.name)+" "+_vm._s(workorder.surname))]),_vm._v(" "),_c('td',{on:{"click":function($event){_vm.toWorkOrder(workorder.workOrderId)}}},[_vm._v(_vm._s(workorder.doctorName)+" "+_vm._s(workorder.doctorSurname))]),_vm._v(" "),_c('td',{on:{"click":function($event){_vm.toWorkOrder(workorder.workOrderId)}}},[_vm._v(_vm._s(workorder.tehnicianName)+" "+_vm._s(workorder.technicianSurname))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toWorkOrder(workorder.workOrderId)}}},[_vm._v(_vm._s(_vm.formatDate(workorder.openDateTime))+" ("+_vm._s(workorder.name)+" "+_vm._s(workorder.surname)+")")]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toWorkOrder(workorder.workOrderId)}}},[_vm._v(_vm._s(_vm.formatDate(workorder.updateDateTime))+" ("+_vm._s(workorder.updateName)+" "+_vm._s(workorder.updateSurname)+")")]),_vm._v(" "),_c('td',{staticClass:"status",class:workorder.status,on:{"click":function($event){_vm.toWorkOrder(workorder.workOrderId)}}},[_vm._v(_vm._s(workorder.statusOut))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteWorkOrder(workorder.workOrderId)}}},[_c('img',{attrs:{"src":__webpack_require__("qmq2"),"alt":""}})]),_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.editWorkOrder(workorder)}}},[_c('img',{attrs:{"src":__webpack_require__("vCtq"),"alt":""}})])])])}))])])]):_vm._e(),_vm._v(" "),(_vm.workorders.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":parseInt(_vm.workorders.totalCount),"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"newworkorder",attrs:{"centered":"","size":"lg","id":"newworkorder","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWWORKORDER')},on:{"ok":_vm.saveWorkOrder}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('inputvalidation',{attrs:{"label":_vm.$t('OURUSER'),"formerror":_vm.formError,"name":"ourUserId"}},[_c('autocompletesimple',{attrs:{"data":_vm.ourUsers,"placeholder":_vm.$t('OURUSER'),"valuekey":'userId',"text":['name', 'surname']},on:{"query":_vm.getOurUsersInit},model:{value:(_vm.formData.ourUserId),callback:function ($$v) {_vm.$set(_vm.formData, "ourUserId", $$v)},expression:"formData.ourUserId"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"real"},model:{value:(_vm.formData.partnerType),callback:function ($$v) {_vm.$set(_vm.formData, "partnerType", $$v)},expression:"formData.partnerType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('REALPARTNER')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"dummy"},model:{value:(_vm.formData.partnerType),callback:function ($$v) {_vm.$set(_vm.formData, "partnerType", $$v)},expression:"formData.partnerType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('DUMMYPARTNER')))])])],1)])]),_vm._v(" "),(_vm.globals.companyType != 'ordination' && _vm.globals.companyType != 'technicallab')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"ordination"},model:{value:(_vm.formData.companyType),callback:function ($$v) {_vm.$set(_vm.formData, "companyType", $$v)},expression:"formData.companyType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('ORDINATION')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group"},[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"technicallab"},model:{value:(_vm.formData.companyType),callback:function ($$v) {_vm.$set(_vm.formData, "companyType", $$v)},expression:"formData.companyType"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('TECHNICALLAB')))])])],1)])]):_vm._e(),_vm._v(" "),(_vm.formData.partnerType == 'dummy')?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group",class:(_vm.formError.dummyPartner) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('PARTNERNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.dummyPartner),expression:"formData.dummyPartner"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('PARTNERNAME')},domProps:{"value":(_vm.formData.dummyPartner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "dummyPartner", $event.target.value)}}}),_vm._v(" "),(_vm.formError.dummyPartner)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.dummyPartner))]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.formData.partnerType == 'real')?_c('div',[(_vm.selecttype == 'ordination')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('inputvalidation',{attrs:{"label":_vm.$t('ORDINATION'),"formerror":_vm.formError,"name":"ordinationId"}},[_c('autocomplete',{attrs:{"setvalue":_vm.setOrdinationId,"value":_vm.formData.ordinationId,"placeholder":_vm.$t('ORDINATION'),"values":_vm.getOrdinationsOptions,"initdata":_vm.getOrdinationsInit}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('inputvalidation',{attrs:{"label":_vm.$t('ORDINATIONUSER'),"formerror":_vm.formError,"name":"ordinationUserId"}},[_c('autocompletesimple',{attrs:{"data":_vm.ordinationUsers,"placeholder":_vm.$t('ORDINATIONUSER'),"valuekey":'userId',"text":['name', 'surname']},on:{"query":_vm.getOrdinationUsers},model:{value:(_vm.formData.ordinationUserId),callback:function ($$v) {_vm.$set(_vm.formData, "ordinationUserId", $$v)},expression:"formData.ordinationUserId"}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.selecttype == 'technicallab')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('inputvalidation',{attrs:{"label":_vm.$t('TECHNICALLAB'),"formerror":_vm.formError,"name":"technicalLabId"}},[_c('autocomplete',{attrs:{"setvalue":_vm.setTechnicalLabId,"value":_vm.formData.technicalLabId,"placeholder":_vm.$t('TECHNICALLAB'),"values":_vm.getTechnicalLabOptions,"initdata":_vm.getTehnicalLabsInit}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('inputvalidation',{attrs:{"label":_vm.$t('TECHNICALLABUSER'),"formerror":_vm.formError,"name":"tehnicianUserId"}},[_c('autocompletesimple',{attrs:{"data":_vm.tehnicianUsers,"placeholder":_vm.$t('TECHNICALLABUSER'),"valuekey":'userId',"text":['name', 'surname']},on:{"query":_vm.getTechnicalLabUsers},model:{value:(_vm.formData.tehnicianUserId),callback:function ($$v) {_vm.$set(_vm.formData, "tehnicianUserId", $$v)},expression:"formData.tehnicianUserId"}})],1)],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.formError.error && _vm.formError.notice)?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('patientsgallery',{attrs:{"patientId":_vm.galleryPatientId}})],1)}
var WorkOrders_staticRenderFns = []
var WorkOrders_esExports = { render: WorkOrders_render, staticRenderFns: WorkOrders_staticRenderFns }
/* harmony default export */ var components_WorkOrders = (WorkOrders_esExports);
// CONCATENATED MODULE: ./src/components/WorkOrders.vue
var WorkOrders_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var WorkOrders___vue_template_functional__ = false
/* styles */
var WorkOrders___vue_styles__ = null
/* scopeId */
var WorkOrders___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WorkOrders___vue_module_identifier__ = null
var WorkOrders_Component = WorkOrders_normalizeComponent(
  WorkOrders,
  components_WorkOrders,
  WorkOrders___vue_template_functional__,
  WorkOrders___vue_styles__,
  WorkOrders___vue_scopeId__,
  WorkOrders___vue_module_identifier__
)

/* harmony default export */ var src_components_WorkOrders = (WorkOrders_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Teeth.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Teeth = ({
  name: 'Teeth',
  props: ['tooth', 'separators'],
  methods: {
    toothClick: function toothClick(tooth) {
      var me = this;
      me.$emit('teethclick', [tooth]);
    },
    separatorClick: function separatorClick(separator) {
      var me = this;
      me.$emit('separatorclick', [separator]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73730bd6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Teeth.vue
var Teeth_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"enable-background":"new 0 0 800 360"},attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 800 360","xml:space":"preserve"}},[_c('g',{attrs:{"id":"gingive"}},[_c('g',{attrs:{"id":"gingive_x5F_izmedju"}},[_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_1_","gradientUnits":"userSpaceOnUse","x1":"4945.7422","y1":"-6287.4346","x2":"4945.7422","y2":"-6328.4131","gradientTransform":"matrix(-1 0 0 -1 5345.7422 -6034.5977)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M391,273.3c0-11.3,4-20.5,9-20.5c5,0,9,9.2,9,20.5c0,11.3,4.5,20.5-9,20.5C386.7,293.8,391,284.6,391,273.3\n\t\t\t\t\tz"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M391,273.3c0-11.3,4-20.5,9-20.5c5,0,9,9.2,9,20.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_2_","gradientUnits":"userSpaceOnUse","x1":"2278.8936","y1":"-6284.5088","x2":"2278.8936","y2":"-6329.4189","gradientTransform":"matrix(-1 0 0 -1 2713.5293 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st2",attrs:{"d":"M424.6,275.3c0-12.4,4.5-22.5,10-22.5c5.5,0,10,10.1,10,22.5s5,22.5-10,22.5\n\t\t\t\t\tC419.9,297.7,424.6,287.7,424.6,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M424.6,275.3c0-12.4,4.5-22.5,10-22.5c5.5,0,10,10.1,10,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_3_","gradientUnits":"userSpaceOnUse","x1":"2245.9807","y1":"-6284.5088","x2":"2245.9807","y2":"-6329.4189","gradientTransform":"matrix(-1 0 0 -1 2713.5293 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st3",attrs:{"d":"M458.7,275.3c0-12.4,4-22.5,8.9-22.5c4.9,0,8.9,10.1,8.9,22.5s4.4,22.5-8.9,22.5\n\t\t\t\t\tC454.5,297.7,458.7,287.7,458.7,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M458.7,275.3c0-12.4,4-22.5,8.9-22.5c4.9,0,8.9,10.1,8.9,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_4_","gradientUnits":"userSpaceOnUse","x1":"2205.2998","y1":"-6284.5078","x2":"2205.2998","y2":"-6329.417","gradientTransform":"matrix(-1 0 0 -1 2713.5293 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st4",attrs:{"d":"M496.7,275.3c0-12.4,5.2-22.5,11.5-22.5c6.4,0,11.5,10.1,11.5,22.5c0,12.4,5.7,22.5-11.5,22.5\n\t\t\t\t\tC491.2,297.7,496.7,287.7,496.7,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M496.7,275.3c0-12.4,5.2-22.5,11.5-22.5c6.4,0,11.5,10.1,11.5,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_5_","gradientUnits":"userSpaceOnUse","x1":"2166.4524","y1":"-6284.5078","x2":"2166.4524","y2":"-6329.417","gradientTransform":"matrix(-1 0 0 -1 2713.5293 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M533.8,275.3c0-12.4,5.9-22.5,13.3-22.5c7.3,0,13.3,10.1,13.3,22.5c0,12.4,6.6,22.5-13.3,22.5\n\t\t\t\t\tC527.5,297.7,533.8,287.7,533.8,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M533.8,275.3c0-12.4,5.9-22.5,13.3-22.5c7.3,0,13.3,10.1,13.3,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_6_","gradientUnits":"userSpaceOnUse","x1":"2127.1702","y1":"-6284.5068","x2":"2127.1702","y2":"-6329.416","gradientTransform":"matrix(-1 0 0 -1 2713.5293 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st6",attrs:{"d":"M571.6,275.3c0-12.4,6.6-22.5,14.8-22.5s14.8,10.1,14.8,22.5c0,12.4,7.3,22.5-14.8,22.5\n\t\t\t\t\tC564.6,297.7,571.6,287.7,571.6,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M571.6,275.3c0-12.4,6.6-22.5,14.8-22.5s14.8,10.1,14.8,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_7_","gradientUnits":"userSpaceOnUse","x1":"2063.8225","y1":"-6284.5068","x2":"2063.8225","y2":"-6329.416","gradientTransform":"matrix(-1 0 0 -1 2713.5293 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M633.6,275.3c0-12.4,7.2-22.5,16.1-22.5c8.9,0,16.1,10.1,16.1,22.5c0,12.4,8,22.5-16.1,22.5\n\t\t\t\t\tC625.9,297.7,633.6,287.7,633.6,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M633.6,275.3c0-12.4,7.2-22.5,16.1-22.5c8.9,0,16.1,10.1,16.1,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_8_","gradientUnits":"userSpaceOnUse","x1":"2002.7194","y1":"-6284.5068","x2":"2002.7194","y2":"-6329.416","gradientTransform":"matrix(-1 0 0 -1 2713.5293 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M696.7,275.3c0-12.4,6.3-22.5,14-22.5c7.8,0,14,10.1,14,22.5c0,12.4,7,22.5-14,22.5\n\t\t\t\t\tC690.1,297.7,696.7,287.7,696.7,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M696.7,275.3c0-12.4,6.3-22.5,14-22.5c7.8,0,14,10.1,14,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_9_","gradientUnits":"userSpaceOnUse","x1":"763.3934","y1":"-6428.0615","x2":"763.3934","y2":"-6472.9697","gradientTransform":"matrix(1 0 0 -1 0 -6178.7051)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st9",attrs:{"d":"M773.7,271.8c0-12.4-4.6-22.5-10.3-22.5c-5.7,0-10.3,10.1-10.3,22.5c0,12.4-5.1,22.5,10.3,22.5\n\t\t\t\t\tC778.6,294.3,773.7,284.2,773.7,271.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st10",attrs:{"d":"M753.6,271.8c0,0,0-1.1,0.1-3.1c0.1-1.9,0.4-4.7,1.2-7.9c0.4-1.6,0.9-3.3,1.7-4.9c0.7-1.6,1.7-3.2,3-4.5\n\t\t\t\tc1.3-1.2,2.9-2,4.6-1.7c1.6,0.2,3.2,1.4,4.4,3c1.2,1.6,2.2,3.5,2.9,5.5c0.7,2,1.2,4.1,1.6,6.1c0.3,2.1,0.5,4.1,0.6,6\n\t\t\t\tc0,1.9,0.1,3.8,0.2,5.5c0.1,1.7,0.3,3.2,0.4,4.6c0.1,1.4,0.2,2.6,0.2,3.6c0,1,0,1.8,0,2.3c0,0.5,0,0.8,0,0.8s0-0.3,0-0.8\n\t\t\t\tc0-0.5,0.1-1.3,0-2.3c0-1-0.1-2.2-0.1-3.6c-0.1-1.4-0.2-2.9-0.3-4.6c-0.1-1.7-0.1-3.5-0.1-5.5c0-1.9-0.2-4-0.5-6.1\n\t\t\t\tc-0.3-2.1-0.8-4.2-1.5-6.3c-0.7-2.1-1.6-4.1-2.9-5.7c-1.2-1.7-2.9-3-4.7-3.3c-1.8-0.3-3.6,0.5-5,1.8c-1.4,1.3-2.4,3-3.3,4.7\n\t\t\t\tc-0.8,1.7-1.4,3.4-1.8,5.1c-0.9,3.3-1.2,6.1-1.3,8.1c-0.1,1-0.1,1.8-0.1,2.3c0,0.5,0,0.8,0,0.8L753.6,271.8z"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_10_","gradientUnits":"userSpaceOnUse","x1":"-2266.8621","y1":"-6284.5088","x2":"-2266.8621","y2":"-6329.4189","gradientTransform":"matrix(1 0 0 -1 2632.2126 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st11",attrs:{"d":"M375.4,275.3c0-12.4-4.5-22.5-10-22.5c-5.5,0-10,10.1-10,22.5s-5,22.5,10,22.5\n\t\t\t\t\tC380.1,297.7,375.4,287.7,375.4,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M375.4,275.3c0-12.4-4.5-22.5-10-22.5c-5.5,0-10,10.1-10,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_11_","gradientUnits":"userSpaceOnUse","x1":"-2299.7749","y1":"-6284.5088","x2":"-2299.7749","y2":"-6329.4189","gradientTransform":"matrix(1 0 0 -1 2632.2126 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st12",attrs:{"d":"M341.3,275.3c0-12.4-4-22.5-8.9-22.5c-4.9,0-8.9,10.1-8.9,22.5s-4.4,22.5,8.9,22.5\n\t\t\t\t\tC345.5,297.7,341.3,287.7,341.3,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M341.3,275.3c0-12.4-4-22.5-8.9-22.5c-4.9,0-8.9,10.1-8.9,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_12_","gradientUnits":"userSpaceOnUse","x1":"-2340.4556","y1":"-6284.5078","x2":"-2340.4556","y2":"-6329.417","gradientTransform":"matrix(1 0 0 -1 2632.2126 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st13",attrs:{"d":"M303.3,275.3c0-12.4-5.2-22.5-11.5-22.5c-6.4,0-11.5,10.1-11.5,22.5c0,12.4-5.7,22.5,11.5,22.5\n\t\t\t\t\tC308.8,297.7,303.3,287.7,303.3,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M303.3,275.3c0-12.4-5.2-22.5-11.5-22.5c-6.4,0-11.5,10.1-11.5,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_13_","gradientUnits":"userSpaceOnUse","x1":"-2379.3037","y1":"-6284.5078","x2":"-2379.3037","y2":"-6329.417","gradientTransform":"matrix(1 0 0 -1 2632.2126 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st14",attrs:{"d":"M266.2,275.3c0-12.4-5.9-22.5-13.3-22.5c-7.3,0-13.3,10.1-13.3,22.5c0,12.4-6.6,22.5,13.3,22.5\n\t\t\t\t\tC272.5,297.7,266.2,287.7,266.2,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M266.2,275.3c0-12.4-5.9-22.5-13.3-22.5c-7.3,0-13.3,10.1-13.3,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_14_","gradientUnits":"userSpaceOnUse","x1":"-2418.5857","y1":"-6284.5068","x2":"-2418.5857","y2":"-6329.416","gradientTransform":"matrix(1 0 0 -1 2632.2126 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st15",attrs:{"d":"M228.4,275.3c0-12.4-6.6-22.5-14.8-22.5s-14.8,10.1-14.8,22.5c0,12.4-7.3,22.5,14.8,22.5\n\t\t\t\t\tC235.4,297.7,228.4,287.7,228.4,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M228.4,275.3c0-12.4-6.6-22.5-14.8-22.5s-14.8,10.1-14.8,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_15_","gradientUnits":"userSpaceOnUse","x1":"-2481.9336","y1":"-6284.5068","x2":"-2481.9336","y2":"-6329.416","gradientTransform":"matrix(1 0 0 -1 2632.2126 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st16",attrs:{"d":"M166.4,275.3c0-12.4-7.2-22.5-16.1-22.5c-8.9,0-16.1,10.1-16.1,22.5c0,12.4-8,22.5,16.1,22.5\n\t\t\t\t\tC174.1,297.7,166.4,287.7,166.4,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M166.4,275.3c0-12.4-7.2-22.5-16.1-22.5c-8.9,0-16.1,10.1-16.1,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_16_","gradientUnits":"userSpaceOnUse","x1":"-2543.0364","y1":"-6284.5068","x2":"-2543.0364","y2":"-6329.416","gradientTransform":"matrix(1 0 0 -1 2632.2126 -6031.6719)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st17",attrs:{"d":"M103.3,275.3c0-12.4-6.3-22.5-14-22.5c-7.8,0-14,10.1-14,22.5c0,12.4-7,22.5,14,22.5\n\t\t\t\t\tC109.9,297.7,103.3,287.7,103.3,275.3z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M103.3,275.3c0-12.4-6.3-22.5-14-22.5c-7.8,0-14,10.1-14,22.5"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_17_","gradientUnits":"userSpaceOnUse","x1":"5309.1494","y1":"-6428.0615","x2":"5309.1494","y2":"-6472.9697","gradientTransform":"matrix(-1 0 0 -1 5345.7422 -6178.7051)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st18",attrs:{"d":"M26.3,271.8c0-12.4,4.6-22.5,10.3-22.5c5.7,0,10.3,10.1,10.3,22.5c0,12.4,5.1,22.5-10.3,22.5\n\t\t\t\t\tC21.4,294.3,26.3,284.2,26.3,271.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st10",attrs:{"d":"M46.3,271.8c0,0,0-1.1-0.1-3.1c-0.1-1.9-0.4-4.7-1.2-7.9c-0.4-1.6-0.9-3.3-1.7-4.9c-0.7-1.6-1.7-3.2-3-4.5\n\t\t\t\tc-1.3-1.2-2.9-2-4.6-1.7c-1.6,0.2-3.2,1.4-4.4,3c-1.2,1.6-2.2,3.5-2.9,5.5c-0.7,2-1.2,4.1-1.6,6.1c-0.3,2.1-0.5,4.1-0.6,6\n\t\t\t\tc0,1.9-0.1,3.8-0.2,5.5c-0.1,1.7-0.3,3.2-0.4,4.6c-0.1,1.4-0.2,2.6-0.2,3.6c0,1,0,1.8,0,2.3c0,0.5,0,0.8,0,0.8s0-0.3,0-0.8\n\t\t\t\tc0-0.5-0.1-1.3,0-2.3c0-1,0.1-2.2,0.1-3.6c0.1-1.4,0.2-2.9,0.3-4.6c0.1-1.7,0.1-3.5,0.1-5.5c0-1.9,0.2-4,0.5-6.1\n\t\t\t\tc0.3-2.1,0.8-4.2,1.5-6.3c0.7-2.1,1.6-4.1,2.9-5.7c1.2-1.7,2.9-3,4.7-3.3c1.8-0.3,3.6,0.5,5,1.8c1.4,1.3,2.4,3,3.3,4.7\n\t\t\t\tc0.8,1.7,1.4,3.4,1.8,5.1c0.9,3.3,1.2,6.1,1.3,8.1c0.1,1,0.1,1.8,0.1,2.3c0,0.5,0,0.8,0,0.8L46.3,271.8z"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_18_","gradientUnits":"userSpaceOnUse","x1":"4945.7422","y1":"126.9082","x2":"4945.7422","y2":"82.752","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st19",attrs:{"d":"M389.4,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1c0-12.2,5.2-22.1-10.5-22.1\n\t\t\t\t\tC384.5,82.8,389.4,92.6,389.4,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M389.4,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_19_","gradientUnits":"userSpaceOnUse","x1":"452.8459","y1":"126.9072","x2":"452.8459","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st21",attrs:{"d":"M464.1,104.8c0,12.2-5,22.1-11.3,22.1c-6.2,0-11.3-9.9-11.3-22.1s-5.6-22.1,11.3-22.1\n\t\t\t\t\tC469.5,82.8,464.1,92.6,464.1,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M464.1,104.8c0,12.2-5,22.1-11.3,22.1c-6.2,0-11.3-9.9-11.3-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_20_","gradientUnits":"userSpaceOnUse","x1":"492.2364","y1":"126.9072","x2":"492.2364","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st22",attrs:{"d":"M501.3,104.8c0,12.2-4,22.1-9,22.1c-5,0-9-9.9-9-22.1s-4.5-22.1,9-22.1C505.6,82.8,501.3,92.6,501.3,104.8\n\t\t\t\t\tz"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M501.3,104.8c0,12.2-4,22.1-9,22.1c-5,0-9-9.9-9-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_21_","gradientUnits":"userSpaceOnUse","x1":"536.1365","y1":"126.9072","x2":"536.1365","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st23",attrs:{"d":"M546.8,104.8c0,12.2-4.7,22.1-10.6,22.1c-5.8,0-10.6-9.9-10.6-22.1s-5.2-22.1,10.6-22.1\n\t\t\t\t\tC551.8,82.8,546.8,92.6,546.8,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M546.8,104.8c0,12.2-4.7,22.1-10.6,22.1c-5.8,0-10.6-9.9-10.6-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_22_","gradientUnits":"userSpaceOnUse","x1":"576.6076","y1":"126.9072","x2":"576.6076","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st24",attrs:{"d":"M586.8,104.8c0,12.2-4.6,22.1-10.2,22.1c-5.6,0-10.2-9.9-10.2-22.1s-5.1-22.1,10.2-22.1\n\t\t\t\t\tC591.7,82.8,586.8,92.6,586.8,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M586.8,104.8c0,12.2-4.6,22.1-10.2,22.1c-5.6,0-10.2-9.9-10.2-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_23_","gradientUnits":"userSpaceOnUse","x1":"613.9481","y1":"126.9072","x2":"613.9481","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st25",attrs:{"d":"M624.5,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1s-5.2-22.1,10.5-22.1\n\t\t\t\t\tC629.5,82.8,624.5,92.6,624.5,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M624.5,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_24_","gradientUnits":"userSpaceOnUse","x1":"665.7634","y1":"126.9072","x2":"665.7634","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st26",attrs:{"d":"M676.3,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1s-5.2-22.1,10.5-22.1\n\t\t\t\t\tC681.3,82.8,676.3,92.6,676.3,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M676.3,104.8c0,12.2-4.7,22.1-10.5,22.1c-5.8,0-10.5-9.9-10.5-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_25_","gradientUnits":"userSpaceOnUse","x1":"713.2646","y1":"126.9072","x2":"713.2646","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st27",attrs:{"d":"M723.3,104.8c0,12.2-4.5,22.1-10,22.1c-5.5,0-10-9.9-10-22.1s-5-22.1,10-22.1\n\t\t\t\t\tC728.1,82.8,723.3,92.6,723.3,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M723.3,104.8c0,12.2-4.5,22.1-10,22.1c-5.5,0-10-9.9-10-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_26_","gradientUnits":"userSpaceOnUse","x1":"763.5087","y1":"126.9072","x2":"763.5087","y2":"82.751"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st28",attrs:{"d":"M773.8,104.8c0,12.2-4.6,22.1-10.3,22.1c-5.7,0-10.3-9.9-10.3-22.1s-5.1-22.1,10.3-22.1\n\t\t\t\t\tC778.7,82.8,773.8,92.6,773.8,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st10",attrs:{"d":"M753.8,104.8c0,0,0,1.1,0.1,3c0.1,1.9,0.4,4.6,1.2,7.8c0.4,1.6,0.9,3.2,1.7,4.8c0.7,1.6,1.7,3.2,3,4.4\n\t\t\t\tc1.3,1.2,2.9,2,4.6,1.7c1.6-0.2,3.2-1.4,4.4-2.9c1.2-1.5,2.2-3.4,2.9-5.4c0.7-2,1.2-4,1.6-6c0.3-2,0.5-4,0.6-5.9\n\t\t\t\tc0-1.9,0.1-3.7,0.2-5.4c0.1-1.7,0.3-3.2,0.4-4.5c0.1-1.3,0.2-2.5,0.2-3.5c0-1,0-1.7,0-2.3c0-0.5,0-0.8,0-0.8s0,0.3,0,0.8\n\t\t\t\tc0,0.5,0.1,1.3,0,2.3c0,1-0.1,2.2-0.1,3.5c-0.1,1.3-0.2,2.9-0.3,4.5c-0.1,1.7-0.1,3.5-0.1,5.4c0,1.9-0.2,3.9-0.5,6\n\t\t\t\tc-0.3,2.1-0.8,4.1-1.5,6.2c-0.7,2-1.6,4-2.9,5.6c-1.2,1.6-2.9,3-4.7,3.2c-1.8,0.3-3.6-0.5-5-1.7c-1.4-1.3-2.4-2.9-3.3-4.6\n\t\t\t\tc-0.8-1.7-1.4-3.4-1.8-5c-0.9-3.2-1.2-6-1.3-8c-0.1-1-0.1-1.8-0.1-2.3c0-0.5,0-0.8,0-0.8L753.8,104.8z"}})]),_vm._v(" "),_c('path',{staticClass:"st29",attrs:{"d":"M630.4,105.1c0,0-1.8,10.2-2.8,13.3c-1,3.1-5,9.6-7.1,11.6s-4.3,4.6-5,6.8c-0.7,2.3,6.8-19.4,7.5-23.8\n\t\t\tC623.6,108.7,629.9,106.3,630.4,105.1z"}}),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_27_","gradientUnits":"userSpaceOnUse","x1":"4998.603","y1":"126.9072","x2":"4998.603","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st30",attrs:{"d":"M335.8,104.8c0,12.2,5,22.1,11.3,22.1c6.2,0,11.3-9.9,11.3-22.1s5.6-22.1-11.3-22.1\n\t\t\t\t\tC330.5,82.8,335.8,92.6,335.8,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M335.8,104.8c0,12.2,5,22.1,11.3,22.1c6.2,0,11.3-9.9,11.3-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_28_","gradientUnits":"userSpaceOnUse","x1":"5037.9922","y1":"126.9072","x2":"5037.9922","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st31",attrs:{"d":"M298.7,104.8c0,12.2,4,22.1,9,22.1c5,0,9-9.9,9-22.1s4.5-22.1-9-22.1C294.4,82.8,298.7,92.6,298.7,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M298.7,104.8c0,12.2,4,22.1,9,22.1c5,0,9-9.9,9-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_29_","gradientUnits":"userSpaceOnUse","x1":"5081.8926","y1":"126.9072","x2":"5081.8926","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st32",attrs:{"d":"M253.2,104.8c0,12.2,4.7,22.1,10.6,22.1c5.8,0,10.6-9.9,10.6-22.1s5.2-22.1-10.6-22.1\n\t\t\t\t\tC248.2,82.8,253.2,92.6,253.2,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M253.2,104.8c0,12.2,4.7,22.1,10.6,22.1c5.8,0,10.6-9.9,10.6-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_30_","gradientUnits":"userSpaceOnUse","x1":"5122.3633","y1":"126.9072","x2":"5122.3633","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st33",attrs:{"d":"M213.1,104.8c0,12.2,4.6,22.1,10.2,22.1c5.6,0,10.2-9.9,10.2-22.1s5.1-22.1-10.2-22.1\n\t\t\t\t\tC208.3,82.8,213.1,92.6,213.1,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M213.1,104.8c0,12.2,4.6,22.1,10.2,22.1c5.6,0,10.2-9.9,10.2-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_31_","gradientUnits":"userSpaceOnUse","x1":"5159.7041","y1":"126.9072","x2":"5159.7041","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st34",attrs:{"d":"M175.5,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1s5.2-22.1-10.5-22.1\n\t\t\t\t\tC170.5,82.8,175.5,92.6,175.5,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M175.5,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_32_","gradientUnits":"userSpaceOnUse","x1":"5211.5205","y1":"126.9072","x2":"5211.5205","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st35",attrs:{"d":"M123.7,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1s5.2-22.1-10.5-22.1\n\t\t\t\t\tC118.7,82.8,123.7,92.6,123.7,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M123.7,104.8c0,12.2,4.7,22.1,10.5,22.1c5.8,0,10.5-9.9,10.5-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_33_","gradientUnits":"userSpaceOnUse","x1":"5259.0205","y1":"126.9072","x2":"5259.0205","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st36",attrs:{"d":"M76.6,104.8c0,12.2,4.5,22.1,10,22.1c5.5,0,10-9.9,10-22.1s5-22.1-10-22.1C71.9,82.8,76.6,92.6,76.6,104.8\n\t\t\t\t\tz"}})],1),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M76.6,104.8c0,12.2,4.5,22.1,10,22.1c5.5,0,10-9.9,10-22.1"}})]),_vm._v(" "),_c('g',[_c('g',[_c('linearGradient',{attrs:{"id":"SVGID_34_","gradientUnits":"userSpaceOnUse","x1":"5309.2646","y1":"126.9072","x2":"5309.2646","y2":"82.751","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6667"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F8DCE7","stop-opacity":"0.542"},attrs:{"offset":"0.807"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.9731"}})],1),_vm._v(" "),_c('path',{staticClass:"st37",attrs:{"d":"M26.2,104.8c0,12.2,4.6,22.1,10.3,22.1c5.7,0,10.3-9.9,10.3-22.1s5.1-22.1-10.3-22.1\n\t\t\t\t\tC21.3,82.8,26.2,92.6,26.2,104.8z"}})],1),_vm._v(" "),_c('path',{staticClass:"st10",attrs:{"d":"M46.2,104.8c0,0,0,1.1-0.1,3c-0.1,1.9-0.4,4.6-1.2,7.8c-0.4,1.6-0.9,3.2-1.7,4.8c-0.7,1.6-1.7,3.2-3,4.4\n\t\t\t\tc-1.3,1.2-2.9,2-4.6,1.7c-1.6-0.2-3.2-1.4-4.4-2.9c-1.2-1.5-2.2-3.4-2.9-5.4c-0.7-2-1.2-4-1.6-6c-0.3-2-0.5-4-0.6-5.9\n\t\t\t\tc0-1.9-0.1-3.7-0.2-5.4c-0.1-1.7-0.3-3.2-0.4-4.5c-0.1-1.3-0.2-2.5-0.2-3.5c0-1,0-1.7,0-2.3c0-0.5,0-0.8,0-0.8s0,0.3,0,0.8\n\t\t\t\tc0,0.5-0.1,1.3,0,2.3c0,1,0.1,2.2,0.1,3.5c0.1,1.3,0.2,2.9,0.3,4.5c0.1,1.7,0.1,3.5,0.1,5.4c0,1.9,0.2,3.9,0.5,6\n\t\t\t\tc0.3,2.1,0.8,4.1,1.5,6.2c0.7,2,1.6,4,2.9,5.6c1.2,1.6,2.9,3,4.7,3.2c1.8,0.3,3.6-0.5,5-1.7c1.4-1.3,2.4-2.9,3.3-4.6\n\t\t\t\tc0.8-1.7,1.4-3.4,1.8-5c0.9-3.2,1.2-6,1.3-8c0.1-1,0.1-1.8,0.1-2.3c0-0.5,0-0.8,0-0.8L46.2,104.8z"}})]),_vm._v(" "),_c('path',{staticClass:"st29",attrs:{"d":"M169.5,105.1c0,0,1.8,10.2,2.8,13.3c1,3.1,5,9.6,7.1,11.6s4.3,4.6,5,6.8c0.7,2.3-6.8-19.4-7.5-23.8\n\t\t\tC176.4,108.7,170.1,106.3,169.5,105.1z"}})]),_vm._v(" "),_c('g',{attrs:{"id":"gk4"}},[_c('linearGradient',{attrs:{"id":"g48_1_","gradientUnits":"userSpaceOnUse","x1":"5284.3013","y1":"333.1807","x2":"5284.3013","y2":"239.4248","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3333"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.4946"}})],1),_vm._v(" "),_c('path',{staticClass:"st38",attrs:{"id":"g48","d":"M40.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8\n\t\t\tc0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8\n\t\t\tc0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23\n\t\t\tC34.6,299.5,40.4,286.3,40.4,273.8z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g47_1_","gradientUnits":"userSpaceOnUse","x1":"5225.2954","y1":"333.1807","x2":"5225.2954","y2":"239.4248","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3441"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4047"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5"}})],1),_vm._v(" "),_c('path',{staticClass:"st39",attrs:{"id":"g47","d":"M99.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8\n\t\t\tc0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8\n\t\t\tc0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23\n\t\t\tC93.6,299.5,99.4,286.3,99.4,273.8z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g46_1_","gradientUnits":"userSpaceOnUse","x1":"5164.0811","y1":"336.5957","x2":"5164.0811","y2":"243.2022","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3602"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4313"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.543"}})],1),_vm._v(" "),_c('path',{staticClass:"st40",attrs:{"id":"g46","d":"M156.1,246.8c0,0,5.9,15.8,5.9,21.5c0,8.6-10.1,47.2-10.1,56.7c0,6.6,1.6,10.1,3.2,10.1\n\t\t\tc1.6,0,5.4-5.8,5.4-8.8c0-1.5,6.3-9.9,12-28.4c2.8-9.2,8.1-10.7,9.2-10.7c2.3,0,4.8,7.2,4.8,15.6c0,8.4-2.8,26-3.2,27.4\n\t\t\tc-0.4,1.5-0.7,2.7-0.7,3.3c0,0.7,0,2.9,2,2.9c4.4,0,19.6-23.6,19.6-39.1c0-19.4-1.4-17.1-1.4-25.8c0-7,8.8-20.1,8.8-28.5\n\t\t\tL156.1,246.8z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g45_1_","gradientUnits":"userSpaceOnUse","x1":"5112.0405","y1":"341.2266","x2":"5112.0405","y2":"247.2334","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4194"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4883"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5968"}})],1),_vm._v(" "),_c('path',{staticClass:"st41",attrs:{"id":"g45","d":"M220,248.3c1.2,8.8,2,21,1.5,31.6c-0.4,8.3-1.2,15.3-1.2,17.4c0,4.6,1.8,10.1,1.8,29.4\n\t\t\tc0,4.8-1.8,8.1-1.8,10.7c0,2.1,0.1,3.9,1.8,3.9c3.8,0,8-8,10.6-13.5c1.6-3.5,11.8-19.5,11.8-34.1c0,0,0.5-29.3,0.5-30.8\n\t\t\tc0-1.5,2.6-15.6,2.6-15.6L220,248.3z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g44_1_","gradientUnits":"userSpaceOnUse","x1":"5072.4565","y1":"337.1982","x2":"5072.4565","y2":"248.9463","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3602"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4417"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5699"}})],1),_vm._v(" "),_c('path',{staticClass:"st42",attrs:{"id":"g44","d":"M287.6,248.9l-28.7,0.7c0,0,3.2,11.8,3.6,16.7c0.3,4.9-1.9,15.9-1.9,21.7c0,5.7,3.9,32.8,3.9,36.4\n\t\t\tc0,3.6-0.7,4.7-0.7,7c0,2.3,0.7,5.7,2.1,5.7c5.5,0,18.9-35.5,18.9-72.1C284.9,254.7,287.6,248.9,287.6,248.9z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g43_1_","gradientUnits":"userSpaceOnUse","x1":"5033.2939","y1":"339.4541","x2":"5033.2939","y2":"250.6982","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4194"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4883"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5968"}})],1),_vm._v(" "),_c('path',{staticClass:"st43",attrs:{"id":"g43","d":"M299,250.7c0,0,1.8,11.2,1.8,14.1s-1.3,14.2-1.3,19.2c0,13.1,5,36,5,40.2S303,336,303,337.4\n\t\t\tc0,1.3,0.8,2.1,1.7,2.1c4.6,0,14.2-19.4,14.2-23.6c0-8.3,5.4-21.4,5.4-25.8c0-4.4,1.7-38.8,1.7-38.8L299,250.7z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g42_1_","gradientUnits":"userSpaceOnUse","x1":"4995.6733","y1":"339.4482","x2":"4995.6733","y2":"255.0381","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4086"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4922"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6237"}})],1),_vm._v(" "),_c('path',{staticClass:"st44",attrs:{"id":"g42","d":"M339.9,255c0,0-1.2,49-1.5,51.4c-0.3,2.4,3.7,17.2,4.2,18.6c0.6,1.4,0,11.1,0,11.9\n\t\t\tc0,0.9,1.5,2.4,2.8,2.4c4.7,0,16.4-26.3,16.4-84.3L339.9,255z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g41_1_","gradientUnits":"userSpaceOnUse","x1":"4960.2124","y1":"336.4502","x2":"4960.2124","y2":"252.3281","gradientTransform":"matrix(-1 0 0 1 5345.7422 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3925"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4761"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6075"}})],1),_vm._v(" "),_c('path',{staticClass:"st45",attrs:{"id":"g41","d":"M373.8,252.4c0,57.5,8.3,84,21.2,84c1.9,0,2.3-0.8,2.3-2.1c0-0.7-3.4-5.4-3.4-14.2\n\t\t\tc0-5.8,3.2-12.8,3.2-17.3c0-8-1.2-7.4-2.2-50.6L373.8,252.4z"}})],1),_vm._v(" "),_c('g',{attrs:{"id":"gk3"}},[_c('linearGradient',{attrs:{"id":"g38_1_","gradientUnits":"userSpaceOnUse","x1":"5450.3228","y1":"333.1807","x2":"5450.3228","y2":"239.4248","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3333"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.4946"}})],1),_vm._v(" "),_c('path',{staticClass:"st46",attrs:{"id":"g38","d":"M759.6,273.8c0-14.8,5.8-26,5.8-34.4c0,0-53.5,0-53.7,4.4c-0.2,4.3,10.1,19.1,10.1,23.8\n\t\t\tc0,3.5,0.9,15.4,0.9,15.4c0,22.6,12.4,50.2,15.9,50.2c2.2,0,2.7-1.8,2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5,1.3-13.6,1.3-19.8\n\t\t\tc0-6.2-2.2-30.7-0.6-30.7c1.2,0,6.2,21,6.7,24.9c0.5,3.9,5.5,13.5,5.5,21.6c0,2.7,1.5,6.9,3.9,6.9c3,0,7.4-12.8,7.4-23\n\t\t\tC765.4,299.5,759.6,286.3,759.6,273.8z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g37_1_","gradientUnits":"userSpaceOnUse","x1":"5391.3169","y1":"333.1807","x2":"5391.3169","y2":"239.4248","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3441"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4047"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5"}})],1),_vm._v(" "),_c('path',{staticClass:"st47",attrs:{"id":"g37","d":"M706.4,306.5c0,10.2-4.4,23-7.4,23c-2.3,0-3.9-4.1-3.9-6.9c0-8.1-5-17.6-5.5-21.6\n\t\t\tc-0.5-3.9-5.4-24.9-6.7-24.9c-1.6,0,0.6,24.5,0.6,30.7c0,6.2-1.3,18.3-1.3,19.8c0,0,0,2.6,0,3.7c0,1.1-0.5,2.9-2.7,2.9\n\t\t\tc-3.5,0-15.9-27.6-15.9-50.2c0,0-0.9-11.9-0.9-15.4c0-4.6-10.3-19.4-10.1-23.8c0.2-4.3,53.7-4.4,53.7-4.4c0,8.4-5.8,19.6-5.8,34.4\n\t\t\tC700.6,286.3,706.4,299.5,706.4,306.5z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g36_1_","gradientUnits":"userSpaceOnUse","x1":"5330.1025","y1":"336.5957","x2":"5330.1025","y2":"243.2022","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3602"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4313"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.543"}})],1),_vm._v(" "),_c('path',{staticClass:"st48",attrs:{"id":"g36","d":"M588.5,243.2c0,8.4,8.8,21.5,8.8,28.5c0,8.7-1.4,6.3-1.4,25.8c0,15.4,15.2,39.1,19.6,39.1\n\t\t\tc2,0,2-2.2,2-2.9c0-0.7-0.3-1.9-0.7-3.3c-0.4-1.5-3.2-19-3.2-27.4c0-8.4,2.5-15.6,4.8-15.6c1.1,0,6.3,1.5,9.2,10.7\n\t\t\tc5.7,18.5,12,26.9,12,28.4c0,3,3.8,8.8,5.4,8.8c1.6,0,3.2-3.5,3.2-10.1c0-9.5-10.1-48.2-10.1-56.7c0-5.7,5.9-21.5,5.9-21.5\n\t\t\tL588.5,243.2z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g35_1_","gradientUnits":"userSpaceOnUse","x1":"5278.0615","y1":"341.2266","x2":"5278.0615","y2":"247.2334","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4194"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4883"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5968"}})],1),_vm._v(" "),_c('path',{staticClass:"st49",attrs:{"id":"g35","d":"M552.5,247.2c0,0,2.6,14.1,2.6,15.6c0,1.5,0.5,30.8,0.5,30.8c0,14.6,10.1,30.6,11.8,34.1\n\t\t\tc2.6,5.5,6.8,13.5,10.6,13.5c1.7,0,1.8-1.7,1.8-3.9c0-2.6-1.8-5.8-1.8-10.7c0-19.3,1.8-24.8,1.8-29.4c0-2.1-0.9-9-1.2-17.4\n\t\t\tc-0.5-10.7,0.3-22.8,1.5-31.6L552.5,247.2z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g34_1_","gradientUnits":"userSpaceOnUse","x1":"5238.4775","y1":"337.1982","x2":"5238.4775","y2":"248.9463","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3602"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4417"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5699"}})],1),_vm._v(" "),_c('path',{staticClass:"st50",attrs:{"id":"g34","d":"M515.1,265.1c0,36.7,13.4,72.1,18.9,72.1c1.3,0,2.1-3.4,2.1-5.7c0-2.3-0.7-3.4-0.7-7\n\t\t\tc0-3.6,3.9-30.7,3.9-36.4c0-5.7-2.3-16.8-1.9-21.7c0.3-4.9,3.6-16.7,3.6-16.7l-28.7-0.7C512.4,248.9,515.1,254.7,515.1,265.1z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g33_1_","gradientUnits":"userSpaceOnUse","x1":"5199.3149","y1":"339.4541","x2":"5199.3149","y2":"250.6982","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4194"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4883"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.5968"}})],1),_vm._v(" "),_c('path',{staticClass:"st51",attrs:{"id":"g33","d":"M474.1,251.3c0,0,1.7,34.4,1.7,38.8c0,4.4,5.4,17.5,5.4,25.8c0,4.2,9.6,23.6,14.2,23.6\n\t\t\tc0.8,0,1.7-0.8,1.7-2.1c0-1.3-1.5-9.1-1.5-13.2s5-27.1,5-40.2c0-4.9-1.3-16.3-1.3-19.2s1.8-14.1,1.8-14.1L474.1,251.3z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g32_1_","gradientUnits":"userSpaceOnUse","x1":"5161.6948","y1":"339.4482","x2":"5161.6948","y2":"255.0381","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4086"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4922"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6237"}})],1),_vm._v(" "),_c('path',{staticClass:"st52",attrs:{"id":"g32","d":"M438.2,255.1c0,58,11.7,84.3,16.4,84.3c1.3,0,2.8-1.6,2.8-2.4c0-0.9-0.6-10.5,0-11.9\n\t\t\tc0.6-1.4,4.5-16.2,4.2-18.6c-0.3-2.4-1.5-51.4-1.5-51.4L438.2,255.1z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g31_1_","gradientUnits":"userSpaceOnUse","x1":"5126.2339","y1":"336.4502","x2":"5126.2339","y2":"252.3281","gradientTransform":"matrix(1 0 0 1 -4711.7773 0)"}},[_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3925"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4761"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.6075"}})],1),_vm._v(" "),_c('path',{staticClass:"st53",attrs:{"id":"g31","d":"M405.1,252.3c-1,43.2-2.2,42.6-2.2,50.6c0,4.5,3.2,11.5,3.2,17.3c0,8.7-3.4,13.5-3.4,14.2\n\t\t\tc0,1.2,0.4,2.1,2.3,2.1c12.9,0,21.2-26.5,21.2-84L405.1,252.3z"}})],1),_vm._v(" "),_c('g',{attrs:{"id":"gk2"}},[_c('linearGradient',{attrs:{"id":"g28_1_","gradientUnits":"userSpaceOnUse","x1":"5206.7998","y1":"129.1572","x2":"5206.7998","y2":"21.8506","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3065"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.5054"}})],1),_vm._v(" "),_c('path',{staticClass:"st54",attrs:{"id":"g28","d":"M740.7,22.2c1.4,0,12.2,3.2,12.2,33.1c0,9.9-0.6,32.4-0.6,39.8c0,4.8,4.7,27.3,4.7,31.2\n\t\t\tc0,6.5-40.1,0-40.1,0s5.5-21.5,5.5-28.1c0-6.6-5.5-25-5.5-35.4c0-10.4,10.7-35,10.7-37.2c0-2.2,1.9-3.8,2.8-3.8\n\t\t\tc0.9,0,3.9,2.5,3.9,8.7s-1.5,15-1.5,20.9c0,5.9,3.6,20.4,3.6,20.4s6.1-23,6.1-28.5c0-5.4-3.9-12.7-3.9-16.1\n\t\t\tC738.6,23.9,739.1,22.2,740.7,22.2z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g27_1_","gradientUnits":"userSpaceOnUse","x1":"5158.7939","y1":"129.1572","x2":"5158.7939","y2":"21.8506","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.2849"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4263"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.5161"}})],1),_vm._v(" "),_c('path',{staticClass:"st55",attrs:{"id":"g27","d":"M690.6,27.3c0,3.4,3.9,10.7,3.9,16.1c0,5.4-6.1,28.5-6.1,28.5s-3.6-14.5-3.6-20.4\n\t\t\tc0-5.9,1.5-14.7,1.5-20.9s-2.9-8.7-3.9-8.7s-2.8,1.6-2.8,3.8c0,2.2-10.8,26.7-10.8,37.2c0,10.4,5.5,28.9,5.5,35.4\n\t\t\tc0,6.5-5.5,28.1-5.5,28.1s40.1,6.5,40.1,0c0-4-4.7-26.4-4.7-31.2c0-7.4,0.6-29.9,0.6-39.8c0-29.9-10.9-33.1-12.2-33.1\n\t\t\tC691.1,22.2,690.6,23.9,690.6,27.3z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g26_1_","gradientUnits":"userSpaceOnUse","x1":"5109.3916","y1":"116.9522","x2":"5109.3916","y2":"23.3106","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.1989"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.3008"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3656"}})],1),_vm._v(" "),_c('path',{staticClass:"st56",attrs:{"id":"g26","d":"M622,110.2c0,5.3-0.3,6.8-0.3,6.8h35.6c-1.9-8.6,5-35.7,5-43c0-33.6-5.7-50.6-8-50.6\n\t\t\tc-1.1,0-2.4,2.8-2.4,4c0,2.5,0.6,5.1,0.6,6.7c-0.4,31.5-8.7,47.7-12.2,47.7c-2.6,0-6.1-11.8-6.1-15.4c0-3.6,1.5-16.3,1.5-25.8\n\t\t\tc0-3-2-17-5.1-17c-1.2,0-3.5,3-3.5,7.3c0,8.2-10.1,35.8-10.1,45.1C616.9,84.2,622,104.9,622,110.2z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g25_1_","gradientUnits":"userSpaceOnUse","x1":"5064.1104","y1":"130.0889","x2":"5064.1104","y2":"22.8428","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3172"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4191"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4839"}})],1),_vm._v(" "),_c('path',{staticClass:"st57",attrs:{"id":"g25","d":"M580.8,90.1c0,12.9,0.4,40,0.4,40h26.6c0,0-5.1-59.4-5.3-62.6c-0.4-4.8-4.9-19.8-4.9-28\n\t\t\tc0-6.6,0.5-8.6,0.5-10.7c0-1.8-1.8-6-4.4-6C584.7,22.8,580.8,63.6,580.8,90.1z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g24_1_","gradientUnits":"userSpaceOnUse","x1":"5027.0698","y1":"128.6455","x2":"5027.0698","y2":"23.5147","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3065"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.405"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4677"}})],1),_vm._v(" "),_c('path',{staticClass:"st58",attrs:{"id":"g24","d":"M562.8,21c1.4,0,1.9,1.6,1.9,3.3c0,6.2,4.6,24.7,4.6,43.7c0,7.6-0.3,52.2,0.3,55.6\n\t\t\tc1,5.7-24.7,0-24.7,0s1.1-39.3,1.1-43.9C546,64,554.6,21,562.8,21z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g23_1_","gradientUnits":"userSpaceOnUse","x1":"4984.7568","y1":"108.9756","x2":"4984.7568","y2":"19.7744","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.1344"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.2133"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.2634"}})],1),_vm._v(" "),_c('path',{staticClass:"st59",attrs:{"id":"g23","d":"M506.9,56c-0.3,5.1-5.1,12.6-5.1,29.6c0,4.2,0,4.1,0.2,23.4h23.7c0,0,2.3-25.7,2.3-35.3\n\t\t\tc0-9.6-4.9-35.9-4.9-38.7c0-2.8,2.1-12,2.1-13.2c0-1.1-0.9-2-2.1-2C515.9,19.8,507.4,45.8,506.9,56z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g22_1_","gradientUnits":"userSpaceOnUse","x1":"4943.9219","y1":"125.2822","x2":"4943.9219","y2":"19.9512","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.2742"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.3761"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4409"}})],1),_vm._v(" "),_c('path',{staticClass:"st60",attrs:{"id":"g22","d":"M461,125.3h25c0.7-9.3,1.3-43.3,1.3-53.4c0-12.2-3.1-22.4-3.1-25.6c0-1.3,0-20.9,0-23.6\n\t\t\tc0-2.7-2-2.8-2-2.8c-2,0-3.3,2.4-3.9,3.6c-0.6,1.2-1.3,1.5-2.2,3C460.9,53.3,461,125.3,461,125.3z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g21_1_","gradientUnits":"userSpaceOnUse","x1":"4897.5776","y1":"129.1885","x2":"4897.5776","y2":"19.4346","gradientTransform":"matrix(1 0 0 1 -4469.8047 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3011"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4227"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.5"}})],1),_vm._v(" "),_c('path',{staticClass:"st61",attrs:{"id":"g21","d":"M447.3,129.2c0,0-3.9-25.3-4.1-29.3c-0.2-4,0.3-24.8,0.3-31.9c0-14.6-6.7-34.6-6.7-41.3\n\t\t\tc0-2.9,0.8-3.2,0.8-5.5c0-1.2-1.4-1.8-2-1.8c-10.7,0-25.3,41.6-25.3,81.7c0,6.2-3.4,12.9-1.5,19.4L447.3,129.2z"}})],1),_vm._v(" "),_c('g',{attrs:{"id":"gk1"}},[_c('linearGradient',{attrs:{"id":"g18_1_","gradientUnits":"userSpaceOnUse","x1":"4807.083","y1":"129.1572","x2":"4807.083","y2":"21.8506","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3065"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.5054"}})],1),_vm._v(" "),_c('path',{staticClass:"st62",attrs:{"id":"g18","d":"M59.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2\n\t\t\tc0,6.5,40.1,0,40.1,0s-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8\n\t\t\tc-0.9,0-3.9,2.5-3.9,8.7s1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1\n\t\t\tC61.4,23.9,60.9,22.2,59.3,22.2z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g17_1_","gradientUnits":"userSpaceOnUse","x1":"4759.0776","y1":"129.1572","x2":"4759.0776","y2":"21.8506","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.2849"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4263"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.5161"}})],1),_vm._v(" "),_c('path',{staticClass:"st63",attrs:{"id":"g17","d":"M107.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2\n\t\t\tc0,6.5,40.1,0,40.1,0s-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8s-3.9,2.5-3.9,8.7\n\t\t\ts1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1C109.4,23.9,108.9,22.2,107.3,22.2z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g16_1_","gradientUnits":"userSpaceOnUse","x1":"4709.6748","y1":"116.9522","x2":"4709.6748","y2":"23.3106","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.1989"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.3008"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.3656"}})],1),_vm._v(" "),_c('path',{staticClass:"st64",attrs:{"id":"g16","d":"M183.1,76c0-9.3-10.1-36.9-10.1-45.1c0-4.3-2.3-7.3-3.5-7.3c-3.1,0-5.1,14-5.1,17\n\t\t\tc0,9.4,1.5,22.2,1.5,25.8c0,3.6-3.6,15.4-6.1,15.4c-3.6,0-11.8-16.3-12.2-47.7c0-1.7,0.6-4.2,0.6-6.7c0-1.2-1.3-4-2.4-4\n\t\t\tc-2.3,0-8,17-8,50.6c0,7.3,7,34.4,5,43h35.6c0,0-0.3-1.5-0.3-6.8C178,104.9,183.1,84.2,183.1,76z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g15_1_","gradientUnits":"userSpaceOnUse","x1":"4664.3936","y1":"130.0889","x2":"4664.3936","y2":"22.8428","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3172"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4191"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4839"}})],1),_vm._v(" "),_c('path',{staticClass:"st65",attrs:{"id":"g15","d":"M206.3,22.8c-2.6,0-4.4,4.2-4.4,6c0,2,0.5,4.1,0.5,10.7c0,8.1-4.5,23.1-4.9,28\n\t\t\tc-0.3,3.2-5.3,62.6-5.3,62.6h26.6c0,0,0.4-27.1,0.4-40C219.2,63.6,215.3,22.8,206.3,22.8z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g14_1_","gradientUnits":"userSpaceOnUse","x1":"4627.3535","y1":"128.6455","x2":"4627.3535","y2":"23.5147","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3065"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.405"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4677"}})],1),_vm._v(" "),_c('path',{staticClass:"st66",attrs:{"id":"g14","d":"M254,79.7c0,4.6,1.1,43.9,1.1,43.9s-25.7,5.7-24.7,0c0.6-3.5,0.3-48,0.3-55.6\n\t\t\tc0-19,4.6-37.4,4.6-43.7c0-1.7,0.5-3.3,1.9-3.3C245.4,21,254,64,254,79.7z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g13_1_","gradientUnits":"userSpaceOnUse","x1":"4585.04","y1":"108.9756","x2":"4585.04","y2":"19.7744","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.1344"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.2133"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.2634"}})],1),_vm._v(" "),_c('path',{staticClass:"st67",attrs:{"id":"g13","d":"M276.8,19.8c-1.3,0-2.1,0.9-2.1,2c0,1.2,2.1,10.4,2.1,13.2c0,2.8-4.9,29.1-4.9,38.7\n\t\t\tc0,9.6,2.3,35.3,2.3,35.3H298c0.2-19.3,0.2-19.2,0.2-23.4c0-17.1-4.8-24.5-5.1-29.6C292.6,45.8,284.1,19.8,276.8,19.8z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g12_1_","gradientUnits":"userSpaceOnUse","x1":"4544.2061","y1":"125.2822","x2":"4544.2061","y2":"19.9512","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.2742"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.3761"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.4409"}})],1),_vm._v(" "),_c('path',{staticClass:"st68",attrs:{"id":"g12","d":"M324,26.6c-0.9-1.5-1.6-1.8-2.2-3c-0.7-1.2-1.9-3.6-3.9-3.6c0,0-2,0.2-2,2.8c0,2.7,0,22.3,0,23.6\n\t\t\tc0,3.2-3.1,13.4-3.1,25.6c0,10,0.6,44.1,1.3,53.4h25C339,125.3,339.1,53.3,324,26.6z"}}),_vm._v(" "),_c('linearGradient',{attrs:{"id":"g11_1_","gradientUnits":"userSpaceOnUse","x1":"4497.8613","y1":"129.1885","x2":"4497.8613","y2":"19.4346","gradientTransform":"matrix(-1 0 0 1 4870.0742 0)"}},[_c('stop',{staticStyle:{"stop-color":"#FACCDE"},attrs:{"offset":"0.3011"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F6E8ED","stop-opacity":"0.3887"},attrs:{"offset":"0.4227"}}),_vm._v(" "),_c('stop',{staticStyle:{"stop-color":"#F4F4F4","stop-opacity":"0"},attrs:{"offset":"0.5"}})],1),_vm._v(" "),_c('path',{staticClass:"st69",attrs:{"id":"g11","d":"M391.2,120.5c2-6.5-1.5-13.2-1.5-19.4c0-40-14.7-81.7-25.3-81.7c-0.6,0-2,0.6-2,1.8\n\t\t\tc0,2.3,0.8,2.6,0.8,5.5c0,6.6-6.7,26.7-6.7,41.3c0,7.1,0.6,27.9,0.3,31.9c-0.3,4-4.1,29.3-4.1,29.3L391.2,120.5z"}})],1)]),_vm._v(" "),_c('g',{attrs:{"id":"teeth"}},[_c('g',{attrs:{"id":"k4"}},[_c('g',{attrs:{"id":"t48"}},[_c('path',{staticClass:"st1",attrs:{"d":"M40.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8\n\t\t\t\tc0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8\n\t\t\t\tc0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23\n\t\t\t\tC34.6,299.5,40.4,286.3,40.4,273.8z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_9",attrs:{"d":"M58.9,278.8c0,0,0.3-7.5,0-8.8c0,0-2.4,7.3-2.6,8.8c-0.2,1.6,0.1,0,0.1,0S57.7,274.9,58.9,278.8z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M59.2,268.4c0,0,2.6,6.3,2.6,26c0,7-2.2,22.1-2,24.3c0.2,2.2-1.2,11.5,0.2,13c0,0-0.7,1.2-1.4-7.9\n\t\t\t\tc-0.7-9.1-1.1-13-1.1-17c0-4,2.6-30.1,0.1-30c0,0-5,18.9-6,23c-0.9,4.2-3.8,12.6-4,13.3c-0.2,0.7-1.8,9.8-1.8,11.2\n\t\t\t\tc0,1.5-2.2,4.3-3.7,4.3c0,0,1.8-3.1,2.5-11.4c0.8-8.3,8.1-28.7,9.1-33.3C54.6,279.3,59.2,268.4,59.2,268.4z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M87,248.3c0,0-8.6,14.6-8.6,17.9c0,3.3-1.5,22.1-1.5,24.1c0,1.9-8.3,42.7-16.3,42.7c0,0,8.6-15,11.3-35.6\n\t\t\t\tc2.7-20.6,1-32.9,6.3-47.9L87,248.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M35.2,243.1c0,0,5.2,21.9,5.2,32.6c0,10.7-5.7,23.4-5.7,30.8c0,7.4,4.4,19.8,4.4,19.8s-2-15.8,0-26.2\n\t\t\t\tc2-10.4,5.2-14.4,5.2-30.1c0-15.7-3.6-26.8-3.6-26.8L35.2,243.1z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M91.4,236.6c0-8.4-4.9-11.4-7.2-13.1c-2.4-1.7-4.4-5.1-8.2-5.1c-4,0-15.3,7.1-15.5,7.1\n\t\t\t\t\tc-0.8,0-8.8-6.1-14.4-6.1c-4.8,0-11.8,4.4-11.8,18c0,14.1,18.6,28.8,24.5,28.8C71.4,266.2,91.4,251,91.4,236.6z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_6",attrs:{"d":"M62.8,224.2c0,0-1.3,6.3-1.3,10.8c0,4.5,2.5,8.2,2.5,8.2s-3-2.3-4.3-7.4c0,0-0.2,4.3-4.2,4.5\n\t\t\t\t\tc0,0,5.2-7.1,3.8-15.3C59.2,224.9,59.3,226.1,62.8,224.2z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M62.4,224.7c0,0-1.9,5.4-2.3,9.3c0,0,0.3-6.1-0.3-8.5C59.7,225.5,61.6,225.3,62.4,224.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_6",attrs:{"d":"M42.5,220.2c0,0-8.3,3.6-8.3,16.2c0,12.6,17.6,29.9,24.5,29.9c12.3,0,32.7-16.8,32.7-28.2\n\t\t\t\t\tc0-11.4,0-2.7,0-2.7c-2.4,10.4-15.7,23.8-31.2,23.8C53,259.1,39,250.7,39,234C39,223.8,42.5,220.2,42.5,220.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_6",attrs:{"d":"M76.9,221.1c-1.9,0-10.8,3.5-10.8,11.5c0,8,3.6,15.7,6.8,15.7s16.2-5.9,16-13.4\n\t\t\t\t\tc-0.2-7.4-3.2-6.9-4.8-7.7C82.6,226.5,80.9,221.1,76.9,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"st73",attrs:{"d":"M64.6,251.9c0,0-8.1,5.1-13.4-1c-5.2-6.1,3.2-6,5.9-6.8C59.7,243.4,68.2,250.4,64.6,251.9z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_6",attrs:{"d":"M57.5,228.4c0,0-1.2,5.7-5.2,9.6c-4,3.9-7.3,2.1-8.4,0c-3.2-6.3-0.4-16.1,3.1-16.1\n\t\t\t\t\tS58.5,225.2,57.5,228.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_6",attrs:{"d":"M71.9,220.2c0,0-9.4,7.2-10.4,13.5c0,0-0.2-7.1-4.8-9.8c0,0,2.1,2.3,5.4,0.9\n\t\t\t\t\tC65.4,223.2,71.9,220.2,71.9,220.2z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t47"}},[_c('path',{staticClass:"st1",attrs:{"d":"M99.4,273.8c0-14.8-5.8-26-5.8-34.4c0,0,53.5,0,53.7,4.4c0.2,4.3-10.1,19.1-10.1,23.8\n\t\t\t\tc0,3.5-0.9,15.4-0.9,15.4c0,22.6-12.4,50.2-15.9,50.2c-2.2,0-2.7-1.8-2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5-1.3-13.6-1.3-19.8\n\t\t\t\tc0-6.2,2.2-30.7,0.6-30.7c-1.2,0-6.2,21-6.7,24.9c-0.5,3.9-5.5,13.5-5.5,21.6c0,2.7-1.5,6.9-3.9,6.9c-3,0-7.4-12.8-7.4-23\n\t\t\t\tC93.6,299.5,99.4,286.3,99.4,273.8z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M118.2,268.4c0,0,2.6,6.3,2.6,26c0,7-2.2,22.1-2,24.3c0.2,2.2-1.2,11.5,0.2,13c0,0-0.7,1.2-1.4-7.9\n\t\t\t\tc-0.7-9.1-1.1-13-1.1-17c0-4,2.6-30.1,0.1-30c0,0-5,18.9-6,23c-0.9,4.2-3.8,12.6-4,13.3c-0.2,0.7-1.8,9.8-1.8,11.2\n\t\t\t\tc0,1.5-2.2,4.3-3.7,4.3c0,0,1.8-3.1,2.5-11.4c0.8-8.3,8.1-28.7,9.1-33.3C113.6,279.3,118.2,268.4,118.2,268.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M117.9,278.8c0,0,0.3-7.5,0-8.8c0,0-2.4,7.3-2.6,8.8c-0.2,1.6,0.1,0,0.1,0\n\t\t\t\tS116.7,274.9,117.9,278.8z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M146,248.3c0,0-8.6,14.6-8.6,17.9c0,3.3-1.5,22.1-1.5,24.1c0,1.9-8.3,42.7-16.3,42.7c0,0,8.6-15,11.3-35.6\n\t\t\t\tc2.7-20.6,1-32.9,6.3-47.9L146,248.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M94.2,243.1c0,0,5.2,21.9,5.2,32.6c0,10.7-5.7,23.4-5.7,30.8c0,7.4,4.4,19.8,4.4,19.8s-2-15.8,0-26.2\n\t\t\t\tc2-10.4,5.2-14.4,5.2-30.1c0-15.7-3.6-26.8-3.6-26.8L94.2,243.1z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M150.4,236.6c0-8.4-4.9-11.4-7.2-13.1c-2.4-1.7-4.4-5.1-8.2-5.1c-4,0-15.3,7.1-15.5,7.1\n\t\t\t\t\tc-0.8,0-8.8-6.1-14.4-6.1c-4.8,0-11.8,4.4-11.8,18c0,14.1,18.6,28.8,24.5,28.8C130.4,266.2,150.4,251,150.4,236.6z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M121.8,224.2c0,0-1.3,6.3-1.3,10.8c0,4.5,2.5,8.2,2.5,8.2s-3-2.3-4.3-7.4c0,0-0.2,4.3-4.2,4.5\n\t\t\t\t\tc0,0,5.2-7.1,3.8-15.3C118.2,224.9,118.3,226.1,121.8,224.2z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M121.4,224.7c0,0-1.9,5.4-2.3,9.3c0,0,0.3-6.1-0.3-8.5C118.8,225.5,120.6,225.3,121.4,224.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M101.5,220.2c0,0-8.3,3.6-8.3,16.2c0,12.6,17.6,29.9,24.5,29.9c12.3,0,32.7-16.8,32.7-28.2\n\t\t\t\t\tc0-11.4,0-2.7,0-2.7c-2.4,10.4-15.7,23.8-31.2,23.8c-7.2,0-21.2-8.5-21.2-25.1C98,223.8,101.5,220.2,101.5,220.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M135.9,221.1c-1.9,0-10.8,3.5-10.8,11.5c0,8,3.6,15.7,6.8,15.7s16.2-5.9,16-13.4\n\t\t\t\t\tc-0.2-7.4-3.2-6.9-4.8-7.7C141.6,226.5,139.9,221.1,135.9,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"st73",attrs:{"d":"M123.6,251.9c0,0-8.1,5.1-13.4-1c-5.2-6.1,3.2-6,5.9-6.8C118.8,243.4,127.2,250.4,123.6,251.9z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M116.5,228.4c0,0-1.2,5.7-5.2,9.6c-4,3.9-7.3,2.1-8.4,0c-3.2-6.3-0.4-16.1,3.1-16.1\n\t\t\t\t\tS117.5,225.2,116.5,228.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M130.9,219.8c0,0-9.4,7.6-10.4,13.9c0,0-0.2-7.1-4.8-9.8c0,0,2.4,2.3,5.6,0.9\n\t\t\t\t\tC124.6,223.2,130.9,219.8,130.9,219.8z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t46"}},[_c('path',{staticClass:"st1",attrs:{"d":"M156.1,246.8c0,0,5.9,15.8,5.9,21.5c0,8.6-10.1,47.2-10.1,56.7c0,6.6,1.6,10.1,3.2,10.1\n\t\t\t\tc1.6,0,5.4-5.8,5.4-8.8c0-1.5,6.3-9.9,12-28.4c2.8-9.2,8.1-10.7,9.2-10.7c2.3,0,4.8,7.2,4.8,15.6c0,8.4-2.8,26-3.2,27.4\n\t\t\t\tc-0.4,1.5-0.7,2.7-0.7,3.3c0,0.7,0,2.9,2,2.9c4.4,0,19.6-23.6,19.6-39.1c0-19.4-1.4-17.1-1.4-25.8c0-7,8.8-20.1,8.8-28.5\n\t\t\t\tL156.1,246.8z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M183.2,334c0,0,6.5-10.9,6.5-25.2c0-18.5-3.8-30-6.5-34.6c-2.7-4.7-6.8,6.8-7.8,9.6\n\t\t\t\tc-1,2.8-9.3,26-11.9,30.5s-6.4,16.8-7.5,17.8c-1.1,1,0.8,2,1.3,1.2c0.6-0.8,2.6-5.6,3.1-7c0.5-1.4,7.3-15.1,8.6-18.6\n\t\t\t\tc1.3-3.5,5.4-20.5,12.5-20.5c4.5,0,4.8,14.6,4.8,15.6C186.4,303.9,183.2,334,183.2,334z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M185.3,292.7c0,0-2.1-10.8-9.9-1.1C175.4,291.6,183.2,265.3,185.3,292.7z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M167.2,257.6c0,0,1,8.5-3,23.7c-4,15.2-11.2,45.6-12.2,47.4c0,0-0.7-3.1,0-7.2c2.6-15.3,9.9-51.1,9.9-53\n\t\t\t\tc0-2.4-5.2-20.8-5.2-20.8L167.2,257.6z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M197.2,261.7c0,0-2.3,11.7-1.1,14.7c1.2,2.9,7.4,17.6,4.5,30.4c-2.9,12.8-12.1,26.2-12.8,27.4\n\t\t\t\tc0,0,16.2-20,16.2-34.9c0-14.9-1.2-23-1.2-29.1c0-6.1,9.8-22.5,9.8-28.7L197.2,261.7z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st74",attrs:{"d":"M174.8,221.5c-4.9,0-7.1,2.2-9.3,6.1c0,0-2.5-3.9-6.4-3.9c-3.4,0-6.3,4.4-6.3,10.6\n\t\t\t\t\tc0,5.6,4.2,17.8,5.1,19.2c7.3,10.5,22,16.6,25.2,16.6c2,0,17-0.5,25-15.4c4.2-7.8,5.3-18.3,5.3-22.5c0-7.3-3.4-8.8-7.2-10.7\n\t\t\t\t\tc-3.8-1.9-4.5-3.1-6.8-3.1c-2.4,0-8.8,2.7-10.5,3.4c-1.7,0.8-3.8,3-3.5,3.9C184.7,223.3,178.9,221.5,174.8,221.5z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M190.5,221.1c0,0-2.4,11.3-1.7,15.6c0.6,4.2,1.6,7.5,1.6,7.5s-4-6.7-4.6-9.8c0,0,0.2,3.5-1.9,5.1\n\t\t\t\t\tc0,0,1.4-12.6-2.8-16.8c0,0,4.4,2,4.3,3.1C185.3,226.8,186.1,222.8,190.5,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"st75",attrs:{"d":"M188.9,221.9c0,0-2.2,6.1-2.9,10.7c0,0,0.1-5.2-2.4-8.7c0,0,1.8,0.6,2.3,1\n\t\t\t\t\tC186.3,225.3,186.3,222.4,188.9,221.9z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M167.2,225c0,0-3.3,4.7-1.8,10c0,0,0.3,0.9-0.4,0c-0.7-0.9-0.4-8.7-2.7-10.4c-2.3-1.7,0.2,0,0.2,0\n\t\t\t\t\ts2.5,2.6,2.9,2.7C165.6,227.4,166.2,225.6,167.2,225z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M157.3,224.1c0,0-2.7,15.1,3.2,22.7c5.8,7.6,16,13.5,20.5,8.6c7.9-8.6,2.8,1.5,12.6,1.5\n\t\t\t\t\tc6.3,0,13.5-0.2,18-11.8c0,0-6.4,24.9-28.5,24.9c-9.7,0-24.1-14.1-25.2-16.6c-1.1-2.5-5.1-13.1-5.1-20.9\n\t\t\t\t\tC152.8,227.3,157.3,224.1,157.3,224.1z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M200.2,221.1c0,0,2.7,4.2,3.5,4.4c0.8,0.2,3.2-0.2,5.3,2.7c2.2,2.9-0.2,15.5-3.5,19.2\n\t\t\t\t\tc0,0-5.5,2.2-9.1,2.2s-4.8-16.6-3.9-23.1C193.5,220,198,219.5,200.2,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M175.3,224.1c0,0-6.8,1.4-6.8,5.4c0,4.1,0.7,22.3,5.7,22.3s8.1-9.7,8.1-17.4\n\t\t\t\t\tC182.3,226.8,180,224.1,175.3,224.1z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M162.2,227.3c0,0-1.3-2.2-3-2c-1.7,0.2-1.3,6.5-0.8,7.3c0.5,0.8,3,2.6,3.8,1.9\n\t\t\t\t\tC163,233.8,163.5,228.7,162.2,227.3z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M198.8,264.9c0,0-8.9,5.2-15.7,5.2c-5.8,0-15.9-6.6-20.2-11C163,259,186.8,269.7,198.8,264.9z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t45"}},[_c('path',{staticClass:"st1",attrs:{"d":"M220,248.3c1.2,8.8,2,21,1.5,31.6c-0.4,8.3-1.2,15.3-1.2,17.4c0,4.6,1.8,10.1,1.8,29.4\n\t\t\t\tc0,4.8-1.8,8.1-1.8,10.7c0,2.1,0.1,3.9,1.8,3.9c3.8,0,8-8,10.6-13.5c1.6-3.5,11.8-19.5,11.8-34.1c0,0,0.5-29.3,0.5-30.8\n\t\t\t\tc0-1.5,2.6-15.6,2.6-15.6L220,248.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M230,255.6c0,0-3.2,23.7-2.8,32s-2.9,41.9-6.2,48.8c0,0,0.9-4.9,0.9-7.9s-1.7-26.4-1.7-31.3\n\t\t\t\tc0-4.9,1.4-17.4,1.4-22.9c0-5.5-1.4-27.6-1.4-27.6L230,255.6z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M246.6,251.9c0,0-1.8,8.8-1.8,11.7c0,2.9-0.6,33.1-0.6,33.1c0,7.9-15.2,44.5-21.7,44.5\n\t\t\t\tc0,0,18.5-28.4,18.5-43.8c0-15.4-1.8-34.2-0.6-44.1L246.6,251.9z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M232.9,218.4c-3.4,0-5.1,0.7-9.5,3.8c-2.5,1.8-6.6,2.3-7.5,5.5c-0.6,2.4-0.6,4.1-0.6,5.8\n\t\t\t\t\tc0,2.8,6.6,34.8,17.6,34.8c10.3,0,20-27.7,20-37.4c0-7.2-2.9-7.2-8.1-9.2C242.7,220.9,238,218.4,232.9,218.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M232.5,220.4c0,0-1.5,0-3.3,2.9c-1.9,2.9-11.1,2-10.2,12.1c0.4,4.8,6.3,26.2,13.5,26.2\n\t\t\t\t\tc7.2,0,15.7-12.1,20.2-27.5c0,0-8.4,34.2-19.7,34.2c-11.4,0-17.6-32.2-17.6-37.2c0-4.9,3.3-6.3,6-7.8\n\t\t\t\t\tC224,221.8,234.8,215.6,232.5,220.4z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M247.2,228.4c0,0,0.4,10.9-4.4,15.4c-4.8,4.5-13.8,3.3-14.8,0.5c-1-2.8,3.8-12.1,4.4-14.5\n\t\t\t\t\tc0.6-2.3,2.4-6.8,2.2-8.4c-0.1-1.6,2.2-2.2,5.2,0C243,223.6,247.5,224,247.2,228.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t44"}},[_c('path',{staticClass:"st1",attrs:{"d":"M287.6,248.9l-28.7,0.7c0,0,3.2,11.8,3.6,16.7c0.3,4.9-1.9,15.9-1.9,21.7c0,5.7,3.9,32.8,3.9,36.4\n\t\t\t\tc0,3.6-0.7,4.7-0.7,7c0,2.3,0.7,5.7,2.1,5.7c5.5,0,18.9-35.5,18.9-72.1C284.9,254.7,287.6,248.9,287.6,248.9z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M269.7,264.5c0,0-3.3,17.6-2.8,24c0.5,6.4,1.8,26.9,1.4,30.9c-0.4,4-1.2,17-2.4,17c-0.7,0-2.3-2-1.9-6\n\t\t\t\tc1.6-13.6-3.3-33.2-3.3-42.4c0-5.7,1.9-15.7,1.9-19.7s-3.2-21.5-3.2-21.5L269.7,264.5z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M284.9,254.2c-0.3,17.4-1.3,58.1-14.8,78.8c0,0,18.5-55.6,11.6-78.8H284.9z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M274.1,218.4c-3.2,0-4.1,0.6-5.6,2.1c-1.7,1.7-3.6,3.9-6.2,4.9c-2.3,0.9-6.5,6.8-6.5,11.2\n\t\t\t\t\tc0,5.5,5.9,33.3,17,33.3c7.1,0,20.1-24.4,20.1-34.5c0-6.5-5.9-8.3-10.9-12.5C280.5,221.6,277.8,218.4,274.1,218.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M272.3,218.7c0,0-0.9,4.5-3.4,7.2c-2.5,2.8-6.9,8.4-7.6,11.5c-0.8,3.1,4.5,23.7,10.8,23.7\n\t\t\t\t\ts15.9-10.1,19.9-19.8c0,0-10.6,28.6-19.1,28.6c-8.5,0-17-23-17-33.3c0-5.5,3.2-9.9,6.5-11.2C266,224,268.2,219.1,272.3,218.7z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M280.9,225.2c0,0,4.4,3.4,4.9,9.8c0.5,6.4-5.3,18.8-11.9,20.4c-6.6,1.6-8.5-7.1-8-12.9\n\t\t\t\t\tc0.5-5.8,5-8.2,6.4-10.3C275.1,227.8,274.8,219.4,280.9,225.2z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t43"}},[_c('path',{staticClass:"st1",attrs:{"d":"M299,250.7c0,0,1.8,11.2,1.8,14.1s-1.3,14.2-1.3,19.2c0,13.1,5,36,5,40.2S303,336,303,337.4\n\t\t\t\tc0,1.3,0.8,2.1,1.7,2.1c4.6,0,14.2-19.4,14.2-23.6c0-8.3,5.4-21.4,5.4-25.8c0-4.4,1.7-38.8,1.7-38.8L299,250.7z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M309.8,274.5c0,0-2.5,16.3-1.8,22.8c0.7,6.5,1,25.8-0.8,30.9c-1.8,5.1-3.1,11.6-3.6,10.8\n\t\t\t\tc-0.5-0.8,0.8-11.3,0.8-14.9c0-3.6-5-30.8-5-40.2c0-9.4,2.7-29.7,2.7-29.7L309.8,274.5z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M325,264.5l-0.8,25.5c0,0-5.4,20.1-5.4,24.3c0,4.1-8.3,19.8-9,20.7c0,0,5.4-14.3,6.7-20.7\n\t\t\t\tc1.2-6.4,6-44.7,4.9-48.8L325,264.5z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M314.5,216.7c-3.1,0-7.8,2.6-11.6,9.2c0,0-8.1,5.9-8.1,10.5c0,7.7,5.4,20.9,6,24.3c1,5.8,5.3,27,13.7,27\n\t\t\t\t\tc10.3,0,18.8-45.6,18.8-57.5c0-4.8-7.3-7-7.3-7S318,216.7,314.5,216.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M313,216.9c0,0-6.5,3.2-10.2,9c-1.4,2.3-2.1,2-2.1,2s-6,4-6,8.5c0,4.5,5.8,23.1,6,24.3\n\t\t\t\t\tc0.2,1.2,5.4,27,13.7,27c8.3,0,17-41.3,17-41.3s-10.2,33.3-16.5,33.3c-6.3,0-14.2-33.1-14.2-42.3\n\t\t\t\t\tC300.7,228.2,309,233.1,313,216.9z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M316.6,220.3c0,0,5.1,4.1,7.3,6.6c2.2,2.5,5.9,8.7,3.7,17c-2.2,8.3-8,21.7-11,22.2\n\t\t\t\t\tc-3,0.5-3.8-21.9-3.6-29.3C313.1,236.7,311,216.5,316.6,220.3z"}}),_vm._v(" "),_c('path',{staticClass:"st29",attrs:{"d":"M331.1,226.4c0,0-2.9-2.1-5.1-3.2c-2-1-5.4-2.6-4.2,0.6C322.9,227,332.4,233.2,331.1,226.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t42"}},[_c('path',{staticClass:"st1",attrs:{"d":"M339.9,255c0,0-1.2,49-1.5,51.4c-0.3,2.4,3.7,17.2,4.2,18.6c0.6,1.4,0,11.1,0,11.9c0,0.9,1.5,2.4,2.8,2.4\n\t\t\t\tc4.7,0,16.4-26.3,16.4-84.3L339.9,255z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M361.8,260.3c0,0-0.3,57.3-14,77.5c0,0,14-40.1,11.4-76L361.8,260.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M339.7,259c0,0-0.2,40.9-1.3,47.5c-0.5,3,3.3,15.5,4.2,18.6c0.9,3.1,0,11.4,0,11.4c3-2.7,6-33.4,6.4-39.1\n\t\t\t\tc0.3-5.7,0.5-26.3,0.5-26.3"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M361.1,221.4h-19.3c-2.8-0.1-6,0.2-6.5,6.2c-0.5,6.4,3.2,47.3,14.5,47.3c10.5,0,16.9-33.3,16.9-38.1\n\t\t\t\t\tc0-2.2,0-10.4,0-10.4C366.6,224.2,365.6,221.4,361.1,221.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M340.6,221.4c0,0-5.4-1.3-5.4,8.7c0,10,4.9,44.8,14.6,44.8c4.9,0,9.3-9.3,9.3-9.3\n\t\t\t\t\ts-4.5,4.2-9.4,4.2s-10.5-22.8-10.5-39C339.2,225,339.1,225.6,340.6,221.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M362,221.3c0,0,4.6,0,4.6,6.3c0,6.3-0.2,12.3-1,16.2C365.6,243.8,367.1,228.8,362,221.3z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M357.9,222.3h-14.7c0,0,0.1,11.9,1.4,19.1c1.2,7.2,3.7,12.3,8.9,12.3\n\t\t\t\t\tC359,253.6,366.7,222.3,357.9,222.3z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M355.6,221.4l1.2,0.2l1.7-0.2c0,0-0.8,6.1-1.4,6.1C356.5,227.5,356.7,221.4,355.6,221.4z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M346.3,221.4l-1.4,0.2l-1.9-0.2c0,0,0.9,6.1,1.6,6.1C345.3,227.5,345.1,221.4,346.3,221.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t41"}},[_c('path',{staticClass:"st1",attrs:{"d":"M373.8,252.4c0,57.5,8.3,84,21.2,84c1.9,0,2.3-0.8,2.3-2.1c0-0.7-3.4-5.4-3.4-14.2c0-5.8,3.2-12.8,3.2-17.3\n\t\t\t\tc0-8-1.2-7.4-2.2-50.6L373.8,252.4z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M385.5,262.2c0,0,5.4,27.6,4.6,38.8c-2,28.5,3.2,35.5,4.9,35.5c3.7,0,2.3-2.1,2.3-2.1s-3.4-5.9-3.4-13.3\n\t\t\t\t\tc0-7.4,3.2-16,3.2-18.2c0-2.2-2.1-44.7-2.1-44.7L385.5,262.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M374.3,261.8c0,0-1,51.3,9.8,66.5c0,0-8.1-47.9-5.9-66.5H374.3z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M397.2,224.7c0-1.3-0.9-3.1-3.4-3.1c-2.2,0-17.2,0-17.6,0c-2.1,0-7.4,1.6-7.4,3.1\n\t\t\t\t\tc0,24.1,8.2,55.8,15.2,55.8c8.3,0,13.2-30.7,13.2-37.5C397.2,236.3,397.2,224.7,397.2,224.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M397.2,228.4c0,31.4-5.8,52.1-13.2,52.1c-3.9,0-7.7-10.4-8.8-14c-1.1-3.6,3.2,7.9,9.5,7.9\n\t\t\t\t\tc8.9,0,12.4-55.1,12.4-50.6C397.1,225.7,397.2,228.4,397.2,228.4z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M392.9,225c0,0-3,10.6-4.2,15.6c-1.8,7.8-1.2,18.7-7.4,18.7c-5.5,0-8.5-34.7-3.9-35.7\n\t\t\t\t\tC382.1,222.6,392.9,221.4,392.9,225z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M386.5,221.7l1.2,0.3l1.7-0.3c0,0-0.8,8.7-1.4,8.7C387.4,230.4,387.6,221.8,386.5,221.7z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M379,221.7l-1.3,0.3l-1.8-0.3c0,0,0.8,10,1.5,10C378,231.7,377.8,221.8,379,221.7z"}})])])]),_vm._v(" "),_c('g',{attrs:{"id":"k3"}},[_c('g',{attrs:{"id":"t38"}},[_c('path',{staticClass:"st1",attrs:{"d":"M759.6,273.8c0-14.8,5.8-26,5.8-34.4c0,0-53.5,0-53.7,4.4c-0.2,4.3,10.1,19.1,10.1,23.8\n\t\t\t\tc0,3.5,0.9,15.4,0.9,15.4c0,22.6,12.4,50.2,15.9,50.2c2.2,0,2.7-1.8,2.7-2.9c0-1.1,0-3.7,0-3.7c0-1.5,1.3-13.6,1.3-19.8\n\t\t\t\tc0-6.2-2.2-30.7-0.6-30.7c1.2,0,6.2,21,6.7,24.9c0.5,3.9,5.5,13.5,5.5,21.6c0,2.7,1.5,6.9,3.9,6.9c3,0,7.4-12.8,7.4-23\n\t\t\t\tC765.4,299.5,759.6,286.3,759.6,273.8z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_9",attrs:{"d":"M741.1,278.8c0,0-0.3-7.5,0-8.8c0,0,2.4,7.3,2.6,8.8c0.2,1.6-0.1,0-0.1,0S742.3,274.9,741.1,278.8\n\t\t\t\tz"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M740.8,268.4c0,0-2.6,6.3-2.6,26c0,7,2.2,22.1,2,24.3c-0.2,2.2,1.2,11.5-0.2,13c0,0,0.7,1.2,1.4-7.9\n\t\t\t\tc0.7-9.1,1.1-13,1.1-17c0-4-2.6-30.1-0.1-30c0,0,5,18.9,6,23c0.9,4.2,3.8,12.6,4,13.3c0.2,0.7,1.8,9.8,1.8,11.2\n\t\t\t\tc0,1.5,2.2,4.3,3.7,4.3c0,0-1.8-3.1-2.5-11.4c-0.8-8.3-8.1-28.7-9.1-33.3C745.4,279.3,740.8,268.4,740.8,268.4z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M713,248.3c0,0,8.6,14.6,8.6,17.9c0,3.3,1.5,22.1,1.5,24.1c0,1.9,8.3,42.7,16.3,42.7c0,0-8.6-15-11.3-35.6\n\t\t\t\tc-2.7-20.6-1-32.9-6.3-47.9L713,248.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M764.8,243.1c0,0-5.2,21.9-5.2,32.6c0,10.7,5.7,23.4,5.7,30.8c0,7.4-4.4,19.8-4.4,19.8s2-15.8,0-26.2\n\t\t\t\tc-2-10.4-5.2-14.4-5.2-30.1c0-15.7,3.6-26.8,3.6-26.8L764.8,243.1z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M708.6,236.6c0-8.4,4.9-11.4,7.2-13.1c2.4-1.7,4.4-5.1,8.2-5.1c4,0,15.3,7.1,15.5,7.1\n\t\t\t\t\tc0.8,0,8.8-6.1,14.4-6.1c4.8,0,11.8,4.4,11.8,18c0,14.1-18.6,28.8-24.5,28.8C728.6,266.2,708.6,251,708.6,236.6z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_6",attrs:{"d":"M737.2,224.2c0,0,1.3,6.3,1.3,10.8c0,4.5-2.5,8.2-2.5,8.2s3-2.3,4.3-7.4c0,0,0.2,4.3,4.2,4.5\n\t\t\t\t\tc0,0-5.2-7.1-3.8-15.3C740.7,224.9,740.7,226.1,737.2,224.2z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M737.6,224.7c0,0,1.9,5.4,2.3,9.3c0,0-0.3-6.1,0.3-8.5C740.2,225.5,738.4,225.3,737.6,224.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_6",attrs:{"d":"M757.5,220.2c0,0,8.3,3.6,8.3,16.2c0,12.6-17.6,29.9-24.5,29.9c-12.3,0-32.7-16.8-32.7-28.2\n\t\t\t\t\tc0-11.4,0-2.7,0-2.7c2.4,10.4,15.7,23.8,31.2,23.8c7.2,0,21.2-8.5,21.2-25.1C761,223.8,757.5,220.2,757.5,220.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_6",attrs:{"d":"M723.1,221.1c1.9,0,10.8,3.5,10.8,11.5c0,8-3.6,15.7-6.8,15.7s-16.2-5.9-16-13.4\n\t\t\t\t\tc0.2-7.4,3.2-6.9,4.8-7.7C717.4,226.5,719.1,221.1,723.1,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"st73",attrs:{"d":"M735.4,251.9c0,0,8.1,5.1,13.4-1c5.2-6.1-3.2-6-5.9-6.8C740.2,243.4,731.8,250.4,735.4,251.9z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_6",attrs:{"d":"M742.5,228.4c0,0,1.2,5.7,5.2,9.6c4,3.9,7.3,2.1,8.4,0c3.2-6.3,0.4-16.1-3.1-16.1\n\t\t\t\t\tS741.5,225.2,742.5,228.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_6",attrs:{"d":"M728.1,220.2c0,0,9.4,7.2,10.4,13.5c0,0,0.2-7.1,4.8-9.8c0,0-2.1,2.3-5.4,0.9\n\t\t\t\t\tC734.6,223.2,728.1,220.2,728.1,220.2z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t37"}},[_c('path',{staticClass:"st1",attrs:{"d":"M706.4,306.5c0,10.2-4.4,23-7.4,23c-2.3,0-3.9-4.1-3.9-6.9c0-8.1-5-17.6-5.5-21.6\n\t\t\t\tc-0.5-3.9-5.4-24.9-6.7-24.9c-1.6,0,0.6,24.5,0.6,30.7c0,6.2-1.3,18.3-1.3,19.8c0,0,0,2.6,0,3.7c0,1.1-0.5,2.9-2.7,2.9\n\t\t\t\tc-3.5,0-15.9-27.6-15.9-50.2c0,0-0.9-11.9-0.9-15.4c0-4.6-10.3-19.4-10.1-23.8c0.2-4.3,53.7-4.4,53.7-4.4\n\t\t\t\tc0,8.4-5.8,19.6-5.8,34.4C700.6,286.3,706.4,299.5,706.4,306.5z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M681.8,268.4c0,0-2.6,6.3-2.6,26c0,7,2.2,22.1,2,24.3c-0.2,2.2,1.2,11.5-0.2,13c0,0,0.7,1.2,1.4-7.9\n\t\t\t\tc0.7-9.1,1.1-13,1.1-17c0-4-2.6-30.1-0.1-30c0,0,5,18.9,6,23c0.9,4.2,3.8,12.6,4,13.3c0.2,0.7,1.8,9.8,1.8,11.2\n\t\t\t\tc0,1.5,2.2,4.3,3.7,4.3c0,0-1.8-3.1-2.5-11.4c-0.8-8.3-8.1-28.7-9.1-33.3C686.4,279.3,681.8,268.4,681.8,268.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M682.1,278.8c0,0-0.3-7.5,0-8.8c0,0,2.4,7.3,2.6,8.8c0.2,1.6-0.1,0-0.1,0S683.2,274.9,682.1,278.8\n\t\t\t\tz"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M654,248.3c0,0,8.6,14.6,8.6,17.9c0,3.3,1.5,22.1,1.5,24.1c0,1.9,8.3,42.7,16.3,42.7c0,0-8.6-15-11.3-35.6\n\t\t\t\tc-2.7-20.6-1-32.9-6.3-47.9L654,248.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M705.8,243.1c0,0-5.2,21.9-5.2,32.6c0,10.7,5.7,23.4,5.7,30.8c0,7.4-4.4,19.8-4.4,19.8s2-15.8,0-26.2\n\t\t\t\tc-2-10.4-5.2-14.4-5.2-30.1c0-15.7,3.6-26.8,3.6-26.8L705.8,243.1z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M649.6,236.6c0-8.4,4.9-11.4,7.2-13.1c2.4-1.7,4.4-5.1,8.2-5.1c4,0,15.3,7.1,15.5,7.1\n\t\t\t\t\tc0.8,0,8.8-6.1,14.4-6.1c4.8,0,11.8,4.4,11.8,18c0,14.1-18.6,28.8-24.5,28.8C669.6,266.2,649.6,251,649.6,236.6z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M678.2,224.2c0,0,1.3,6.3,1.3,10.8c0,4.5-2.5,8.2-2.5,8.2s3-2.3,4.3-7.4c0,0,0.2,4.3,4.2,4.5\n\t\t\t\t\tc0,0-5.2-7.1-3.8-15.3C681.7,224.9,681.7,226.1,678.2,224.2z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M678.6,224.7c0,0,1.9,5.4,2.3,9.3c0,0-0.3-6.1,0.3-8.5C681.2,225.5,679.4,225.3,678.6,224.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M698.5,220.2c0,0,8.3,3.6,8.3,16.2c0,12.6-17.6,29.9-24.5,29.9c-12.3,0-32.7-16.8-32.7-28.2\n\t\t\t\t\tc0-11.4,0-2.7,0-2.7c2.4,10.4,15.7,23.8,31.2,23.8c7.2,0,21.2-8.5,21.2-25.1C702,223.8,698.5,220.2,698.5,220.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M664.1,221.1c1.9,0,10.8,3.5,10.8,11.5c0,8-3.6,15.7-6.8,15.7s-16.2-5.9-16-13.4\n\t\t\t\t\tc0.2-7.4,3.2-6.9,4.8-7.7C658.4,226.5,660.1,221.1,664.1,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"st73",attrs:{"d":"M676.4,251.9c0,0,8.1,5.1,13.4-1c5.2-6.1-3.2-6-5.9-6.8C681.2,243.4,672.8,250.4,676.4,251.9z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M683.4,228.4c0,0,1.2,5.7,5.2,9.6c4,3.9,7.3,2.1,8.4,0c3.2-6.3,0.4-16.1-3.1-16.1\n\t\t\t\t\tS682.5,225.2,683.4,228.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M669.1,219.8c0,0,9.4,7.6,10.4,13.9c0,0,0.2-7.1,4.8-9.8c0,0-2.4,2.3-5.6,0.9\n\t\t\t\t\tC675.4,223.2,669.1,219.8,669.1,219.8z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t36"}},[_c('path',{staticClass:"st1",attrs:{"d":"M588.5,243.2c0,8.4,8.8,21.5,8.8,28.5c0,8.7-1.4,6.3-1.4,25.8c0,15.4,15.2,39.1,19.6,39.1c2,0,2-2.2,2-2.9\n\t\t\t\tc0-0.7-0.3-1.9-0.7-3.3c-0.4-1.5-3.2-19-3.2-27.4c0-8.4,2.5-15.6,4.8-15.6c1.1,0,6.3,1.5,9.2,10.7c5.7,18.5,12,26.9,12,28.4\n\t\t\t\tc0,3,3.8,8.8,5.4,8.8c1.6,0,3.2-3.5,3.2-10.1c0-9.5-10.1-48.2-10.1-56.7c0-5.7,5.9-21.5,5.9-21.5L588.5,243.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M616.8,334c0,0-6.5-10.9-6.5-25.2c0-18.5,3.8-30,6.5-34.6c2.7-4.7,6.8,6.8,7.8,9.6c1,2.8,9.3,26,11.9,30.5\n\t\t\t\ts6.4,16.8,7.5,17.8c1.1,1-0.8,2-1.3,1.2c-0.6-0.8-2.6-5.6-3.1-7c-0.5-1.4-7.3-15.1-8.6-18.6c-1.3-3.5-5.4-20.5-12.5-20.5\n\t\t\t\tc-4.5,0-4.8,14.6-4.8,15.6C613.6,303.9,616.8,334,616.8,334z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M614.7,292.7c0,0,2.1-10.8,9.9-1.1C624.6,291.6,616.8,265.3,614.7,292.7z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M632.8,257.6c0,0-1,8.5,3,23.7c4,15.2,11.2,45.6,12.2,47.4c0,0,0.7-3.1,0-7.2c-2.6-15.3-9.9-51.1-9.9-53\n\t\t\t\tc0-2.4,5.2-20.8,5.2-20.8L632.8,257.6z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M602.8,261.7c0,0,2.3,11.7,1.1,14.7c-1.2,2.9-7.4,17.6-4.5,30.4c2.9,12.8,12.1,26.2,12.8,27.4\n\t\t\t\tc0,0-16.2-20-16.2-34.9c0-14.9,1.2-23,1.2-29.1c0-6.1-9.8-22.5-9.8-28.7L602.8,261.7z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st74",attrs:{"d":"M625.2,221.5c4.9,0,7.1,2.2,9.3,6.1c0,0,2.5-3.9,6.4-3.9c3.4,0,6.3,4.4,6.3,10.6c0,5.6-4.2,17.8-5.1,19.2\n\t\t\t\t\tc-7.3,10.5-22,16.6-25.2,16.6c-2,0-17-0.5-25-15.4c-4.2-7.8-5.3-18.3-5.3-22.5c0-7.3,3.4-8.8,7.2-10.7c3.8-1.9,4.5-3.1,6.8-3.1\n\t\t\t\t\tc2.4,0,8.8,2.7,10.5,3.4c1.7,0.8,3.8,3,3.5,3.9C615.3,223.3,621.1,221.5,625.2,221.5z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M609.5,221.1c0,0,2.4,11.3,1.7,15.6c-0.6,4.2-1.6,7.5-1.6,7.5s4-6.7,4.6-9.8c0,0-0.2,3.5,1.9,5.1\n\t\t\t\t\tc0,0-1.4-12.6,2.8-16.8c0,0-4.4,2-4.3,3.1C614.7,226.8,613.9,222.8,609.5,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"st75",attrs:{"d":"M611.1,221.9c0,0,2.2,6.1,2.9,10.7c0,0-0.1-5.2,2.4-8.7c0,0-1.8,0.6-2.3,1\n\t\t\t\t\tC613.7,225.3,613.6,222.4,611.1,221.9z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M632.8,225c0,0,3.3,4.7,1.8,10c0,0-0.3,0.9,0.4,0c0.7-0.9,0.4-8.7,2.7-10.4c2.3-1.7-0.2,0-0.2,0\n\t\t\t\t\ts-2.5,2.6-2.9,2.7C634.4,227.4,633.7,225.6,632.8,225z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M642.7,224.1c0,0,2.7,15.1-3.2,22.7c-5.8,7.6-16,13.5-20.5,8.6c-7.9-8.6-2.8,1.5-12.6,1.5\n\t\t\t\t\tc-6.3,0-13.5-0.2-18-11.8c0,0,6.4,24.9,28.5,24.9c9.7,0,24.1-14.1,25.2-16.6c1.1-2.5,5.1-13.1,5.1-20.9\n\t\t\t\t\tC647.1,227.3,642.7,224.1,642.7,224.1z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M599.8,221.1c0,0-2.7,4.2-3.5,4.4c-0.8,0.2-3.2-0.2-5.3,2.7c-2.2,2.9,0.2,15.5,3.5,19.2\n\t\t\t\t\tc0,0,5.5,2.2,9.1,2.2c3.7,0,4.8-16.6,3.9-23.1C606.5,220,602,219.5,599.8,221.1z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M624.7,224.1c0,0,6.8,1.4,6.8,5.4c0,4.1-0.7,22.3-5.7,22.3s-8.1-9.7-8.1-17.4\n\t\t\t\t\tC617.7,226.8,620,224.1,624.7,224.1z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M637.8,227.3c0,0,1.3-2.2,3-2c1.7,0.2,1.3,6.5,0.8,7.3c-0.5,0.8-3,2.6-3.8,1.9\n\t\t\t\t\tC637,233.8,636.5,228.7,637.8,227.3z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M601.2,264.9c0,0,8.9,5.2,15.7,5.2c5.8,0,15.9-6.6,20.2-11C637,259,613.2,269.7,601.2,264.9z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t35"}},[_c('path',{staticClass:"st1",attrs:{"d":"M552.5,247.2c0,0,2.6,14.1,2.6,15.6c0,1.5,0.5,30.8,0.5,30.8c0,14.6,10.1,30.6,11.8,34.1\n\t\t\t\tc2.6,5.5,6.8,13.5,10.6,13.5c1.7,0,1.8-1.7,1.8-3.9c0-2.6-1.8-5.8-1.8-10.7c0-19.3,1.8-24.8,1.8-29.4c0-2.1-0.9-9-1.2-17.4\n\t\t\t\tc-0.5-10.7,0.3-22.8,1.5-31.6L552.5,247.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M570,255.6c0,0,3.2,23.7,2.8,32s2.9,41.9,6.2,48.8c0,0-0.9-4.9-0.9-7.9s1.7-26.4,1.7-31.3\n\t\t\t\tc0-4.9-1.4-17.4-1.4-22.9c0-5.5,1.4-27.6,1.4-27.6L570,255.6z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M553.4,251.9c0,0,1.8,8.8,1.8,11.7c0,2.9,0.6,33.1,0.6,33.1c0,7.9,15.2,44.5,21.7,44.5\n\t\t\t\tc0,0-18.5-28.4-18.5-43.8c0-15.4,1.8-34.2,0.6-44.1L553.4,251.9z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M567.1,218.4c3.4,0,5.1,0.7,9.5,3.8c2.5,1.8,6.6,2.3,7.5,5.5c0.6,2.4,0.6,4.1,0.6,5.8\n\t\t\t\t\tc0,2.8-6.6,34.8-17.6,34.8c-10.3,0-20-27.7-20-37.4c0-7.2,2.9-7.2,8.1-9.2C557.3,220.9,562,218.4,567.1,218.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M567.5,220.4c0,0,1.5,0,3.3,2.9c1.9,2.9,11.1,2,10.2,12.1c-0.4,4.8-6.3,26.2-13.5,26.2\n\t\t\t\t\tc-7.2,0-15.7-12.1-20.2-27.5c0,0,8.4,34.2,19.7,34.2c11.4,0,17.6-32.2,17.6-37.2c0-4.9-3.3-6.3-6-7.8\n\t\t\t\t\tC576,221.8,565.2,215.6,567.5,220.4z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M552.7,228.4c0,0-0.4,10.9,4.4,15.4c4.8,4.5,13.8,3.3,14.8,0.5c1-2.8-3.8-12.1-4.4-14.5\n\t\t\t\t\tc-0.6-2.3-2.4-6.8-2.2-8.4c0.1-1.6-2.2-2.2-5.2,0C557,223.6,552.5,224,552.7,228.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t34"}},[_c('path',{staticClass:"st1",attrs:{"d":"M515.1,265.1c0,36.7,13.4,72.1,18.9,72.1c1.3,0,2.1-3.4,2.1-5.7c0-2.3-0.7-3.4-0.7-7\n\t\t\t\tc0-3.6,3.9-30.7,3.9-36.4c0-5.7-2.3-16.8-1.9-21.7c0.3-4.9,3.6-16.7,3.6-16.7l-28.7-0.7C512.4,248.9,515.1,254.7,515.1,265.1z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M530.3,264.5c0,0,3.3,17.6,2.8,24c-0.5,6.4-1.8,26.9-1.4,30.9c0.4,4,1.2,17,2.4,17c0.7,0,2.3-2,1.9-6\n\t\t\t\tc-1.6-13.6,3.3-33.2,3.3-42.4c0-5.7-1.9-15.7-1.9-19.7s3.2-21.5,3.2-21.5L530.3,264.5z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M515.1,254.2c0.3,17.4,1.3,58.1,14.8,78.8c0,0-18.5-55.6-11.6-78.8H515.1z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M525.9,218.4c3.2,0,4.1,0.6,5.6,2.1c1.7,1.7,3.6,3.9,6.2,4.9c2.3,0.9,6.5,6.8,6.5,11.2\n\t\t\t\t\tc0,5.5-5.9,33.3-17,33.3c-7.1,0-20.1-24.4-20.1-34.5c0-6.5,5.9-8.3,10.9-12.5C519.5,221.6,522.2,218.4,525.9,218.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M527.7,218.7c0,0,0.9,4.5,3.4,7.2c2.5,2.8,6.9,8.4,7.6,11.5c0.8,3.1-4.5,23.7-10.8,23.7\n\t\t\t\t\tS512,251,508.1,241.3c0,0,10.6,28.6,19.1,28.6c8.5,0,17-23,17-33.3c0-5.5-3.2-9.9-6.5-11.2C534,224,531.8,219.1,527.7,218.7z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M519.1,225.2c0,0-4.4,3.4-4.9,9.8c-0.5,6.4,5.3,18.8,11.9,20.4c6.6,1.6,8.5-7.1,8-12.9\n\t\t\t\t\tc-0.5-5.8-5-8.2-6.4-10.3C524.8,227.8,525.2,219.4,519.1,225.2z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t33"}},[_c('path',{staticClass:"st1",attrs:{"d":"M474.1,251.3c0,0,1.7,34.4,1.7,38.8c0,4.4,5.4,17.5,5.4,25.8c0,4.2,9.6,23.6,14.2,23.6\n\t\t\t\tc0.8,0,1.7-0.8,1.7-2.1c0-1.3-1.5-9.1-1.5-13.2s5-27.1,5-40.2c0-4.9-1.3-16.3-1.3-19.2s1.8-14.1,1.8-14.1L474.1,251.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M490.2,274.5c0,0,2.5,16.3,1.8,22.8c-0.7,6.5-1,25.8,0.8,30.9c1.8,5.1,3.1,11.6,3.6,10.8\n\t\t\t\tc0.5-0.8-0.8-11.3-0.8-14.9c0-3.6,5-30.8,5-40.2c0-9.4-2.7-29.7-2.7-29.7L490.2,274.5z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M474.9,264.5l0.8,25.5c0,0,5.4,20.1,5.4,24.3c0,4.1,8.3,19.8,9,20.7c0,0-5.4-14.3-6.7-20.7\n\t\t\t\tc-1.2-6.4-6-44.7-4.9-48.8L474.9,264.5z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M485.5,216.7c3.1,0,7.8,2.6,11.6,9.2c0,0,8.1,5.9,8.1,10.5c0,7.7-5.4,20.9-6,24.3c-1,5.8-5.3,27-13.7,27\n\t\t\t\t\tc-10.3,0-18.8-45.6-18.8-57.5c0-4.8,7.3-7,7.3-7S482,216.7,485.5,216.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M487,216.9c0,0,6.5,3.2,10.2,9c1.4,2.3,2.1,2,2.1,2s6,4,6,8.5c0,4.5-5.8,23.1-6,24.3\n\t\t\t\t\tc-0.2,1.2-5.4,27-13.7,27c-8.3,0-17-41.3-17-41.3s10.2,33.3,16.5,33.3c6.3,0,14.2-33.1,14.2-42.3\n\t\t\t\t\tC499.2,228.2,491,233.1,487,216.9z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M483.4,220.3c0,0-5.1,4.1-7.3,6.6c-2.2,2.5-5.9,8.7-3.7,17c2.2,8.3,8,21.7,11,22.2\n\t\t\t\t\tc3,0.5,3.8-21.9,3.6-29.3C486.9,236.7,489,216.5,483.4,220.3z"}}),_vm._v(" "),_c('path',{staticClass:"st29",attrs:{"d":"M468.9,226.4c0,0,2.9-2.1,5.1-3.2c2-1,5.4-2.6,4.2,0.6C477.1,227,467.6,233.2,468.9,226.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t32"}},[_c('path',{staticClass:"st1",attrs:{"d":"M438.2,255.1c0,58,11.7,84.3,16.4,84.3c1.3,0,2.8-1.6,2.8-2.4c0-0.9-0.6-10.5,0-11.9\n\t\t\t\tc0.6-1.4,4.5-16.2,4.2-18.6c-0.3-2.4-1.5-51.4-1.5-51.4L438.2,255.1z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M438.2,260.3c0,0,0.3,57.3,14,77.5c0,0-14-40.1-11.4-76L438.2,260.3z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M460.3,259c0,0,0.2,40.9,1.3,47.5c0.5,3-3.3,15.5-4.2,18.6c-0.9,3.1,0,11.4,0,11.4c-3-2.7-6-33.4-6.4-39.1\n\t\t\t\tc-0.3-5.7-0.5-26.3-0.5-26.3"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M438.9,221.4h19.3c2.8-0.1,6,0.2,6.5,6.2c0.5,6.4-3.2,47.3-14.5,47.3c-10.5,0-16.9-33.3-16.9-38.1\n\t\t\t\t\tc0-2.2,0-10.4,0-10.4C433.4,224.2,434.3,221.4,438.9,221.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M459.4,221.4c0,0,5.4-1.3,5.4,8.7c0,10-4.9,44.8-14.6,44.8c-4.9,0-9.3-9.3-9.3-9.3\n\t\t\t\t\ts4.5,4.2,9.4,4.2s10.5-22.8,10.5-39C460.8,225,460.9,225.6,459.4,221.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M438,221.3c0,0-4.6,0-4.6,6.3c0,6.3,0.2,12.3,1,16.2C434.3,243.8,432.9,228.8,438,221.3z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M442.1,222.3h14.7c0,0-0.1,11.9-1.4,19.1c-1.2,7.2-3.7,12.3-8.9,12.3\n\t\t\t\t\tC440.9,253.6,433.2,222.3,442.1,222.3z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M444.4,221.4l-1.2,0.2l-1.7-0.2c0,0,0.8,6.1,1.4,6.1C443.4,227.5,443.2,221.4,444.4,221.4z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M453.6,221.4l1.4,0.2l1.9-0.2c0,0-0.9,6.1-1.6,6.1C454.7,227.5,454.9,221.4,453.6,221.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t31"}},[_c('path',{staticClass:"st1",attrs:{"d":"M405.1,252.3c-1,43.2-2.2,42.6-2.2,50.6c0,4.5,3.2,11.5,3.2,17.3c0,8.7-3.4,13.5-3.4,14.2\n\t\t\t\tc0,1.2,0.4,2.1,2.3,2.1c12.9,0,21.2-26.5,21.2-84L405.1,252.3z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M414.5,262.2c0,0-5.4,27.6-4.6,38.8c2,28.5-3.2,35.5-4.9,35.5c-3.7,0-2.3-2.1-2.3-2.1s3.4-5.9,3.4-13.3\n\t\t\t\t\tc0-7.4-3.2-16-3.2-18.2c0-2.2,2.1-44.7,2.1-44.7L414.5,262.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M425.7,261.8c0,0,1,51.3-9.8,66.5c0,0,8.1-47.9,5.9-66.5H425.7z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M402.7,224.7c0-1.3,0.9-3.1,3.4-3.1c2.2,0,17.2,0,17.6,0c2.1,0,7.4,1.6,7.4,3.1c0,24.1-8.2,55.8-15.2,55.8\n\t\t\t\t\tc-8.3,0-13.2-30.7-13.2-37.5C402.7,236.3,402.7,224.7,402.7,224.7z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_7",attrs:{"d":"M402.7,228.4c0,31.4,5.8,52.1,13.2,52.1c3.9,0,7.7-10.4,8.8-14c1.1-3.6-3.2,7.9-9.5,7.9\n\t\t\t\t\tc-8.9,0-12.4-55.1-12.4-50.6C402.9,225.7,402.7,228.4,402.7,228.4z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_7",attrs:{"d":"M407.1,225c0,0,3,10.6,4.2,15.6c1.8,7.8,1.2,18.7,7.4,18.7c5.5,0,8.5-34.7,3.9-35.7\n\t\t\t\t\tC417.9,222.6,407.1,221.4,407.1,225z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M413.5,221.7l-1.2,0.3l-1.7-0.3c0,0,0.8,8.7,1.4,8.7C412.6,230.4,412.4,221.8,413.5,221.7z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M421,221.7l1.3,0.3l1.8-0.3c0,0-0.8,10-1.5,10C422,231.7,422.2,221.8,421,221.7z"}})])])]),_vm._v(" "),_c('g',{attrs:{"id":"k2"}},[_c('g',{attrs:{"id":"t28"}},[_c('path',{staticClass:"st1",attrs:{"d":"M740.7,22.2c1.4,0,12.2,3.2,12.2,33.1c0,9.9-0.6,32.4-0.6,39.8c0,4.8,4.7,27.3,4.7,31.2c0,6.5-40.1,0-40.1,0\n\t\t\t\ts5.5-21.5,5.5-28.1c0-6.6-5.5-25-5.5-35.4c0-10.4,10.7-35,10.7-37.2c0-2.2,1.9-3.8,2.8-3.8c0.9,0,3.9,2.5,3.9,8.7\n\t\t\t\ts-1.5,15-1.5,20.9c0,5.9,3.6,20.4,3.6,20.4s6.1-23,6.1-28.5c0-5.4-3.9-12.7-3.9-16.1C738.6,23.9,739.1,22.2,740.7,22.2z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M730.5,21.9c0,0,1.8,3.8,1,7.8c-0.8,4-3,21.4-3,26.5c0,2,6.3,18.1,7.9,29.8c0,0,0.7-11.5,0-14\n\t\t\t\t\tc0,0-3.6-15.9-3.6-21.1c0-5.2,1.5-14.5,1.5-21.2C734.4,23,730.5,21.9,730.5,21.9z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M732.6,54.3c0,0,0,0.1,0.1,0.4c0.4,3.7,3.6,30,4.1,33.3c0.5,3.6-0.1,5.6-0.1,5.6s0.9-6.5,0.3-14.7\n\t\t\t\t\tc-0.7-8.2,4.1-15,5.8-32.7c0,0-5.5,24.1-6,25.1"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M742.7,22.8c0,0,6.4,11.2,6.7,21.9c0.3,10.7-3.4,36.9-3.4,45s9.5,38.5,9.5,38.5l1.5-0.6\n\t\t\t\t\tc0,0-4.8-27.8-4.8-31.5c0-3.8,0.4-35.3,0.4-48.5C752.6,30.8,742.7,22.8,742.7,22.8z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M759.6,133.3c0,12.9-4.4,19.6-8.3,19.6c-1.2,0-9-4.8-9.6-4.8c-1.8,0-11.2,7.2-13.5,7.2\n\t\t\t\t\tc-2.3,0-4.5-2.6-5.5-3c-1-0.4-9-3.4-9-10.1c0-6.7,4.1-33.2,25.9-33.2C743.6,109,759.6,115.9,759.6,133.3z"}}),_vm._v(" "),_c('path',{staticClass:"st75",attrs:{"d":"M735.7,128.2c0,0,5.1,2,5.5,8.9c0.4,6.9,1.3,8.9-0.6,11.3c0,0,1.4-1.4,2.9,0.5c0,0-1.4-4-1-7.7\n\t\t\t\t\tc0.4-3.8-0.9-7.3,2.4-10.3c0,0-2.8,1-3.2,3C741.6,133.9,740.7,130.2,735.7,128.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_9",attrs:{"d":"M743.6,138.3c0,0-0.9-3.2,2.5-6.2c3.4-3,6.5-7.3,7.8-6.1c1.2,1.2,3.2,12,2.5,14.8\n\t\t\t\t\tc-0.8,2.8-1.2,7.9-3.8,8.7c-2.5,0.9-7-0.6-7.8-2.1C744.1,145.9,743.5,140.8,743.6,138.3z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M735.7,130.9c0,0,1.8,3.9,1.8,8.6c0,3-0.8,9.4-4,11.2c-1.5,0.8-5.8,3.8-7,2.3c-1.3-1.5-4.1-3.2-6-4\n\t\t\t\t\tc-1.9-0.8-5.5-4.6-5.3-6.8c0.3-2.2,0.8-10.4,4-14C722.5,124.6,733.2,125.1,735.7,130.9z"}}),_vm._v(" "),_c('path',{staticClass:"st78",attrs:{"d":"M724.1,119.2c0,0,11,4.8,13.9,7.8c2.9,2.9,9.9-6.2,11.2-7.8c1.4-1.6-6.8-11.3-17.8-6.7\n\t\t\t\t\tC722.4,116.2,724.1,119.2,724.1,119.2z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_10",attrs:{"d":"M754.5,118c0,0,5.2,8.3,5.2,14.1c0,5.8-2.1,20.7-7.9,20.7c-5.8,0-6.9-4.2-10-4.9\n\t\t\t\t\tc-3-0.7-11.3,8-13.5,7.3c-2.1-0.6-9.2-4.8-9.6-5.1s7.1,3.3,8.9,3.2c1.8-0.1,11.7-7.3,14.2-7.3s6.7,3.8,10,3.8\n\t\t\t\t\tc3.3,0,6.4-5,6.4-16.7C758.1,128.9,754.5,118,754.5,118z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M742.5,43.4c0-4.2-2.4-9.6-3.4-13.4c-0.2,0.3-0.3,0.7-0.3,1.2c0,1.4,0.5,9.8,0.5,9.8\n\t\t\t\t\tc0,4.5-2.8,14.8-4.9,21.5c1,4.9,2,9.3,2,9.3S742.5,48.9,742.5,43.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t27"}},[_c('path',{staticClass:"st1",attrs:{"d":"M690.6,27.3c0,3.4,3.9,10.7,3.9,16.1c0,5.4-6.1,28.5-6.1,28.5s-3.6-14.5-3.6-20.4c0-5.9,1.5-14.7,1.5-20.9\n\t\t\t\ts-2.9-8.7-3.9-8.7s-2.8,1.6-2.8,3.8c0,2.2-10.8,26.7-10.8,37.2c0,10.4,5.5,28.9,5.5,35.4c0,6.5-5.5,28.1-5.5,28.1\n\t\t\t\ts40.1,6.5,40.1,0c0-4-4.7-26.4-4.7-31.2c0-7.4,0.6-29.9,0.6-39.8c0-29.9-10.9-33.1-12.2-33.1C691.1,22.2,690.6,23.9,690.6,27.3z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M682.5,21.9c0,0,1.8,3.8,1,7.8c-0.8,4-3,21.4-3,26.5c0,2,6.3,18.1,7.9,29.8c0,0,0.7-11.5,0-14\n\t\t\t\t\tc0,0-3.6-15.9-3.6-21.1c0-5.2,1.5-14.5,1.5-21.2C686.4,23,682.5,21.9,682.5,21.9z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M684.6,54.3c0,0,0,0.1,0.1,0.4c0.4,3.7,3.6,30,4.1,33.3c0.5,3.6-0.1,5.6-0.1,5.6s0.9-6.5,0.3-14.7\n\t\t\t\t\tc-0.7-8.2,4.1-15,5.8-32.7c0,0-5.5,24.1-6,25.1"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M694.7,22.8c0,0,6.4,11.2,6.7,21.9c0.3,10.7-3.4,36.9-3.4,45s9.5,38.5,9.5,38.5l1.5-0.6\n\t\t\t\t\tc0,0-4.8-27.8-4.8-31.5c0-3.8,0.4-35.3,0.4-48.5C704.6,30.8,694.7,22.8,694.7,22.8z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M711.6,133.3c0,12.9-4.4,19.6-8.3,19.6c-1.2,0-9-4.8-9.6-4.8c-1.8,0-11.2,7.2-13.5,7.2s-4.5-2.6-5.5-3\n\t\t\t\t\tc-1-0.4-9-3.4-9-10.1c0-6.7,4.1-33.2,25.9-33.2C695.6,109,711.6,115.9,711.6,133.3z"}}),_vm._v(" "),_c('path',{staticClass:"st75",attrs:{"d":"M687.7,128.2c0,0,5.1,2,5.5,8.9c0.4,6.9,1.3,8.9-0.6,11.3c0,0,1.4-1.4,2.9,0.5c0,0-1.4-4-1-7.7\n\t\t\t\t\tc0.4-3.8-0.9-7.3,2.4-10.3c0,0-2.8,1-3.2,3C693.6,133.9,692.7,130.2,687.7,128.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M695.6,138.3c0,0-0.9-3.2,2.5-6.2c3.4-3,6.5-7.3,7.8-6.1c1.2,1.2,3.2,12,2.5,14.8\n\t\t\t\t\tc-0.8,2.8-1.2,7.9-3.8,8.7c-2.5,0.9-7-0.6-7.8-2.1C696.1,145.9,695.5,140.8,695.6,138.3z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M687.7,130.9c0,0,1.8,3.9,1.8,8.6c0,3-0.8,9.4-4,11.2c-1.5,0.8-5.8,3.8-7,2.3c-1.2-1.5-4.1-3.2-6-4\n\t\t\t\t\tc-1.9-0.8-5.5-4.6-5.3-6.8c0.3-2.2,0.8-10.4,4-14C674.5,124.6,685.2,125.1,687.7,130.9z"}}),_vm._v(" "),_c('path',{staticClass:"st78",attrs:{"d":"M676.1,119.2c0,0,11,4.8,13.9,7.8c2.9,2.9,9.9-6.2,11.2-7.8c1.4-1.6-6.8-11.3-17.8-6.7\n\t\t\t\t\tC674.4,116.2,676.1,119.2,676.1,119.2z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M706.4,118c0,0,5.2,8.3,5.2,14.1c0,5.8-2.1,20.7-7.9,20.7c-5.8,0-6.9-4.2-10-4.9\n\t\t\t\t\tc-3-0.7-11.3,8-13.5,7.3c-2.1-0.6-9.2-4.8-9.6-5.1s7.1,3.3,8.9,3.2c1.8-0.1,11.7-7.3,14.2-7.3s6.7,3.8,10,3.8\n\t\t\t\t\tc3.3,0,6.4-5,6.4-16.7C710.1,128.9,706.4,118,706.4,118z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M694.5,43.4c0-4.2-2.4-9.6-3.4-13.4c-0.2,0.3-0.3,0.7-0.3,1.2c0,1.4,0.5,9.8,0.5,9.8\n\t\t\t\t\tc0,4.5-2.8,14.8-4.9,21.5c1,4.9,2,9.3,2,9.3S694.5,48.9,694.5,43.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t26"}},[_c('path',{staticClass:"st1",attrs:{"d":"M622,110.2c0,5.3-0.3,6.8-0.3,6.8h35.6c-1.9-8.6,5-35.7,5-43c0-33.6-5.7-50.6-8-50.6c-1.1,0-2.4,2.8-2.4,4\n\t\t\t\tc0,2.5,0.6,5.1,0.6,6.7c-0.4,31.5-8.7,47.7-12.2,47.7c-2.6,0-6.1-11.8-6.1-15.4c0-3.6,1.5-16.3,1.5-25.8c0-3-2-17-5.1-17\n\t\t\t\tc-1.2,0-3.5,3-3.5,7.3c0,8.2-10.1,35.8-10.1,45.1C616.9,84.2,622,104.9,622,110.2z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M631.2,24.8c0,0,2.2,10.2,2.2,15.2c0,4.9-2.2,17-2.2,27.1s6.3,20.7,9.3,22.6\n\t\t\t\t\tc0,0,8.3-8.3,9.5-29.9c0,0-4.6,21.7-10.1,21.7c-2.9,0-6.2-14.5-6.2-15.4c0-0.8,2-20,2-24.9C635.7,36.4,633.6,25,631.2,24.8z"}}),_vm._v(" "),_c('path',{staticClass:"st79",attrs:{"d":"M636.2,77c3,6.7,2,12.2,4.3,15.3c0,0,1.1-8.9,3.8-15.3c0,0-2.5,4.9-3.8,4.9C639.2,82,636.2,77,636.2,77z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M623,49.2c0,0-6.1,20.9-6.1,26.9c0,5.9,4.8,21.3,4.8,42h9.5C631.2,118,616.3,89.7,623,49.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M657.6,29.6c0,0,2.1,27.2,1.1,43.7s-9.7,42-9.7,42l7.1-1.7c0,0,1.5-13.3,2.2-14.4c0.7-1.1,4-20,4-25.4\n\t\t\t\t\tS660.9,32.3,657.6,29.6z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M664,134.4c0,0,0.4,6.6-2.4,9.5c-2.9,2.9-7.1,7.1-7.1,7.1c-0.3,0.4-1.4,1.6-2.3,1.6c-0.9,0-8.6-6-9.3-6\n\t\t\t\t\tc-0.7,0-8.7,8.8-14.9,8.8c-2.1,0-4.2-2.8-5.7-3.4c-1.5-0.5-8-2.4-8-9.1c0-4.8,3.4-9.6,8.1-28c1.8-6.8,14.4-16.3,18.7-16.3\n\t\t\t\t\tC653.5,98.5,664,122.5,664,134.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M646.1,102c0,0,4.8,5.7,5.1,8.3c0.4,2.7,2.2,8.8,5.9,12.5c3.6,3.8,6,14.3,3.9,18.2\n\t\t\t\t\tc-2.1,3.9-6,8.6-6,8.6s6.7-4.7,7.8-7.7c1.2-2.9,1-6.2,1-9.8c0,0-1.7-22.3-17.7-32.3C646.1,99.8,643,97.8,646.1,102z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M641.7,144.3c0,0-0.6-5.4-0.6-8.4c0-2.9-1.3-7-4-8.9c-2.8-1.8-1.8-1.8-1.8-1.8s5.7,1.9,6.7,5.6\n\t\t\t\t\tc0,0,3.5-3.2,7.8-4c0,0-5.2,3-6.4,6.6c-1.1,3.6-0.7,9,0.2,10.8c0.8,1.8,6.9,6.7,8.3,7.3c1.4,0.6-1.8,0.1-8-4.9\n\t\t\t\t\tc-0.3-0.3-0.9-0.4-0.9-0.4s-3.4,3.8-5.6,4.7C635.2,151.8,640.1,149,641.7,144.3z"}}),_vm._v(" "),_c('path',{staticClass:"st73",attrs:{"d":"M637.4,122.4c0,0,3.8,2.2,4.8,3.9c1,1.7,3.1-0.2,5.4-1c2.2-0.8,2.8-4.6,2.4-7.1c-0.4-2.5-2.8-7.5-6.2-10.8\n\t\t\t\t\tc-3.4-3.3-2.8-1.6-3.6,0.8C639.4,110.5,633.9,119.9,637.4,122.4z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M635.1,127.9c0,0,4,2.1,4.5,4.3c0.5,2.2,0.4,6.6,0,9.4c-0.4,2.8-1.9,5.5-3.4,7.4\n\t\t\t\t\tc-5.8,7.1-10.9,3-12.4,1.8c-1.5-1.3-9.7-3.6-5.8-12.3c1.5-3.3,7.4-11.7,9-12.2C628.7,125.7,633.6,126.9,635.1,127.9z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M643.1,139.5c0,0,0.5,4.2,6.9,10c2.9,2.7,4.3-0.7,4.3-0.7c0,0,3.6-4.8,4.2-10.4c0.6-5.6,0.1-12.5-2.9-12.5\n\t\t\t\t\tc-1.8,0-7.1,2.5-8.6,4.1C645.5,131.6,643.4,132.6,643.1,139.5z"}}),_vm._v(" "),_c('path',{staticClass:"st29",attrs:{"d":"M656.9,111.1c0,0,7.1,16.8,7.1,24.4c0,7.6-10.9,17.1-11.8,17.1c-1,0-9.5-5.9-9.5-5.9s-10.8,8.7-14.7,8.7\n\t\t\t\t\ts-5.7-3.4-5.7-3.4s-7.2-3.2-8-7.6c0,0,6.3,3.4,9.7,6.3c3.4,2.9,15.5-2.8,18.4-5.9c1.2-1.3,1.5,0,2.5,1c1,1,6,4,7.4,4.1\n\t\t\t\t\tc1.4,0.1,9.5-7.6,9.5-14.8C661.7,127.8,657.6,113.1,656.9,111.1z"}})]),_vm._v(" "),_c('g',[_c('g',[_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M634.1,66.3c0,3.6,3.6,15.4,6.1,15.4c2.9,0,8.9-10.9,11.3-32c-1.3-12.4-3-23.4-3.5-25.6\n\t\t\t\t\t\t\tc-0.8-3.9-2.8-3.7-2.8-3.7c-0.5,0-0.9,0.1-1.3,0.3c-4.2,1.9-5,13-6.3,16.2c-0.4,1-1.2,2.1-2,3.2c0,0.1,0,0.3,0,0.4\n\t\t\t\t\t\t\tC635.6,50,634.1,62.7,634.1,66.3z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st79",attrs:{"d":"M640.2,81.7c2.7,0,8.1-9.4,10.8-27.8c-3.2,14.1-9.2,21.7-10.1,22c-1,0.4-3.2-5.1-4.6-10.9\n\t\t\t\t\t\t\tc-1.3-5.6-0.8-18-0.8-18.8c-0.4,8.3-1.4,17.2-1.4,20.1C634.1,69.9,637.6,81.7,640.2,81.7z"}})])]),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M644.4,20.5C644.4,20.5,644.4,20.5,644.4,20.5c0,0.2,4.9,23.2,2.2,49.6c1.6-5,3.1-11.5,4-19.6\n\t\t\t\t\tc-0.1-1.6-0.2-3.2-0.4-4.8c-1-8.5-2-15.8-2.7-19.4C646.7,22.7,645.7,20.5,644.4,20.5z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t25"}},[_c('path',{staticClass:"st1",attrs:{"d":"M580.8,90.1c0,12.9,0.4,40,0.4,40h26.6c0,0-5.1-59.4-5.3-62.6c-0.4-4.8-4.9-19.8-4.9-28\n\t\t\t\tc0-6.6,0.5-8.6,0.5-10.7c0-1.8-1.8-6-4.4-6C584.7,22.8,580.8,63.6,580.8,90.1z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M596.3,30.1c0,0-2.7,10-3,26.9c-0.3,17,7.5,56.4,7.5,56.4l6.5,2l-2.4-25l-2.6-25.9c0,0-4.6-16.3-4.6-20.4\n\t\t\t\t\tC597.7,40.2,598,28.7,596.3,30.1z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M583.8,124c0,0,0.1-74.7,1.4-82.8c0,0-4.2,26.2-4.3,38.1c-0.1,11.9,0.2,45.8,0.2,45.8L583.8,124z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M594,106.5c5.7,0,17.8,16.4,17.8,31.7c0,8.5-4,6.2-7.8,9.7c-3.8,3.6-7.7,7.4-10.7,7.4\n\t\t\t\t\tc-1.6,0-16.9-5.1-16.9-11.6C576.4,136.9,584.1,106.5,594,106.5z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M596.3,107.2c0,0,3.9,6.9,4.3,9.9c0.3,3,2.1,9.4,1.9,16.7c-0.2,7.3-4.7,13.7-3.4,15.5\n\t\t\t\t\tc1.8,2.4,4.9-3.2,7.9-3.4c3-0.2,5.2-4.8,4.3-12.2C610.5,126.4,606.7,113.3,596.3,107.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M595,114.4c0,0,3.7,7.5,2.5,14.2c-1.2,6.7-0.7,13.3-1,16.9c-0.3,3.6-1.5,7.4-4.3,7.4\n\t\t\t\t\tc-2.2,0-5-4-7.2-6.5c-2.2-2.5-4.3-4-4.3-8.2C580.7,135.6,590.8,102.4,595,114.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t24"}},[_c('path',{staticClass:"st1",attrs:{"d":"M562.8,21c1.4,0,1.9,1.6,1.9,3.3c0,6.2,4.6,24.7,4.6,43.7c0,7.6-0.3,52.2,0.3,55.6c1,5.7-24.7,0-24.7,0\n\t\t\t\ts1.1-39.3,1.1-43.9C546,64,554.6,21,562.8,21z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M563.9,27.2c0,0-2.3,26.6-2,29.7l1,50.4l6.4,6.2l-0.1-26.9c0,0,0.7-30.1-1.3-36.5\n\t\t\t\t\tC566,43.7,564.9,27.6,563.9,27.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M553.9,39.2c0,0-8.1,21.3-8.1,47.5c0,16.7,0,29.5,0,29.5l3.2-9.9C549,106.2,550.1,52.4,553.9,39.2z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M557.3,101.9c4.1,0,8.8,2.4,13.1,17.9c3,10.8,4.5,14,4.5,18.5c0,4.5-0.9,9.8-10.2,12.8\n\t\t\t\t\tc-4.7,1.5-5.9,4.3-8.7,4.3c-3.8,0-8.1-4.1-11.1-4.9c-3-0.8-7.3-2.9-7.3-9.9C537.6,134.7,547.3,101.9,557.3,101.9z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M557.5,104.5c0,0,3.8,1.9,4.7,6.9c0.8,5,6.3,13.6,6.5,14.6c0.2,1,1.4,12.3-2,16.7\n\t\t\t\t\tc-3.3,4.4-7.7,6.7-9.2,8.2c-1.5,1.5-5.5-1.3-7.7-1.7c-2.2-0.4-4.7-3.1-7.3-2.5c-2.6,0.6-2.1,2,0.9,3.1c3,1.1,10.6,5.4,12.6,5.4\n\t\t\t\t\tc2,0,10.3-5.8,13.3-6.3c3-0.5,5.6-8.1,5.6-10.7c0-2.6-8-36.3-16.3-36.3S557.5,104.5,557.5,104.5z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M552.5,106.5c0,0-6.3,10.4-7.8,16.1c-1.5,5.6-1.8,8.9-1.7,12.4c0.2,3.5,0,4.8,4.7,7.5\n\t\t\t\t\tc4.8,2.7,6.6,6.5,8.5,5.4s1.6-13.2,1.6-19.3c0-6-0.2-10,0-13.4C558,111.9,556,104.4,552.5,106.5z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t23"}},[_c('path',{staticClass:"st1",attrs:{"d":"M506.9,56c-0.3,5.1-5.1,12.6-5.1,29.6c0,4.2,0,4.1,0.2,23.4h23.7c0,0,2.3-25.7,2.3-35.3\n\t\t\t\tc0-9.6-4.9-35.9-4.9-38.7c0-2.8,2.1-12,2.1-13.2c0-1.1-0.9-2-2.1-2C515.9,19.8,507.4,45.8,506.9,56z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M523.6,20.8c0,0-6.4,26.3-5.4,33.5c1,7.2,3.5,30.6,2.6,41.7c-0.9,11.1,2.8,17.7,2.8,17.7l1.8-3.6l1.2-14.9\n\t\t\t\t\tc0,0,1.4-17.8,1.4-24.5c0-6.7-4.8-33.9-4.8-38.1C523.2,28.4,524.2,18.5,523.6,20.8z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M506.1,58.2c0,0-1.4,46.6,2.4,59.9c0.9,3.1,0,1.3,0,1.3l-5.9,0.6c0,0-0.7-22.9-0.7-32.4\n\t\t\t\t\tC501.9,72.2,506.1,58.2,506.1,58.2z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M514.2,87.6c7.5,0,15.2,12.5,15.2,23.7c0,4.9,7,19,7,24.3c0,5.7-9,10.8-9,10.8s-7.4,8.9-12.4,8.9\n\t\t\t\t\tc-6.7,0-13.1-6.2-13.1-6.2s-8.1-2.4-8.1-5.6C493.8,140.2,499.6,87.6,514.2,87.6z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M519.8,151.3c1.3-5.6,4.2-10,6-10.9c5.6-2.9,6.2-5,6.2-5.2c0.8-11.2-7.8-22.1-7.6-25.9\n\t\t\t\t\tc0.2-3.8-5.3-14.4-8.2-15c-2.8-0.6-8,0-10.5,7.5c-0.8,2.4-8.2,34.6-9,38.6c-0.8,4.1-2.5,5-2.8,4c-0.3-1,0-4.1,0.2-6.2\n\t\t\t\t\tc0.3-2,7-50.6,19.9-50.6c12.9,0,14.5,19,14.5,22c0,0,2.9,10,4.3,13.7c1.3,3.7,5.7,12.4,2,16.3c-3.7,3.9-6.6,5.7-7.6,6.7\n\t\t\t\t\tC526.5,147.5,518.7,156.2,519.8,151.3z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M498.5,143.3c0,0,3.9-0.4,6.2,1.2c2.3,1.6,3.1,6,8.1,6.1c5,0.2,2.3-6.5,2.3-12.1\n\t\t\t\t\tc0-5.5-1.3-17.5-1.8-21.5c-0.5-3.9-0.8-15-1.5-16.7c-0.7-1.8-3.8,3.2-4.9,7.9C505.8,113,495.5,140.8,498.5,143.3z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t22"}},[_c('path',{staticClass:"st1",attrs:{"d":"M461,125.3h25c0.7-9.3,1.3-43.3,1.3-53.4c0-12.2-3.1-22.4-3.1-25.6c0-1.3,0-20.9,0-23.6c0-2.7-2-2.8-2-2.8\n\t\t\t\tc-2,0-3.3,2.4-3.9,3.6c-0.6,1.2-1.3,1.5-2.2,3C460.9,53.3,461,125.3,461,125.3z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M483.2,20.1c0,0-4.6,32.2-5.9,43.6C476,75.1,479.2,116,479,120c-0.2,4,5.3,6.4,7,5.2\n\t\t\t\t\tc1.7-1.2,0-20.1,0-20.1s1.3-31.9,1.3-34.6c0-2.7-3.1-21.5-3.1-26.2C484.2,39.6,485.9,21.1,483.2,20.1z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M468.1,44.7c0,0-6.9,48-6.9,68c0,8.6-0.1,11.1,2.9,9.3c0,0,4.4-3,4-8.2C467.7,108.4,466.1,58.6,468.1,44.7\n\t\t\t\t\tz"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M452.1,148.3c0,3.6,1.2,5.2,3.6,5.2c3.6,0,6.8,0.5,7.8,0.5s4.2,1.3,6.7,1.3c3.7,0,6-2.7,7.2-2.7\n\t\t\t\t\tc2.2,0,14.1-0.1,14.1-16.7c0-14-12.5-40.7-19-40.7C462.5,95.2,452.1,136.5,452.1,148.3z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M456.6,123.7c0,0,6.9-19.5,15.1-20.6s13.6,16.6,14.3,22.1c2,16.2-4.4,25.1-6.3,26.9\n\t\t\t\t\tc0,0,7.2-2.4,8.6-5.6c2.4-5.2,5.7-17.9-3.6-35.4C475.5,93.7,472,95,470.9,95.5C469.9,96.1,460.1,102.2,456.6,123.7z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M453.7,148c0,0,8.4-21.9,17.5-21.9c9,0,14.2,14,10.9,18.8c-3.3,4.8-8.8,8.6-12,8\n\t\t\t\t\tc-3.2-0.7-8.3-0.8-11.5-0.8C455.3,152.2,452.2,151.5,453.7,148z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M473.8,150.9c0,0,3.6-2.2,4.3-7.4c0,0,1.1,4.6,0.9,6.8C478.8,152.6,471.1,153.8,473.8,150.9z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t21"}},[_c('path',{staticClass:"st1",attrs:{"d":"M447.3,129.2c0,0-3.9-25.3-4.1-29.3c-0.2-4,0.3-24.8,0.3-31.9c0-14.6-6.7-34.6-6.7-41.3\n\t\t\t\tc0-2.9,0.8-3.2,0.8-5.5c0-1.2-1.4-1.8-2-1.8c-10.7,0-25.3,41.6-25.3,81.7c0,6.2-3.4,12.9-1.5,19.4L447.3,129.2z"}}),_vm._v(" "),_c('g',[_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M434.8,19.4c0,0-4.2,14.4-5.3,30.9c-1,16.5-2,59.4,0,65.9c2,6.5,13.2,9.9,13.9,5.8\n\t\t\t\t\t\tc0.7-4.1-0.2-16.9-0.2-22.9c-0.1-6,0.2-21.2,0.2-28.5c0-14.9-6.6-43.7-6.6-46.5S438,19.8,434.8,19.4z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M417.2,49c0,0-4.7,53.2-1.3,63.6c0,0-1.5,9.3-3.9,3.6c-2.4-5.7-1.9-13.1-1.8-17.7\n\t\t\t\t\t\tC410.4,93.9,413.5,52.8,417.2,49z"}})])]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M403,153.9c0,0,8.9,2.1,14.8,0.7c0,0,9.8,1.6,15.4-0.1c0,0,11.6,0.7,14.4-1.7c2.8-2.4,2.9-9.2,2.9-11.9\n\t\t\t\t\tc0-15.3-11.8-53.8-22.9-53.8c-10.5,0-24.5,22.2-24.5,49.5C403.1,141.7,403,147.8,403,153.9z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M405.1,118.6c0,0,8.2-31,21.8-31c10.6,0,16.4,21,20.8,35.6c1.1,3.7,3.3,18.2,2,15.5\n\t\t\t\t\tc-5.6-12-7.8-10.2-11.8-22.7c-15.3-48.1-29.6,0.3-34.3,11.1L405.1,118.6z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M406.2,149.4c0,0,4.5-26.1,17-30.9c5.9-2.3,7.2,7.5,11.6,14.2c4.3,6.8,9.4,10.5,10.5,14\n\t\t\t\t\tc1.1,3.5-3.8,6.4-9.4,5.5c-5.6-0.9-7.8,0.8-12.5,0.2C418.6,151.9,403,155.4,406.2,149.4z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M416,154.9l1.8-0.3l2.4,0.3c0,0-1.1-10.1-2.1-10.1C417.3,144.8,417.6,154.8,416,154.9z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M431.2,154.9l1.7-0.3l2.4,0.3c0,0-1.1-10.1-2.1-10.1C432.5,144.8,432.8,154.8,431.2,154.9z"}})])])]),_vm._v(" "),_c('g',{attrs:{"id":"k1"}},[_c('g',{attrs:{"id":"t18"}},[_c('path',{staticClass:"st1",attrs:{"d":"M59.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2c0,6.5,40.1,0,40.1,0\n\t\t\t\ts-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8c-0.9,0-3.9,2.5-3.9,8.7\n\t\t\t\ts1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1C61.4,23.9,60.9,22.2,59.3,22.2z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M69.5,21.9c0,0-1.8,3.8-1,7.8c0.8,4,3,21.4,3,26.5c0,2-6.3,18.1-7.9,29.8c0,0-0.7-11.5,0-14\n\t\t\t\t\tc0,0,3.6-15.9,3.6-21.1c0-5.2-1.5-14.5-1.5-21.2C65.6,23,69.5,21.9,69.5,21.9z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M67.4,54.3c0,0,0,0.1-0.1,0.4c-0.4,3.7-3.6,30-4.1,33.3c-0.5,3.6,0.1,5.6,0.1,5.6s-0.9-6.5-0.3-14.7\n\t\t\t\t\tc0.7-8.2-4.1-15-5.8-32.7c0,0,5.5,24.1,6,25.1"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M57.3,22.8c0,0-6.4,11.2-6.7,21.9c-0.3,10.7,3.4,36.9,3.4,45s-9.5,38.5-9.5,38.5l-1.5-0.6\n\t\t\t\t\tc0,0,4.8-27.8,4.8-31.5c0-3.8-0.4-35.3-0.4-48.5C47.4,30.8,57.3,22.8,57.3,22.8z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M40.4,133.3c0,12.9,4.4,19.6,8.3,19.6c1.2,0,9-4.8,9.6-4.8c1.8,0,11.2,7.2,13.5,7.2c2.3,0,4.5-2.6,5.5-3\n\t\t\t\t\tc1-0.4,9-3.4,9-10.1c0-6.7-4.1-33.2-25.9-33.2C56.4,109,40.4,115.9,40.4,133.3z"}}),_vm._v(" "),_c('path',{staticClass:"st75",attrs:{"d":"M64.2,128.2c0,0-5.1,2-5.5,8.9c-0.4,6.9-1.3,8.9,0.6,11.3c0,0-1.4-1.4-2.9,0.5c0,0,1.4-4,1-7.7\n\t\t\t\t\tc-0.4-3.8,0.9-7.3-2.4-10.3c0,0,2.8,1,3.2,3C58.4,133.9,59.2,130.2,64.2,128.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_9",attrs:{"d":"M56.4,138.3c0,0,0.9-3.2-2.5-6.2c-3.4-3-6.5-7.3-7.8-6.1c-1.2,1.2-3.2,12-2.5,14.8\n\t\t\t\t\tc0.8,2.8,1.2,7.9,3.8,8.7c2.5,0.9,7-0.6,7.8-2.1C55.9,145.9,56.5,140.8,56.4,138.3z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M64.2,130.9c0,0-1.8,3.9-1.8,8.6c0,3,0.8,9.4,4,11.2c1.5,0.8,5.8,3.8,7,2.3c1.3-1.5,4.1-3.2,6-4\n\t\t\t\t\tc1.9-0.8,5.5-4.6,5.3-6.8c-0.3-2.2-0.8-10.4-4-14C77.5,124.6,66.7,125.1,64.2,130.9z"}}),_vm._v(" "),_c('path',{staticClass:"st78",attrs:{"d":"M75.9,119.2c0,0-11,4.8-13.9,7.8c-2.9,2.9-9.9-6.2-11.2-7.8c-1.4-1.6,6.8-11.3,17.8-6.7\n\t\t\t\t\tC77.6,116.2,75.9,119.2,75.9,119.2z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_10",attrs:{"d":"M45.5,118c0,0-5.2,8.3-5.2,14.1c0,5.8,2.1,20.7,7.9,20.7c5.8,0,6.9-4.2,10-4.9\n\t\t\t\t\tc3-0.7,11.3,8,13.5,7.3c2.1-0.6,9.2-4.8,9.6-5.1s-7.1,3.3-8.9,3.2c-1.8-0.1-11.7-7.3-14.2-7.3s-6.7,3.8-10,3.8\n\t\t\t\t\tc-3.3,0-6.4-5-6.4-16.7C41.9,128.9,45.5,118,45.5,118z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M57.5,43.4c0-4.2,2.4-9.6,3.4-13.4c0.2,0.3,0.3,0.7,0.3,1.2c0,1.4-0.5,9.8-0.5,9.8\n\t\t\t\t\tc0,4.5,2.8,14.8,4.9,21.5c-1,4.9-2,9.3-2,9.3S57.5,48.9,57.5,43.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t17_1_"}},[_c('path',{staticClass:"st1",attrs:{"d":"M107.3,22.2c-1.4,0-12.2,3.2-12.2,33.1c0,9.9,0.6,32.4,0.6,39.8c0,4.8-4.7,27.3-4.7,31.2\n\t\t\t\tc0,6.5,40.1,0,40.1,0s-5.5-21.5-5.5-28.1c0-6.6,5.5-25,5.5-35.4c0-10.4-10.7-35-10.7-37.2c0-2.2-1.9-3.8-2.8-3.8\n\t\t\t\ts-3.9,2.5-3.9,8.7s1.5,15,1.5,20.9c0,5.9-3.6,20.4-3.6,20.4s-6.1-23-6.1-28.5c0-5.4,3.9-12.7,3.9-16.1\n\t\t\t\tC109.4,23.9,108.9,22.2,107.3,22.2z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M117.5,21.9c0,0-1.8,3.8-1,7.8c0.8,4,3,21.4,3,26.5c0,2-6.3,18.1-7.9,29.8c0,0-0.7-11.5,0-14\n\t\t\t\t\tc0,0,3.6-15.9,3.6-21.1c0-5.2-1.5-14.5-1.5-21.2C113.6,23,117.5,21.9,117.5,21.9z"}}),_vm._v(" "),_c('path',{staticClass:"st72",attrs:{"d":"M115.4,54.3c0,0,0,0.1-0.1,0.4c-0.4,3.7-3.6,30-4.1,33.3c-0.5,3.6,0.1,5.6,0.1,5.6s-0.9-6.5-0.3-14.7\n\t\t\t\t\tc0.7-8.2-4.1-15-5.8-32.7c0,0,5.5,24.1,6,25.1"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M105.3,22.8c0,0-6.4,11.2-6.7,21.9c-0.3,10.7,3.4,36.9,3.4,45s-9.5,38.5-9.5,38.5l-1.5-0.6\n\t\t\t\t\tc0,0,4.8-27.8,4.8-31.5c0-3.8-0.4-35.3-0.4-48.5C95.4,30.8,105.3,22.8,105.3,22.8z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M88.4,133.3c0,12.9,4.4,19.6,8.3,19.6c1.2,0,9-4.8,9.6-4.8c1.8,0,11.2,7.2,13.5,7.2s4.5-2.6,5.5-3\n\t\t\t\t\tc1-0.4,9-3.4,9-10.1c0-6.7-4.1-33.2-25.9-33.2C104.4,109,88.4,115.9,88.4,133.3z"}}),_vm._v(" "),_c('path',{staticClass:"st75",attrs:{"d":"M112.3,128.2c0,0-5.1,2-5.5,8.9c-0.4,6.9-1.3,8.9,0.6,11.3c0,0-1.4-1.4-2.9,0.5c0,0,1.4-4,1-7.7\n\t\t\t\t\tc-0.4-3.8,0.9-7.3-2.4-10.3c0,0,2.8,1,3.2,3C106.4,133.9,107.3,130.2,112.3,128.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M104.4,138.3c0,0,0.9-3.2-2.5-6.2c-3.4-3-6.5-7.3-7.8-6.1c-1.2,1.2-3.2,12-2.5,14.8\n\t\t\t\t\tc0.8,2.8,1.2,7.9,3.8,8.7c2.5,0.9,7-0.6,7.8-2.1C103.9,145.9,104.5,140.8,104.4,138.3z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M112.3,130.9c0,0-1.8,3.9-1.8,8.6c0,3,0.8,9.4,4,11.2c1.5,0.8,5.8,3.8,7,2.3c1.2-1.5,4.1-3.2,6-4\n\t\t\t\t\tc1.9-0.8,5.5-4.6,5.3-6.8c-0.3-2.2-0.8-10.4-4-14C125.5,124.6,114.8,125.1,112.3,130.9z"}}),_vm._v(" "),_c('path',{staticClass:"st78",attrs:{"d":"M123.9,119.2c0,0-11,4.8-13.9,7.8c-2.9,2.9-9.9-6.2-11.2-7.8c-1.4-1.6,6.8-11.3,17.8-6.7\n\t\t\t\t\tC125.6,116.2,123.9,119.2,123.9,119.2z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M93.5,118c0,0-5.2,8.3-5.2,14.1c0,5.8,2.1,20.7,7.9,20.7c5.8,0,6.9-4.2,10-4.9\n\t\t\t\t\tc3-0.7,11.3,8,13.5,7.3c2.1-0.6,9.2-4.8,9.6-5.1s-7.1,3.3-8.9,3.2c-1.8-0.1-11.7-7.3-14.2-7.3s-6.7,3.8-10,3.8\n\t\t\t\t\tc-3.3,0-6.4-5-6.4-16.7C89.9,128.9,93.5,118,93.5,118z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M105.5,43.4c0-4.2,2.4-9.6,3.4-13.4c0.2,0.3,0.3,0.7,0.3,1.2c0,1.4-0.5,9.8-0.5,9.8\n\t\t\t\t\tc0,4.5,2.8,14.8,4.9,21.5c-1,4.9-2,9.3-2,9.3S105.5,48.9,105.5,43.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t16"}},[_c('path',{staticClass:"st1",attrs:{"d":"M183.1,76c0-9.3-10.1-36.9-10.1-45.1c0-4.3-2.3-7.3-3.5-7.3c-3.1,0-5.1,14-5.1,17c0,9.4,1.5,22.2,1.5,25.8\n\t\t\t\tc0,3.6-3.6,15.4-6.1,15.4c-3.6,0-11.8-16.3-12.2-47.7c0-1.7,0.6-4.2,0.6-6.7c0-1.2-1.3-4-2.4-4c-2.3,0-8,17-8,50.6\n\t\t\t\tc0,7.3,7,34.4,5,43h35.6c0,0-0.3-1.5-0.3-6.8C178,104.9,183.1,84.2,183.1,76z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M168.8,24.8c0,0-2.2,10.2-2.2,15.2c0,4.9,2.2,17,2.2,27.1s-6.3,20.7-9.3,22.6\n\t\t\t\t\tc0,0-8.3-8.3-9.5-29.9c0,0,4.6,21.7,10.1,21.7c2.9,0,6.2-14.5,6.2-15.4c0-0.8-2-20-2-24.9C164.3,36.4,166.4,25,168.8,24.8z"}}),_vm._v(" "),_c('path',{staticClass:"st79",attrs:{"d":"M163.8,77c-3,6.7-2,12.2-4.3,15.3c0,0-1.1-8.9-3.8-15.3c0,0,2.5,4.9,3.8,4.9C160.8,82,163.8,77,163.8,77z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M177,49.2c0,0,6.1,20.9,6.1,26.9c0,5.9-4.8,21.3-4.8,42h-9.5C168.7,118,183.7,89.7,177,49.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M142.4,29.6c0,0-2.1,27.2-1.1,43.7s9.7,42,9.7,42l-7.1-1.7c0,0-1.5-13.3-2.2-14.4c-0.7-1.1-4-20-4-25.4\n\t\t\t\t\tS139.1,32.3,142.4,29.6z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M136,134.4c0,0-0.4,6.6,2.4,9.5c2.9,2.9,7.1,7.1,7.1,7.1c0.3,0.4,1.4,1.6,2.3,1.6c0.9,0,8.6-6,9.3-6\n\t\t\t\t\tc0.7,0,8.7,8.8,14.9,8.8c2.1,0,4.2-2.8,5.7-3.4c1.5-0.5,8-2.4,8-9.1c0-4.8-3.4-9.6-8.1-28c-1.8-6.8-14.4-16.3-18.7-16.3\n\t\t\t\t\tC146.5,98.5,136,122.5,136,134.4z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M153.9,102c0,0-4.8,5.7-5.1,8.3c-0.4,2.7-2.2,8.8-5.9,12.5c-3.6,3.8-6,14.3-3.9,18.2\n\t\t\t\t\tc2.1,3.9,6,8.6,6,8.6s-6.7-4.7-7.8-7.7c-1.2-2.9-1-6.2-1-9.8c0,0,1.7-22.3,17.7-32.3C153.9,99.8,157,97.8,153.9,102z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M158.3,144.3c0,0,0.6-5.4,0.6-8.4c0-2.9,1.3-7,4-8.9c2.8-1.8,1.8-1.8,1.8-1.8s-5.7,1.9-6.7,5.6\n\t\t\t\t\tc0,0-3.5-3.2-7.8-4c0,0,5.2,3,6.4,6.6c1.1,3.6,0.7,9-0.2,10.8c-0.8,1.8-6.9,6.7-8.3,7.3c-1.4,0.6,1.8,0.1,8-4.9\n\t\t\t\t\tc0.3-0.3,0.9-0.4,0.9-0.4s3.4,3.8,5.6,4.7C164.8,151.8,159.8,149,158.3,144.3z"}}),_vm._v(" "),_c('path',{staticClass:"st73",attrs:{"d":"M162.6,122.4c0,0-3.8,2.2-4.8,3.9c-1,1.7-3.1-0.2-5.4-1c-2.2-0.8-2.8-4.6-2.4-7.1\n\t\t\t\t\tc0.4-2.5,2.8-7.5,6.2-10.8c3.4-3.3,2.8-1.6,3.6,0.8C160.6,110.5,166.1,119.9,162.6,122.4z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M164.8,127.9c0,0-4,2.1-4.5,4.3c-0.5,2.2-0.4,6.6,0,9.4c0.4,2.8,1.9,5.5,3.4,7.4\n\t\t\t\t\tc5.8,7.1,10.9,3,12.4,1.8c1.5-1.3,9.7-3.6,5.8-12.3c-1.5-3.3-7.4-11.7-9-12.2C171.3,125.7,166.4,126.9,164.8,127.9z"}}),_vm._v(" "),_c('path',{staticClass:"st76",attrs:{"d":"M156.9,139.5c0,0-0.5,4.2-6.9,10c-2.9,2.7-4.3-0.7-4.3-0.7c0,0-3.6-4.8-4.2-10.4\n\t\t\t\t\tc-0.6-5.6-0.1-12.5,2.9-12.5c1.8,0,7.1,2.5,8.6,4.1C154.5,131.6,156.6,132.6,156.9,139.5z"}}),_vm._v(" "),_c('path',{staticClass:"st29",attrs:{"d":"M143.1,111.1c0,0-7.1,16.8-7.1,24.4c0,7.6,10.9,17.1,11.8,17.1s9.5-5.9,9.5-5.9s10.8,8.7,14.7,8.7\n\t\t\t\t\tc3.9,0,5.7-3.4,5.7-3.4s7.2-3.2,8-7.6c0,0-6.3,3.4-9.7,6.3c-3.4,2.9-15.5-2.8-18.4-5.9c-1.2-1.3-1.5,0-2.5,1c-1,1-6,4-7.4,4.1\n\t\t\t\t\tc-1.4,0.1-9.5-7.6-9.5-14.8C138.3,127.8,142.4,113.1,143.1,111.1z"}})]),_vm._v(" "),_c('g',[_c('g',[_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M165.9,66.3c0,3.6-3.6,15.4-6.1,15.4c-2.9,0-8.9-10.9-11.3-32c1.3-12.4,3-23.4,3.5-25.6\n\t\t\t\t\t\t\tc0.8-3.9,2.8-3.7,2.8-3.7c0.5,0,0.9,0.1,1.3,0.3c4.2,1.9,5,13,6.3,16.2c0.4,1,1.2,2.1,2,3.2c0,0.1,0,0.3,0,0.4\n\t\t\t\t\t\t\tC164.4,50,165.9,62.7,165.9,66.3z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st79",attrs:{"d":"M159.8,81.7c-2.7,0-8.1-9.4-10.8-27.8c3.2,14.1,9.2,21.7,10.1,22c1,0.4,3.2-5.1,4.6-10.9\n\t\t\t\t\t\t\tc1.3-5.6,0.8-18,0.8-18.8c0.4,8.3,1.4,17.2,1.4,20.1C165.9,69.9,162.4,81.7,159.8,81.7z"}})])]),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M155.6,20.5C155.6,20.5,155.6,20.5,155.6,20.5c0,0.2-4.9,23.2-2.2,49.6c-1.6-5-3.1-11.5-4-19.6\n\t\t\t\t\tc0.1-1.6,0.2-3.2,0.4-4.8c1-8.5,2-15.8,2.7-19.4C153.2,22.7,154.3,20.5,155.6,20.5z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t15"}},[_c('path',{staticClass:"st1",attrs:{"d":"M206.3,22.8c-2.6,0-4.4,4.2-4.4,6c0,2,0.5,4.1,0.5,10.7c0,8.1-4.5,23.1-4.9,28c-0.3,3.2-5.3,62.6-5.3,62.6\n\t\t\t\th26.6c0,0,0.4-27.1,0.4-40C219.2,63.6,215.3,22.8,206.3,22.8z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M203.7,30.1c0,0,2.7,10,3,26.9c0.3,17-7.5,56.4-7.5,56.4l-6.5,2l2.4-25l2.6-25.9c0,0,4.6-16.3,4.6-20.4\n\t\t\t\t\tC202.3,40.2,202,28.7,203.7,30.1z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M216.2,124c0,0-0.1-74.7-1.4-82.8c0,0,4.2,26.2,4.3,38.1c0.1,11.9-0.2,45.8-0.2,45.8L216.2,124z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M206,106.5c-5.7,0-17.8,16.4-17.8,31.7c0,8.5,4,6.2,7.8,9.7c3.8,3.6,7.7,7.4,10.7,7.4\n\t\t\t\t\tc1.6,0,16.9-5.1,16.9-11.6C223.6,136.9,215.9,106.5,206,106.5z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M203.7,107.2c0,0-3.9,6.9-4.3,9.9c-0.3,3-2.1,9.4-1.9,16.7c0.2,7.3,4.7,13.7,3.4,15.5\n\t\t\t\t\tc-1.8,2.4-4.9-3.2-7.9-3.4c-3-0.2-5.2-4.8-4.3-12.2C189.5,126.4,193.3,113.3,203.7,107.2z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M205,114.4c0,0-3.7,7.5-2.5,14.2c1.2,6.7,0.7,13.3,1,16.9c0.3,3.6,1.5,7.4,4.3,7.4\n\t\t\t\t\tc2.2,0,5-4,7.2-6.5c2.2-2.5,4.3-4,4.3-8.2C219.3,135.6,209.2,102.4,205,114.4z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t14"}},[_c('path',{staticClass:"st1",attrs:{"d":"M254,79.7c0,4.6,1.1,43.9,1.1,43.9s-25.7,5.7-24.7,0c0.6-3.5,0.3-48,0.3-55.6c0-19,4.6-37.4,4.6-43.7\n\t\t\t\tc0-1.7,0.5-3.3,1.9-3.3C245.4,21,254,64,254,79.7z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M236.1,27.2c0,0,2.3,26.6,2,29.7l-1,50.4l-6.4,6.2l0.1-26.9c0,0-0.7-30.1,1.3-36.5\n\t\t\t\t\tC234,43.7,235,27.6,236.1,27.2z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M246.1,39.2c0,0,8.1,21.3,8.1,47.5c0,16.7,0,29.5,0,29.5l-3.2-9.9C251,106.2,249.9,52.4,246.1,39.2z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M242.7,101.9c-4.1,0-8.8,2.4-13.1,17.9c-3,10.8-4.5,14-4.5,18.5c0,4.5,0.9,9.8,10.3,12.8\n\t\t\t\t\tc4.7,1.5,5.9,4.3,8.7,4.3c3.8,0,8.1-4.1,11.1-4.9c3-0.8,7.3-2.9,7.3-9.9C262.4,134.7,252.7,101.9,242.7,101.9z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M242.5,104.5c0,0-3.8,1.9-4.7,6.9c-0.8,5-6.3,13.6-6.5,14.6c-0.2,1-1.4,12.3,2,16.7\n\t\t\t\t\tc3.3,4.4,7.7,6.7,9.2,8.2c1.5,1.5,5.5-1.3,7.7-1.7c2.2-0.4,4.7-3.1,7.3-2.5c2.6,0.6,2.1,2-0.9,3.1c-3,1.1-10.6,5.4-12.6,5.4\n\t\t\t\t\tc-2,0-10.3-5.8-13.3-6.3c-3-0.5-5.6-8.1-5.6-10.7c0-2.6,8-36.3,16.3-36.3S242.5,104.5,242.5,104.5z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M247.5,106.5c0,0,6.3,10.4,7.8,16.1c1.5,5.6,1.8,8.9,1.7,12.4c-0.2,3.5,0,4.8-4.7,7.5\n\t\t\t\t\tc-4.8,2.7-6.6,6.5-8.5,5.4s-1.6-13.2-1.6-19.3c0-6,0.2-10,0-13.4C242,111.9,244,104.4,247.5,106.5z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t13"}},[_c('path',{staticClass:"st1",attrs:{"d":"M276.8,19.8c-1.3,0-2.1,0.9-2.1,2c0,1.2,2.1,10.4,2.1,13.2c0,2.8-4.9,29.1-4.9,38.7c0,9.6,2.3,35.3,2.3,35.3\n\t\t\t\tH298c0.2-19.3,0.2-19.2,0.2-23.4c0-17.1-4.8-24.5-5.1-29.6C292.6,45.8,284.1,19.8,276.8,19.8z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M276.3,20.8c0,0,6.4,26.3,5.4,33.5c-1,7.2-3.5,30.6-2.6,41.7c0.9,11.1-2.8,17.7-2.8,17.7l-1.8-3.6\n\t\t\t\t\tl-1.2-14.9c0,0-1.4-17.8-1.4-24.5c0-6.7,4.8-33.9,4.8-38.1C276.8,28.4,275.8,18.5,276.3,20.8z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M293.9,58.2c0,0,1.4,46.6-2.4,59.9c-0.9,3.1,0,1.3,0,1.3l5.9,0.6c0,0,0.7-22.9,0.7-32.4\n\t\t\t\t\tC298.1,72.2,293.9,58.2,293.9,58.2z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M285.8,87.6c-7.5,0-15.2,12.5-15.2,23.7c0,4.9-7,19-7,24.3c0,5.7,9,10.8,9,10.8s7.4,8.9,12.4,8.9\n\t\t\t\t\tc6.7,0,13.1-6.2,13.1-6.2s8.1-2.4,8.1-5.6C306.2,140.2,300.4,87.6,285.8,87.6z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M280.2,151.3c-1.3-5.6-4.2-10-6-10.9c-5.6-2.9-6.2-5-6.2-5.2c-0.8-11.2,7.8-22.1,7.6-25.9\n\t\t\t\t\tc-0.2-3.8,5.3-14.4,8.2-15c2.8-0.6,8,0,10.5,7.5c0.8,2.4,8.2,34.6,9,38.6c0.8,4.1,2.5,5,2.8,4c0.3-1,0-4.1-0.2-6.2\n\t\t\t\t\tc-0.3-2-7-50.6-19.9-50.6c-12.9,0-14.5,19-14.5,22c0,0-2.9,10-4.3,13.7c-1.3,3.7-5.7,12.4-2,16.3c3.7,3.9,6.6,5.7,7.6,6.7\n\t\t\t\t\tC273.5,147.5,281.3,156.2,280.2,151.3z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M301.5,143.3c0,0-3.9-0.4-6.2,1.2c-2.3,1.6-3.1,6-8.1,6.1c-5,0.2-2.3-6.5-2.3-12.1\n\t\t\t\t\tc0-5.5,1.3-17.5,1.8-21.5c0.5-3.9,0.8-15,1.5-16.7c0.7-1.8,3.8,3.2,4.9,7.9C294.2,113,304.5,140.8,301.5,143.3z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t12"}},[_c('path',{staticClass:"st1",attrs:{"d":"M324,26.6c-0.9-1.5-1.6-1.8-2.2-3c-0.7-1.2-1.9-3.6-3.9-3.6c0,0-2,0.2-2,2.8c0,2.7,0,22.3,0,23.6\n\t\t\t\tc0,3.2-3.1,13.4-3.1,25.6c0,10,0.6,44.1,1.3,53.4h25C339,125.3,339.1,53.3,324,26.6z"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M316.9,20.1c0,0,4.5,32.1,5.8,43.6c1.3,11.4-1.9,52.3-1.7,56.3c0.2,4-5.3,6.4-7,5.2\n\t\t\t\t\tc-1.7-1.2,0-20.1,0-20.1s-1.3-31.9-1.3-34.6c0-2.7,3.1-21.5,3.1-26.2C315.8,39.6,314.1,21.1,316.9,20.1z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M330.8,44.7c0,0,7.5,34.2,8,68c0.1,8.6,0.1,11.1-2.9,9.3c0,0-4.4-3-4-8.2\n\t\t\t\t\tC332.3,108.4,333.6,57.8,330.8,44.7z"}})]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M347.9,148.3c0,3.6-1.2,5.2-3.6,5.2c-3.6,0-6.8,0.5-7.8,0.5s-4.2,1.3-6.7,1.3c-3.7,0-6-2.7-7.2-2.7\n\t\t\t\t\tc-2.2,0-14.1-0.1-14.1-16.7c0-14,12.5-40.7,19-40.7C337.5,95.2,347.9,136.5,347.9,148.3z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M343.4,123.7c0,0-6.9-19.5-15.1-20.6s-13.6,16.6-14.3,22.1c-2,16.2,4.4,25.1,6.3,26.9\n\t\t\t\t\tc0,0-7.2-2.4-8.6-5.6c-2.4-5.2-5.7-17.9,3.6-35.4C324.5,93.7,328,95,329,95.5C330.1,96.1,339.9,102.2,343.4,123.7z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M346.3,148c0,0-8.4-21.9-17.5-21.9c-9,0-14.2,14-10.9,18.8c3.3,4.8,8.8,8.6,12,8\n\t\t\t\t\tc3.2-0.7,8.3-0.8,11.5-0.8C344.7,152.2,347.8,151.5,346.3,148z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M326.2,150.9c0,0-3.6-2.2-4.3-7.4c0,0-1.1,4.6-0.9,6.8C321.2,152.6,328.9,153.8,326.2,150.9z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"t11"}},[_c('path',{staticClass:"st1",attrs:{"d":"M391.2,120.5c2-6.5-1.5-13.2-1.5-19.4c0-40-14.7-81.7-25.3-81.7c-0.6,0-2,0.6-2,1.8c0,2.3,0.8,2.6,0.8,5.5\n\t\t\t\tc0,6.6-6.7,26.7-6.7,41.3c0,7.1,0.6,27.9,0.3,31.9c-0.3,4-4.1,29.3-4.1,29.3L391.2,120.5z"}}),_vm._v(" "),_c('g',[_c('g',[_c('path',{staticClass:"st70",attrs:{"d":"M365.2,19.4c0,0,4.2,14.4,5.3,30.9c1,16.5,2,59.4,0,65.9c-2,6.5-13.2,9.9-13.9,5.8\n\t\t\t\t\t\tc-0.7-4.1,0.2-16.9,0.2-22.9c0.1-6-0.2-21.2-0.2-28.5c0-14.9,6.6-43.7,6.6-46.5S362,19.8,365.2,19.4z"}}),_vm._v(" "),_c('path',{staticClass:"st70",attrs:{"d":"M382.8,49c0,0,4.7,53.2,1.3,63.6c0,0,1.5,9.3,3.9,3.6s1.9-13.1,1.8-17.7C389.6,93.9,386.5,52.8,382.8,49z\n\t\t\t\t\t\t"}})])]),_vm._v(" "),_c('g',[_c('path',{staticClass:"st71",attrs:{"d":"M397,153.9c0,0-8.9,2.1-14.8,0.7c0,0-9.8,1.6-15.4-0.1c0,0-11.6,0.7-14.4-1.7c-2.8-2.4-2.9-9.2-2.9-11.9\n\t\t\t\t\tc0-15.3,11.8-53.8,22.9-53.8c10.5,0,24.5,22.2,24.5,49.5C396.9,141.7,397,147.8,397,153.9z"}}),_vm._v(" "),_c('path',{staticClass:"Shade_x0020_11",attrs:{"d":"M394.9,118.6c0,0-8.2-31-21.8-31c-10.6,0-16.4,21-20.8,35.6c-1.1,3.7-3.3,18.2-2,15.5\n\t\t\t\t\tc5.6-12,7.8-10.2,11.8-22.7c15.3-48.1,29.6,0.3,34.3,11.1L394.9,118.6z"}}),_vm._v(" "),_c('path',{staticClass:"Highligh_x0020_10",attrs:{"d":"M393.8,149.4c0,0-4.5-26.1-17-30.9c-5.9-2.3-7.2,7.5-11.6,14.2c-4.3,6.8-9.4,10.5-10.5,14\n\t\t\t\t\tc-1.1,3.5,3.8,6.4,9.4,5.5c5.6-0.9,7.8,0.8,12.5,0.2C381.3,151.9,397,155.4,393.8,149.4z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M384,154.9l-1.7-0.3l-2.4,0.3c0,0,1.1-10.1,2.1-10.1C382.7,144.8,382.4,154.8,384,154.9z"}}),_vm._v(" "),_c('path',{staticClass:"st77",attrs:{"d":"M368.8,154.9l-1.7-0.3l-2.4,0.3c0,0,1.1-10.1,2.1-10.1C367.5,144.8,367.2,154.8,368.8,154.9z"}})])])])]),_vm._v(" "),_c('g',{attrs:{"id":"numbers"}},[_c('g',{attrs:{"id":"numbers_x5F_k4"}},[_c('g',{attrs:{"id":"n48"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M60.2,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M57.6,205.8v-3.3c0-0.7,0-1.4,0.1-2.2\n\t\t\t\t\th-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H57.6z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M64.4,199c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.8,0.8-1.5,1.1\n\t\t\t\t\tc0.8,0.4,1.4,0.8,1.7,1.2c0.3,0.4,0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7c-1.1,0-1.9-0.2-2.5-0.7\n\t\t\t\t\tc-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.7,0.3-1.3,0.8-1.7\n\t\t\t\t\tC62.8,199.2,63.6,199,64.4,199z M62.3,206.6c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5c0.7,0,1.2-0.2,1.6-0.5\n\t\t\t\t\tc0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1C62.4,205.7,62.3,206.2,62.3,206.6\n\t\t\t\t\tz M64.4,200c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.8,0.6,1.5,0.9\n\t\t\t\t\tc0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1C65.5,200.1,65,200,64.4,200z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n47"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M119.9,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M117.3,205.8v-3.3\n\t\t\t\t\tc0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H117.3z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M122.1,209.2l4.1-8.9h-5.4v-1h6.7v0.9l-4.1,9.1H122.1z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n46"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M180.7,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M178.1,205.8v-3.3\n\t\t\t\t\tc0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H178.1z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M181.8,204.9c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2\n\t\t\t\t\tc-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2\n\t\t\t\t\tc0,1-0.3,1.9-0.9,2.5c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C182.1,207.4,181.8,206.3,181.8,204.9z M185.2,208.3\n\t\t\t\t\tc0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3\n\t\t\t\t\tc-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3s0.4,0.7,0.8,1C184.3,208.2,184.7,208.3,185.2,208.3z\n\t\t\t\t\t"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n45"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M233.1,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M230.5,205.8v-3.3\n\t\t\t\t\tc0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H230.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M237.2,203.1c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9\n\t\t\t\t\tc-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6\n\t\t\t\t\tc0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C236.1,203.1,236.6,203.1,237.2,203.1z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n44"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M273.4,206.9h-1.5v2.3h-1.1v-2.3H266v-1l4.7-6.8h1.2v6.7h1.5V206.9z M270.8,205.8v-3.3\n\t\t\t\t\tc0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H270.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M281.4,206.9h-1.5v2.3h-1.1v-2.3H274v-1l4.7-6.8h1.2v6.7h1.5V206.9z M278.8,205.8v-3.3\n\t\t\t\t\tc0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H278.8z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n43"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M313.6,206.9h-1.5v2.3H311v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M311,205.8v-3.3c0-0.7,0-1.4,0.1-2.2\n\t\t\t\t\tH311c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H311z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M320.7,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C320.4,200.1,320.7,200.8,320.7,201.5z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n42"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M348.5,206.9H347v2.3h-1.1v-2.3H341v-1l4.7-6.8h1.2v6.7h1.5V206.9z M345.9,205.8v-3.3c0-0.7,0-1.4,0.1-2.2\n\t\t\t\t\th-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H345.9z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M356,209.2h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V209.2z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n41"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M381.8,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M379.3,205.8v-3.3\n\t\t\t\t\tc0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H379.3z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M387,209.2h-1.1V202c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V209.2z"}})])])]),_vm._v(" "),_c('g',{attrs:{"id":"numbers_x5F_k3_1_"}},[_c('g',{attrs:{"id":"n38"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M738.2,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C738,200.1,738.2,200.8,738.2,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M743.4,199c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.8,0.8-1.5,1.1\n\t\t\t\t\tc0.8,0.4,1.4,0.8,1.7,1.2c0.3,0.4,0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7c-1.1,0-1.9-0.2-2.5-0.7\n\t\t\t\t\tc-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.7,0.3-1.3,0.8-1.7\n\t\t\t\t\tC741.8,199.2,742.5,199,743.4,199z M741.2,206.6c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5c0.7,0,1.2-0.2,1.6-0.5\n\t\t\t\t\tc0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1\n\t\t\t\t\tC741.4,205.7,741.2,206.2,741.2,206.6z M743.4,200c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1\n\t\t\t\t\tc0.3,0.3,0.8,0.6,1.5,0.9c0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1\n\t\t\t\t\tC744.4,200.1,743.9,200,743.4,200z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n37"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M678.6,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C678.3,200.1,678.6,200.8,678.6,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M681.6,209.2l4.1-8.9h-5.4v-1h6.7v0.9l-4.1,9.1H681.6z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n36"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M617.7,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C617.4,200.1,617.7,200.8,617.7,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M619.6,204.9c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2\n\t\t\t\t\tc-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2\n\t\t\t\t\tc0,1-0.3,1.9-0.9,2.5c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C619.9,207.4,619.6,206.3,619.6,204.9z M623,208.3\n\t\t\t\t\tc0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3\n\t\t\t\t\tc-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.7,0.8,1\n\t\t\t\t\tC622.2,208.2,622.6,208.3,623,208.3z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n35"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M565.3,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C565.1,200.1,565.3,200.8,565.3,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M570.3,203.1c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9\n\t\t\t\t\tc-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6\n\t\t\t\t\tc0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C569.2,203.1,569.8,203.1,570.3,203.1z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n34"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M525,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C524.8,200.1,525,200.8,525,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M533.9,206.9h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V206.9z M531.3,205.8v-3.3\n\t\t\t\t\tc0-0.7,0-1.4,0.1-2.2h-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H531.3z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n33"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M484.9,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C484.6,200.1,484.9,200.8,484.9,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M492.9,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C492.6,200.1,492.9,200.8,492.9,201.5z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n32"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M450,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C449.7,200.1,450,200.8,450,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M458.3,209.2h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V209.2z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n31"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M416.6,201.5c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C416.3,200.1,416.6,200.8,416.6,201.5z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M422.6,209.2h-1.1V202c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V209.2z"}})])])]),_vm._v(" "),_c('g',{attrs:{"id":"numbers_x5F_k2"}},[_c('g',{attrs:{"id":"n28"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M735.9,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M740.7,168.6c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3\n\t\t\t\t\tc-0.3,0.4-0.8,0.8-1.5,1.1c0.8,0.4,1.4,0.8,1.7,1.2s0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7\n\t\t\t\t\tc-1.1,0-1.9-0.2-2.5-0.7c-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4\n\t\t\t\t\tc0-0.7,0.3-1.3,0.8-1.7C739.1,168.9,739.8,168.6,740.7,168.6z M738.5,176.3c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5\n\t\t\t\t\tc0.7,0,1.2-0.2,1.6-0.5c0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1\n\t\t\t\t\tC738.7,175.3,738.5,175.8,738.5,176.3z M740.7,169.6c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1\n\t\t\t\t\tc0.3,0.3,0.8,0.6,1.5,0.9c0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1\n\t\t\t\t\tC741.7,169.7,741.3,169.6,740.7,169.6z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n27"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M687,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M689.7,178.8l4.1-8.9h-5.4v-1h6.7v0.9l-4.1,9.1H689.7z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n26"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M639.2,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M640.7,174.5c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2\n\t\t\t\t\tc-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2\n\t\t\t\t\tc0,1-0.3,1.9-0.8,2.4c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C641.1,177,640.7,175.9,640.7,174.5z M644.1,178\n\t\t\t\t\tc0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3\n\t\t\t\t\tc-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.7,0.8,1\n\t\t\t\t\tC643.3,177.8,643.7,178,644.1,178z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n25"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M594,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M598.5,172.7c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9\n\t\t\t\t\tc-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6\n\t\t\t\t\tc0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C597.5,172.7,598,172.7,598.5,172.7z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n24"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M556.1,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1\n\t\t\t\t\tV178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M564.6,176.5h-1.5v2.3H562v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V176.5z M562,175.5v-3.3c0-0.7,0-1.4,0.1-2.2\n\t\t\t\t\tH562c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H562z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n23"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M514.3,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1\n\t\t\t\t\tV178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M522,171.1c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C521.7,169.8,522,170.4,522,171.1z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n22"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M473,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M481,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7c0.5,0.5,0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1\n\t\t\t\t\tv0.1h5.1V178.8z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n21"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M426,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1\n\t\t\t\t\tV178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M431.6,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}})])])]),_vm._v(" "),_c('g',{attrs:{"id":"numbers_x5F_k1"}},[_c('g',{attrs:{"id":"n18"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M60,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M67.1,168.6c0.9,0,1.6,0.2,2.2,0.6c0.5,0.4,0.8,1,0.8,1.8c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.8,0.8-1.5,1.1\n\t\t\t\t\tc0.8,0.4,1.4,0.8,1.7,1.2c0.3,0.4,0.5,0.9,0.5,1.5c0,0.8-0.3,1.5-0.9,2c-0.6,0.5-1.4,0.7-2.4,0.7c-1.1,0-1.9-0.2-2.5-0.7\n\t\t\t\t\tc-0.6-0.5-0.9-1.1-0.9-2c0-1.1,0.7-2,2.1-2.7c-0.6-0.4-1.1-0.7-1.4-1.2c-0.3-0.4-0.4-0.9-0.4-1.4c0-0.7,0.3-1.3,0.8-1.7\n\t\t\t\t\tC65.5,168.9,66.2,168.6,67.1,168.6z M65,176.3c0,0.5,0.2,1,0.6,1.3c0.4,0.3,0.9,0.5,1.6,0.5c0.7,0,1.2-0.2,1.6-0.5\n\t\t\t\t\tc0.4-0.3,0.6-0.8,0.6-1.3c0-0.4-0.2-0.8-0.5-1.2c-0.4-0.3-1-0.7-1.9-1c-0.7,0.3-1.2,0.6-1.5,1C65.1,175.3,65,175.8,65,176.3z\n\t\t\t\t\t M67.1,169.6c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.6-0.5,1.1c0,0.4,0.1,0.8,0.4,1.1c0.3,0.3,0.8,0.6,1.5,0.9\n\t\t\t\t\tc0.7-0.3,1.1-0.6,1.4-0.9c0.3-0.3,0.4-0.7,0.4-1.1c0-0.5-0.2-0.8-0.5-1.1C68.1,169.7,67.7,169.6,67.1,169.6z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n17"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M109.2,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M114.3,178.8l4.1-8.9H113v-1h6.7v0.9l-4.1,9.1H114.3z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n16"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M156.7,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M160.6,174.5c0-2,0.4-3.4,1.1-4.4c0.8-1,1.9-1.5,3.4-1.5c0.5,0,0.9,0,1.2,0.1v1c-0.4-0.1-0.8-0.2-1.2-0.2\n\t\t\t\t\tc-1.1,0-1.9,0.3-2.5,1c-0.6,0.7-0.9,1.7-0.9,3.1h0.1c0.5-0.8,1.3-1.2,2.4-1.2c0.9,0,1.6,0.3,2.1,0.8c0.5,0.5,0.8,1.3,0.8,2.2\n\t\t\t\t\tc0,1-0.3,1.9-0.9,2.4c-0.6,0.6-1.3,0.9-2.3,0.9c-1,0-1.9-0.4-2.5-1.2C160.9,177,160.6,175.9,160.6,174.5z M164,178\n\t\t\t\t\tc0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.5-1,0.5-1.8c0-0.7-0.2-1.2-0.5-1.6c-0.3-0.4-0.8-0.6-1.5-0.6c-0.4,0-0.8,0.1-1.1,0.3\n\t\t\t\t\tc-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.7,0.8,1\n\t\t\t\t\tC163.1,177.8,163.5,178,164,178z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n15"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M201.9,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M208.8,172.7c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.2,0.9,2.1c0,1-0.3,1.8-1,2.4c-0.7,0.6-1.6,0.9-2.7,0.9\n\t\t\t\t\tc-1.1,0-2-0.2-2.6-0.5v-1.1c0.3,0.2,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.8,0,1.4-0.2,1.9-0.6c0.4-0.4,0.7-0.9,0.7-1.6\n\t\t\t\t\tc0-1.4-0.9-2.1-2.6-2.1c-0.4,0-1,0.1-1.7,0.2l-0.6-0.4l0.4-4.7h5v1h-4l-0.3,3C207.7,172.7,208.3,172.7,208.8,172.7z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n14"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M240.2,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M251,176.5h-1.5v2.3h-1.1v-2.3h-4.9v-1l4.7-6.8h1.2v6.7h1.5V176.5z M248.5,175.5v-3.3c0-0.7,0-1.4,0.1-2.2\n\t\t\t\t\th-0.1c-0.2,0.4-0.4,0.8-0.6,1.1l-3.1,4.4H248.5z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n13"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M281.8,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M291.8,171.1c0,0.6-0.2,1.2-0.5,1.6c-0.4,0.4-0.9,0.7-1.5,0.8v0.1c0.8,0.1,1.4,0.4,1.8,0.8\n\t\t\t\t\tc0.4,0.4,0.6,0.9,0.6,1.6c0,1-0.3,1.7-1,2.2c-0.7,0.5-1.6,0.8-2.8,0.8c-0.5,0-1,0-1.5-0.1c-0.4-0.1-0.9-0.2-1.3-0.4v-1.1\n\t\t\t\t\tc0.4,0.2,0.9,0.4,1.4,0.5c0.5,0.1,1,0.2,1.4,0.2c1.7,0,2.6-0.7,2.6-2c0-1.2-1-1.8-2.9-1.8h-1v-1h1c0.8,0,1.4-0.2,1.9-0.5\n\t\t\t\t\tc0.5-0.3,0.7-0.8,0.7-1.4c0-0.5-0.2-0.9-0.5-1.1c-0.3-0.3-0.8-0.4-1.4-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.3-1.3,0.7\n\t\t\t\t\tl-0.6-0.8c0.4-0.3,0.9-0.6,1.4-0.8c0.5-0.2,1.1-0.3,1.7-0.3c1,0,1.7,0.2,2.3,0.7C291.5,169.8,291.8,170.4,291.8,171.1z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n12"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M323.4,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M333.8,178.8h-6.6v-1l2.6-2.6c0.8-0.8,1.3-1.4,1.6-1.7c0.3-0.3,0.4-0.7,0.6-1c0.1-0.3,0.2-0.7,0.2-1.1\n\t\t\t\t\tc0-0.5-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5c-0.4,0-0.8,0.1-1.2,0.2c-0.4,0.1-0.8,0.4-1.2,0.7l-0.6-0.8\n\t\t\t\t\tc0.9-0.8,1.9-1.1,3-1.1c0.9,0,1.7,0.2,2.2,0.7s0.8,1.1,0.8,1.9c0,0.6-0.2,1.3-0.5,1.9c-0.4,0.6-1,1.4-2,2.4l-2.2,2.1v0.1h5.1\n\t\t\t\t\tV178.8z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"n11"}},[_c('g',[_c('path',{staticClass:"st80",attrs:{"d":"M369.6,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}}),_vm._v(" "),_c('path',{staticClass:"st80",attrs:{"d":"M377.6,178.8h-1.1v-7.1c0-0.6,0-1.2,0.1-1.7c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.7,0.5-1.6,1.3l-0.6-0.8\n\t\t\t\t\tl2.6-2h1V178.8z"}})])])])]),_vm._v(" "),_c('g',{attrs:{"id":"lines"}},[_c('line',{staticClass:"st81",attrs:{"id":"horiz","x1":"2","y1":"189.6","x2":"798","y2":"189.6"}}),_vm._v(" "),_c('line',{staticClass:"st81",attrs:{"id":"vert","x1":"400","y1":"13.7","x2":"400","y2":"346.3"}})]),_vm._v(" "),_c('g',{attrs:{"id":"teeth_x5F_dark_x5F_overlays"}},[_c('path',{staticClass:"st82",class:((_vm.tooth[48]) ? 'active' : ''),attrs:{"id":"dark_x5F_48","d":"M91.4,232.2C91.4,232.1,91.4,232.1,91.4,232.2c-1.3-5-4.5-7.4-6.5-8.8l-0.4-0.3\n\t\tc-0.6-0.5-1.2-1-1.9-1.7c-1.7-1.7-3.7-3.5-6.7-3.5c-3.3,0-11.1,4.5-14.5,6.5c-0.5,0.3-0.9,0.5-1.1,0.6c-0.3-0.1-1-0.6-1.7-1\n\t\tc-2.9-1.8-8.4-5.1-12.6-5.1c-3,0-5.9,1.5-8.1,4.1c-2.8,3.3-4.2,8.3-4.2,14.4c0,1.4,0.2,2.8,0.5,4.1c0.3,3.1,1.2,6.6,2.2,10.4\n\t\tc1.6,6.3,3.5,13.5,3.5,21.9c0,7-1.8,14.3-3.5,20.6c-1.2,4.8-2.3,9-2.3,12.1c0,9.5,4.2,23.5,7.9,23.5c2.7,0,4.4-4.4,4.4-7.4\n\t\tc0-5.1,2-10.8,3.6-15.4c0.9-2.5,1.7-4.7,1.8-6.2c0.5-4.2,4.5-20.6,6-24c0,0,0.1,0,0.1,0c0.4,2.7-0.1,12.6-0.5,19.4\n\t\tc-0.3,4.4-0.5,8.2-0.5,10.2c0,4.1,0.6,10.9,1,15.4c0.2,2.2,0.3,3.9,0.3,4.4v3.7c0,1.6,0.8,3.4,3.2,3.4c4.4,0,16.4-28.7,16.4-50.7\n\t\tc0-0.5,0.9-12,0.9-15.5c0-2.2,2.6-7,5-11.7c1-1.9,2-3.8,2.9-5.6c3.2-4.4,5.3-9.1,5.3-13.8C91.9,234.9,91.7,233.5,91.4,232.2z"},on:{"click":function($event){_vm.toothClick(48)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[47]) ? 'active' : ''),attrs:{"id":"dark_x5F_47","d":"M150.4,232.2C150.4,232.1,150.4,232.1,150.4,232.2c-1.3-5-4.5-7.4-6.5-8.8l-0.4-0.3\n\t\tc-0.6-0.5-1.2-1-1.9-1.7c-1.7-1.7-3.7-3.5-6.7-3.5c-3.3,0-11.1,4.5-14.5,6.5c-0.5,0.3-0.9,0.5-1.1,0.6c-0.3-0.1-1-0.6-1.7-1\n\t\tc-2.9-1.8-8.4-5.1-12.6-5.1c-3,0-5.9,1.5-8.1,4.1c-2.8,3.3-4.2,8.3-4.2,14.4c0,1.4,0.2,2.8,0.5,4.1c0.3,3.1,1.2,6.6,2.2,10.4\n\t\tc1.6,6.3,3.5,13.5,3.5,21.9c0,7-1.8,14.3-3.5,20.6c-1.2,4.8-2.3,9-2.3,12.1c0,9.5,4.2,23.5,7.9,23.5c2.7,0,4.4-4.4,4.4-7.4\n\t\tc0-5.1,2-10.8,3.6-15.4c0.9-2.5,1.7-4.7,1.8-6.2c0.5-4.2,4.5-20.6,6-24c0,0,0.1,0,0.1,0c0.4,2.7-0.1,12.6-0.5,19.4\n\t\tc-0.3,4.4-0.5,8.2-0.5,10.2c0,4.1,0.6,10.9,1,15.4c0.2,2.2,0.3,3.9,0.3,4.4v3.7c0,1.6,0.8,3.4,3.2,3.4c4.4,0,16.4-28.7,16.4-50.7\n\t\tc0-0.5,0.9-12,0.9-15.5c0-2.2,2.6-7,5-11.7c1-1.9,2-3.8,2.9-5.6c3.2-4.4,5.3-9.1,5.3-13.8C150.9,234.9,150.7,233.5,150.4,232.2z"},on:{"click":function($event){_vm.toothClick(47)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[46]) ? 'active' : ''),attrs:{"id":"dark_x5F_46","d":"M206.7,221.2l-0.3-0.1c-1.3-0.7-2.3-1.2-3.1-1.7c-1.4-0.9-2.3-1.4-4-1.4\n\t\tc-2.5,0-9.2,2.8-10.8,3.5c-1.2,0.5-2.7,1.9-3.5,3.1c-1.9-2.1-7-3.5-10.4-3.5c-4.9,0-7.2,2.1-9.4,5.7c-0.9-1.2-3.2-3.5-6.3-3.5\n\t\tc-3.9,0-6.8,4.8-6.8,11.1c0,5.6,4.2,17.9,5.2,19.4c0.2,0.3,0.5,0.6,0.7,0.9c1.5,4.8,3.2,10.7,3.2,13.7c0,4.1-2.3,15.2-4.8,27\n\t\tc-2.6,12.2-5.2,24.8-5.2,29.7c0,6.3,1.5,10.6,3.7,10.6c2,0,5.9-6.2,5.9-9.3c0-0.3,0.7-1.6,1.5-3c2.3-4.3,6.5-12.2,10.5-25.2\n\t\tc2.6-8.6,7.5-10.4,8.7-10.4c1.7,0,4.3,6.5,4.3,15.1c0,8.3-2.7,25.8-3.1,27.3c-0.5,1.6-0.8,2.7-0.8,3.5c0,2.8,1.4,3.4,2.5,3.4\n\t\tc4.7,0,20.1-24,20.1-39.6c0-11.7-0.5-15.5-0.9-18.6c-0.3-2-0.5-3.7-0.5-7.2c0-3.2,2-7.9,4.1-12.8c1-2.3,2-4.7,2.8-7\n\t\tc3.2-7.7,3.9-16.6,3.9-19.7C214,224.7,210.5,223,206.7,221.2z"},on:{"click":function($event){_vm.toothClick(46)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[45]) ? 'active' : ''),attrs:{"id":"dark_x5F_45","d":"M246.8,221.9c-0.6-0.2-1.2-0.4-1.8-0.6c-0.4-0.2-0.9-0.4-1.5-0.6c-2.5-1.1-6.4-2.8-10.6-2.8\n\t\tc-3.6,0-5.5,0.9-9.8,3.9c-0.8,0.5-1.7,0.9-2.6,1.4c-2.2,1-4.4,2-5.1,4.4c-0.7,2.5-0.7,4.2-0.7,5.9c0,1.7,1.9,11.4,5.3,20.3\n\t\tc0.9,8.9,1.2,18.3,0.9,26.1c-0.2,4.8-0.6,9.2-0.9,12.4c-0.2,2.4-0.4,4.1-0.4,5c0,1.6,0.2,3.1,0.5,5.4c0.2,1.2,0.3,2.7,0.5,4.3\n\t\tc0.2,3.9,0.5,8.2,0.8,12c0.1,2.3,0.1,4.8,0.1,7.7c0,2.7-0.6,4.9-1.1,6.8c-0.4,1.4-0.7,2.7-0.7,3.8c0,1.8,0,4.4,2.3,4.4\n\t\tc4.1,0,8.3-7.8,11-13.7c0.2-0.5,0.7-1.3,1.2-2.3c3.2-5.8,10.6-19.5,10.6-32c0-1.2,0.5-29.3,0.5-30.9c0-0.7,0.6-4.3,1.3-8.1\n\t\tc4.2-8.7,6.8-19.1,6.8-23.9C253.4,224.2,250.9,223.4,246.8,221.9z"},on:{"click":function($event){_vm.toothClick(45)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[44]) ? 'active' : ''),attrs:{"id":"dark_x5F_44","d":"M286.2,225.3c-1.3-0.9-2.6-1.8-3.9-2.9c-0.2-0.2-0.5-0.5-0.8-0.7c-1.6-1.5-4.1-3.8-7.3-3.8\n\t\tc-3.4,0-4.4,0.7-5.9,2.3l-0.5,0.5c-1.5,1.6-3.3,3.4-5.6,4.4c-2.5,1-6.8,7.1-6.8,11.6c0,3,1.6,11.4,4.4,18.9\n\t\tc0.2,0.6,0.5,1.2,0.7,1.8c0.8,3.3,1.5,6.9,1.7,9c0.2,2.6-0.4,7-0.9,11.2c-0.5,3.8-1,7.7-1,10.4c0,3.2,1.2,13.1,2.3,21.8\n\t\tc0.8,6.7,1.6,13,1.6,14.6c0,2-0.2,3.2-0.4,4.2c-0.1,0.9-0.3,1.7-0.3,2.8c0,2,0.6,6.2,2.6,6.2c2.7,0,6.8-7.1,10.5-18\n\t\tc0.1-0.4,0.3-0.9,0.4-1.3c0.1-0.3,0.2-0.6,0.3-1c0.1-0.3,0.2-0.6,0.3-0.9c4.3-13.8,7.9-32.7,7.9-51.5c0-3.5,0.3-6.4,0.7-8.8\n\t\tc4.1-7.3,7.3-15.8,7.3-20.9C293.4,230.3,289.9,227.9,286.2,225.3z"},on:{"click":function($event){_vm.toothClick(44)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[43]) ? 'active' : ''),attrs:{"id":"dark_x5F_43","d":"M326.2,222.8c-0.9-0.7-8.2-6.6-11.7-6.6c-3,0-8,2.4-12,9.3c-0.9,0.7-8.3,6.3-8.3,10.8\n\t\tc0,5.4,2.6,13.3,4.4,19c0.4,1.2,0.8,2.3,1,3.2c0.3,2.5,0.6,5,0.6,6.1c0,1.2-0.2,4.1-0.5,7.3c-0.4,4.2-0.8,9.1-0.8,11.9\n\t\tc0,8.4,2,20.8,3.5,29.8c0.8,5,1.5,8.9,1.5,10.4c0,2.6-0.6,6.7-1,9.7c-0.3,1.8-0.4,3-0.4,3.5c0,1.7,1.1,2.6,2.2,2.6\n\t\tc5,0,14.7-19.6,14.7-24.1c0-4.7,1.8-11.2,3.3-16.5c1.1-4,2.1-7.4,2.1-9.3c0-1.9,0.3-9.3,0.7-17.1c5.1-14.6,8.4-35.4,8.4-42.7\n\t\tC333.8,225.4,327.1,223.1,326.2,222.8z"},on:{"click":function($event){_vm.toothClick(43)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[42]) ? 'active' : ''),attrs:{"id":"dark_x5F_42","d":"M361.1,220.9l-19.3,0c-3.2-0.2-6.5,0.5-7,6.6c-0.3,3.5,0.8,20.3,4.5,33\n\t\tc-0.3,12.9-1.1,44-1.4,45.9c-0.3,2.5,3.6,17.3,4.3,18.9c0.4,1,0.1,7.8,0,10.3c0,0.7-0.1,1.2-0.1,1.4c0,1.2,1.8,2.9,3.3,2.9\n\t\tc4.7,0,16.4-24.2,16.9-81.1c0.1-0.4,0.2-0.7,0.4-1.1c2.9-9,4.5-18.6,4.5-21v-10.4C367.1,224.7,366.5,220.9,361.1,220.9z"},on:{"click":function($event){_vm.toothClick(42)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[41]) ? 'active' : ''),attrs:{"id":"dark_x5F_41","d":"M397.3,333.2c-0.9-1.9-3-6.2-3-12.9c0-3,0.9-6.3,1.8-9.6c0.8-2.9,1.5-5.6,1.5-7.7\n\t\tc0-2.7-0.1-4.5-0.4-7.2c-0.4-5.1-1.1-13.4-1.7-37.1c1.4-6.8,2.2-13.2,2.2-15.6v-18.3c0-1.7-1.2-3.6-3.9-3.6h-17.6\n\t\tc-1.9,0-7.9,1.5-7.9,3.6c0,11.5,1.9,25.3,5,37c1,61.9,12.2,75.2,21.6,75.2c2.5,0,2.8-1.4,2.8-2.6\n\t\tC397.8,334.1,397.7,333.8,397.3,333.2z"},on:{"click":function($event){_vm.toothClick(41)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[38]) ? 'active' : ''),attrs:{"id":"dark_x5F_38","d":"M760.1,273.8c0-8.4,1.8-15.5,3.5-21.9c1-3.9,1.9-7.3,2.2-10.4c0.3-1.4,0.5-2.8,0.5-4.1\n\t\tc0-6.1-1.5-11.1-4.2-14.4c-2.2-2.6-5.1-4.1-8.1-4.1c-4.2,0-9.6,3.3-12.6,5.1c-0.7,0.4-1.5,0.9-1.7,1c-0.2-0.1-0.7-0.4-1.1-0.6\n\t\tc-3.3-1.9-11.1-6.5-14.5-6.5c-3,0-4.9,1.9-6.7,3.5c-0.6,0.6-1.3,1.2-1.9,1.7l-0.4,0.3c-2,1.4-5.2,3.8-6.5,8.8c0-0.1,0-0.1,0,0\n\t\tc-0.3,1.3-0.5,2.7-0.5,4.4c0,4.6,2.1,9.4,5.3,13.8c0.8,1.7,1.9,3.6,2.9,5.6c2.5,4.7,5,9.5,5,11.7c0,3.5,0.9,15,0.9,15.4\n\t\tc0,22,12,50.7,16.4,50.7c2.3,0,3.2-1.8,3.2-3.4v-3.7c0-0.5,0.1-2.2,0.3-4.4c0.4-4.5,1-11.3,1-15.4c0-2-0.2-5.8-0.5-10.2\n\t\tc-0.4-6.8-1-16.7-0.5-19.4c0,0,0.1,0,0.1,0c1.5,3.4,5.5,19.8,6,24c0.2,1.5,1,3.6,1.8,6.2c1.6,4.6,3.6,10.2,3.6,15.4\n\t\tc0,3,1.7,7.4,4.4,7.4c3.8,0,7.9-14,7.9-23.5c0-3.1-1.1-7.2-2.3-12.1C762,288.1,760.1,280.9,760.1,273.8z"},on:{"click":function($event){_vm.toothClick(38)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[37]) ? 'active' : ''),attrs:{"id":"dark_x5F_37","d":"M706.8,241.6c0.3-1.4,0.5-2.8,0.5-4.1c0-6.1-1.5-11.1-4.2-14.4c-2.2-2.6-5.1-4.1-8.1-4.1\n\t\tc-4.2,0-9.7,3.3-12.6,5.1c-0.7,0.4-1.5,0.9-1.7,1c-0.2-0.1-0.7-0.4-1.1-0.6c-3.3-1.9-11.1-6.5-14.5-6.5c-3,0-4.9,1.9-6.7,3.5\n\t\tc-0.6,0.6-1.3,1.2-1.9,1.7l-0.4,0.3c-2,1.4-5.2,3.8-6.5,8.8c0-0.1,0-0.1,0,0c-0.3,1.3-0.5,2.7-0.5,4.4c0,4.6,2.1,9.4,5.3,13.8\n\t\tc0.8,1.7,1.9,3.6,2.9,5.6c2.5,4.7,5,9.5,5,11.7c0,3.5,0.9,15,0.9,15.4c0,22,12,50.7,16.4,50.7c2.3,0,3.2-1.8,3.2-3.4v-3.7\n\t\tc0-0.5,0.1-2.2,0.3-4.4c0.4-4.5,1-11.3,1-15.4c0-2-0.2-5.8-0.5-10.2c-0.4-6.8-1-16.7-0.5-19.4c0,0,0.1,0,0.1,0\n\t\tc1.5,3.4,5.5,19.8,6,24c0.2,1.5,1,3.6,1.8,6.2c1.6,4.6,3.6,10.2,3.6,15.4c0,3,1.7,7.4,4.4,7.4c3.8,0,7.9-14,7.9-23.5\n\t\tc0-3.1-1.1-7.2-2.3-12.1c-1.6-6.4-3.5-13.6-3.5-20.6c0-8.4,1.8-15.5,3.5-21.9C705.6,248.1,706.5,244.7,706.8,241.6z"},on:{"click":function($event){_vm.toothClick(37)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[36]) ? 'active' : ''),attrs:{"id":"dark_x5F_36","d":"M638.5,268.4c0-3,1.7-8.8,3.2-13.7c0.2-0.3,0.5-0.6,0.7-0.9c1-1.5,5.2-13.9,5.2-19.4\n\t\tc0-6.3-2.9-11.1-6.8-11.1c-3.1,0-5.4,2.3-6.3,3.5c-2.2-3.6-4.5-5.7-9.4-5.7c-3.4,0-8.5,1.3-10.4,3.5c-0.7-1.2-2.3-2.5-3.5-3.1\n\t\tc-1.5-0.7-8.2-3.5-10.8-3.5c-1.7,0-2.6,0.6-4,1.4c-0.8,0.5-1.7,1.1-3.1,1.7l-0.3,0.1c-3.7,1.8-7.2,3.6-7.2,11\n\t\tc0,3.1,0.8,12,3.9,19.7c0.8,2.3,1.8,4.7,2.8,7c2.1,4.9,4.1,9.6,4.1,12.8c0,3.5-0.2,5.2-0.5,7.2c-0.4,3.1-0.9,6.9-0.9,18.6\n\t\tc0,15.5,15.4,39.6,20.1,39.6c1.1,0,2.5-0.6,2.5-3.4c0-0.7-0.3-1.9-0.8-3.5c-0.4-1.5-3.1-19-3.1-27.3c0-8.6,2.6-15.1,4.3-15.1\n\t\tc1.2,0,6.1,1.8,8.7,10.4c4,13,8.2,20.9,10.5,25.2c0.8,1.5,1.5,2.7,1.5,3c0,3.1,3.9,9.3,5.9,9.3c2.2,0,3.7-4.3,3.7-10.6\n\t\tc0-4.9-2.7-17.5-5.2-29.7C640.9,283.6,638.5,272.5,638.5,268.4z"},on:{"click":function($event){_vm.toothClick(36)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[35]) ? 'active' : ''),attrs:{"id":"dark_x5F_35","d":"M585.2,233.5c0-1.8,0-3.5-0.7-5.9c-0.7-2.5-2.9-3.5-5.1-4.4c-1-0.4-1.9-0.8-2.6-1.4\n\t\tc-4.3-3-6.2-3.9-9.8-3.9c-4.3,0-8.1,1.7-10.6,2.8c-0.6,0.2-1.1,0.5-1.5,0.6c-0.6,0.2-1.2,0.4-1.8,0.6c-4.1,1.4-6.6,2.3-6.6,9\n\t\tc0,4.8,2.7,15.2,6.8,23.9c0.7,3.7,1.3,7.4,1.3,8.1c0,1.5,0.4,29.7,0.5,30.8c0,12.5,7.4,26.1,10.6,32c0.6,1,1,1.8,1.2,2.4\n\t\tc2.8,5.9,6.9,13.7,11,13.7c2.3,0,2.3-2.5,2.3-4.4c0-1.1-0.3-2.4-0.7-3.8c-0.5-1.9-1.1-4.1-1.1-6.8c0-2.8,0-5.4,0.1-7.7\n\t\tc0.2-3.8,0.5-8.2,0.8-12.1c0.2-1.7,0.3-3.1,0.5-4.3c0.3-2.2,0.5-3.8,0.5-5.4c0-0.9-0.2-2.6-0.4-5c-0.3-3.2-0.7-7.6-0.9-12.4\n\t\tc-0.4-7.8,0-17.2,0.9-26.1C583.3,245,585.2,235.2,585.2,233.5z"},on:{"click":function($event){_vm.toothClick(35)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[34]) ? 'active' : ''),attrs:{"id":"dark_x5F_34","d":"M537.9,225c-2.3-0.9-4.1-2.8-5.6-4.4l-0.5-0.5c-1.6-1.6-2.6-2.3-5.9-2.3\n\t\tc-3.3,0-5.7,2.3-7.3,3.8c-0.3,0.3-0.6,0.5-0.8,0.7c-1.3,1.1-2.6,2-3.9,2.9c-3.7,2.5-7.2,4.9-7.2,10c0,5.1,3.2,13.6,7.3,20.9\n\t\tc0.4,2.4,0.7,5.3,0.7,8.8c0,18.8,3.6,37.7,7.9,51.5c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.2,0.7,0.3,1c0.1,0.4,0.3,0.9,0.4,1.3\n\t\tc3.7,11,7.8,18,10.5,18c2,0,2.6-4.2,2.6-6.2c0-1.1-0.1-1.9-0.3-2.8c-0.2-1.1-0.4-2.3-0.4-4.2c0-1.6,0.8-7.9,1.6-14.6\n\t\tc1.1-8.7,2.3-18.6,2.3-21.8c0-2.7-0.5-6.6-1-10.4c-0.5-4.3-1.1-8.7-0.9-11.2c0.1-2.2,0.9-5.8,1.7-9c0.3-0.6,0.5-1.2,0.7-1.8\n\t\tc2.8-7.5,4.4-15.9,4.4-18.9C544.7,232.1,540.4,226,537.9,225z"},on:{"click":function($event){_vm.toothClick(34)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[33]) ? 'active' : ''),attrs:{"id":"dark_x5F_33","d":"M497.5,225.5c-4-6.9-9-9.3-12-9.3c-3.5,0-10.8,5.9-11.7,6.6c-0.9,0.3-7.6,2.6-7.6,7.5\n\t\tc0,7.3,3.3,28.2,8.4,42.7c0.3,7.8,0.7,15.2,0.7,17.1c0,1.9,1,5.3,2.1,9.3c1.5,5.2,3.3,11.8,3.3,16.5c0,4.5,9.6,24.1,14.7,24.1\n\t\tc1,0,2.2-0.9,2.2-2.6c0-0.5-0.2-1.8-0.4-3.5c-0.4-3-1-7.1-1-9.7c0-1.5,0.6-5.4,1.5-10.4c1.5-9,3.5-21.4,3.5-29.8\n\t\tc0-2.8-0.4-7.6-0.8-11.9c-0.3-3.3-0.5-6.1-0.5-7.3c0-1.1,0.3-3.6,0.6-6.1c0.3-0.9,0.6-2,1-3.2c1.9-5.7,4.4-13.6,4.4-19\n\t\tC505.8,231.8,498.5,226.2,497.5,225.5z"},on:{"click":function($event){_vm.toothClick(33)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[32]) ? 'active' : ''),attrs:{"id":"dark_x5F_32","d":"M465.2,227.5c-0.5-6.1-3.8-6.8-7-6.6h-19.3c-5.5,0-6.1,3.8-6.1,5.5v10.4\n\t\tc0,2.4,1.6,12,4.5,21c0.1,0.4,0.2,0.7,0.4,1.1c0.5,56.9,12.2,81.1,16.9,81.1c1.5,0,3.3-1.8,3.3-2.9c0-0.2,0-0.7-0.1-1.4\n\t\tc-0.1-2.5-0.4-9.3,0-10.3c0.6-1.5,4.6-16.3,4.3-18.9c-0.2-1.9-1-33-1.4-45.9C464.4,247.8,465.5,231,465.2,227.5z"},on:{"click":function($event){_vm.toothClick(32)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[31]) ? 'active' : ''),attrs:{"id":"dark_x5F_31","d":"M423.8,221.2h-17.6c-2.7,0-3.9,1.9-3.9,3.6V243c0,2.4,0.7,8.8,2.2,15.6\n\t\tc-0.6,23.7-1.3,32-1.7,37.1c-0.2,2.7-0.4,4.5-0.4,7.2c0,2.2,0.7,4.9,1.5,7.7c0.9,3.2,1.8,6.6,1.8,9.6c0,6.7-2.1,11.1-3,12.9\n\t\tc-0.3,0.7-0.5,1-0.5,1.2c0,1.2,0.3,2.6,2.8,2.6c9.5,0,20.6-13.3,21.6-75.2c3.1-11.7,5-25.5,5-37\n\t\tC431.6,222.6,425.7,221.2,423.8,221.2z"},on:{"click":function($event){_vm.toothClick(31)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[28]) ? 'active' : ''),attrs:{"id":"dark_x5F_28","d":"M756.9,120.8c-0.4-2.6-1-5.7-1.5-8.9c-1.2-7.1-2.5-14.4-2.5-16.9c0-3.4,0.1-10.1,0.3-17.3\n\t\tc0.2-8.5,0.4-17.2,0.4-22.5c0-32.1-12.6-33.6-12.7-33.6c-2.3,0-2.6,2.7-2.6,5.6c0,0.8,0.2,1.7,0.5,2.7c-0.2,0.3-0.3,0.8-0.3,1.3\n\t\tc0,1.4,0.5,9.5,0.5,9.8c0,4.1-2.4,13.2-4.3,19.4c-0.6-3.4-1.1-6.8-1.1-9c0-2.9,0.4-6.6,0.7-10.2c0.4-3.7,0.8-7.6,0.8-10.7\n\t\tc0-6.5-3.1-9.2-4.4-9.2c-1.3,0-3.3,1.9-3.3,4.3c0,0.6-1.2,3.7-2.5,7.4c-3.3,9-8.3,22.5-8.3,29.8c0,5.9,1.7,14.2,3.2,21.6\n\t\tc1.2,5.6,2.3,11,2.3,13.8c0,6.4-5.4,27.7-5.5,27.9l-0.1,0.5l0.1,0c-2.4,6.4-3.1,12.7-3.1,15.5c0,6.3,6.5,9.5,9.3,10.6\n\t\tc0.2,0.1,0.7,0.4,1.2,0.8c1.2,0.9,2.8,2.2,4.5,2.2c1.3,0,3.9-1.6,7.7-4c2.3-1.4,5.1-3.2,5.8-3.2c0.3,0.1,1.8,0.9,3.1,1.6\n\t\tc0.4,0.2,0.7,0.4,1,0.6c0.9,0.7,1.9,1.3,3.2,1.7c1.1,0.6,1.9,0.9,2.3,0.9c4.3,0,8.8-7,8.8-20.1\n\t\tC760.1,128.3,758.8,124.2,756.9,120.8z"},on:{"click":function($event){_vm.toothClick(28)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[27]) ? 'active' : ''),attrs:{"id":"dark_x5F_27","d":"M707.3,111.9c-1.2-7.1-2.5-14.4-2.5-16.9c0-3.4,0.1-10.1,0.3-17.3\n\t\tc0.2-8.5,0.4-17.2,0.4-22.5c0-32.1-12.6-33.6-12.7-33.6c-2.3,0-2.6,2.7-2.6,5.6c0,0.8,0.2,1.7,0.5,2.7c-0.2,0.3-0.3,0.8-0.3,1.3\n\t\tc0,1.4,0.5,9.5,0.5,9.8c0,4.1-2.4,13.2-4.2,19.4c-0.6-3.4-1.1-6.8-1.1-9c0-2.9,0.4-6.6,0.7-10.2c0.4-3.7,0.8-7.6,0.8-10.7\n\t\tc0-6.5-3.1-9.2-4.4-9.2c-1.3,0-3.3,1.9-3.3,4.3c0,0.6-1.2,3.7-2.5,7.4c-3.3,9-8.3,22.5-8.3,29.8c0,5.9,1.7,14.2,3.2,21.6\n\t\tc1.2,5.6,2.3,11,2.3,13.8c0,6.4-5.4,27.7-5.5,27.9l-0.1,0.5l0.1,0c-2.4,6.4-3.1,12.7-3.1,15.5c0,6.3,6.5,9.5,9.3,10.6\n\t\tc0.2,0.1,0.7,0.4,1.2,0.8c1.2,0.9,2.8,2.2,4.5,2.2c1.3,0,3.9-1.6,7.7-4c2.3-1.4,5.1-3.2,5.8-3.2c0.3,0.1,1.8,0.9,3.1,1.6\n\t\tc0.4,0.2,0.7,0.4,1,0.6c0.9,0.7,1.9,1.3,3.2,1.7c1.1,0.6,1.9,0.9,2.3,0.9c4.3,0,8.8-7,8.8-20.1c0-4.9-1.3-9-3.3-12.4\n\t\tC708.4,118.2,707.9,115.1,707.3,111.9z"},on:{"click":function($event){_vm.toothClick(27)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[26]) ? 'active' : ''),attrs:{"id":"dark_x5F_26","d":"M657.5,111.5c0.2-6.2,1.8-15.1,3.2-22.6c1.2-6.5,2.2-12.1,2.2-14.9c0-17.9-1.6-31.3-3.6-40\n\t\tc-0.2-0.7-0.3-1.4-0.5-2c-1.5-6-3.2-9.2-4.4-9.2c-1.5,0-2.9,3.2-2.9,4.5c0,1.4,0.2,2.8,0.3,4c0.1,1,0.2,2,0.2,2.7\n\t\tc-0.1,3.8-0.2,7.4-0.5,10.8c-1.2-10.4-2.6-18.9-3-20.7c-0.9-4.2-3.2-4.1-3.3-4.1c-0.5,0-1,0.1-1.5,0.3c-3.2,1.5-4.4,7.4-5.5,12.1\n\t\tc-0.4,1.8-0.7,3.4-1.1,4.3c-0.2,0.6-0.6,1.3-1.2,2.1c-0.5-4.6-2.3-15.7-5.5-15.7c-1.6,0-4,3.3-4,7.8c0,3.9-2.3,12.3-4.8,21.2\n\t\tc-2.6,9.4-5.3,19.1-5.3,24c0,4.6,1.6,13,2.9,20.5c0.9,5.1,1.8,9.9,2.1,12.6c0,0.2,0,0.4,0,0.7c0,0.2,0,0.3,0,0.5\n\t\tc0,5.2-0.3,6.7-0.3,6.7l-0.1,0.6h0.1c-2.1,7.7-3.8,12.7-5.1,16.4c-1.4,4-2.3,6.5-2.3,8.9c0,6.7,6,8.8,8,9.5l0.3,0.1\n\t\tc0.3,0.1,0.6,0.3,0.9,0.5c0.5,0.5,1.2,1.2,2.1,1.7c0.9,0.7,1.9,1.2,2.9,1.2c4.9,0,10.5-4.9,13.5-7.5c0.6-0.5,1.2-1.1,1.5-1.2\n\t\tc0.6,0.3,2.4,1.6,3.9,2.6c3.6,2.6,4.8,3.4,5.4,3.4c0.8,0,1.6-0.6,2.7-1.7c0,0,4.2-4.2,7.1-7.1c3-3,2.6-9.4,2.6-9.8\n\t\tC664.4,128.2,661.8,119,657.5,111.5z"},on:{"click":function($event){_vm.toothClick(26)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[25]) ? 'active' : ''),attrs:{"id":"dark_x5F_25","d":"M607,115.4l0.3,0.1l-2.2-22.4c-1.1-12.8-2.1-24.3-2.2-25.7c-0.2-1.9-0.9-5.2-1.8-9\n\t\tc-1.4-6.2-3.1-13.9-3.1-18.9c0-4.2,0.2-6.5,0.3-8.2c0.1-0.9,0.1-1.7,0.1-2.4c0-1.9-1.9-6.5-4.9-6.5c-10.1,0-13.3,45.7-13.3,67.8\n\t\tc0,8.8,0.2,24.4,0.3,33.3c-3,8.4-4.7,17.3-4.7,20.3c0,6.9,15.4,12.1,17.4,12.1c3.1,0,6.9-3.6,10.5-7.1l0.5-0.5\n\t\tc1.1-1.1,2.3-1.6,3.4-2.1c2.4-1,4.5-1.9,4.5-8c0-6.2-2-12.7-4.8-18.2C607.3,118.5,607.2,117,607,115.4z"},on:{"click":function($event){_vm.toothClick(25)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[24]) ? 'active' : ''),attrs:{"id":"dark_x5F_24","d":"M570.8,119.6c-0.3-1.2-0.7-2.3-1-3.4c-0.2-11.1-0.1-31.6-0.1-41.9c0-2.9,0-5.1,0-6.4\n\t\tc0-12.1-1.9-24-3.2-32.6c-0.8-4.9-1.4-8.8-1.4-11c0-2.4-0.9-3.8-2.4-3.8c-8.7,0-17.2,43.5-17.2,59.2c0,3.2-0.6,24.2-0.9,36\n\t\tc-4.5,9.8-7.5,21.7-7.5,24.7c0,5.5,2.6,9,7.6,10.4c1.1,0.3,2.5,1.1,4,2c2.3,1.4,4.8,2.9,7.2,2.9c1.6,0,2.7-0.8,4-1.7\n\t\tc1.2-0.9,2.6-1.9,4.8-2.6c9.3-2.9,10.6-8.3,10.6-13.2c0-3.3-0.8-5.8-2.3-10.9C572.5,125.3,571.7,122.7,570.8,119.6z"},on:{"click":function($event){_vm.toothClick(24)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[23]) ? 'active' : ''),attrs:{"id":"dark_x5F_23","d":"M529.9,111.3c0-4.3-1.1-8.6-2.8-12.5c0.7-8.3,1.5-19.5,1.5-25.2c0-6.3-2-19.3-3.5-28.9\n\t\tc-0.8-5-1.4-8.9-1.4-9.8c0-1.7,0.8-5.8,1.4-8.8c0.5-2.4,0.7-3.8,0.7-4.3c0-1.4-1.1-2.5-2.6-2.5c-7.8,0-16.2,26.4-16.7,36.7\n\t\tc-0.1,1.6-0.7,3.6-1.4,6c-1.5,5.1-3.7,12.2-3.7,23.6c0,3.7,0,4,0.1,16.8c-6,16.5-8.2,40.6-8.2,41c0,3.4,7.1,5.7,8.4,6.1\n\t\tc0.8,0.8,7,6.3,13.4,6.3c4.9,0,11.9-8.1,12.7-9c1-0.6,9.2-5.5,9.2-11.2c0-2.8-1.8-7.8-3.6-12.7\n\t\tC531.6,118.4,529.9,113.6,529.9,111.3z"},on:{"click":function($event){_vm.toothClick(23)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[22]) ? 'active' : ''),attrs:{"id":"dark_x5F_22","d":"M487.8,71.9c0-8.1-1.4-15.4-2.3-20.2c-0.5-2.4-0.8-4.3-0.8-5.4c0-0.5,0-4.1,0-8.4\n\t\tc0-6.1,0-13.6,0-15.2c0-1-0.3-1.7-0.6-2.2c-0.3-0.7-0.9-0.9-1.1-0.9c-0.3-0.1-0.6-0.2-0.8-0.2c-2.3,0-3.7,2.5-4.4,3.9\n\t\tc-0.3,0.6-0.6,0.9-1,1.3c-0.4,0.4-0.8,0.9-1.2,1.7c-3.3,5.8-5.9,13.8-7.9,22.7c0.1-1.7,0.3-3.2,0.5-4.4c0,0-0.3,2.4-0.9,6.2\n\t\tc-4.1,19.3-5.8,42.5-6.4,57.8c-1.2,2.7-2.3,6-3.2,9.8c-3.7,11.6-6.1,24.2-6.1,29.8c0,2.4,0.4,5.7,4.1,5.7c2.4,0,4.5,0.2,6,0.3\n\t\tc0.8,0.1,1.4,0.1,1.8,0.1c0.3,0,1.1,0.2,1.9,0.4c1.4,0.4,3.2,0.9,4.8,0.9c2.5,0,4.4-1.1,5.7-1.9c0.6-0.4,1.2-0.7,1.5-0.7\n\t\tc13.2,0,14.6-12,14.6-17.2c0-5.7-2.1-13.5-5-20.8C487.4,101.2,487.8,79.6,487.8,71.9z"},on:{"click":function($event){_vm.toothClick(22)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[21]) ? 'active' : ''),attrs:{"id":"dark_x5F_21","d":"M443.7,99.9c-0.2-2.4,0-11.3,0.2-19.2c0.1-5.1,0.2-9.9,0.2-12.7c0-8.8-2.4-19.5-4.3-28.1\n\t\tc-0.2-0.8-0.3-1.5-0.5-2.3c-0.7-3.9-1.4-7.2-1.8-9.7c0-0.5-0.1-0.9-0.1-1.3c0-1.5,0.2-2.2,0.4-3c0.2-0.7,0.4-1.4,0.4-2.5\n\t\tc0-1.5-1.6-2.3-2.5-2.3c-5.4,0-11.8,9.8-17.1,26.2c-0.4,1.4-0.9,2.8-1.3,4.2c0-0.2,0-0.2,0-0.2c-1.3,1.3-2.6,7.4-3.6,14.8\n\t\tc-2.5,12.2-3.8,25.1-3.8,37.2c0,1-0.1,2-0.2,3c-4.1,8.8-6.9,20.2-6.9,32.4c0,2.5,0,5.1-0.1,7.9c0,3.1-0.1,6.2-0.1,9.5v0.4l0.4,0.1\n\t\tc0.4,0.1,9,2.1,14.9,0.7c0.7,0.1,4.5,0.7,8.6,0.7c2.4,0,4.9-0.2,6.9-0.8c1.2,0.1,11.8,0.6,14.7-1.8c3.1-2.6,3.1-9.9,3.1-12.3\n\t\tc0-6.1-2.1-16.9-5.4-27.2C444.6,107.6,443.8,101.6,443.7,99.9z"},on:{"click":function($event){_vm.toothClick(21)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[18]) ? 'active' : ''),attrs:{"id":"dark_x5F_18","d":"M83.6,126.7l-0.1-0.5c-0.1-0.2-5.5-21.5-5.5-27.9c0-2.8,1.1-8.2,2.3-13.8\n\t\tc1.5-7.4,3.2-15.7,3.2-21.6c0-7.3-5-20.8-8.3-29.8c-1.3-3.6-2.5-6.8-2.5-7.4c0-2.4-2-4.3-3.3-4.3c-1.2,0-4.4,2.7-4.4,9.2\n\t\tc0,3.1,0.4,7,0.8,10.7c0.4,3.6,0.7,7.3,0.7,10.2c0,2.2-0.5,5.6-1.1,9c-1.8-6.2-4.3-15.2-4.3-19.3c0-0.3,0.5-8.5,0.5-9.8\n\t\tc0-0.5-0.1-0.9-0.3-1.3c0.3-1,0.5-1.9,0.5-2.7c0-2.9-0.3-5.6-2.6-5.6c-1,0-4.1,1-7,5.6c-3.8,5.9-5.7,15.4-5.7,28\n\t\tc0,5.3,0.2,14,0.4,22.5c0.1,7.1,0.3,13.8,0.3,17.3c0,2.5-1.3,9.8-2.5,16.9c-0.6,3.2-1.1,6.4-1.5,8.9c-2,3.4-3.3,7.5-3.3,12.4\n\t\tc0,13.1,4.5,20.1,8.8,20.1c0.4,0,1.2-0.3,2.3-0.9c1.3-0.4,2.3-1,3.2-1.7c0.3-0.2,0.7-0.4,1-0.6c1.3-0.7,2.8-1.6,3-1.6\n\t\tc0.7,0,3.6,1.8,5.8,3.2c3.8,2.4,6.4,4,7.7,4c1.8,0,3.4-1.3,4.5-2.2c0.5-0.4,0.9-0.7,1.2-0.8c2.8-1.1,9.3-4.3,9.3-10.6\n\t\tC86.7,139.4,86,133.1,83.6,126.7L83.6,126.7z"},on:{"click":function($event){_vm.toothClick(18)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[17]) ? 'active' : ''),attrs:{"id":"dark_x5F_17","d":"M131.7,126.7l-0.1-0.5c-0.1-0.2-5.5-21.5-5.5-27.9c0-2.8,1.1-8.2,2.3-13.8\n\t\tc1.5-7.4,3.2-15.7,3.2-21.6c0-7.3-5-20.8-8.3-29.8c-1.3-3.6-2.5-6.8-2.5-7.4c0-2.4-2-4.3-3.3-4.3c-1.2,0-4.4,2.7-4.4,9.2\n\t\tc0,3.1,0.4,7,0.8,10.7c0.4,3.6,0.7,7.3,0.7,10.2c0,2.2-0.5,5.6-1.1,9c-1.8-6.2-4.2-15.2-4.3-19.3c0-0.3,0.5-8.5,0.5-9.8\n\t\tc0-0.5-0.1-0.9-0.3-1.3c0.3-1,0.5-1.9,0.5-2.7c0-2.9-0.3-5.6-2.6-5.6c-1,0-4.1,1-7,5.6c-3.8,5.9-5.7,15.4-5.7,28\n\t\tc0,5.3,0.2,14,0.4,22.5c0.1,7.1,0.3,13.8,0.3,17.3c0,2.5-1.3,9.8-2.5,16.9c-0.6,3.2-1.1,6.4-1.5,8.9c-2,3.4-3.3,7.5-3.3,12.4\n\t\tc0,13.1,4.5,20.1,8.8,20.1c0.4,0,1.2-0.3,2.3-0.9c1.3-0.4,2.3-1,3.2-1.7c0.3-0.2,0.7-0.4,1-0.6c1.3-0.7,2.8-1.6,3-1.6\n\t\tc0.7,0,3.6,1.8,5.8,3.2c3.8,2.4,6.4,4,7.7,4c1.8,0,3.4-1.3,4.5-2.2c0.5-0.4,0.9-0.7,1.2-0.8c2.8-1.1,9.3-4.3,9.3-10.6\n\t\tC134.7,139.4,134,133.1,131.7,126.7L131.7,126.7z"},on:{"click":function($event){_vm.toothClick(17)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[16]) ? 'active' : ''),attrs:{"id":"dark_x5F_16","d":"M178.9,117.5L178.9,117.5l0-0.6c0,0-0.3-1.5-0.3-6.7c0-0.1,0-0.3,0-0.4c0-0.2,0-0.4,0-0.7\n\t\tc0.2-2.7,1.1-7.5,2.1-12.6c1.4-7.4,2.9-15.9,2.9-20.5c0-4.9-2.7-14.6-5.3-24c-2.5-8.9-4.8-17.2-4.8-21.2c0-4.5-2.4-7.8-4-7.8\n\t\tc-3.2,0-5,11.1-5.5,15.7c-0.5-0.8-0.9-1.5-1.2-2.1c-0.4-0.9-0.7-2.5-1.1-4.3c-1-4.8-2.3-10.7-5.5-12.1c-0.5-0.2-1-0.3-1.5-0.3\n\t\tc0,0,0,0,0,0c-0.1,0-2.4-0.1-3.3,4.1c-0.4,1.8-1.8,10.3-3,20.7c-0.3-3.4-0.4-7-0.5-10.8c0-0.7,0.1-1.7,0.2-2.7\n\t\tc0.2-1.2,0.3-2.6,0.3-4c0-1.2-1.4-4.5-2.9-4.5c-1.2,0-2.9,3.1-4.4,9.2c-0.2,0.6-0.3,1.2-0.5,2c-2,8.6-3.6,22.1-3.6,40\n\t\tc0,2.8,1,8.4,2.2,14.9c1.3,7.5,2.9,16.4,3.2,22.6c-4.3,7.6-7,16.7-7,22.9c0,0.5-0.4,6.8,2.6,9.8c2.9,2.9,7,7.1,7,7.1\n\t\tc1,1.2,1.9,1.7,2.7,1.7c0.6,0,1.8-0.8,5.4-3.4c1.5-1.1,3.4-2.4,3.9-2.6c0.3,0.2,0.9,0.7,1.5,1.2c3,2.6,8.6,7.5,13.5,7.5\n\t\tc1,0,2-0.5,2.9-1.2c0.9-0.5,1.6-1.1,2.1-1.7c0.3-0.2,0.6-0.4,0.9-0.5l0.3-0.1c2-0.7,8-2.8,8-9.5c0-2.5-0.9-4.9-2.3-8.9\n\t\tC182.7,130.1,180.9,125.1,178.9,117.5z"},on:{"click":function($event){_vm.toothClick(16)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[15]) ? 'active' : ''),attrs:{"id":"dark_x5F_15","d":"M219.7,90.1c0-22.1-3.3-67.8-13.3-67.8c-3,0-4.9,4.6-4.9,6.5c0,0.7,0.1,1.5,0.1,2.4\n\t\tc0.1,1.7,0.3,4,0.3,8.2c0,5-1.7,12.7-3.1,18.9c-0.9,3.8-1.6,7.1-1.8,9c-0.1,1.4-1.1,12.9-2.2,25.7l-2.2,22.4l0.3-0.1\n\t\tc-0.1,1.6-0.3,3.1-0.4,4.5c-2.8,5.5-4.8,12-4.8,18.2c0,6.1,2.1,7,4.5,8c1.1,0.5,2.3,1,3.4,2.1l0.5,0.5c3.7,3.5,7.5,7.1,10.5,7.1\n\t\tc2,0,17.4-5.2,17.4-12.1c0-3.5-1.9-12.3-4.7-20.3C219.5,114.5,219.7,98.9,219.7,90.1z"},on:{"click":function($event){_vm.toothClick(15)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[14]) ? 'active' : ''),attrs:{"id":"dark_x5F_14","d":"M254.5,79.7c0-15.7-8.6-59.2-17.2-59.2c-1.5,0-2.4,1.4-2.4,3.8c0,2.2-0.6,6.1-1.4,11\n\t\tc-1.4,8.7-3.2,20.5-3.2,32.6c0,1.2,0,3.5,0,6.4c0,10.3,0.1,30.8-0.1,41.9c-0.3,1.1-0.7,2.2-1,3.4c-0.9,3.1-1.6,5.7-2.2,7.7\n\t\tc-1.5,5.1-2.3,7.7-2.3,10.9c0,4.9,1.3,10.3,10.6,13.2c2.2,0.7,3.6,1.7,4.8,2.6c1.3,0.9,2.4,1.7,4,1.7c2.4,0,5-1.5,7.3-2.9\n\t\tc1.5-0.9,2.8-1.7,4-2c5.1-1.4,7.6-4.9,7.6-10.4c0-3.1-3-14.9-7.5-24.8C255,104,254.5,83,254.5,79.7z"},on:{"click":function($event){_vm.toothClick(14)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[13]) ? 'active' : ''),attrs:{"id":"dark_x5F_13","d":"M298.9,85.6c0-11.5-2.1-18.5-3.7-23.6c-0.7-2.4-1.3-4.4-1.4-6c-0.5-10.3-8.9-36.7-16.7-36.7\n\t\tc-1.5,0-2.6,1.1-2.6,2.5c0,0.5,0.3,1.9,0.7,4.3c0.6,3,1.4,7.2,1.4,8.8c0,0.9-0.6,4.9-1.4,9.8c-1.5,9.5-3.5,22.6-3.5,28.9\n\t\tc0,5.6,0.8,16.9,1.5,25.2c-1.7,3.8-2.8,8.2-2.8,12.5c0,2.3-1.7,7.1-3.4,11.6c-1.8,4.9-3.6,9.9-3.6,12.7c0,5.7,8.2,10.7,9.2,11.2\n\t\tc0.8,0.9,7.8,9,12.7,9c6.4,0,12.6-5.5,13.4-6.3c1.3-0.4,8.4-2.7,8.4-6.1c0-0.4-2.2-24.5-8.2-41C298.9,89.6,298.9,89.2,298.9,85.6z"},on:{"click":function($event){_vm.toothClick(13)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[12]) ? 'active' : ''),attrs:{"id":"dark_x5F_12","d":"M339.1,108.7c-0.6-15.3-2.3-38.5-6.4-57.8c-0.1-0.7-0.3-1.3-0.4-1.9\n\t\tc-2-8.9-4.6-16.9-7.9-22.7l0,0c-0.5-0.8-0.9-1.2-1.2-1.6c-0.4-0.4-0.7-0.8-1-1.3c-0.7-1.4-2-3.9-4.4-3.9c0,0,0,0,0,0\n\t\tc-0.2,0-0.5,0.1-0.7,0.2c-0.5,0.3-1,0.6-1.1,0.9c-0.4,0.5-0.6,1.2-0.6,2.2c0,1.6,0,9,0,15.2c0,4.3,0,7.9,0,8.4c0,1-0.4,2.9-0.8,5.4\n\t\tc-0.9,4.8-2.3,12.1-2.3,20.2c0,7.6,0.4,29.3,0.8,43.3c-2.9,7.3-5,15-5,20.8c0,5.2,1.4,17.2,14.6,17.2c0.3,0,0.9,0.3,1.5,0.7\n\t\tc1.3,0.8,3.2,1.9,5.7,1.9c1.6,0,3.4-0.5,4.8-0.9c0.8-0.2,1.6-0.4,1.9-0.4c0.4,0,1-0.1,1.8-0.1c1.4-0.1,3.6-0.3,6-0.3\n\t\tc3.7,0,4.1-3.2,4.1-5.7c0-5.6-2.4-18.2-6.1-29.8C341.4,114.6,340.3,111.4,339.1,108.7z"},on:{"click":function($event){_vm.toothClick(12)}}}),_vm._v(" "),_c('path',{staticClass:"st82",class:((_vm.tooth[11]) ? 'active' : ''),attrs:{"id":"dark_x5F_11","d":"M397.5,144.5c0-2.8-0.1-5.5-0.1-7.9c0-12.2-2.8-23.6-6.9-32.4c-0.1-1-0.2-2-0.2-3\n\t\tc0-12.1-1.4-25-3.8-37.2c-1.1-7.5-2.3-13.5-3.6-14.9c0,0,0,0.1,0,0.2c-0.4-1.4-0.8-2.8-1.3-4.2c-5.3-16.4-11.7-26.2-17.1-26.2\n\t\tc-0.9,0-2.5,0.8-2.5,2.3c0,1.1,0.2,1.8,0.4,2.5c0.2,0.7,0.4,1.5,0.4,3c0,0.4,0,0.8-0.1,1.3c-0.4,2.4-1.1,5.8-1.8,9.7\n\t\tc-0.2,0.7-0.3,1.5-0.5,2.3c-1.9,8.6-4.3,19.3-4.3,28.1c0,2.8,0.1,7.6,0.2,12.7c0.1,7.9,0.3,16.8,0.2,19.2\n\t\tc-0.1,1.7-0.9,7.7-1.8,13.8c-3.3,10.3-5.4,21.1-5.4,27.2c0,2.4,0,9.7,3.1,12.3c2.9,2.4,13.5,1.9,14.7,1.8c2,0.6,4.5,0.8,6.9,0.8\n\t\tc4.1,0,7.9-0.6,8.6-0.7c5.9,1.4,14.5-0.6,14.9-0.7l0.4-0.1v-0.4C397.5,150.7,397.5,147.5,397.5,144.5z"},on:{"click":function($event){_vm.toothClick(11)}}})]),_vm._v(" "),_c('g',{attrs:{"id":"separator_marks_deselcted"}},[_c('g',{attrs:{"id":"sep_x5F_42"},on:{"click":function($event){_vm.separatorClick(42)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"362.1","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[42]) ? 'active' : ''),attrs:{"points":"367.1,207.3 371.1,199.3 363.1,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_43"},on:{"click":function($event){_vm.separatorClick(43)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"328.3","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[43]) ? 'active' : ''),attrs:{"points":"333.3,207.3 337.3,199.3 329.3,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_44"},on:{"click":function($event){_vm.separatorClick(44)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"289.2","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[44]) ? 'active' : ''),attrs:{"points":"294.2,207.3 298.2,199.3 290.2,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_45"},on:{"click":function($event){_vm.separatorClick(45)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"250.1","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[45]) ? 'active' : ''),attrs:{"points":"255.1,207.3 259.1,199.3 251.1,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_46"},on:{"click":function($event){_vm.separatorClick(46)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"207.5","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[46]) ? 'active' : ''),attrs:{"points":"212.5,207.3 216.5,199.3 208.5,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_47"},on:{"click":function($event){_vm.separatorClick(47)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"145.4","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[47]) ? 'active' : ''),attrs:{"points":"150.4,207.3 154.4,199.3 146.4,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_48"},on:{"click":function($event){_vm.separatorClick(48)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"86.4","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[48]) ? 'active' : ''),attrs:{"points":"91.4,207.3 95.4,199.3 87.4,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_31-41"},on:{"click":function($event){_vm.separatorClick(31)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"395","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[31] || _vm.separators[41]) ? 'active' : ''),attrs:{"points":"400,207.3 396,199.3 404,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_32"},on:{"click":function($event){_vm.separatorClick(32)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"428.1","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[32]) ? 'active' : ''),attrs:{"points":"433.1,207.3 429.1,199.3 437.1,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_33"},on:{"click":function($event){_vm.separatorClick(33)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"461.9","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[33]) ? 'active' : ''),attrs:{"points":"466.9,207.3 462.9,199.3 470.9,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_34"},on:{"click":function($event){_vm.separatorClick(34)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"501","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[34]) ? 'active' : ''),attrs:{"points":"506,207.3 502,199.3 510,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_35"},on:{"click":function($event){_vm.separatorClick(35)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"540.1","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[35]) ? 'active' : ''),attrs:{"points":"545.1,207.3 541.1,199.3 549.1,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_36"},on:{"click":function($event){_vm.separatorClick(36)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"582.7","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[36]) ? 'active' : ''),attrs:{"points":"587.7,207.3 583.7,199.3 591.7,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_37"},on:{"click":function($event){_vm.separatorClick(37)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"644.8","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[37]) ? 'active' : ''),attrs:{"points":"649.8,207.3 645.8,199.3 653.8,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_38"},on:{"click":function($event){_vm.separatorClick(38)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"703.8","y":"199.3","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[38]) ? 'active' : ''),attrs:{"points":"708.8,207.3 704.8,199.3 712.8,199.3 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_22"},on:{"click":function($event){_vm.separatorClick(22)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"446.1","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[22]) ? 'active' : ''),attrs:{"points":"451.1,171 447.1,179 455.1,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_23"},on:{"click":function($event){_vm.separatorClick(23)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"488.2","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[23]) ? 'active' : ''),attrs:{"points":"493.2,171 489.2,179 497.2,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_24"},on:{"click":function($event){_vm.separatorClick(24)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"531.9","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[24]) ? 'active' : ''),attrs:{"points":"536.9,171 532.9,179 540.9,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_25"},on:{"click":function($event){_vm.separatorClick(25)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"570.6","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[25]) ? 'active' : ''),attrs:{"points":"575.6,171 571.6,179 579.6,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_26"},on:{"click":function($event){_vm.separatorClick(26)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"610.6","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[26]) ? 'active' : ''),attrs:{"points":"615.6,171 611.6,179 619.6,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_27"},on:{"click":function($event){_vm.separatorClick(27)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"661","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[27]) ? 'active' : ''),attrs:{"points":"666,171 662,179 670,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_28"},on:{"click":function($event){_vm.separatorClick(28)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"707.3","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[28]) ? 'active' : ''),attrs:{"points":"712.3,171 708.3,179 716.3,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_11-21"},on:{"click":function($event){_vm.separatorClick(11)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"395","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[11] || _vm.separators[21]) ? 'active' : ''),attrs:{"points":"400,171 404,179 396,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_12"},on:{"click":function($event){_vm.separatorClick(12)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"344","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[12]) ? 'active' : ''),attrs:{"points":"349,171 353,179 345,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_13"},on:{"click":function($event){_vm.separatorClick(13)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"302","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[13]) ? 'active' : ''),attrs:{"points":"307,171 311,179 303,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_14"},on:{"click":function($event){_vm.separatorClick(14)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"258.3","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[14]) ? 'active' : ''),attrs:{"points":"263.3,171 267.3,179 259.3,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_15"},on:{"click":function($event){_vm.separatorClick(15)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"219.6","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[15]) ? 'active' : ''),attrs:{"points":"224.6,171 228.6,179 220.6,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_16"},on:{"click":function($event){_vm.separatorClick(16)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"179.6","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[16]) ? 'active' : ''),attrs:{"points":"184.6,171 188.6,179 180.6,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_17"},on:{"click":function($event){_vm.separatorClick(17)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"129.2","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[17]) ? 'active' : ''),attrs:{"points":"134.2,171 138.2,179 130.2,179 \t\t"}})]),_vm._v(" "),_c('g',{attrs:{"id":"sep_x5F_18"},on:{"click":function($event){_vm.separatorClick(18)}}},[_c('rect',{staticClass:"st76",attrs:{"x":"82.9","y":"169","width":"10","height":"10"}}),_vm._v(" "),_c('polygon',{staticClass:"st83",class:((_vm.separators[18]) ? 'active' : ''),attrs:{"points":"87.9,171 91.9,179 83.9,179 \t\t"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"separator_Lines"}},[(((_vm.separators[48]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_48","x":"90.4","y":"200.2","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[47]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_47","x":"149.4","y":"200.2","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[46]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_46","x":"211.5","y":"200.2","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[45]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_45","x":"254.1","y":"200.2","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[44]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_44","x":"293.2","y":"200.2","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[43]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_43","x":"332.3","y":"200.3","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[42]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_42","x":"366.1","y":"200.2","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[38]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_38","x":"707.8","y":"200.2","transform":"matrix(-1 -4.456536e-11 4.456536e-11 -1 1417.5228 552.213)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[37]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_37","x":"648.8","y":"200.2","transform":"matrix(-1 -4.547486e-11 4.547486e-11 -1 1299.511 552.213)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[36]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_36","x":"586.6","y":"200.2","transform":"matrix(-1 -4.547486e-11 4.547486e-11 -1 1175.2864 552.213)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[35]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_35","x":"544.1","y":"200.2","transform":"matrix(-1 -4.547486e-11 4.547486e-11 -1 1090.1263 552.213)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[34]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_34","x":"505","y":"200.2","transform":"matrix(-1 -5.093182e-11 5.093182e-11 -1 1011.9271 552.213)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[33]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_33","x":"465.9","y":"200.3","transform":"matrix(-1 -4.547486e-11 4.547486e-11 -1 933.7532 552.338)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[32]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_32","x":"432","y":"200.2","transform":"matrix(-1 -4.456536e-11 4.456536e-11 -1 866.0775 552.213)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[31] || _vm.separators[41]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_31-41","x":"399","y":"200.2","transform":"matrix(-1 -4.547486e-11 4.547486e-11 -1 799.9603 552.213)","width":"2","height":"151.8"}}):_vm._e(),_vm._v(" "),(((_vm.separators[28]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_28","x":"711.3","y":"8","transform":"matrix(-1 -4.456536e-11 4.456536e-11 -1 1424.5892 185.9112)","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[27]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_27","x":"664.9","y":"8","transform":"matrix(-1 -4.456536e-11 4.456536e-11 -1 1331.8704 185.9112)","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[26]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_26","x":"614.6","y":"8","transform":"matrix(-1 -4.456536e-11 4.456536e-11 -1 1231.1702 185.9112)","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[25]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_25","x":"574.5","y":"8","transform":"matrix(-1 -4.365587e-11 4.365587e-11 -1 1151.0912 185.9112)","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[24]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_24","x":"535.9","y":"8","transform":"matrix(-1 -4.456536e-11 4.456536e-11 -1 1073.7596 185.9112)","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[23]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_23","x":"492.2","y":"8","transform":"matrix(-1 -4.547486e-11 4.547486e-11 -1 986.4089 186.0362)","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[22]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_22","x":"450.1","y":"8","transform":"matrix(-1 -4.456536e-11 4.456536e-11 -1 902.2572 185.9112)","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[18]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_18","x":"86.9","y":"8","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[17]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_17","x":"133.2","y":"8","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[16]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_16","x":"183.6","y":"8","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[15]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_15","x":"223.6","y":"8","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[14]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_14","x":"262.3","y":"8","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[13]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_13","x":"306","y":"8","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[12]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_12","x":"348","y":"8","width":"2","height":"170"}}):_vm._e(),_vm._v(" "),(((_vm.separators[11] || _vm.separators[21]) ? 'active' : ''))?_c('rect',{staticClass:"st84",attrs:{"id":"line_x5F_11-21","x":"399","y":"8","width":"2","height":"170"}}):_vm._e()])])}
var Teeth_staticRenderFns = []
var Teeth_esExports = { render: Teeth_render, staticRenderFns: Teeth_staticRenderFns }
/* harmony default export */ var components_Teeth = (Teeth_esExports);
// CONCATENATED MODULE: ./src/components/Teeth.vue
function injectStyle (ssrContext) {
  __webpack_require__("j9IK")
}
var Teeth_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Teeth___vue_template_functional__ = false
/* styles */
var Teeth___vue_styles__ = injectStyle
/* scopeId */
var Teeth___vue_scopeId__ = "data-v-73730bd6"
/* moduleIdentifier (server only) */
var Teeth___vue_module_identifier__ = null
var Teeth_Component = Teeth_normalizeComponent(
  Teeth,
  components_Teeth,
  Teeth___vue_template_functional__,
  Teeth___vue_styles__,
  Teeth___vue_scopeId__,
  Teeth___vue_module_identifier__
)

/* harmony default export */ var src_components_Teeth = (Teeth_Component.exports);

// CONCATENATED MODULE: ./src/api/protetics.js


/* harmony default export */ var protetics = ({
  getProtetics: function getProtetics(params, cb) {
    AxApi.get('/rest/Protetics/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveProtetic: function saveProtetic(params, cb) {
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/Protetics/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/Protetics/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deleteProtetic: function deleteProtetic(params, cb) {
    AxApi.post('/rest/Protetics/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  resetProtetics: function resetProtetics(params, cb) {
    AxApi.post('/rest/Protetics/resetProtetics', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./src/api/protetic_colors.js


/* harmony default export */ var protetic_colors = ({
  getColors: function getColors(params, cb) {
    params.type = 'ordination';
    AxApi.get('/rest/ProteticColors/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/WorkOrder.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var WorkOrder_moment = __webpack_require__("PJh5");

/* harmony default export */ var WorkOrder = ({
  name: 'WorkOrder',
  components: {
    'patientsgallery': src_components_PatientsGallery,
    'teeth': src_components_Teeth
  },
  data: function data() {
    return {
      workOrderId: false,
      chatUserId: false,
      patientdata: {},
      protetics: {},
      implantchecked: false,
      category: 'fixed',
      galleryPatientId: false,
      workorder: {},
      tasks: [],
      talks: [],
      possibleUsers: {},
      formTaskError: {},
      formTask: {
        id: '',
        text: '',
        toUserId: '',
        deadlinedate: '',
        deadlinetime: { HH: "10", mm: "00" }
      },
      expenses: [],
      formExpenseError: {},
      formExpense: {
        text: '',
        price: 0
      },
      tasksvisible: false,
      chatvisible: false,
      colors: {},
      selectedColor: false,
      mobileTab: 'protetic',
      toothprops: {},
      tooth: {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false,
        upper: false,
        lower: false
      },
      separators: {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false
      },
      upperSelected: false,
      lowerSelected: false,
      showProtetics: false,
      showInfo: false
    };
  },
  created: function created() {
    var me = this;

    me.workOrderId = me.$route.params.workOrderId;

    me.chatvisible = false;
    me.tasksvisible = false;

    if (typeof me.$route.query.open != 'undefined' && me.$route.query.open == 'tasks') {
      me.tasksvisible = true;
    }

    if (typeof me.$route.query.open != 'undefined' && me.$route.query.open == 'chat') {
      me.chatvisible = true;
    }

    me.refreshProtetics();

    me.getWorkOrder();

    setInterval(function () {
      if (window.innerWidth >= 768) me.showProtetics = true;else if (me.mobileTab == 'protetic') me.showProtetics = true;else me.showProtetics = false;

      if (window.innerWidth >= 768) me.showInfo = true;else if (me.mobileTab == 'info') me.showInfo = true;else me.showInfo = false;
    }, 1000);
  },
  methods: {
    selectAll: function selectAll(what) {
      var me = this;

      var obj = me.upperSelected;

      me.tooth.upper = false;
      me.tooth.lower = false;

      if (what[0] == 31) obj = me.lowerSelected;

      if (!obj) {
        me.activateTeeth(what[0], what[7], what[8], what[15], true);
        if (me.category != 'fixed') {
          if (what[0] == 31) me.tooth.lower = true;else me.tooth.upper = true;
        }
      } else {
        me.deactivateTeeth(what[0], what[7], what[8], what[15], true);
      }

      if (what[0] == 31) me.lowerSelected = !me.lowerSelected;else me.upperSelected = !me.upperSelected;
    },
    getWorkOrder: function getWorkOrder() {
      var me = this;

      workorders.getWorkOrders({ workOrderId: me.workOrderId }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }

        me.workorder = data.root[0];
        if (data.root[0].separators != '') me.separators = JSON.parse(data.root[0].separators);

        patients.getPatient({ id: me.workorder.patientId }, function (data) {
          if (data.error && data.error == true) {
            vue_esm["default"].$notify.error(data.notice);
            return;
          }
          me.patientdata = data.root;
        });

        me.getTasks();
        me.getTalks();
        me.getExpenses();
        me.getProtetics();
        me.getWorkOrderPossibleUsers({});
        me.getProteticColors();
      });
    },
    getProteticColors: function getProteticColors() {
      var me = this;
      protetic_colors.getColors({}, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }

        me.colors = data;
      });
    },
    returnTalkTime: function returnTalkTime(dateTime) {
      return WorkOrder_moment(dateTime).format('DD.MM.YYYY. (HH:mm)');
    },
    startChat: function startChat() {
      var me = this;
      this.$store.commit('setChatData', { chatUserId: me.chatUserId, workOrderId: me.workOrderId });
    },

    toogleTooth: function toogleTooth(tooths) {
      var me = this;
      me.tooth.upper = false;
      me.tooth.lower = false;
      if (me.category == 'fixed') {
        for (var i = 0; i < tooths.length; i++) {
          me.activateTeeth(tooths[i], tooths[i]);
        }
      } else {
        var tooth = tooths[0];
        if (me.tooth[tooth] == false) {
          me.deactivateAllTeeth();
          if (tooth >= 11 && tooth <= 18 || tooth >= 21 && tooth <= 28) {
            me.activateTeeth(11, 18, 21, 28);
            me.tooth.upper = true;
          } else if (tooth >= 31 && tooth <= 38 || tooth >= 41 && tooth <= 48) {
            me.activateTeeth(31, 38, 41, 48);
            me.tooth.lower = true;
          }
        } else me.deactivateAllTeeth();
      }
    },
    toogleSeparators: function toogleSeparators(separator) {
      var me = this;
      me.separators[separator[0]] = !me.separators[separator[0]];
      workorders.toogleSeparators({ workOrderId: me.workOrderId, separators: stringify_default()(me.separators) }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }
        me.getWorkOrder();
      });
    },

    activateTeeth: function activateTeeth(start, end, secStart, secEnd, noDeact) {
      var me = this;

      if (typeof noDeact == 'undefined' || noDeact == false) {
        for (var i = start; i <= end; i++) {
          if (me.tooth[i] == true) {
            me.deactivateTeeth(start, end, secStart, secEnd);
            return;
          }
        }

        for (var i = secStart; i <= secEnd; i++) {
          if (me.tooth[i] == true) {
            me.deactivateTeeth(start, end, secStart, secEnd);
            return;
          }
        }
      }

      for (var i = start; i <= end; i++) {
        me.tooth[i] = true;
      }

      for (var i = secStart; i <= secEnd; i++) {
        me.tooth[i] = true;
      }
    },
    deactivateTeeth: function deactivateTeeth(start, end, secStart, secEnd) {
      var me = this;
      for (var i = start; i <= end; i++) {
        me.tooth[i] = false;
      }

      for (var i = secStart; i <= secEnd; i++) {
        me.tooth[i] = false;
      }
    },
    deactivateAllTeeth: function deactivateAllTeeth() {
      var me = this;
      for (var i = 11; i <= 48; i++) {
        me.tooth[i] = false;
      }
    },
    addProtetic: function addProtetic(protetic) {
      var me = this;
      workorders.addProtetic({ workOrderId: me.workOrderId, proteticId: protetic.proteticId, tooths: stringify_default()(me.tooth) }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }
        me.refreshProtetics();
      });
    },
    deleteToothProp: function deleteToothProp(props) {
      var me = this;

      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          workorders.deleteProtetic({ workOrderId: me.workOrderId, props: stringify_default()(props) }, function (data) {
            if (data.error && data.error == true) {
              vue_esm["default"].$notify.error(data.notice);
              return;
            }
            me.refreshProtetics();
          });
        }
      });
    },
    refreshProtetics: function refreshProtetics() {
      var me = this;
      workorders.getProtetics({ workOrderId: me.workOrderId }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }

        me.toothprops = data.data;
      });
    },
    getProtetics: function getProtetics() {
      var me = this;
      protetics.getProtetics({ workOrderId: me.workOrderId, active: 1 }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }
        me.protetics = data;
      });
    },
    getWorkOrderPossibleUsers: function getWorkOrderPossibleUsers(params) {
      var me = this;
      workorders.getWorkOrderPossibleUsers(extends_default()({}, params, { workOrderId: me.workOrderId }), function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }
        me.possibleUsers = data;
      });
    },
    showPatientGallery: function showPatientGallery() {
      var me = this;
      me.galleryPatientId = false;
      vue_esm["default"].nextTick(function () {
        me.galleryPatientId = me.workorder.patientId;
      });
    },
    saveTask: function saveTask(bvEvt) {
      var me = this;

      bvEvt.preventDefault();

      me.formTask.workOrderId = me.workorder.workOrderId;
      var params = assign_default()({}, me.formTask);
      console.log(stringify_default()(params.deadlinetime));
      params.deadlinedate = WorkOrder_moment(params.deadlinedate).format('YYYY-MM-DD');
      params.deadlinetime = params.deadlinetime.HH + ':' + params.deadlinetime.mm;

      workorders.saveTask(params, function (val) {
        if (val.error) {
          me.formTaskError = val;
        } else {
          me.formTask.text = '';
          me.$refs.newtask.hide();
          me.getTasks();
        }
      });
    },
    getTasks: function getTasks() {
      var me = this;
      workorders.getTasks({ workOrderId: me.workorder.workOrderId }, function (data) {
        if (data.error && data.error == true) {
          me.$notify.error(data.notice);
          return;
        }
        me.tasks = data.root;
      });
    },
    getTalks: function getTalks() {
      var me = this;
      workordertalks.selectAllWorkOrderChats({ workOrderId: me.workorder.workOrderId }, function (data) {
        if (data.error && data.error == true) {
          me.$notify.error(data.notice);
          return;
        }
        me.talks = data.root;
      });
    },
    deleteTask: function deleteTask(workOrderTaskId) {
      var me = this;

      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          workorders.deleteTask({ id: workOrderTaskId }, function (data) {
            if (data.error && data.error == true) vue_esm["default"].$notify.error(data.notice);else vue_esm["default"].$notify.success(data.notice);
            me.getTasks();
          });
        }
      });
    },
    newTask: function newTask() {
      var me = this;
      me.formTask = {
        id: '',
        text: '',
        toUserId: '',
        deadlinedate: '',
        deadlinetime: { HH: "10", mm: "00" }
      };
      me.$refs.newtask.show();
    },
    editTask: function editTask(data) {
      var me = this;
      data = assign_default()({}, data, {});
      data.id = data.workOrderTaskId;
      data.deadlinedate = data.deadline;
      data.deadlinetime = { HH: WorkOrder_moment(data.deadline).format('HH'), mm: WorkOrder_moment(data.deadline).format('mm') };
      me.formTask = data;
      me.$refs.newtask.show();
    },
    newExpense: function newExpense() {
      var me = this;
      me.formExpense = {
        text: '',
        price: 0
      };
      me.$refs.newexpense.show();
    },
    saveExpenses: function saveExpenses(bvEvt) {
      var me = this;

      bvEvt.preventDefault();

      workorders.saveExpenses({ workOrderId: me.workorder.workOrderId, text: me.formExpense.text, price: me.formExpense.price }, function (val) {
        if (val.error) {
          me.formExpenseError = val;
        } else {
          me.formExpense.text = '';
          me.$refs.newexpense.hide();
          me.getExpenses();
        }
      });
    },
    getExpenses: function getExpenses() {
      var me = this;
      workorders.getExpenses({ workOrderId: me.workorder.workOrderId }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }
        me.expenses = data.root;
      });
    },
    deleteExpenses: function deleteExpenses(workOrderExpenseId) {
      var me = this;

      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          workorders.deleteExpenses({ id: workOrderTaskId }, function (data) {
            if (data.error && data.error == true) vue_esm["default"].$notify.error(data.notice);else vue_esm["default"].$notify.success(data.notice);
            me.getExpenses();
          });
        }
      });
    },
    closeWorkOrder: function closeWorkOrder() {
      var me = this;

      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          workorders.saveWorkOrder({ id: me.workorder.workOrderId, status: 'closed' }, function (data) {
            if (data.error && data.error == true) vue_esm["default"].$notify.error(data.notice);else me.workorder.status = 'closed';
          });
        }
      });
    },
    toggleMobileTabs: function toggleMobileTabs() {
      var me = this;
      if (me.mobileTab == 'protetic') me.mobileTab = 'info';else me.mobileTab = 'protetic';
    }
  },
  watch: {
    'workorder.notice': function workorderNotice(val, oldVal) {
      var me = this;

      if (typeof oldVal == 'undefined') return;

      workorders.saveWorkOrder({ id: me.workorder.workOrderId, notice: val }, function (data) {
        if (data.error && data.error == true) vue_esm["default"].$notify.error(data.notice);
      });
    },
    'workorder.color': function workorderColor(val, oldVal) {
      var me = this;

      if (typeof oldVal == 'undefined') return;

      workorders.saveWorkOrder({ id: me.workorder.workOrderId, color: val }, function (data) {
        if (data.error && data.error == true) vue_esm["default"].$notify.error(data.notice);
      });
    },
    category: function category() {
      var me = this;
      me.deactivateAllTeeth();
    },
    tooth: function tooth() {
      alert('xxxx');
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
    filteredprotetics: function filteredprotetics() {
      var me = this;

      var out = [],
          outone = [];
      if (me.protetics.root) {
        for (var i = 0; i < me.protetics.root.length; i++) {
          var protetic = me.protetics.root[i];
          if (protetic.category == me.category) {
            if (me.category == 'fixed') {
              if (me.implantchecked == true && protetic.implant == true) {
                outone.push(protetic);
                continue;
              } else if (me.implantchecked == false && protetic.implant == true) {
                continue;
              }
            }
            out.push(protetic);
          }
        }
      }

      return [].concat(outone, out);
    },
    selectedprotetics: function selectedprotetics() {
      var me = this;

      var out = [];
      if (me.protetics.root) {
        for (var i = 0; i < me.protetics.root.length; i++) {
          var protetic = me.protetics.root[i];
          if (protetic.num > 0) out.push(protetic);
        }
      }

      return out;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-387a39ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkOrder.vue
var WorkOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page workorder"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-4 title"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2 col-md-1"},[_c('a',{on:{"click":_vm.back}},[_c('img',{attrs:{"src":__webpack_require__("Abw3"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-11 namescol"},[_c('h1',[_vm._v(_vm._s(_vm.patientdata.name)+" "+_vm._s(_vm.patientdata.surname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('WORKORDER'))+": "+_vm._s(_vm.workorder.workOrderId))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 namescol"},[_c('span',[_vm._v(_vm._s(_vm.$t('DOCTOR')))]),_vm._v(" "),(_vm.workorder.doctorName != null)?_c('a',{on:{"click":function($event){$event.preventDefault();_vm.startChatByUserId(_vm.workorder.ordinationUserId, _vm.workOrderId)}}},[_c('img',{attrs:{"src":__webpack_require__("y/Pd"),"alt":""}}),_vm._v(" "+_vm._s(_vm.workorder.doctorName)+" "+_vm._s(_vm.workorder.doctorSurname))]):_vm._e(),_vm._v(" "),(_vm.workorder.doctorName == null)?_c('a',[_vm._v(_vm._s(_vm.workorder.dummyPartner))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-6 namescol"},[_c('span',[_vm._v(_vm._s(_vm.$t('TECHNICIAN')))]),_vm._v(" "),(_vm.workorder.tehnicianName != null)?_c('a',{on:{"click":function($event){$event.preventDefault();_vm.startChatByUserId(_vm.workorder.tehnicianUserId, _vm.workOrderId)}}},[_c('img',{attrs:{"src":__webpack_require__("y/Pd"),"alt":""}}),_vm._v(" "+_vm._s(_vm.workorder.tehnicianName)+" "+_vm._s(_vm.workorder.technicianSurname))]):_vm._e(),_vm._v(" "),(_vm.workorder.tehnicianName == null)?_c('a',[_vm._v(_vm._s(_vm.workorder.dummyPartner))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"},[_c('router-link',{staticClass:"btn btn-white d-none d-md-block",attrs:{"to":{ path: '/printworkorder/'+_vm.workOrderId}}},[_c('img',{attrs:{"src":__webpack_require__("AN+Y"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('PRINTWORKORDER')))])],1)])]),_vm._v(" "),_c('div',{staticClass:"gridheader secondary d-md-none"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"tablink",class:(_vm.mobileTab == 'protetic') ? 'active' : '',attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMobileTabs($event)}}},[_vm._v(_vm._s(_vm.$t('PROTETICLIST')))])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('a',{staticClass:"tablink",class:(_vm.mobileTab == 'info') ? 'active' : '',attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleMobileTabs($event)}}},[_vm._v(_vm._s(_vm.$t('INFORMATIONS')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 first-col d-none d-md-block"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.$t('PROTETICLIST')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('a',{class:(_vm.category == 'fixed') ? 'active' : '',on:{"click":function($event){$event.preventDefault();_vm.category = 'fixed'}}},[_vm._v(_vm._s(_vm.$t('FIXED')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('a',{class:(_vm.category == 'mobile') ? 'active' : '',on:{"click":function($event){$event.preventDefault();_vm.category = 'mobile'}}},[_vm._v(_vm._s(_vm.$t('MOBILE')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('a',{class:(_vm.category == 'other') ? 'active' : '',on:{"click":function($event){$event.preventDefault();_vm.category = 'other'}}},[_vm._v(_vm._s(_vm.$t('REST')))])])])]),_vm._v(" "),_c('div',{staticClass:"list-container"},[(_vm.category == 'fixed')?_c('div',{staticClass:"implant-comp"},[_vm._v(_vm._s(_vm.$t('IMPLANTCOMPONENTS'))+" "),_c('b-form-checkbox',{staticClass:"grey",model:{value:(_vm.implantchecked),callback:function ($$v) {_vm.implantchecked=$$v},expression:"implantchecked"}},[_vm._v(_vm._s(_vm.$t('SHOW')))])],1):_vm._e(),_vm._v(" "),_c('ul',_vm._l((_vm.filteredprotetics),function(protetic){return _c('li',{on:{"click":function($event){_vm.addProtetic(protetic)}}},[_c('span',{staticClass:"col-md-8 title"},[_vm._v(_vm._s(protetic.name))]),_c('span',{staticClass:"col-md-2 shortname-type",style:('background-color: '+(protetic.color)+';')},[_vm._v(_vm._s(protetic.shortname))]),_c('span',{staticClass:"col-md-2 quantity"},[_vm._v("x"+_vm._s(protetic.num))])])}))])]),_vm._v(" "),(_vm.showProtetics)?_c('div',{staticClass:"col-lg-3 first-col d-md-none"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.$t('PROTETICLIST')))])])]),_vm._v(" "),_c('div',{staticClass:"list-container"},[_c('ul',_vm._l((_vm.selectedprotetics),function(protetic){return _c('li',[_c('span',{staticClass:"col-md-8 title"},[_vm._v(_vm._s(protetic.name))]),_c('span',{staticClass:"col-md-2 shortname-type",style:('background-color: '+(protetic.color)+';')},[_vm._v(_vm._s(protetic.shortname))]),_c('span',{staticClass:"col-md-2 quantity"},[_vm._v("x"+_vm._s(protetic.num))])])}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-6 mainworkorderteeth d-none d-md-block"},[_c('div',{staticClass:"row tm100"},[_c('div',{staticClass:"col-md-12 center"},[_c('a',{staticClass:"btn btn-fourth",on:{"click":function($event){$event.preventDefault();_vm.selectAll([11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28])}}},[_vm._v(_vm._s(_vm.$t('SELECTALL')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 center"},[_c('img',{staticClass:"workorderteethimg",attrs:{"src":__webpack_require__("TB/a")}}),_vm._v(" "),_c('div',{staticClass:"workorderteeth"},[_c('div',{staticClass:"selectedteeth"},[_c('teeth',{attrs:{"tooth":_vm.tooth,"separators":_vm.separators},on:{"teethclick":_vm.toogleTooth,"separatorclick":_vm.toogleSeparators}})],1),_vm._v(" "),_vm._l((_vm.toothprops.upper),function(props){return _c('span',{staticClass:"bigname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.name))])}),_vm._v(" "),_c('div',{staticClass:"upper"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[18]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[17]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[16]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[15]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[14]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[13]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[12]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[11]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])}))]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[21]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[22]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[23]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[24]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[25]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[26]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[27]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[28]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])}))])]),_vm._v(" "),_c('div',{staticClass:"middle"}),_vm._v(" "),_c('div',{staticClass:"lower"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[48]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[47]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[46]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[45]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[44]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[43]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[42]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[41]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])}))]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[31]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[32]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[33]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[34]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[35]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[36]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[37]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[38]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.shortname))])}))])]),_vm._v(" "),_vm._l((_vm.toothprops.lower),function(props){return _c('span',{staticClass:"bigname-type lower-type",style:('background-color: '+props.color),on:{"click":function($event){$event.preventDefault();_vm.deleteToothProp(props)}}},[_vm._v(_vm._s(props.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 center"},[_c('a',{staticClass:"btn btn-fourth",on:{"click":function($event){$event.preventDefault();_vm.selectAll([31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48])}}},[_vm._v(_vm._s(_vm.$t('SELECTALL')))])])])]),_vm._v(" "),(_vm.showInfo)?_c('div',{staticClass:"col-lg-3 last-col enable-scroll"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.notice",modifiers:{"notice":true}}],staticClass:"col-item"},[_vm._v(_vm._s(_vm.$t('NOTICE'))+" "),_c('span',{staticClass:"down"})]),_vm._v(" "),_c('b-collapse',{attrs:{"accordion":"right-accordion","visible":_vm.workorder.notice != '',"id":"notice"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.workorder.notice),expression:"workorder.notice"}],staticClass:"form-control secondary",attrs:{"name":"notice"},domProps:{"value":(_vm.workorder.notice)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workorder, "notice", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.tasks",modifiers:{"tasks":true}}],staticClass:"col-item"},[_vm._v(_vm._s(_vm.$t('TASKS'))+" "),_c('span',{staticClass:"down"}),_vm._v(" "),_c('a',{staticClass:"flexright"},[_c('img',{attrs:{"src":__webpack_require__("gnEX"),"alt":""},on:{"click":function($event){$event.stopPropagation();_vm.newTask($event)}}})])]),_vm._v(" "),_c('b-collapse',{staticClass:"tasks",attrs:{"accordion":"right-accordion","id":"tasks","visible":_vm.tasksvisible}},[_c('div',[_c('ul',_vm._l((_vm.tasks),function(task){return _c('li',[_c('div',{class:task.status},[_c('div',[_c('span',{staticClass:"user"},[(task.userId != _vm.globals.userId)?_c('img',{attrs:{"src":__webpack_require__("eX+1"),"alt":""},on:{"click":function($event){$event.preventDefault();_vm.startChatByUserId(task.userId, _vm.workOrderId)}}}):_vm._e(),_vm._v(" "+_vm._s(task.name)+" "+_vm._s(task.surname)+" "),_c('img',{attrs:{"src":__webpack_require__("zsfH"),"alt":""}}),_vm._v(" "+_vm._s(task.toName)+" "+_vm._s(task.toSurname)+" "),(task.toUserId != _vm.globals.userId)?_c('img',{attrs:{"src":__webpack_require__("eX+1"),"alt":""},on:{"click":function($event){$event.preventDefault();_vm.startChatByUserId(task.toUserId, _vm.workOrderId)}}}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(task.deadline))]),_vm._v(" "),(task.status == 'finished')?_c('span',{staticClass:"finishedtask"},[_vm._v("("+_vm._s(_vm.$t('FINISHED'))+")")]):_vm._e()]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":__webpack_require__("vCtq"),"alt":""},on:{"click":function($event){_vm.editTask(task)}}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("z6Az"),"alt":""},on:{"click":function($event){_vm.deleteTask(task.workOrderTaskId)}}})])]),_vm._v(" "),_c('div',{staticClass:"inner"},[_vm._v("\n                  "+_vm._s(task.text)+"\n                ")])])}))])]),_vm._v(" "),_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.additionalexpenses",modifiers:{"additionalexpenses":true}}],staticClass:"col-item"},[_vm._v(_vm._s(_vm.$t('ADDITIONALEXPENSES'))+" "),_c('span',{staticClass:"down"}),_vm._v(" "),_c('a',{staticClass:"flexright"},[_c('img',{attrs:{"src":__webpack_require__("gnEX"),"alt":""},on:{"click":function($event){$event.stopPropagation();_vm.newExpense($event)}}})])]),_vm._v(" "),_c('b-collapse',{staticClass:"tasks",attrs:{"accordion":"right-accordion","id":"additionalexpenses"}},[_c('div',[_c('ul',_vm._l((_vm.expenses),function(expense){return _c('li',[_c('div',[_c('div',[_vm._v("\n                    "+_vm._s(_vm.$t('PRICE'))+"\n                  ")]),_vm._v(" "),_c('div',[_vm._v("\n                    "+_vm._s(expense.price)+" "+_vm._s(_vm.$t('KNABBRV'))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"inner"},[_vm._v("\n                  "+_vm._s(expense.text)+"\n                ")])])}))])]),_vm._v(" "),_c('div',{staticClass:"col-item",on:{"click":_vm.showPatientGallery}},[_vm._v(_vm._s(_vm.$t('GALLERY'))+" "),_vm._m(0,false,false)]),_vm._v(" "),_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.talks",modifiers:{"talks":true}}],staticClass:"col-item"},[_vm._v(_vm._s(_vm.$t('TALKS'))+" "),_c('span',{staticClass:"down"}),_vm._v(" "),_c('a',{staticClass:"flexright"},[_c('img',{directives:[{name:"b-modal",rawName:"v-b-modal.newchat",modifiers:{"newchat":true}}],attrs:{"src":__webpack_require__("gnEX"),"alt":""}})])]),_vm._v(" "),_c('b-collapse',{staticClass:"tasks",attrs:{"accordion":"right-accordion","id":"talks","visible":_vm.chatvisible}},[_c('div',[_c('ul',_vm._l((_vm.talks),function(talk){return _c('li',{key:talk.workOrderTalkId,on:{"click":function($event){$event.preventDefault();_vm.startChatByUserId((talk.toUserId == _vm.globals.userId ? talk.fromUserId : talk.toUserId), _vm.workOrderId)}}},[_c('div',[_c('div',[_c('span',{staticClass:"user"},[_c('img',{attrs:{"src":__webpack_require__("eX+1"),"alt":""}}),_vm._v(" "+_vm._s(talk.name)+" "+_vm._s(talk.surname)+" "),_c('img',{attrs:{"src":__webpack_require__("zsfH"),"alt":""}}),_vm._v(" "+_vm._s(talk.toName)+" "+_vm._s(talk.toSurname))]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.returnTalkTime(talk.dateTime)))])])]),_vm._v(" "),_c('div',{staticClass:"inner"},[_vm._v("\n                  "+_vm._s(talk.text)+"\n                ")])])}))])]),_vm._v(" "),_c('div',{staticClass:"workorderstatus"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group "},[_c('label',[_vm._v(_vm._s(_vm.$t('COLOR')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.workorder.color),expression:"workorder.color"}],staticClass:"form-control secondary",attrs:{"name":"color"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.workorder, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.colors.root),function(color){return _c('option',{domProps:{"value":color.colorValue}},[_vm._v(_vm._s(color.colorValue))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('WORKORDERSTATUS')))]),_vm._v(" "),(_vm.workorder.status == 'open')?_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.closeWorkOrder}},[_vm._v(_vm._s(_vm.$t('CLOSEWORKORDER')))]):_vm._e(),_vm._v(" "),(_vm.workorder.status == 'closed')?_c('a',{staticClass:"btn btn-red"},[_vm._v(_vm._s(_vm.$t('WORKORDERCLOSED')))]):_vm._e()])])])],1):_vm._e()]),_vm._v(" "),_c('patientsgallery',{attrs:{"patientId":_vm.galleryPatientId}}),_vm._v(" "),_c('b-modal',{ref:"newtask",attrs:{"centered":"","size":"lg","id":"newtask","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWTASK')},on:{"ok":_vm.saveTask}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group",class:(_vm.formTaskError.notice && _vm.formTaskError.notice.text) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('TEXT')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formTask.text),expression:"formTask.text"}],staticClass:"form-control secondary",domProps:{"value":(_vm.formTask.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formTask, "text", $event.target.value)}}}),_vm._v(" "),(_vm.formTaskError.notice && _vm.formTaskError.notice.text)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formTaskError.notice.text))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('inputvalidation',{attrs:{"label":_vm.$t('DATE'),"formerror":_vm.formTaskError,"name":"deadline"}},[_c('datepicker',{attrs:{"format":"dd.MM.yyyy","bootstrapStyling":true,"placeholder":_vm.$t('DATE')},model:{value:(_vm.formTask.deadlinedate),callback:function ($$v) {_vm.$set(_vm.formTask, "deadlinedate", $$v)},expression:"formTask.deadlinedate"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('inputvalidation',{attrs:{"label":_vm.$t('TIME'),"formerror":_vm.formTaskError,"name":"deadline"}},[_c('timepicker',{attrs:{"format":"HH:mm","minute-interval":15,"placeholder":_vm.$t('DEADLINE')},model:{value:(_vm.formTask.deadlinetime),callback:function ($$v) {_vm.$set(_vm.formTask, "deadlinetime", $$v)},expression:"formTask.deadlinetime"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('inputvalidation',{attrs:{"label":_vm.$t('TOUSER'),"formerror":_vm.formTaskError,"name":"toUserId"}},[_c('autocompletesimple',{attrs:{"data":_vm.possibleUsers.root,"placeholder":_vm.$t('TOUSER'),"valuekey":'userId',"text":'nameSurname'},on:{"query":_vm.getWorkOrderPossibleUsers},model:{value:(_vm.formTask.toUserId),callback:function ($$v) {_vm.$set(_vm.formTask, "toUserId", $$v)},expression:"formTask.toUserId"}})],1)],1)]),_vm._v(" "),(_vm.formTaskError.error && typeof _vm.formTaskError.notice == 'string')?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formTaskError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('b-modal',{ref:"newexpense",attrs:{"centered":"","size":"lg","id":"newexpense","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWEXPENSE')},on:{"ok":_vm.saveExpenses}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:(_vm.formExpenseError.notice && _vm.formExpenseError.notice.text) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('TEXT')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.formExpense.text),expression:"formExpense.text"}],staticClass:"form-control secondary",domProps:{"value":(_vm.formExpense.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formExpense, "text", $event.target.value)}}}),_vm._v(" "),(_vm.formExpenseError.notice && _vm.formExpenseError.notice.text)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formExpenseError.notice.text))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:(_vm.formExpenseError.notice && _vm.formExpenseError.notice.price) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('PRICE')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formExpense.price),expression:"formExpense.price"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('PRICE')},domProps:{"value":(_vm.formExpense.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formExpense, "price", $event.target.value)}}}),_vm._v(" "),(_vm.formExpenseError.notice && _vm.formExpenseError.notice.price)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formExpenseError.notice.price))]):_vm._e()])])]),_vm._v(" "),(_vm.formExpenseError.error && typeof _vm.formExpenseError.notice == 'string')?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formExpenseError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('b-modal',{ref:"newchat",attrs:{"centered":"","size":"sm","id":"newchat","ok-title":_vm.$t('STARTCHAT'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWCHAT')},on:{"ok":_vm.startChat}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('SELECTUSER')))]),_vm._v(" "),_c('b-form-select',{staticClass:"form-control secondary",attrs:{"plain":true,"options":_vm.possibleUsers.root,"value-field":"userId","text-field":"nameSurname","placeholder":_vm.$t('SELECTUSER')},model:{value:(_vm.chatUserId),callback:function ($$v) {_vm.chatUserId=$$v},expression:"chatUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)}
var WorkOrder_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"flexright"},[_c('img',{attrs:{"src":__webpack_require__("sE/t"),"alt":""}})])}]
var WorkOrder_esExports = { render: WorkOrder_render, staticRenderFns: WorkOrder_staticRenderFns }
/* harmony default export */ var components_WorkOrder = (WorkOrder_esExports);
// CONCATENATED MODULE: ./src/components/WorkOrder.vue
var WorkOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var WorkOrder___vue_template_functional__ = false
/* styles */
var WorkOrder___vue_styles__ = null
/* scopeId */
var WorkOrder___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WorkOrder___vue_module_identifier__ = null
var WorkOrder_Component = WorkOrder_normalizeComponent(
  WorkOrder,
  components_WorkOrder,
  WorkOrder___vue_template_functional__,
  WorkOrder___vue_styles__,
  WorkOrder___vue_scopeId__,
  WorkOrder___vue_module_identifier__
)

/* harmony default export */ var src_components_WorkOrder = (WorkOrder_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./src/api/dentalsolutions.js




/* harmony default export */ var dentalsolutions = ({
    getDentalSolutions: function getDentalSolutions(params, cb) {
        AxApi.get('/rest/DentalSolutions/selectRow', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    selectDentalSolutionUsers: function selectDentalSolutionUsers(params, cb) {
        AxApi.get('/rest/DentalSolutions/selectDentalSolutionUsers', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    getReport: function getReport(params, cb) {
        AxApi.get('/rest/DentalSolutions/getReport', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    getMonthlyReport: function getMonthlyReport(params, cb) {
        AxApi.get('/rest/DentalSolutions/getMonthlyReport', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    getClientReport: function getClientReport(params, cb) {
        AxApi.get('/rest/DentalSolutions/getClientReport', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    saveDentalSolution: function saveDentalSolution(params, cb) {
        if (typeof params.id != 'undefined' && params.id != '') {
            AxApi.post('/rest/DentalSolutions/updateRow', params).then(function (response) {
                cb(response.data);
            }).catch(function (e) {
                //TODO
            });
        } else {
            AxApi.post('/rest/DentalSolutions/insertRow', params).then(function (response) {
                cb(response.data);
            }).catch(function (e) {
                //TODO
            });
        }
    },
    deleteDentalSolution: function deleteDentalSolution(params, cb) {
        AxApi.post('/rest/DentalSolutions/deleteRow', params).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    uploadStl: function uploadStl(params, cb) {
        AxApi.post('/rest/DentalSolutions/uploadStl', params).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    deleteStl: function deleteStl(params, cb) {
        AxApi.post('/rest/DentalSolutions/deleteStl', params).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    changeFilePlatform: function changeFilePlatform(params, cb) {
        AxApi.post('/rest/DentalSolutions/changeFilePlatform', params).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    saveAll: function saveAll(params, cb) {
        AxApi.get('/rest/DentalSolutions/saveAll', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    getDentalSolutionPossibleUsers: function getDentalSolutionPossibleUsers(params, cb) {
        AxApi.get('/rest/DentalSolutions/getDentalSolutionPossibleUsers', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    getDentalSolutionOrdererCompanies: function getDentalSolutionOrdererCompanies(params, cb) {
        AxApi.get('/rest/DentalSolutions/getDentalSolutionOrdererCompanies', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    },
    deleteOpened: function deleteOpened() {
        var _this = this;

        return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return AxApi.get('/rest/DentalSolutions/deleteOpened');

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DentalSolutions.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DentalSolutions = ({
    name: 'DentalSolutions',
    data: function data() {
        var me = this;
        return {
            dentalsolutions: {
                root: [],
                totalCount: 0
            },
            dentalsolutionsorderercompanies: {
                root: [],
                totalCount: 0
            },
            formData: {
                id: '',
                workerCompanyId: ''
            },
            formError: {},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 20,
                showAll: false,
                ordererCompanyId: null
            }
        };
    },
    created: function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            var me;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            me = this;
                            _context.next = 3;
                            return dentalsolutions.deleteOpened();

                        case 3:

                            this.getDentalSolutions();
                            this.getDentalSolutionOrdererCompanies();

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
        getDentalSolutionCompaniesInit: 'getDentalSolutionCompanies'
    }), {
        toDentalSolution: function toDentalSolution(dentalSolutionId) {
            var me = this;
            me.$router.push('/dentalsolutions/' + dentalSolutionId);
        },
        saveDentalSolution: function saveDentalSolution(bvEvt) {
            var me = this;
            bvEvt.preventDefault();

            dentalsolutions.saveDentalSolution(me.formData, function (val) {
                if (val.error) {
                    if (typeof_default()(val.notice) == 'object') {
                        var notice = '';
                        for (var key in val.notice) {
                            notice += val.notice[key];
                        }
                        val.notice = notice;
                    }
                    me.formError = val;
                } else {
                    me.$refs.newdentalsolution.hide();
                    me.$router.push('/dentalsolutions/' + val.lastId);
                }
            });
        },
        getDentalSolutions: function getDentalSolutions() {
            var me = this;
            dentalsolutions.getDentalSolutions(me.getParams, function (data) {
                if (data.error && data.error == true) {
                    vue_esm["default"].$notify.error(data.notice);
                    return;
                }
                me.dentalsolutions = data;
            });
        },
        getDentalSolutionOrdererCompanies: function getDentalSolutionOrdererCompanies() {
            var me = this;
            dentalsolutions.getDentalSolutionOrdererCompanies({}, function (data) {
                if (data.error && data.error == true) {
                    vue_esm["default"].$notify.error(data.notice);
                    return;
                }
                me.dentalsolutionsorderercompanies = data;
            });
        },
        deleteDentalSolution: function deleteDentalSolution(id) {
            var me = this;
            me.$store.commit('setModalAlert', {
                text: me.$i18n.t('AREYOUSHURE'),
                btnAction: function btnAction() {
                    dentalsolutions.deleteDentalSolution({
                        id: id
                    }, function (data) {
                        if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
                        me.getDentalSolutions();
                    });
                }
            });
        },
        addDentalSolution: function addDentalSolution() {
            var me = this;

            if (me.globals.defaultDentalSolutionsCompanyId.trim() != '' && me.globals.defaultDentalSolutionsUserId.trim() != '') {
                dentalsolutions.saveDentalSolution(me.formData, function (val) {
                    if (val.error) {
                        vue_esm["default"].$notify.error(val.notice);
                    } else {
                        me.$router.push('/dentalsolutions/' + val.lastId);
                    }
                });
                return;
            }

            me.formData = {
                id: '',
                workerCompanyId: ''
            };

            me.$refs.newdentalsolution.show();
        },

        setWorkerCompanyId: function setWorkerCompanyId(data) {
            var me = this;
            me.formData.workerCompanyId = data;
        }
    }),
    watch: {
        saveDentalSolutionResponse: function saveDentalSolutionResponse(val) {
            var me = this;

            me.formError = {};

            if (val.error == true) {
                if (typeof_default()(val.notice) == 'object') {
                    me.formError = val.notice;
                    val.notice = '';
                }
            } else {
                this.$refs.newdentalsolution.hide();
                me.getDentalSolutions();
                for (var key in me.formData) {
                    me.formData[key] = '';
                }
            }
        },
        'pagination.query': function paginationQuery() {
            var me = this;
            me.getDentalSolutions();
        },
        'pagination.currentPage': function paginationCurrentPage(newValue, oldValue) {
            var me = this;
            me.getDentalSolutions();
        },
        'pagination.showAll': function paginationShowAll() {
            var me = this;
            me.getDentalSolutions();
        },
        'pagination.ordererCompanyId': function paginationOrdererCompanyId() {
            var me = this;
            me.getDentalSolutions();
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['modalAlert', 'dentalSolutionCompanies', 'globals']), {
        getParams: function getParams() {
            var me = this;
            var data = assign_default()({}, me.pagination, {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getDentalSolutionCompanies: function getDentalSolutionCompanies() {
            var me = this,
                options = [];

            for (var i = 0; i < me.dentalSolutionCompanies.root.length; i++) {
                var company = me.dentalSolutionCompanies.root[i];
                options.push({
                    value: company.companyId,
                    text: company.companyName
                });
            }

            return options;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050484e4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DentalSolutions.vue
var DentalSolutions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-4 title"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 namescol"},[_c('h1',[_vm._v(_vm._s(_vm.$t('ORDERS')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"text-left"},[_c('b-form-checkbox',{staticClass:"grey",model:{value:(_vm.pagination.showAll),callback:function ($$v) {_vm.$set(_vm.pagination, "showAll", $$v)},expression:"pagination.showAll"}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('SHOWALL')))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.globals.auth == 9)?_c('div',[_c('label',[_vm._v(_vm._s(_vm.$t('COMPANY')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pagination.ordererCompanyId),expression:"pagination.ordererCompanyId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.pagination, "ordererCompanyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('ALL')))]),_vm._v(" "),_vm._l((_vm.dentalsolutionsorderercompanies.root),function(item){return _c('option',{key:item.ordererCompanyId,domProps:{"value":item.ordererCompanyId}},[_vm._v(_vm._s(item.companyName))])})],2)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action d-none d-md-block"},[(_vm.globals.auth != 9)?_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.addDentalSolution}},[_c('img',{attrs:{"src":__webpack_require__("2L7A"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDDENTALSOLUTION')))]):_vm._e()])])]),_vm._v(" "),(_vm.dentalsolutions.root.length == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 center nothing"},[_c('img',{attrs:{"src":__webpack_require__("UD2X"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('CURRENTLYNOORDERS')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.addDentalSolution}},[_c('img',{attrs:{"src":__webpack_require__("2L7A"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDDENTALSOLUTION')))])])]):_vm._e(),_vm._v(" "),(_vm.dentalsolutions.root.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('NUM')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ORDEREDON')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('OPENEDBY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('NOTIFYDATE')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('PRODUCT')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('QUANTITY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('STLFILESNUM')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('STATUS')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('NOTICE')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.dentalsolutions.root),function(dentalsolution){return _c('tr',{key:dentalsolution.dentalSolutionId},[_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(dentalsolution.dentalSolutionId))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(_vm.formatDate(dentalsolution.openDateTime)))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(dentalsolution.name)+" "+_vm._s(dentalsolution.surname))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(_vm.formatDate(dentalsolution.notifyDate, 'DD.MM.YYYY.')))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell",on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(_vm.$t(dentalsolution.product)))]),_vm._v(" "),_c('td',{on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(dentalsolution.num))]),_vm._v(" "),_c('td',{on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(dentalsolution.files ? dentalsolution.files.length : 0))]),_vm._v(" "),_c('td',{staticClass:"status",class:dentalsolution.status,on:{"click":function($event){_vm.toDentalSolution(dentalsolution.dentalSolutionId)}}},[_vm._v(_vm._s(dentalsolution.statusOut))]),_vm._v(" "),_c('td',[(dentalsolution.notice !== '')?_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":dentalsolution.notice,"src":__webpack_require__("d5YL"),"alt":""}}):_vm._e()])])}))])])]):_vm._e(),_vm._v(" "),(_vm.dentalsolutions.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":parseInt(_vm.dentalsolutions.totalCount),"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"newdentalsolution",attrs:{"centered":"","size":"sm","id":"newdentalsolution","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWDENTALSOLUTION')},on:{"ok":_vm.saveDentalSolution}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('inputvalidation',{attrs:{"label":_vm.$t('DENTALSOLUTIONCOMPANY'),"formerror":_vm.formError,"name":"workerCompanyId"}},[_c('autocomplete',{attrs:{"setvalue":_vm.setWorkerCompanyId,"value":_vm.formData.workerCompanyId,"placeholder":_vm.$t('DENTALSOLUTIONCOMPANY'),"values":_vm.getDentalSolutionCompanies,"initdata":_vm.getDentalSolutionCompaniesInit}})],1)],1)]),_vm._v(" "),(_vm.formError.error && _vm.formError.notice)?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)}
var DentalSolutions_staticRenderFns = []
var DentalSolutions_esExports = { render: DentalSolutions_render, staticRenderFns: DentalSolutions_staticRenderFns }
/* harmony default export */ var components_DentalSolutions = (DentalSolutions_esExports);
// CONCATENATED MODULE: ./src/components/DentalSolutions.vue
var DentalSolutions_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DentalSolutions___vue_template_functional__ = false
/* styles */
var DentalSolutions___vue_styles__ = null
/* scopeId */
var DentalSolutions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DentalSolutions___vue_module_identifier__ = null
var DentalSolutions_Component = DentalSolutions_normalizeComponent(
  DentalSolutions,
  components_DentalSolutions,
  DentalSolutions___vue_template_functional__,
  DentalSolutions___vue_styles__,
  DentalSolutions___vue_scopeId__,
  DentalSolutions___vue_module_identifier__
)

/* harmony default export */ var src_components_DentalSolutions = (DentalSolutions_Component.exports);

// CONCATENATED MODULE: ./src/api/dentalsolutiontypes.js


/* harmony default export */ var dentalsolutiontypes = ({
    selectRow: function selectRow(params, cb) {
        AxApi.get('/rest/DentalSolutionsTypes/selectRow', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DentalSolution.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var DentalSolution_moment = __webpack_require__("PJh5");

/* harmony default export */ var DentalSolution = ({
    name: 'DentalSolution',
    data: function data() {
        return {
            solutionLoaded: false,
            dentalSolutionId: false,
            showNoticeModal: false,
            chatUserId: false,
            dentalsolutiontypes: {},
            category: 'printing',
            dentalSolution: {},
            talks: [],
            possibleUsers: {},
            chatvisible: false,
            colors: ['A1', 'A2', 'A3'],
            selectedColor: false,
            showCenterPart: true,
            showInfo: true,
            loading: false,
            platform: ['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 'p7', 'p8', 'p9', 'p10']
        };
    },
    created: function created() {
        var _this = this;

        return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            var me;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            me = _this;


                            me.dentalSolutionId = me.$route.params.dentalSolutionId;

                            me.chatvisible = false;

                            if (typeof me.$route.query.open != 'undefined' && me.$route.query.open == 'chat') {
                                me.chatvisible = true;
                            }

                            _context.next = 6;
                            return me.getDentalSolution();

                        case 6:

                            me.getDentalSolutionTypes();

                            setInterval(function () {
                                if (window.innerWidth >= 768) me.showCenterPart = true;else if (me.mobileTab == 'protetic') me.showCenterPart = true;else me.showCenterPart = false;

                                if (window.innerWidth >= 768) me.showInfo = true;else if (me.mobileTab == 'info') me.showInfo = true;else me.showInfo = false;
                            }, 1000);

                        case 8:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    methods: {
        delayedReload: function delayedReload() {
            var me = this;

            setTimeout(function () {
                me.getDentalSolution();
            }, 1000);
        },
        formatDate: function formatDate(date) {
            return DentalSolution_moment(date).format('YYYY-MM-DD');
        },
        updateProperty: function updateProperty(dentalSolutionId, params) {
            var _this2 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                var me;
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                me = _this2;


                                me.loading = true;

                                _context2.next = 4;
                                return dentalsolutions.saveDentalSolution(extends_default()({}, params, { id: dentalSolutionId }), function (data) {
                                    me.loading = false;

                                    if (data.error && data.error == true) {
                                        vue_esm["default"].$notify.error(data.notice);
                                    }

                                    me.getDentalSolution();
                                });

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        changeOrderStatus: function changeOrderStatus(dentalSolutionId, status) {
            var _this3 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                var me;
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                me = _this3;


                                me.$store.commit('setModalAlert', {
                                    text: me.$i18n.t('AREYOUSHURE'),
                                    btnAction: function () {
                                        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                                            return regenerator_default.a.wrap(function _callee3$(_context3) {
                                                while (1) {
                                                    switch (_context3.prev = _context3.next) {
                                                        case 0:
                                                            me.loading = true;

                                                            _context3.next = 3;
                                                            return dentalsolutions.saveDentalSolution({ id: dentalSolutionId, status: status }, function (data) {
                                                                me.loading = false;

                                                                if (data.error && data.error == true) {
                                                                    vue_esm["default"].$notify.error(data.notice);
                                                                }

                                                                me.getDentalSolution();
                                                            });

                                                        case 3:
                                                        case 'end':
                                                            return _context3.stop();
                                                    }
                                                }
                                            }, _callee3, this);
                                        }));

                                        function btnAction() {
                                            return _ref.apply(this, arguments);
                                        }

                                        return btnAction;
                                    }()
                                });

                            case 2:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            }))();
        },
        changeFilePlatform: function changeFilePlatform(file) {
            var _this4 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
                var me;
                return regenerator_default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                me = _this4;


                                me.loading = true;

                                _context5.next = 4;
                                return dentalsolutions.changeFilePlatform({ dentalSolutionFileId: file.dentalSolutionFileId, dentalSolutionId: me.dentalSolutionId, platform: file.platform }, function (data) {
                                    me.loading = false;

                                    if (data.error && data.error == true) {
                                        vue_esm["default"].$notify.error(data.notice);
                                    }

                                    me.getDentalSolution();
                                });

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this4);
            }))();
        },
        filesChange: function filesChange(fieldName, fileList) {
            var _this5 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                var me;
                return regenerator_default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                me = _this5;


                                me.loading = true;

                                _context6.next = 4;
                                return dentalsolutions.uploadStl(extends_default()({}, fileList, { dentalSolutionId: me.dentalSolutionId }), function (data) {
                                    me.loading = false;

                                    if (data.error && data.error == true) {
                                        vue_esm["default"].$notify.error(data.notice);
                                    }

                                    me.getDentalSolution();
                                });

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this5);
            }))();
        },
        deleteStl: function deleteStl(dentalSolutionFileId) {
            var _this6 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                var me;
                return regenerator_default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                me = _this6;


                                me.loading = true;

                                _context7.next = 4;
                                return dentalsolutions.deleteStl({ dentalSolutionFileId: dentalSolutionFileId, dentalSolutionId: me.dentalSolutionId }, function (data) {
                                    me.loading = false;

                                    if (data.error && data.error == true) {
                                        vue_esm["default"].$notify.error(data.notice);
                                    }

                                    me.getDentalSolution();
                                });

                            case 4:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this6);
            }))();
        },
        getDentalSolutionTypes: function getDentalSolutionTypes() {
            var me = this;
            dentalsolutiontypes.selectRow({}, function (data) {
                if (data.error && data.error == true) {
                    vue_esm["default"].$notify.error(data.notice);
                    return;
                }

                if (data.root) {
                    for (var i = 0; i < data.root.length; i++) {
                        var ds = data.root[i];
                        if (ds.dentalSolutionTypeId == me.dentalSolution.dentalSolutionTypeId) {
                            me.category = ds.category;
                        }
                    }
                }

                me.dentalsolutiontypes = assign_default()({}, data);
            });
        },
        getDentalSolution: function getDentalSolution() {
            var _this7 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                var me;
                return regenerator_default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                me = _this7;


                                me.loading = true;

                                _context8.next = 4;
                                return dentalsolutions.getDentalSolutions({
                                    dentalSolutionId: me.dentalSolutionId
                                }, function (data) {
                                    me.loading = false;

                                    if (data.error && data.error == true) {
                                        vue_esm["default"].$notify.error(data.notice);
                                        return;
                                    }

                                    me.dentalSolution = assign_default()({}, data.root[0]);

                                    me.getTalks();
                                    me.getDentalSolutionPossibleUsers({});

                                    me.$nextTick(function () {
                                        me.solutionLoaded = true;
                                    });
                                });

                            case 4:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this7);
            }))();
        },
        returnTalkTime: function returnTalkTime(dateTime) {
            return DentalSolution_moment(dateTime).format('DD.MM.YYYY. (HH:mm)');
        },
        startChat: function startChat() {
            var me = this;
            this.$store.commit('setChatData', {
                chatUserId: me.chatUserId,
                dentalSolutionId: me.dentalSolutionId
            });
        },

        getDentalSolutionPossibleUsers: function getDentalSolutionPossibleUsers(params) {
            var me = this;
            dentalsolutions.getDentalSolutionPossibleUsers(extends_default()({}, params, {
                dentalSolutionId: me.dentalSolutionId
            }), function (data) {
                if (data.error && data.error == true) {
                    vue_esm["default"].$notify.error(data.notice);
                    return;
                }
                me.possibleUsers = data;
            });
        },
        getTalks: function getTalks() {
            var me = this;
            workordertalks.selectAllDentalSolutionChats({
                dentalSolutionId: me.dentalSolution.dentalSolutionId
            }, function (data) {
                if (data.error && data.error == true) {
                    me.$notify.error(data.notice);
                    return;
                }
                me.talks = data.root;
            });
        }
    },
    watch: {
        'dentalSolution.isRepeat': function dentalSolutionIsRepeat(value) {
            var me = this;

            if (me.solutionLoaded) {
                me.updateProperty(me.dentalSolution.dentalSolutionId, { isRepeat: value });
            }
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        notifyOrOrder: function notifyOrOrder() {
            var me = this;

            if (me.globals.auth != 9 && me.dentalSolution.files !== undefined) {
                if (me.dentalSolution.files.length > 0) {
                    return false;
                } else if (me.dentalSolution.status == 'open') {
                    return true;
                }
            }

            return false;
        },

        filteredDentalSolutionTypes: function filteredDentalSolutionTypes() {
            var me = this;

            var out = [];

            if (me.dentalsolutiontypes.root) {
                for (var i = 0; i < me.dentalsolutiontypes.root.length; i++) {
                    var ds = me.dentalsolutiontypes.root[i];
                    if (ds.category == me.category) {
                        out.push(ds);
                    }
                }
            }

            return out;
        },
        hasColor: function hasColor() {
            var me = this;

            var out = [];
            if (me.dentalsolutiontypes.root) {
                for (var i = 0; i < me.dentalsolutiontypes.root.length; i++) {
                    var ds = me.dentalsolutiontypes.root[i];
                    if (ds.dentalSolutionTypeId == me.dentalSolution.dentalSolutionTypeId && ds.hasColor == 1) {
                        return true;
                    }
                }
            }

            return false;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc66cc1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DentalSolution.vue
var DentalSolution_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page workorder"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-4 title"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2 col-md-1"},[_c('a',{on:{"click":_vm.back}},[_c('img',{attrs:{"src":__webpack_require__("Abw3"),"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"col-10 col-md-11 namescol"},[_c('span',[_vm._v(_vm._s(_vm.$t('DENTALSOLUTION'))+": "+_vm._s(_vm.dentalSolution.dentalSolutionId))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 namescol"},[_c('span',[_vm._v(_vm._s(_vm.$t('CLIENT')))]),_vm._v(" "),_c('a',{on:{"click":function($event){$event.preventDefault();_vm.startChatByUserIdDental(_vm.dentalSolution.ordererUserId, _vm.dentalSolution.dentalSolutionId)}}},[_c('img',{attrs:{"src":__webpack_require__("y/Pd"),"alt":""}}),_vm._v(" "+_vm._s(_vm.dentalSolution.ordererName)+" "+_vm._s(_vm.dentalSolution.ordererSurname))])]),_vm._v(" "),_c('div',{staticClass:"col-6 namescol"},[_c('span',[_vm._v(_vm._s(_vm.$t('DENTALSOLUTIONCOMPANY')))]),_vm._v(" "),_c('a',{on:{"click":function($event){$event.preventDefault();_vm.startChatByUserIdDental(_vm.dentalSolution.tehnicianUserId, _vm.dentalSolution.dentalSolutionId)}}},[_c('img',{attrs:{"src":__webpack_require__("y/Pd"),"alt":""}}),_vm._v(" "+_vm._s(_vm.dentalSolution.workerCompany))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"},[(_vm.notifyOrOrder)?[_c('button',{staticClass:"btn btn-white d-none d-md-block",on:{"click":function($event){_vm.showNoticeModal = true}}},[_vm._v(_vm._s(_vm.$t('NOTIFY')))])]:(_vm.globals.auth != 9 && (_vm.dentalSolution.status == 'open' || _vm.dentalSolution.status == 'notice') && _vm.dentalSolution.files && _vm.dentalSolution.files.length > 0)?[_c('button',{staticClass:"btn btn-white d-none d-md-block",on:{"click":function($event){_vm.changeOrderStatus(_vm.dentalSolution.dentalSolutionId, 'ordered')}}},[_vm._v(_vm._s(_vm.$t('ORDER')))])]:_vm._e(),_vm._v(" "),(_vm.globals.auth == 9 && _vm.dentalSolution.status == 'ordered')?[_c('button',{staticClass:"btn btn-white d-none d-md-block",on:{"click":function($event){_vm.changeOrderStatus(_vm.dentalSolution.dentalSolutionId, 'inprocess')}}},[_vm._v(_vm._s(_vm.$t('INPROCESS')))])]:_vm._e(),_vm._v(" "),(_vm.globals.auth == 9 && _vm.dentalSolution.status == 'inprocess')?[_c('button',{staticClass:"btn btn-white d-none d-md-block",on:{"click":function($event){_vm.changeOrderStatus(_vm.dentalSolution.dentalSolutionId, 'finished')}}},[_vm._v(_vm._s(_vm.$t('FINISH')))])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 first-col d-none d-md-block"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"row"},[_c('h2',[_vm._v(_vm._s(_vm.$t('PRODUCTLIST')))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('a',{class:(_vm.category == 'printing') ? 'active' : '',on:{"click":function($event){$event.preventDefault();_vm.category = 'printing'}}},[_vm._v(_vm._s(_vm.$t('PRINTING')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('a',{class:(_vm.category == 'milling') ? 'active' : '',on:{"click":function($event){$event.preventDefault();_vm.category = 'milling'}}},[_vm._v(_vm._s(_vm.$t('MILLING')))])])])]),_vm._v(" "),_c('div',{staticClass:"list-container"},[_c('ul',_vm._l((_vm.filteredDentalSolutionTypes),function(ds){return _c('li',{key:ds.dentalSolutionTypeId},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dentalSolution.dentalSolutionTypeId),expression:"dentalSolution.dentalSolutionTypeId"}],attrs:{"type":"radio","name":"dentalSolutionTypeId"},domProps:{"value":ds.dentalSolutionTypeId,"checked":_vm._q(_vm.dentalSolution.dentalSolutionTypeId,ds.dentalSolutionTypeId)},on:{"change":[function($event){_vm.$set(_vm.dentalSolution, "dentalSolutionTypeId", ds.dentalSolutionTypeId)},function($event){_vm.updateProperty(_vm.dentalSolution.dentalSolutionId, {dentalSolutionTypeId: _vm.dentalSolution.dentalSolutionTypeId})}]}}),_vm._v(" "+_vm._s(_vm.$t(ds.name))+"\n                    ")])})),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group pb-3 mt-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('NUMBEROFITEMS')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dentalSolution.num),expression:"dentalSolution.num"}],staticClass:"form-control",attrs:{"type":"text","name":"num"},domProps:{"value":(_vm.dentalSolution.num)},on:{"change":function($event){_vm.updateProperty(_vm.dentalSolution.dentalSolutionId, {num: _vm.dentalSolution.num})},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dentalSolution, "num", $event.target.value)}}})])]),_vm._v(" "),(_vm.hasColor)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group pb-3"},[_c('label',[_vm._v(_vm._s(_vm.$t('COLOR')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dentalSolution.color),expression:"dentalSolution.color"}],staticClass:"form-control secondary",attrs:{"name":"color"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dentalSolution, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.updateProperty(_vm.dentalSolution.dentalSolutionId, {color: _vm.dentalSolution.color})}]}},_vm._l((_vm.colors),function(color){return _c('option',{key:color,domProps:{"value":color}},[_vm._v(_vm._s(color))])}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group mb-0"},[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":"1","unchecked-value":"0"},model:{value:(_vm.dentalSolution.isRepeat),callback:function ($$v) {_vm.$set(_vm.dentalSolution, "isRepeat", $$v)},expression:"dentalSolution.isRepeat"}},[_vm._v(_vm._s(_vm.$t('ISREPEAT')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 d-none d-md-block dentalsolution"},[_c('div',{staticClass:"row"},[(_vm.dentalSolution.status)?_c('div',{staticClass:"status-container"},[_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.$t('DENTALSOLUTIONSTATUS'))+": "),_c('span',[_vm._v(_vm._s(_vm.$t('DS_'+_vm.dentalSolution.status.toUpperCase())))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"stl-container"},[(_vm.dentalSolution.files)?_c('div',{staticClass:"row title"},[_c('div',{staticClass:"col-6 text-left"},[_c('span',[_vm._v(_vm._s(_vm.$t('UPLOADED'))+":")]),_vm._v(" "+_vm._s(_vm.dentalSolution.files.length)+" "+_vm._s(_vm.$t('FILES'))+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col-6 text-right"},[_vm._v("\n                            "+_vm._s(_vm.$t('SAVEALL'))+" "),_c('a',{staticClass:"btn btn-secondary",attrs:{"target":"_blank","href":'/rest/DentalSolutions/saveAll?dentalSolutionId='+_vm.dentalSolution.dentalSolutionId},on:{"click":_vm.delayedReload}},[_c('img',{attrs:{"src":__webpack_require__("T1Gp")}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row files"},[_c('div',{staticClass:"col-12"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('icon',{attrs:{"name":"spinner","scale":"2","spin":""}})],1):(_vm.dentalSolution.files)?_c('ul',_vm._l((_vm.dentalSolution.files),function(file){return _c('li',{key:file.dentalSolutionFileId,staticClass:"mb-4"},[_c('div',{staticClass:"file"},[_vm._v("\n                                        "+_vm._s(file.name)+"\n                                        "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.deleteStl(file.dentalSolutionFileId)}}},[_c('img',{attrs:{"src":__webpack_require__("z6Az")}})])]),_vm._v(" "),_c('a',{staticClass:"btn btn-secondary",attrs:{"target":"_blank","href":'/rest/DentalSolutions/downloadStl?dentalSolutionFileId='+file.dentalSolutionFileId+'&dentalSolutionId='+_vm.dentalSolution.dentalSolutionId},on:{"click":_vm.delayedReload}},[_c('img',{attrs:{"src":__webpack_require__("T1Gp")}})]),_vm._v(" "),(file.downloaded == '1')?_c('img',{attrs:{"src":__webpack_require__("3gCU"),"alt":""}}):_c('img',{attrs:{"src":__webpack_require__("8va9"),"alt":""}}),_vm._v(" "),(_vm.globals.auth == 9)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('PLATFORM')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(file.platform),expression:"file.platform"}],staticClass:"form-control",attrs:{"name":"platform"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(file, "platform", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.changeFilePlatform(file)}]}},_vm._l((_vm.platform),function(pl){return _c('option',{key:pl,domProps:{"value":pl}},[_vm._v(_vm._s(pl))])}))]):_vm._e()])})):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"upload"},[_c('form',{attrs:{"enctype":"multipart/form-data","novalidate":""}},[_c('input',{attrs:{"type":"file","multiple":"","name":"stlSrc","accept":"application/sta"},on:{"change":function($event){_vm.filesChange($event.target.name, $event.target.files)}}}),_vm._v(" "),_c('div',{staticClass:"upl-container"},[_c('a',{staticClass:"btn btn-primary d-none d-md-block mb-3"},[_c('img',{attrs:{"src":__webpack_require__("2gfX"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDFILE')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('ORDRAGANDDROP')))])])])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 last-col"},[(_vm.showInfo)?[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.notice",modifiers:{"notice":true}}],staticClass:"col-item"},[_vm._v(_vm._s(_vm.$t('NOTICE'))+" "),_c('span',{staticClass:"down"})]),_vm._v(" "),_c('b-collapse',{attrs:{"accordion":"right-accordion","visible":_vm.dentalSolution.notice != '',"id":"notice"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.dentalSolution.notice),expression:"dentalSolution.notice"}],staticClass:"form-control secondary",attrs:{"name":"notice"},domProps:{"value":(_vm.dentalSolution.notice)},on:{"change":function($event){_vm.updateProperty(_vm.dentalSolution.dentalSolutionId, {notice: _vm.dentalSolution.notice})},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dentalSolution, "notice", $event.target.value)}}})]),_vm._v(" "),(_vm.dentalSolution.status == 'ordered')?_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.talks",modifiers:{"talks":true}}],staticClass:"col-item"},[_vm._v(_vm._s(_vm.$t('TALKS'))+" "),_c('span',{staticClass:"down"}),_vm._v(" "),_c('a',{staticClass:"flexright"},[_c('img',{directives:[{name:"b-modal",rawName:"v-b-modal.newchat",modifiers:{"newchat":true}}],attrs:{"src":__webpack_require__("gnEX"),"alt":""}})])]):_vm._e(),_vm._v(" "),(_vm.dentalSolution.status == 'ordered')?_c('b-collapse',{staticClass:"tasks",attrs:{"accordion":"right-accordion","id":"talks","visible":_vm.chatvisible}},[_c('div',[_c('ul',_vm._l((_vm.talks),function(talk){return _c('li',{key:talk.workOrderTalkId,on:{"click":function($event){$event.preventDefault();_vm.startChatByUserIdDental((talk.toUserId == _vm.globals.userId ? talk.fromUserId : talk.toUserId), _vm.dentalSolution.dentalSolutionId)}}},[_c('div',[_c('div',[_c('span',{staticClass:"user"},[_c('img',{attrs:{"src":__webpack_require__("eX+1"),"alt":""}}),_vm._v(" "+_vm._s(talk.name)+" "+_vm._s(talk.surname)+" "),_c('img',{attrs:{"src":__webpack_require__("zsfH"),"alt":""}}),_vm._v(" "+_vm._s(talk.toName)+" "+_vm._s(talk.toSurname))]),_vm._v(" "),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.returnTalkTime(talk.dateTime)))])])]),_vm._v(" "),_c('div',{staticClass:"inner"},[_vm._v("\n                                    "+_vm._s(talk.text)+"\n                                ")])])}))])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.dentalSolution.notifyDate)?_c('div',{staticClass:"status-container mt-2"},[_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.$t('NOTIFYDATE'))+": "),_c('span',[_vm._v(_vm._s(_vm.dentalSolution.notifyDate))])])]):_vm._e()],2)]),_vm._v(" "),_c('b-modal',{ref:"newchat",attrs:{"centered":"","size":"sm","id":"newchat","ok-title":_vm.$t('STARTCHAT'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWCHAT')},on:{"ok":_vm.startChat}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('SELECTUSER')))]),_vm._v(" "),_c('b-form-select',{staticClass:"form-control secondary",attrs:{"plain":true,"options":_vm.possibleUsers.root,"value-field":"userId","text-field":"nameSurname","placeholder":_vm.$t('SELECTUSER')},model:{value:(_vm.chatUserId),callback:function ($$v) {_vm.chatUserId=$$v},expression:"chatUserId"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('b-modal',{attrs:{"centered":"","size":"sm","ok-title":_vm.$t('NOTIFY'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NOTIFY')},on:{"ok":function($event){_vm.updateProperty(_vm.dentalSolution.dentalSolutionId, {notifyDate: _vm.formatDate(_vm.dentalSolution.notifyDate)}); _vm.changeOrderStatus(_vm.dentalSolution.dentalSolutionId, 'notice')}},model:{value:(_vm.showNoticeModal),callback:function ($$v) {_vm.showNoticeModal=$$v},expression:"showNoticeModal"}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('SELECTDATE')))]),_vm._v(" "),_c('datepicker',{attrs:{"input-class":"secondary","bootstrapStyling":true,"format":"dd.MM.yyyy","placeholder":_vm.$t('NOTIFICATIONDATE')},model:{value:(_vm.dentalSolution.notifyDate),callback:function ($$v) {_vm.$set(_vm.dentalSolution, "notifyDate", $$v)},expression:"dentalSolution.notifyDate"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)}
var DentalSolution_staticRenderFns = []
var DentalSolution_esExports = { render: DentalSolution_render, staticRenderFns: DentalSolution_staticRenderFns }
/* harmony default export */ var components_DentalSolution = (DentalSolution_esExports);
// CONCATENATED MODULE: ./src/components/DentalSolution.vue
var DentalSolution_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DentalSolution___vue_template_functional__ = false
/* styles */
var DentalSolution___vue_styles__ = null
/* scopeId */
var DentalSolution___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DentalSolution___vue_module_identifier__ = null
var DentalSolution_Component = DentalSolution_normalizeComponent(
  DentalSolution,
  components_DentalSolution,
  DentalSolution___vue_template_functional__,
  DentalSolution___vue_styles__,
  DentalSolution___vue_scopeId__,
  DentalSolution___vue_module_identifier__
)

/* harmony default export */ var src_components_DentalSolution = (DentalSolution_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrintDsDaily.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var PrintDsDaily = ({
    name: 'PrintDsDaily',
    data: function data() {
        return {
            dentalsolutiontypes: {},
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: []
            },
            params: {
                date: new Date(),
                ordererCompanyId: '',
                dentalSolutionTypeId: null
            }
        };
    },
    created: function created() {
        var me = this;

        me.params = me.$route.query;

        me.getReport();
    },
    methods: {
        getReport: function getReport() {
            var me = this;
            var params = extends_default()({}, me.params);

            params.date = moment_default()(params.date).format('YYYY-MM-DD');

            dentalsolutions.getReport(params, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.report = data;
                }
            });
        }
    },
    computed: {
        total: function total() {
            var me = this;

            var num = 0;
            var filesNum = 0;
            var repeat = 0;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(me.report.root), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    num += parseInt(item.num);
                    filesNum += parseInt(item.filesNum);
                    repeat += item.isRepeat === '1' ? parseInt(item.filesNum) : 0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return {
                num: num,
                filesNum: filesNum,
                repeat: repeat
            };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab066b1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrintDsDaily.vue
var PrintDsDaily_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"row reports"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('TIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('CLIENT')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('QUANTITY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('FILESNUM')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('PLATFORMS')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ISREPEAT')))]),_vm._v(" "),_c('td',{staticStyle:{"width":"5px"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.report.root),function(row,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm.formatDate(row.updateDateTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.companyName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.filesNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t(row.name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.platforms))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((row.isRepeat == '1') ? _vm.$t('YES') : _vm.$t('NO')))]),_vm._v(" "),_c('td')])})),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.$t('TOTAL')+':'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total.num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total.filesNum))]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total.repeat))]),_vm._v(" "),_c('td')])])])])])])}
var PrintDsDaily_staticRenderFns = []
var PrintDsDaily_esExports = { render: PrintDsDaily_render, staticRenderFns: PrintDsDaily_staticRenderFns }
/* harmony default export */ var components_PrintDsDaily = (PrintDsDaily_esExports);
// CONCATENATED MODULE: ./src/components/PrintDsDaily.vue
var PrintDsDaily_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PrintDsDaily___vue_template_functional__ = false
/* styles */
var PrintDsDaily___vue_styles__ = null
/* scopeId */
var PrintDsDaily___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintDsDaily___vue_module_identifier__ = null
var PrintDsDaily_Component = PrintDsDaily_normalizeComponent(
  PrintDsDaily,
  components_PrintDsDaily,
  PrintDsDaily___vue_template_functional__,
  PrintDsDaily___vue_styles__,
  PrintDsDaily___vue_scopeId__,
  PrintDsDaily___vue_module_identifier__
)

/* harmony default export */ var src_components_PrintDsDaily = (PrintDsDaily_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrintDsMonthly.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var PrintDsMonthly = ({
    name: 'ReportsDs',
    data: function data() {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0,
                total: 0
            },
            params: {
                month: moment_default()().format('M'),
                year: moment_default()().format('YYYY'),
                ordererCompanyId: '',
                dentalSolutionTypeId: null
            }
        };
    },
    created: function created() {
        var me = this;

        me.params = me.$route.query;

        me.getMonthlyReport();
    },
    methods: {
        getMonthlyReport: function getMonthlyReport() {
            var me = this;
            var params = extends_default()({}, me.params);

            params.date = moment_default()(params.date).format('YYYY-MM-DD');

            dentalsolutions.getMonthlyReport(params, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.report = data;
                }
            });
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        years: function years() {
            var data = [];

            for (var i = 2020; i < 2040; i++) {
                data.push(i);
            }

            return data;
        },
        months: function months() {
            var data = [];

            for (var i = 1; i <= 12; i++) {
                if (String(i).length == 1) {
                    data.push('0' + String(i));
                } else {
                    data.push(String(i));
                }
            }

            return data;
        },
        getQueryParams: function getQueryParams() {
            var me = this;

            return extends_default()({}, me.params, {
                date: moment_default()(me.params.date).format('YYYY-MM-DD')
            });
        },
        reportTitle: function reportTitle() {
            var me = this;

            if (me.report.reportHeader !== undefined) {
                return me.report.reportHeader.date + ' ' + me.report.reportHeader.name;
            }

            return '';
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277d0fa6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrintDsMonthly.vue
var PrintDsMonthly_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"row reports report-monthly"},[_c('h2',[_vm._v(_vm._s(_vm.reportTitle))]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[(_vm.report.root[0])?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('CLIENT')))]),_vm._v(" "),_vm._l((_vm.report.root[0].quantityPerDate),function(num,date){return _c('td',[_vm._v(_vm._s(date))])}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('TOTAL')))])],2):_vm._e()]),_vm._v(" "),_c('tbody',_vm._l((_vm.report.root),function(row,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(row.companyName))]),_vm._v(" "),_vm._l((row.quantityPerDate),function(num,date){return _c('td',[_c('div',{staticClass:"date",class:{'empty': (num == 0)}},[_vm._v(_vm._s((num == 0) ? '' : num))])])}),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.num))])],2)})),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('TOTAL')+':'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.report.total))]),_vm._v(" "),_c('td')])])])])])])}
var PrintDsMonthly_staticRenderFns = []
var PrintDsMonthly_esExports = { render: PrintDsMonthly_render, staticRenderFns: PrintDsMonthly_staticRenderFns }
/* harmony default export */ var components_PrintDsMonthly = (PrintDsMonthly_esExports);
// CONCATENATED MODULE: ./src/components/PrintDsMonthly.vue
var PrintDsMonthly_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PrintDsMonthly___vue_template_functional__ = false
/* styles */
var PrintDsMonthly___vue_styles__ = null
/* scopeId */
var PrintDsMonthly___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintDsMonthly___vue_module_identifier__ = null
var PrintDsMonthly_Component = PrintDsMonthly_normalizeComponent(
  PrintDsMonthly,
  components_PrintDsMonthly,
  PrintDsMonthly___vue_template_functional__,
  PrintDsMonthly___vue_styles__,
  PrintDsMonthly___vue_scopeId__,
  PrintDsMonthly___vue_module_identifier__
)

/* harmony default export */ var src_components_PrintDsMonthly = (PrintDsMonthly_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrintDsClient.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var PrintDsClient = ({
    name: 'ReportsDs',
    data: function data() {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0
            },
            params: {
                month: moment_default()().format('M'),
                year: moment_default()().format('YYYY'),
                ordererCompanyId: ''
            }
        };
    },
    created: function created() {
        var me = this;

        me.params = me.$route.query;

        me.getClientReport();
    },
    methods: {
        getClientReport: function getClientReport() {
            var me = this;
            var params = extends_default()({}, me.params);

            params.date = moment_default()(params.date).format('YYYY-MM-DD');

            dentalsolutions.getClientReport(params, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.report = data;
                }
            });
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        getQueryParams: function getQueryParams() {
            var me = this;

            return extends_default()({}, me.params, {
                date: moment_default()(me.params.date).format('YYYY-MM-DD')
            });
        },
        reportTitle: function reportTitle() {
            var me = this;

            if (me.report.reportHeader !== undefined) {
                return me.report.reportHeader.date + ' ' + me.report.reportHeader.companyName;
            }

            return '';
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7ffbae6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrintDsClient.vue
var PrintDsClient_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"row reports report-monthly"},[_c('div',{staticClass:"table-responsive"},[_c('h2',[_vm._v(_vm._s(_vm.reportTitle))]),_vm._v(" "),_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('DATETIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('PRODUCT')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('QUANTITY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ISREPEAT')))]),_vm._v(" "),_c('td')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.report.root),function(row,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm.formatDate(row.updateDateTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t(row.name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.isRepeat))]),_vm._v(" "),_c('td')])}))])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_vm._l((_vm.report.products),function(product){return _c('td',[_vm._v(_vm._s(_vm.$t(product.name)))])}),_vm._v(" "),_c('td')],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('QUANTITY'))+":")]),_vm._v(" "),_vm._l((_vm.report.products),function(product){return _c('td',[_vm._v(_vm._s(product.num))])}),_vm._v(" "),_c('td')],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('REPEATNUM'))+":")]),_vm._v(" "),_vm._l((_vm.report.products),function(product){return _c('td',[_vm._v(_vm._s(product.isRepeat))])}),_vm._v(" "),_c('td')],2)])])])])])}
var PrintDsClient_staticRenderFns = []
var PrintDsClient_esExports = { render: PrintDsClient_render, staticRenderFns: PrintDsClient_staticRenderFns }
/* harmony default export */ var components_PrintDsClient = (PrintDsClient_esExports);
// CONCATENATED MODULE: ./src/components/PrintDsClient.vue
var PrintDsClient_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PrintDsClient___vue_template_functional__ = false
/* styles */
var PrintDsClient___vue_styles__ = null
/* scopeId */
var PrintDsClient___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintDsClient___vue_module_identifier__ = null
var PrintDsClient_Component = PrintDsClient_normalizeComponent(
  PrintDsClient,
  components_PrintDsClient,
  PrintDsClient___vue_template_functional__,
  PrintDsClient___vue_styles__,
  PrintDsClient___vue_scopeId__,
  PrintDsClient___vue_module_identifier__
)

/* harmony default export */ var src_components_PrintDsClient = (PrintDsClient_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ReportDsHolder.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ReportDsHolder = ({
    name: 'Profile',
    data: function data() {
        return {};
    },
    created: function created() {
        var me = this;
    },
    methods: {},
    watch: {},
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        routename: function routename() {
            return this.$route.name;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd1a3bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDsHolder.vue
var ReportDsHolder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 title"},[_c('h1',{staticClass:"mrgn"},[_vm._v(_vm._s(_vm.$t('REPORTS')))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[(_vm.globals.auth == 9)?_c('li',{class:(_vm.routename == 'ReportsDsDaily') ? 'active' : ''},[_c('router-link',{attrs:{"to":'/reportsds/daily'}},[_vm._v(_vm._s(_vm.$t('DSREPORTDAILY')))])],1):_vm._e(),_vm._v(" "),(_vm.globals.auth == 9)?_c('li',{class:(_vm.routename == 'ReportsDsMonthly') ? 'active' : ''},[_c('router-link',{attrs:{"to":'/reportsds/monthly'}},[_vm._v(_vm._s(_vm.$t('DSREPORTMONTHLY')))])],1):_vm._e(),_vm._v(" "),_c('li',{class:(_vm.routename == 'ReportsDsClient') ? 'active' : ''},[_c('router-link',{attrs:{"to":'/reportsds/client'}},[_vm._v(_vm._s(_vm.$t('DSREPORTCLIENT')))])],1)])])])]),_vm._v(" "),_c('router-view')],1)}
var ReportDsHolder_staticRenderFns = []
var ReportDsHolder_esExports = { render: ReportDsHolder_render, staticRenderFns: ReportDsHolder_staticRenderFns }
/* harmony default export */ var components_ReportDsHolder = (ReportDsHolder_esExports);
// CONCATENATED MODULE: ./src/components/ReportDsHolder.vue
var ReportDsHolder_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ReportDsHolder___vue_template_functional__ = false
/* styles */
var ReportDsHolder___vue_styles__ = null
/* scopeId */
var ReportDsHolder___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReportDsHolder___vue_module_identifier__ = null
var ReportDsHolder_Component = ReportDsHolder_normalizeComponent(
  ReportDsHolder,
  components_ReportDsHolder,
  ReportDsHolder___vue_template_functional__,
  ReportDsHolder___vue_styles__,
  ReportDsHolder___vue_scopeId__,
  ReportDsHolder___vue_module_identifier__
)

/* harmony default export */ var src_components_ReportDsHolder = (ReportDsHolder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrintWorkOrder.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var PrintWorkOrder_moment = __webpack_require__("PJh5");

/* harmony default export */ var PrintWorkOrder = ({
  name: 'PrintWorkOrder',
  components: {
    'teeth': src_components_Teeth
  },
  data: function data() {
    return {
      workOrderId: false,
      patientdata: {},
      workorder: {},
      toothprops: {},
      tooth: {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false,
        upper: false,
        lower: false
      },
      separators: {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false
      },
      upperSelected: false,
      lowerSelected: false,
      showProtetics: false,
      showInfo: false
    };
  },
  created: function created() {
    var me = this;

    me.workOrderId = me.$route.params.workOrderId;

    me.refreshProtetics();
    me.getWorkOrder();
  },
  methods: {
    getDoctor: function getDoctor() {
      var me = this;

      if (me.workorder.doctorName == null) {
        return me.workorder.dummyPartner;
      }

      return me.workorder.doctorName + ' ' + me.workorder.doctorSurname;
    },
    getTechnician: function getTechnician() {
      var me = this;

      if (me.workorder.tehnicianName == null) {
        return me.workorder.dummyPartner;
      }

      return me.workorder.tehnicianName + ' ' + me.workorder.technicianSurname;
    },
    getWorkOrder: function getWorkOrder() {
      var me = this;

      workorders.getWorkOrders({ workOrderId: me.workOrderId }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }

        me.workorder = data.root[0];
        if (data.root[0].separators != '') me.separators = JSON.parse(data.root[0].separators);

        patients.getPatient({ id: me.workorder.patientId }, function (data) {
          if (data.error && data.error == true) {
            vue_esm["default"].$notify.error(data.notice);
            return;
          }
          me.patientdata = data.root;
        });

        me.getProtetics();
      });
    },

    getProtetics: function getProtetics() {
      var me = this;
      protetics.getProtetics({ workOrderId: me.workOrderId, active: 1 }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }
        me.protetics = data;
      });
    },
    refreshProtetics: function refreshProtetics() {
      var me = this;
      workorders.getProtetics({ workOrderId: me.workOrderId }, function (data) {
        if (data.error && data.error == true) {
          vue_esm["default"].$notify.error(data.notice);
          return;
        }

        me.toothprops = data.data;
      });
    }
  },
  watch: {},
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b9f95d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrintWorkOrder.vue
var PrintWorkOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page workorder"},[_c('div',{staticClass:"row printsummary"},[_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('PATIENTNAME')))]),_vm._v(" "),_c('div',{staticClass:"summaryval"},[_vm._v(_vm._s(_vm.patientdata.name)+" "+_vm._s(_vm.patientdata.surname))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"sec"},[_vm._v(_vm._s(_vm.$t('NOTICE')))]),_vm._v(" "),_c('div',{staticClass:"summaryval sec"},[_vm._v(_vm._s(_vm.workorder.notice))])])])]),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('DOCTOR')))]),_vm._v(" "),_c('div',{staticClass:"summaryval"},[_vm._v(_vm._s(_vm.getDoctor()))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('TECHNICIAN')))]),_vm._v(" "),_c('div',{staticClass:"summaryval"},[_vm._v(_vm._s(_vm.getTechnician()))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('OPENDATE')))]),_vm._v(" "),_c('div',{staticClass:"summaryval"},[_vm._v(_vm._s(_vm.workorder.openDateTime))])])]),_vm._v(" "),(_vm.workorder.color)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('COLOR')))]),_vm._v(" "),_c('div',{staticClass:"summaryval"},[_vm._v(_vm._s(_vm.workorder.color))])])]):_vm._e()]),_vm._v(" "),_vm._m(0,false,false)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 center mainworkorderteeth"},[_c('img',{staticClass:"workorderteethimg",attrs:{"src":__webpack_require__("TB/a")}}),_vm._v(" "),_c('div',{staticClass:"workorderteeth"},[_c('div',{staticClass:"selectedteeth"},[_c('teeth',{attrs:{"tooth":_vm.tooth,"separators":_vm.separators}})],1),_vm._v(" "),_vm._l((_vm.toothprops.upper),function(props){return _c('span',{staticClass:"bigname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.name))])}),_vm._v(" "),_c('div',{staticClass:"upper"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[18]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[17]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[16]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[15]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[14]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[13]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[12]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[11]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])}))]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[21]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[22]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[23]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[24]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[25]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[26]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[27]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[28]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])}))])]),_vm._v(" "),_c('div',{staticClass:"middle"}),_vm._v(" "),_c('div',{staticClass:"lower"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[48]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[47]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[46]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[45]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[44]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[43]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[42]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[41]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])}))]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[31]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smallest"},_vm._l((_vm.toothprops[32]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth small"},_vm._l((_vm.toothprops[33]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[34]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth smaller"},_vm._l((_vm.toothprops[35]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[36]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[37]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])})),_vm._v(" "),_c('div',{staticClass:"tooth"},_vm._l((_vm.toothprops[38]),function(props){return _c('span',{staticClass:"shortname-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.shortname))])}))])]),_vm._v(" "),_vm._l((_vm.toothprops.lower),function(props){return _c('span',{staticClass:"bigname-type lower-type",style:('background-color: '+props.color)},[_vm._v(_vm._s(props.name))])})],2)])])])}
var PrintWorkOrder_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-2"},[_c('img',{attrs:{"src":__webpack_require__("tKQo"),"alt":""}})])}]
var PrintWorkOrder_esExports = { render: PrintWorkOrder_render, staticRenderFns: PrintWorkOrder_staticRenderFns }
/* harmony default export */ var components_PrintWorkOrder = (PrintWorkOrder_esExports);
// CONCATENATED MODULE: ./src/components/PrintWorkOrder.vue
var PrintWorkOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PrintWorkOrder___vue_template_functional__ = false
/* styles */
var PrintWorkOrder___vue_styles__ = null
/* scopeId */
var PrintWorkOrder___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PrintWorkOrder___vue_module_identifier__ = null
var PrintWorkOrder_Component = PrintWorkOrder_normalizeComponent(
  PrintWorkOrder,
  components_PrintWorkOrder,
  PrintWorkOrder___vue_template_functional__,
  PrintWorkOrder___vue_styles__,
  PrintWorkOrder___vue_scopeId__,
  PrintWorkOrder___vue_module_identifier__
)

/* harmony default export */ var src_components_PrintWorkOrder = (PrintWorkOrder_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-color/dist/vue-color.min.js
var vue_color_min = __webpack_require__("Zzkc");
var vue_color_min_default = /*#__PURE__*/__webpack_require__.n(vue_color_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Protetics.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Protetics = ({
  components: {
    'chrome-picker': vue_color_min["Chrome"]
  },
  name: 'Protetics',
  data: function data() {
    return {
      query: '',
      category: 'fixed',
      implantchecked: false,
      protetics: {},
      formData: {
        id: '',
        name: '',
        shortname: '',
        color: '',
        category: '',
        implant: ''
      },
      formError: {},
      pagination: {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  created: function created() {
    this.getProtetics();
  },
  methods: {
    addProtetic: function addProtetic(data) {
      var me = this;
      me.formData = {
        id: '',
        name: '',
        shortname: '',
        color: '',
        category: '',
        implant: ''
      };
      me.$refs.newprotetic.show();
    },
    getProtetics: function getProtetics() {
      var me = this;
      protetics.getProtetics({}, function (data) {
        if (data.error && data.error == true) {
          Vue.$notify.error(data.notice);
          return;
        }
        me.protetics = data;
      });
    },
    saveProtetic: function saveProtetic(bvEvt) {
      var me = this;

      bvEvt.preventDefault();

      protetics.saveProtetic(me.formData, function (val) {
        if (val.error) {
          me.formError = val;
        } else {
          me.formError = {};
          me.formData = {
            id: '',
            name: '',
            shortname: '',
            color: '',
            category: '',
            implant: false
          };
          me.$refs.newprotetic.hide();
          me.getProtetics();
        }
      });
    },
    deleteProtetic: function deleteProtetic(id) {
      var me = this;
      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          protetics.deleteProtetic({ id: id }, function (data) {
            if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
            me.getProtetics();
          });
        }
      });
    },
    editProtetic: function editProtetic(data) {
      var me = this;
      data = assign_default()({}, data, {});
      data.id = data.proteticId;
      me.formData = data;
      me.$refs.newprotetic.show();
    },
    updateColorValue: function updateColorValue(val) {
      var me = this;
      me.formData.color = val.hex;
    },
    toogleActivation: function toogleActivation(protetic) {
      var me = this;
      protetics.saveProtetic({ id: protetic.proteticId, active: protetic.active == 1 ? 0 : 1 }, function (data) {
        if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
        me.getProtetics();
      });
    },
    resetProtetics: function resetProtetics() {
      var me = this;
      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          protetics.resetProtetics({}, function (data) {
            if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
            me.getProtetics();
          });
        }
      });
    }
  },
  watch: {
    query: function query() {
      var me = this;
      me.getProtetics();
    },
    category: function category(val) {
      var me = this;
      me.getProtetics();
    },
    'pagination.currentPage': function paginationCurrentPage(newValue, oldValue) {
      var me = this;
      me.getProtetics();
    }
  },
  computed: {
    getParams: function getParams() {
      var me = this;
      var data = assign_default()({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    },
    filteredprotetics: function filteredprotetics() {
      var me = this;

      var out = [];
      if (me.protetics.root) {
        for (var i = 0; i < me.protetics.root.length; i++) {
          var protetic = me.protetics.root[i];
          if (protetic.category == me.category) {
            if (me.category == 'fixed') {
              if (me.implantchecked != protetic.implant) continue;
            }
            out.push(protetic);
          }
        }
      }

      return out;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b732537","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Protetics.vue
var Protetics_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-4 title"},[_c('h1',{staticClass:"mrgn"},[_vm._v(_vm._s(_vm.$t('PROTETICS')))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',{class:(_vm.category == 'fixed') ? 'active' : ''},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.category = 'fixed'}}},[_vm._v(_vm._s(_vm.$t('FIXED')))])]),_vm._v(" "),_c('li',{class:(_vm.category == 'mobile') ? 'active' : ''},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.category = 'mobile'}}},[_vm._v(_vm._s(_vm.$t('MOBILE')))])]),_vm._v(" "),_c('li',{class:(_vm.category == 'other') ? 'active' : ''},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.category = 'other'}}},[_vm._v(_vm._s(_vm.$t('OTHER')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 action"},[_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.addProtetic}},[_c('img',{attrs:{"src":__webpack_require__("53Vg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDPROTETIC')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-white",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.resetProtetics($event)}}},[_c('img',{attrs:{"src":__webpack_require__("53Vg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('RESETTODEFAULTPROTETICS')))])])])]),_vm._v(" "),(_vm.category == 'fixed')?_c('div',{staticClass:"gridheader secondary"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 title"},[_vm._v(_vm._s(_vm.$t('IMPLANTCOMPONENTS'))+" "),_c('b-form-checkbox',{staticClass:"grey",model:{value:(_vm.implantchecked),callback:function ($$v) {_vm.implantchecked=$$v},expression:"implantchecked"}},[_vm._v(_vm._s(_vm.$t('SHOW')))])],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('SHORTNAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ACTIVATION')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ACTIONS')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredprotetics),function(protetic){return _c('tr',[_c('td',[_vm._v(_vm._s(protetic.name))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"shortname-type minwidth",style:('background-color: '+(protetic.color)+';')},[_vm._v(_vm._s(protetic.shortname))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"switch",class:(protetic.active == 1) ? 'on' : 'off',on:{"click":function($event){_vm.toogleActivation(protetic)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteProtetic(protetic.proteticId)}}},[_c('img',{attrs:{"src":__webpack_require__("qmq2"),"alt":""}})]),_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.editProtetic(protetic)}}},[_c('img',{attrs:{"src":__webpack_require__("vCtq"),"alt":""}})])])])}))])])]),_vm._v(" "),(_vm.protetics.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.protetics.totalCount,"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"newprotetic",attrs:{"id":"newprotetic","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWPROTETIC')},on:{"ok":_vm.saveProtetic}},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row",class:(_vm.formError.notice && _vm.formError.notice.name) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('NAME')},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.name)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row",class:(_vm.formError.notice && _vm.formError.notice.shortname) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('SHORTNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.shortname),expression:"formData.shortname"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('SHORTNAME')},domProps:{"value":(_vm.formData.shortname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "shortname", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.shortname)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.shortname))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row"},[_c('label',[_vm._v(_vm._s(_vm.$t('COLOR')))])]),_vm._v(" "),_c('div',{staticClass:"form-group row",class:(_vm.formError.notice && _vm.formError.notice.color) ? 'has-danger' :''},[_c('chrome-picker',{attrs:{"value":_vm.formData.color},on:{"input":_vm.updateColorValue}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.color)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.color))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row",class:(_vm.formError.notice && _vm.formError.notice.category) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('CATEGORY')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.category),expression:"formData.category"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"fixed"}},[_vm._v(_vm._s(_vm.$t('FIXED')))]),_vm._v(" "),_c('option',{attrs:{"value":"mobile"}},[_vm._v(_vm._s(_vm.$t('MOBILE')))]),_vm._v(" "),_c('option',{attrs:{"value":"other"}},[_vm._v(_vm._s(_vm.$t('OTHER')))])]),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.category)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.category))]):_vm._e()])]),_vm._v(" "),(_vm.formData.category == 'fixed')?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group row",class:(_vm.formError.notice && _vm.formError.notice.implant) ? 'has-danger' :''},[_c('b-form-checkbox',{staticClass:"grey",model:{value:(_vm.formData.implant),callback:function ($$v) {_vm.$set(_vm.formData, "implant", $$v)},expression:"formData.implant"}},[_vm._v(_vm._s(_vm.$t('IMPLANT')))]),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.implant)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.implant))]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.formError.error && typeof _vm.formError.notice == 'string')?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)}
var Protetics_staticRenderFns = []
var Protetics_esExports = { render: Protetics_render, staticRenderFns: Protetics_staticRenderFns }
/* harmony default export */ var components_Protetics = (Protetics_esExports);
// CONCATENATED MODULE: ./src/components/Protetics.vue
var Protetics_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Protetics___vue_template_functional__ = false
/* styles */
var Protetics___vue_styles__ = null
/* scopeId */
var Protetics___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Protetics___vue_module_identifier__ = null
var Protetics_Component = Protetics_normalizeComponent(
  Protetics,
  components_Protetics,
  Protetics___vue_template_functional__,
  Protetics___vue_styles__,
  Protetics___vue_scopeId__,
  Protetics___vue_module_identifier__
)

/* harmony default export */ var src_components_Protetics = (Protetics_Component.exports);

// CONCATENATED MODULE: ./src/api/employees.js


/* harmony default export */ var employees = ({
  getEmployees: function getEmployees(params, cb) {
    params.onlyActive = 1;
    AxApi.get('/rest/User/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  selectMyData: function selectMyData(params, cb) {
    AxApi.get('/rest/User/selectMyData', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveEmployee: function saveEmployee(params, cb) {
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/User/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/User/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deleteEmployee: function deleteEmployee(params, cb) {
    AxApi.post('/rest/User/deactivateUser', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EmployeeForm.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var EmployeeForm = ({
  name: 'ControlPanel',
  props: ['formError', 'formData', 'simple']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-907d52c0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmployeeForm.vue
var EmployeeForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"col-12",attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.name) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.name),expression:"formData.name"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('NAME')},domProps:{"value":(_vm.formData.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "name", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.name)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.name))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.surname) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('SURNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.surname),expression:"formData.surname"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('SURNAME')},domProps:{"value":(_vm.formData.surname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "surname", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.surname)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.surname))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.simple)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.userGroup) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('USERGROUP')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userGroup),expression:"formData.userGroup"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "userGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$t('OWNER')))]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v(_vm._s(_vm.$t('ADMINISTRATOR')))]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v(_vm._s(_vm.$t('NURSE')))]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v(_vm._s(_vm.$t('TECHNICIAN')))]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v(_vm._s(_vm.$t('DOCTOR')))])]),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.userGroup)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.userGroup))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.simple) ? 'col-12' : 'col-md-4'},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.userEmail) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('USEREMAIL')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userEmail),expression:"formData.userEmail"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('USEREMAIL')},domProps:{"value":(_vm.formData.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "userEmail", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.userEmail)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.userEmail))]):_vm._e()])]),_vm._v(" "),(!_vm.simple)?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.status) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('STATUS')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.status),expression:"formData.status"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formData, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"active"}},[_vm._v(_vm._s(_vm.$t('ACTIVE')))]),_vm._v(" "),_c('option',{attrs:{"value":"inactive"}},[_vm._v(_vm._s(_vm.$t('INACTIVE')))])]),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.status)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.status))]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.formData.id == '')?_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.username) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('USERNAME')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.username),expression:"formData.username"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.$t('USERNAME')},domProps:{"value":(_vm.formData.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "username", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.username)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.username))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{class:(_vm.formData.id == '') ? 'col-md-4' : 'col-md-6'},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.password) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('PASSWORD')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.password),expression:"formData.password"}],staticClass:"form-control secondary",attrs:{"type":"password","placeholder":_vm.$t('PASSWORD')},domProps:{"value":(_vm.formData.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "password", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.password)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.password))]):_vm._e()])]),_vm._v(" "),_c('div',{class:(_vm.formData.id == '') ? 'col-md-4' : 'col-md-6'},[_c('div',{staticClass:"form-group",class:(_vm.formError.notice && _vm.formError.notice.checkpassword) ? 'has-danger' :''},[_c('label',[_vm._v(_vm._s(_vm.$t('REPEATPASSWORD')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.checkpassword),expression:"formData.checkpassword"}],staticClass:"form-control secondary",attrs:{"type":"password","placeholder":_vm.$t('REPEATPASSWORD')},domProps:{"value":(_vm.formData.checkpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "checkpassword", $event.target.value)}}}),_vm._v(" "),(_vm.formError.notice && _vm.formError.notice.checkpassword)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formError.notice.checkpassword))]):_vm._e()])])]),_vm._v(" "),(_vm.formError.error && typeof _vm.formError.notice == 'string')?_c('p',{staticClass:"bg-danger"},[_vm._v(_vm._s(_vm.formError.notice))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var EmployeeForm_staticRenderFns = []
var EmployeeForm_esExports = { render: EmployeeForm_render, staticRenderFns: EmployeeForm_staticRenderFns }
/* harmony default export */ var components_EmployeeForm = (EmployeeForm_esExports);
// CONCATENATED MODULE: ./src/components/EmployeeForm.vue
var EmployeeForm_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EmployeeForm___vue_template_functional__ = false
/* styles */
var EmployeeForm___vue_styles__ = null
/* scopeId */
var EmployeeForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EmployeeForm___vue_module_identifier__ = null
var EmployeeForm_Component = EmployeeForm_normalizeComponent(
  EmployeeForm,
  components_EmployeeForm,
  EmployeeForm___vue_template_functional__,
  EmployeeForm___vue_styles__,
  EmployeeForm___vue_scopeId__,
  EmployeeForm___vue_module_identifier__
)

/* harmony default export */ var src_components_EmployeeForm = (EmployeeForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Employees.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Employees = ({
  name: 'Employees',
  components: {
    'employee-form': src_components_EmployeeForm
  },
  data: function data() {
    return {
      employees: { root: [], totalCount: 0 },
      formData: {
        id: '',
        name: '',
        surname: '',
        userEmail: '',
        username: '',
        password: '',
        userGroup: '',
        status: 'active'
      },
      formError: {},
      pagination: {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  created: function created() {
    var me = this;
    me.getEmployees();
  },
  methods: {
    newEmployee: function newEmployee() {
      var me = this;
      me.clearEmployee();
      me.$refs.newemployee.show();
    },
    clearEmployee: function clearEmployee() {
      var me = this;
      me.formData = {
        id: '',
        name: '',
        surname: '',
        userEmail: '',
        username: '',
        password: '',
        userGroup: '',
        status: 'active'
      };
    },

    saveEmployee: function saveEmployee(bvEvt) {
      var me = this;

      bvEvt.preventDefault();

      employees.saveEmployee(me.formData, function (val) {
        if (val.error) {
          me.formError = val;
        } else {
          me.formError = {};
          me.formData = {
            id: '',
            name: '',
            surname: '',
            userEmail: '',
            username: '',
            password: '',
            userGroup: '',
            status: 'active'
          };
          me.$refs.newemployee.hide();
          me.getEmployees();
        }
      });
    },
    getEmployees: function getEmployees() {
      var me = this;
      employees.getEmployees(me.getParams, function (data) {
        if (data.error && data.error == true) {
          Vue.$notify.error(data.notice);
          return;
        }
        me.employees = data;
      });
    },
    deleteEmployee: function deleteEmployee(id) {
      var me = this;
      me.$store.commit('setModalAlert', {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function btnAction() {
          employees.deleteEmployee({ id: id }, function (data) {
            if (data.error && data.error == true) me.$notify.error(data.notice);else me.$notify.success(data.notice);
            me.getEmployees();
          });
        }
      });
    },
    editEmployee: function editEmployee(data) {
      var me = this;
      data = assign_default()({}, data, {});
      data.id = data.userId;
      me.formData = data;
      me.$refs.newemployee.show();
    }
  },
  watch: {
    'pagination.currentPage': function paginationCurrentPage(val) {
      var me = this;
      me.getEmployees();
    }
  },
  computed: {
    getParams: function getParams() {
      var me = this;
      var data = assign_default()({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11946fdf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Employees.vue
var Employees_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-4 title"},[_c('h1',[_vm._v(_vm._s(_vm.$t('EMPLOYEES')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pagination.query),expression:"pagination.query"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('SEARCHEMPLOYEES')},domProps:{"value":(_vm.pagination.query)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pagination, "query", $event.target.value)}}}),_vm._v(" "),(_vm.pagination.query == '')?_c('div',{staticClass:"input-group-addon"},[_c('img',{attrs:{"src":__webpack_require__("2rBp"),"alt":""}})]):_vm._e(),_vm._v(" "),(_vm.pagination.query != '')?_c('div',{staticClass:"input-group-addon",on:{"click":function($event){_vm.pagination.query = ''}}},[_c('img',{staticClass:"emptysearch",attrs:{"src":__webpack_require__("8vQW"),"alt":""}})]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"},[_c('a',{staticClass:"btn btn-primary",on:{"click":_vm.newEmployee}},[_c('img',{attrs:{"src":__webpack_require__("53Vg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDEMPLOYEE')))])])])]),_vm._v(" "),(_vm.employees.root.length == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 center nothing"},[_c('img',{attrs:{"src":__webpack_require__("UD2X"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('CURRENTLYNOEMPLOYEES')))]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.newemployee",modifiers:{"newemployee":true}}],staticClass:"btn btn-primary"},[_c('img',{attrs:{"src":__webpack_require__("53Vg"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('ADDEMPLOYEE')))])])]):_vm._e(),_vm._v(" "),(_vm.employees.root.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('USERNAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('SURNAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('GROUPNAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('DATEENTERED')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('STATUS')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ACTIONS')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.employees.root),function(employee){return _c('tr',[_c('td',[_c('b',[_vm._v(_vm._s(employee.username))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(employee.name))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(employee.surname))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee.groupName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee.dateEntered))]),_vm._v(" "),_c('td',{staticClass:"status",class:employee.status},[_vm._v(_vm._s(employee.statusOut))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.deleteEmployee(employee.userId)}}},[_c('img',{attrs:{"src":__webpack_require__("qmq2"),"alt":""}})]),_c('a',{staticClass:"grid-action",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.editEmployee(employee)}}},[_c('img',{attrs:{"src":__webpack_require__("vCtq"),"alt":""}})])])])}))])])]):_vm._e(),_vm._v(" "),(_vm.employees.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":parseInt(_vm.employees.totalCount),"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"newemployee",attrs:{"size":"lg","centered":"","id":"newemployee","ok-title":_vm.$t('SAVE'),"cancel-title":_vm.$t('CANCEL'),"title":_vm.$t('NEWEMPLOYEE')},on:{"ok":_vm.saveEmployee}},[_c('employee-form',{attrs:{"formData":_vm.formData,"formError":_vm.formError,"simple":false}})],1)],1)}
var Employees_staticRenderFns = []
var Employees_esExports = { render: Employees_render, staticRenderFns: Employees_staticRenderFns }
/* harmony default export */ var components_Employees = (Employees_esExports);
// CONCATENATED MODULE: ./src/components/Employees.vue
var Employees_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Employees___vue_template_functional__ = false
/* styles */
var Employees___vue_styles__ = null
/* scopeId */
var Employees___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Employees___vue_module_identifier__ = null
var Employees_Component = Employees_normalizeComponent(
  Employees,
  components_Employees,
  Employees___vue_template_functional__,
  Employees___vue_styles__,
  Employees___vue_scopeId__,
  Employees___vue_module_identifier__
)

/* harmony default export */ var src_components_Employees = (Employees_Component.exports);

// CONCATENATED MODULE: ./src/api/reports.js


/* harmony default export */ var reports = ({
  getReports: function getReports(params, cb) {
    AxApi.get('/rest/Reports/getReports', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reports.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Reports = ({
  name: 'Reports',
  data: function data() {
    return {
      companies: {
        root: [],
        totalCount: 0
      },
      users: {
        root: [],
        totalCount: 0
      },
      protetics: [],
      params: {
        startDate: new Date(),
        endDate: new Date(),
        status: 'closed',
        companyId: '',
        userId: ''
      }
    };
  },
  created: function created() {
    var me = this;
    me.getReports(true);
  },
  methods: {
    getCompanies: function getCompanies(params) {
      var me = this;
      params.onlyConnected = 1;
      params.includeFictionalCompanies = 1;
      companydata.selectRow(params, function (data) {
        if (data.error) {
          me.$notify.error(data.notice);
        } else {
          me.companies = data;
        }
      });
    },
    getUsers: function getUsers(params) {
      var me = this;
      employees.getEmployees(params, function (data) {
        if (data.error) {
          me.$notify.error(data.notice);
        } else {
          me.users = data;
        }
      });
    },
    setCompanyId: function setCompanyId(val) {
      var me = this;
      me.params.companyId = val;
    },
    setUserId: function setUserId(val) {
      var me = this;
      me.params.userId = val;
    },

    getReports: function getReports(firstLoad) {
      var me = this;
      reports.getReports(me.params, function (data) {
        if (data.error && data.error == true) {
          Vue.$notify.error(data.notice);
          return;
        }

        if (typeof firstLoad != 'undefined' && firstLoad == true) {
          var dummyData = assign_default()({}, data.data, {});

          for (var i = 0; i < dummyData.length; i++) {
            var protetic = dummyData[i];
            protetic.cnt = 0;
          }

          me.protetics = dummyData;

          setTimeout(function () {
            me.protetics = data.data;
          }, 500);
        } else me.protetics = data.data;
      });
    }
  },
  computed: {
    max: function max() {
      var me = this,
          max = 0;

      for (var i = 0; i < me.protetics.length; i++) {
        var protetic = me.protetics[i];
        if (max < parseInt(protetic.cnt)) max = parseInt(protetic.cnt);
      }

      return max;
    },
    getCompaniesOptions: function getCompaniesOptions() {
      var me = this,
          options = [];

      for (var i = 0; i < me.companies.root.length; i++) {
        var company = me.companies.root[i];
        options.push({ value: company.companyId, text: company.companyName });
      }

      return options;
    },
    getUsersOptions: function getUsersOptions() {
      var me = this,
          options = [];

      for (var i = 0; i < me.users.root.length; i++) {
        var user = me.users.root[i];
        options.push({ value: user.userId, text: user.name + ' ' + user.surname });
      }

      return options;
    }
  },
  watch: {
    'params.startDate': function paramsStartDate() {
      var me = this;
      me.getReports(true);
    },
    'params.endDate': function paramsEndDate() {
      var me = this;
      me.getReports(true);
    },
    'params.status': function paramsStatus() {
      var me = this;
      me.getReports(true);
    },
    'params.companyId': function paramsCompanyId() {
      var me = this;
      me.getReports(true);
    },
    'params.userId': function paramsUserId() {
      var me = this;
      me.getReports(true);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b91e2096","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports.vue
var Reports_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-2 title"},[_c('h1',[_vm._v(_vm._s(_vm.$t('REPORTS')))])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 search-form"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('STARTDATE')))]),_vm._v(" "),_c('datepicker',{attrs:{"bootstrapStyling":true,"format":"dd.MM.yyyy","placeholder":_vm.$t('STARTDATE')},model:{value:(_vm.params.startDate),callback:function ($$v) {_vm.$set(_vm.params, "startDate", $$v)},expression:"params.startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('ENDDATE')))]),_vm._v(" "),_c('datepicker',{attrs:{"bootstrapStyling":true,"format":"dd.MM.yyyy","placeholder":_vm.$t('ENDDATE')},model:{value:(_vm.params.endDate),callback:function ($$v) {_vm.$set(_vm.params, "endDate", $$v)},expression:"params.endDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('STATUS')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status),expression:"params.status"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"closed"}},[_vm._v(_vm._s(_vm.$t('CLOSED')))]),_vm._v(" "),_c('option',{attrs:{"value":"open"}},[_vm._v(_vm._s(_vm.$t('OPEN')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('COMPANY')))]),_vm._v(" "),_c('autocomplete',{attrs:{"setvalue":_vm.setCompanyId,"value":_vm.params.companyId,"placeholder":_vm.$t('COMPANY'),"values":_vm.getCompaniesOptions,"initdata":_vm.getCompanies}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('RESPONSIBLEPERSON')))]),_vm._v(" "),_c('autocomplete',{attrs:{"setvalue":_vm.setUserId,"value":_vm.params.userId,"placeholder":_vm.$t('RESPONSIBLEPERSON'),"values":_vm.getUsersOptions,"initdata":_vm.getUsers}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"})])]),_vm._v(" "),_c('div',{staticClass:"row reports"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('SHORTNAME')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.protetics),function(protetic){return _c('tr',[_c('td',{},[_vm._v(_vm._s(protetic.name))]),_vm._v(" "),_c('td',{staticClass:"protetictd"},[_c('b-progress',{attrs:{"max":_vm.max}},[_c('b-progress-bar',{style:('background-color: '+protetic.color),attrs:{"height":"1.5rem","value":parseInt(protetic.cnt)}},[_vm._v(_vm._s(protetic.shortname))])],1),_vm._v(" "),_c('span',{staticClass:"proteticcnt"},[_vm._v(_vm._s(protetic.cnt))])],1)])}))])])])])}
var Reports_staticRenderFns = []
var Reports_esExports = { render: Reports_render, staticRenderFns: Reports_staticRenderFns }
/* harmony default export */ var components_Reports = (Reports_esExports);
// CONCATENATED MODULE: ./src/components/Reports.vue
var Reports_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Reports___vue_template_functional__ = false
/* styles */
var Reports___vue_styles__ = null
/* scopeId */
var Reports___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Reports___vue_module_identifier__ = null
var Reports_Component = Reports_normalizeComponent(
  Reports,
  components_Reports,
  Reports___vue_template_functional__,
  Reports___vue_styles__,
  Reports___vue_scopeId__,
  Reports___vue_module_identifier__
)

/* harmony default export */ var src_components_Reports = (Reports_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ReportsDsDaily.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ReportsDsDaily = ({
    name: 'ReportsDs',
    data: function data() {
        return {
            dentalsolutiontypes: {},
            companies: {
                root: [],
                totalCount: 0
            },
            report: {},
            params: {
                date: new Date(),
                ordererCompanyId: '',
                dentalSolutionTypeId: null
            }
        };
    },
    created: function created() {
        var me = this;

        me.getCompanies();
        me.getDentalSolutionTypes();
        me.getReport();
    },
    methods: {
        getDentalSolutionTypes: function getDentalSolutionTypes() {
            var me = this;
            dentalsolutiontypes.selectRow({}, function (data) {
                if (data.error && data.error == true) {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.dentalsolutiontypes = assign_default()({}, data);
            });
        },
        getCompanies: function getCompanies() {
            var me = this;
            dentalsolutions.selectDentalSolutionUsers({}, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.companies = data;
                }
            });
        },
        setCompanyId: function setCompanyId(val) {
            var me = this;
            me.params.companyId = val;
        },
        getReport: function getReport() {
            var me = this;
            var params = extends_default()({}, me.params);

            params.date = moment_default()(params.date).format('YYYY-MM-DD');

            dentalsolutions.getReport(params, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.report = data;
                }
            });
        }
    },
    watch: {
        'params.date': function paramsDate() {
            var me = this;
            me.getReport();
        },
        'params.ordererCompanyId': function paramsOrdererCompanyId() {
            var me = this;
            me.getReport();
        },
        'params.dentalSolutionTypeId': function paramsDentalSolutionTypeId() {
            var me = this;
            me.getReport();
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        getQueryParams: function getQueryParams() {
            var me = this;

            return extends_default()({}, me.params, {
                date: moment_default()(me.params.date).format('YYYY-MM-DD')
            });
        },
        total: function total() {
            var me = this;

            var num = 0;
            var filesNum = 0;
            var repeat = 0;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(me.report.root), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    num += parseInt(item.num);
                    filesNum += parseInt(item.filesNum);
                    repeat += item.isRepeat === '1' ? parseInt(item.filesNum) : 0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return {
                num: num,
                filesNum: filesNum,
                repeat: repeat
            };
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6175bae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportsDsDaily.vue
var ReportsDsDaily_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-8 search-form"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('DATE')))]),_vm._v(" "),_c('datepicker',{attrs:{"bootstrapStyling":true,"format":"dd.MM.yyyy","placeholder":_vm.$t('STARTDATE')},model:{value:(_vm.params.date),callback:function ($$v) {_vm.$set(_vm.params, "date", $$v)},expression:"params.date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('COMPANY')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.ordererCompanyId),expression:"params.ordererCompanyId"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "ordererCompanyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('ALL')))]),_vm._v(" "),_vm._l((_vm.companies.root),function(company){return _c('option',{key:company.companyId,domProps:{"value":company.companyId}},[_vm._v(_vm._s(company.companyName))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('PRODUCT')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.dentalSolutionTypeId),expression:"params.dentalSolutionTypeId"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "dentalSolutionTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.dentalsolutiontypes.root),function(ds){return _c('option',{key:ds.dentalSolutionTypeId,domProps:{"value":ds.dentalSolutionTypeId}},[_vm._v(_vm._s(_vm.$t(ds.name)))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 action"},[_c('router-link',{staticClass:"btn btn-white d-none d-md-block",attrs:{"to":{ path: '/printdsdailyreport/', query: _vm.getQueryParams }}},[_c('img',{attrs:{"src":__webpack_require__("AN+Y"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('PRINT')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"})])]),_vm._v(" "),_c('div',{staticClass:"row reports report-monthly"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('TIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('CLIENT')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('QUANTITY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('FILESNUM')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('PLATFORMS')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ISREPEAT')))]),_vm._v(" "),_c('td',{staticStyle:{"width":"5px"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.report.root),function(row,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm.formatDate(row.updateDateTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.companyName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.filesNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t(row.name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.platforms))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((row.isRepeat == '1') ? _vm.$t('YES') : _vm.$t('NO')))]),_vm._v(" "),_c('td')])}))])])]),_vm._v(" "),_c('div',{staticClass:"row reports report-monthly fixed-bottom"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('TOTALNUM')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('TOTALFILESNUM')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('TOTALREPEAT')))]),_vm._v(" "),_c('td',{staticStyle:{"width":"5px"}})])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.total.num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total.filesNum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total.repeat))]),_vm._v(" "),_c('td')])])])])])])}
var ReportsDsDaily_staticRenderFns = []
var ReportsDsDaily_esExports = { render: ReportsDsDaily_render, staticRenderFns: ReportsDsDaily_staticRenderFns }
/* harmony default export */ var components_ReportsDsDaily = (ReportsDsDaily_esExports);
// CONCATENATED MODULE: ./src/components/ReportsDsDaily.vue
var ReportsDsDaily_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ReportsDsDaily___vue_template_functional__ = false
/* styles */
var ReportsDsDaily___vue_styles__ = null
/* scopeId */
var ReportsDsDaily___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReportsDsDaily___vue_module_identifier__ = null
var ReportsDsDaily_Component = ReportsDsDaily_normalizeComponent(
  ReportsDsDaily,
  components_ReportsDsDaily,
  ReportsDsDaily___vue_template_functional__,
  ReportsDsDaily___vue_styles__,
  ReportsDsDaily___vue_scopeId__,
  ReportsDsDaily___vue_module_identifier__
)

/* harmony default export */ var src_components_ReportsDsDaily = (ReportsDsDaily_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ReportsDsMonthly.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ReportsDsMonthly = ({
    name: 'ReportsDs',
    data: function data() {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0,
                total: 0
            },
            params: {
                month: moment_default()().format('M'),
                year: moment_default()().format('YYYY'),
                ordererCompanyId: '',
                dentalSolutionTypeId: ''
            }
        };
    },
    created: function created() {
        var me = this;

        me.getCompanies();
        me.getDentalSolutionTypes();
        me.getMonthlyReport();
    },
    methods: {
        getDentalSolutionTypes: function getDentalSolutionTypes() {
            var me = this;
            dentalsolutiontypes.selectRow({}, function (data) {
                if (data.error && data.error == true) {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.dentalsolutiontypes = assign_default()({}, data);
            });
        },
        getCompanies: function getCompanies() {
            var me = this;
            dentalsolutions.selectDentalSolutionUsers({}, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.companies = data;
                }
            });
        },
        setCompanyId: function setCompanyId(val) {
            var me = this;
            me.params.companyId = val;
        },
        getMonthlyReport: function getMonthlyReport() {
            var me = this;
            var params = extends_default()({}, me.params);

            params.date = moment_default()(params.date).format('YYYY-MM-DD');

            dentalsolutions.getMonthlyReport(params, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.report = data;
                }
            });
        }
    },
    watch: {
        'params.date': function paramsDate() {
            var me = this;
            me.getMonthlyReport();
        },
        'params.ordererCompanyId': function paramsOrdererCompanyId() {
            var me = this;
            me.getMonthlyReport();
        },
        'params.dentalSolutionTypeId': function paramsDentalSolutionTypeId() {
            var me = this;
            me.getMonthlyReport();
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        years: function years() {
            var data = [];

            for (var i = 2020; i < 2040; i++) {
                data.push(i);
            }

            return data;
        },
        months: function months() {
            var data = [];

            for (var i = 1; i <= 12; i++) {
                if (String(i).length == 1) {
                    data.push('0' + String(i));
                } else {
                    data.push(String(i));
                }
            }

            return data;
        },
        getQueryParams: function getQueryParams() {
            var me = this;

            return extends_default()({}, me.params, {
                date: moment_default()(me.params.date).format('YYYY-MM-DD')
            });
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7898cc14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportsDsMonthly.vue
var ReportsDsMonthly_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-8 search-form"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('MONTH')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.month),expression:"params.month"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.months),function(month){return _c('option',{key:month,domProps:{"value":month}},[_vm._v(_vm._s(month))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('YEAR')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.year),expression:"params.year"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.years),function(year){return _c('option',{key:year,domProps:{"value":year}},[_vm._v(_vm._s(year))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('COMPANY')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.ordererCompanyId),expression:"params.ordererCompanyId"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "ordererCompanyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('ALL')))]),_vm._v(" "),_vm._l((_vm.companies.root),function(company){return _c('option',{key:company.companyId,domProps:{"value":company.companyId}},[_vm._v(_vm._s(company.companyName))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('PRODUCT')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.dentalSolutionTypeId),expression:"params.dentalSolutionTypeId"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "dentalSolutionTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.dentalsolutiontypes.root),function(ds){return _c('option',{key:ds.dentalSolutionTypeId,domProps:{"value":ds.dentalSolutionTypeId}},[_vm._v(_vm._s(_vm.$t(ds.name)))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 action"},[_c('router-link',{staticClass:"btn btn-white d-none d-md-block",attrs:{"to":{ path: '/printdsmonthlyreport/', query: _vm.getQueryParams }}},[_c('img',{attrs:{"src":__webpack_require__("AN+Y"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('PRINT')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"})])]),_vm._v(" "),_c('div',{staticClass:"row reports report-monthly"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[(_vm.report.root[0])?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('CLIENT')))]),_vm._v(" "),_vm._l((_vm.report.root[0].quantityPerDate),function(num,date){return _c('td',[_vm._v(_vm._s(date))])}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('TOTAL')))])],2):_vm._e()]),_vm._v(" "),_c('tbody',_vm._l((_vm.report.root),function(row,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(row.companyName))]),_vm._v(" "),_vm._l((row.quantityPerDate),function(num,date){return _c('td',[_c('div',{staticClass:"date",class:{'empty': (num == 0)}},[_vm._v(_vm._s((num == 0) ? '' : num))])])}),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.num))])],2)})),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('TOTAL')+':'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.report.total))]),_vm._v(" "),_c('td')])])])])])])}
var ReportsDsMonthly_staticRenderFns = []
var ReportsDsMonthly_esExports = { render: ReportsDsMonthly_render, staticRenderFns: ReportsDsMonthly_staticRenderFns }
/* harmony default export */ var components_ReportsDsMonthly = (ReportsDsMonthly_esExports);
// CONCATENATED MODULE: ./src/components/ReportsDsMonthly.vue
var ReportsDsMonthly_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ReportsDsMonthly___vue_template_functional__ = false
/* styles */
var ReportsDsMonthly___vue_styles__ = null
/* scopeId */
var ReportsDsMonthly___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReportsDsMonthly___vue_module_identifier__ = null
var ReportsDsMonthly_Component = ReportsDsMonthly_normalizeComponent(
  ReportsDsMonthly,
  components_ReportsDsMonthly,
  ReportsDsMonthly___vue_template_functional__,
  ReportsDsMonthly___vue_styles__,
  ReportsDsMonthly___vue_scopeId__,
  ReportsDsMonthly___vue_module_identifier__
)

/* harmony default export */ var src_components_ReportsDsMonthly = (ReportsDsMonthly_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ReportsDsClient.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var ReportsDsClient = ({
    name: 'ReportsDs',
    data: function data() {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0
            },
            params: {
                month: moment_default()().format('M'),
                year: moment_default()().format('YYYY'),
                ordererCompanyId: ''
            }
        };
    },
    created: function created() {
        var me = this;

        me.getCompanies();
        me.getDentalSolutionTypes();
        me.getClientReport();
    },
    methods: {
        getDentalSolutionTypes: function getDentalSolutionTypes() {
            var me = this;
            dentalsolutiontypes.selectRow({}, function (data) {
                if (data.error && data.error == true) {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.dentalsolutiontypes = assign_default()({}, data);
            });
        },
        getCompanies: function getCompanies() {
            var me = this;
            dentalsolutions.selectDentalSolutionUsers({}, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.companies = data;
                }
            });
        },
        setCompanyId: function setCompanyId(val) {
            var me = this;
            me.params.companyId = val;
        },
        getClientReport: function getClientReport() {
            var me = this;
            var params = extends_default()({}, me.params);

            params.date = moment_default()(params.date).format('YYYY-MM-DD');

            dentalsolutions.getClientReport(params, function (data) {
                if (data.error) {
                    me.$notify.error(data.notice);
                } else {
                    me.report = data;
                }
            });
        }
    },
    watch: {
        'params.date': function paramsDate() {
            var me = this;
            me.getClientReport();
        },
        'params.ordererCompanyId': function paramsOrdererCompanyId() {
            var me = this;
            me.getClientReport();
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        years: function years() {
            var data = [];

            for (var i = 2020; i < 2040; i++) {
                data.push(i);
            }

            return data;
        },
        months: function months() {
            var data = [];

            for (var i = 1; i <= 12; i++) {
                if (String(i).length == 1) {
                    data.push('0' + String(i));
                } else {
                    data.push(String(i));
                }
            }

            return data;
        },
        getQueryParams: function getQueryParams() {
            var me = this;

            return extends_default()({}, me.params, {
                date: moment_default()(me.params.date).format('YYYY-MM-DD')
            });
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a5b46a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportsDsClient.vue
var ReportsDsClient_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row wrapper"},[_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-8 search-form"},[_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('MONTH')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.month),expression:"params.month"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.months),function(month){return _c('option',{key:month,domProps:{"value":month}},[_vm._v(_vm._s(month))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('YEAR')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.year),expression:"params.year"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.years),function(year){return _c('option',{key:year,domProps:{"value":year}},[_vm._v(_vm._s(year))])}))])]),_vm._v(" "),(_vm.globals.auth == 9)?_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('COMPANY')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.ordererCompanyId),expression:"params.ordererCompanyId"}],staticClass:"form-control secondary",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "ordererCompanyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.companies.root),function(company){return _c('option',{key:company.companyId,domProps:{"value":company.companyId}},[_vm._v(_vm._s(company.companyName))])}))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 action"},[_c('router-link',{staticClass:"btn btn-white d-none d-md-block",attrs:{"to":{ path: '/printdsclientreport/', query: _vm.getQueryParams }}},[_c('img',{attrs:{"src":__webpack_require__("AN+Y"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('PRINT')))])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"})])]),_vm._v(" "),_c('div',{staticClass:"row reports report-monthly"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('DATETIME')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('PRODUCT')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('QUANTITY')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('ISREPEAT')))]),_vm._v(" "),_c('td')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.report.root),function(row,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm.formatDate(row.updateDateTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t(row.name)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.isRepeat))]),_vm._v(" "),_c('td')])}))])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"maintable reports"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_vm._l((_vm.report.products),function(product){return _c('td',[_vm._v(_vm._s(_vm.$t(product.name)))])}),_vm._v(" "),_c('td')],2)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('QUANTITY'))+":")]),_vm._v(" "),_vm._l((_vm.report.products),function(product){return _c('td',[_vm._v(_vm._s(product.num))])}),_vm._v(" "),_c('td')],2),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('REPEATNUM'))+":")]),_vm._v(" "),_vm._l((_vm.report.products),function(product){return _c('td',[_vm._v(_vm._s(product.isRepeat))])}),_vm._v(" "),_c('td')],2)])])])])])}
var ReportsDsClient_staticRenderFns = []
var ReportsDsClient_esExports = { render: ReportsDsClient_render, staticRenderFns: ReportsDsClient_staticRenderFns }
/* harmony default export */ var components_ReportsDsClient = (ReportsDsClient_esExports);
// CONCATENATED MODULE: ./src/components/ReportsDsClient.vue
var ReportsDsClient_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ReportsDsClient___vue_template_functional__ = false
/* styles */
var ReportsDsClient___vue_styles__ = null
/* scopeId */
var ReportsDsClient___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReportsDsClient___vue_module_identifier__ = null
var ReportsDsClient_Component = ReportsDsClient_normalizeComponent(
  ReportsDsClient,
  components_ReportsDsClient,
  ReportsDsClient___vue_template_functional__,
  ReportsDsClient___vue_styles__,
  ReportsDsClient___vue_scopeId__,
  ReportsDsClient___vue_module_identifier__
)

/* harmony default export */ var src_components_ReportsDsClient = (ReportsDsClient_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Profile.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Profile = ({
    name: 'Profile',
    data: function data() {
        return {};
    },
    created: function created() {
        var me = this;
    },
    methods: {},
    watch: {},
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        routename: function routename() {
            return this.$route.name;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92f53508","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"gridheader"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 title"},[_c('h1',{staticClass:"mrgn"},[_vm._v(_vm._s(_vm.$t('PROFILE')))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[(_vm.globals.auth != 9 && _vm.globals.auth != 10)?_c('li',{class:(_vm.routename == 'Tasks') ? 'active' : ''},[_c('router-link',{attrs:{"to":'/profile/tasks'}},[_vm._v(_vm._s(_vm.$t('TASKS')))])],1):_vm._e(),_vm._v(" "),_c('li',{class:(_vm.routename == 'Chat') ? 'active' : ''},[_c('router-link',{attrs:{"to":'/profile/chat'}},[_vm._v(_vm._s(_vm.$t('CHAT')))])],1),_vm._v(" "),_c('li',{class:(_vm.routename == 'Notifications') ? 'active' : ''},[_c('router-link',{attrs:{"to":'/profile/notifications'}},[_vm._v(_vm._s(_vm.$t('NOTIFICATIONS')))])],1),_vm._v(" "),_c('li',{staticClass:"d-none d-md-inline-block",class:(_vm.routename == 'User') ? 'active' : ''},[_c('router-link',{attrs:{"to":'/profile/user'}},[_vm._v(_vm._s(_vm.$t('PERSONALDATA')))])],1)])])])]),_vm._v(" "),_c('router-view')],1)}
var Profile_staticRenderFns = []
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var components_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/components/Profile.vue
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = null
/* scopeId */
var Profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  components_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var src_components_Profile = (Profile_Component.exports);

// CONCATENATED MODULE: ./src/api/workordertasks.js


/* harmony default export */ var workordertasks = ({
  getFromAndToUsers: function getFromAndToUsers(params, cb) {
    AxApi.get('/rest/WorkOrderTasks/getFromAndToUsers', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  getTasksByFromTo: function getTasksByFromTo(params, cb) {
    AxApi.get('/rest/WorkOrderTasks/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  toggleTask: function toggleTask(params, cb) {
    AxApi.post('/rest/WorkOrderTasks/toggleTask', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tasks.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var Tasks_moment = __webpack_require__("PJh5");

/* harmony default export */ var Tasks = ({
    name: 'Tasks',
    data: function data() {
        return {
            checkedVal: false,
            taskUsers: {},
            tasks: {},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 20,
                userFrom: false,
                userTo: false,
                selectedDate: null
            }
        };
    },
    created: function created() {
        var me = this;
        me.pagination.userTo = me.globals.userId;
        me.getUsers();
        me.getTasksByFromTo();
    },
    methods: {
        getStatusBool: function getStatusBool(status) {
            var me = this;
            if (status == 'finished') return true;
            return false;
        },
        toggleTask: function toggleTask(val, workOrderTaskId) {
            var me = this;
            workordertasks.toggleTask({
                workOrderTaskId: workOrderTaskId,
                checked: val
            }, function (data) {
                if (data.error && data.error == true) {
                    me.$notify.error(data.notice);
                }
                me.getTasksByFromTo();
            });
        },
        formatTime: function formatTime(deadline) {
            var me = this;
            return Tasks_moment(deadline).format('HH:mm');
        },
        formatDate: function formatDate(date) {
            var me = this;
            return Tasks_moment(date).format('DD.MM.YYYY. HH:mm');
        },
        getUsers: function getUsers() {
            var me = this;
            workordertasks.getFromAndToUsers({}, function (data) {
                if (data.error && data.error == true) {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.taskUsers = data;
            });
        },
        getTasksByFromTo: function getTasksByFromTo() {
            var me = this;
            me.tasks = {};
            workordertasks.getTasksByFromTo(me.getParams, function (data) {
                if (data.error && data.error == true) {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.tasks = data;
            });
        }
    },
    watch: {
        'pagination.query': function paginationQuery() {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.userFrom': function paginationUserFrom() {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.currentPage': function paginationCurrentPage(newValue, oldValue) {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.userTo': function paginationUserTo() {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.selectedDate': function paginationSelectedDate(newValue, oldValue) {
            var me = this;
            if (oldValue != null && (typeof oldValue === 'undefined' ? 'undefined' : typeof_default()(oldValue)) == 'object' && newValue != null && (typeof newValue === 'undefined' ? 'undefined' : typeof_default()(newValue)) == 'object' && oldValue.getTime() == newValue.getTime()) me.pagination.selectedDate = null;else me.getTasksByFromTo();
        }
    },
    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['globals']), {
        formatedDate: function formatedDate() {
            var me = this;
            if (me.pagination.selectedDate == null) return '*';
            return Tasks_moment(me.pagination.selectedDate).format('DD.MM.YYYY');
        },

        getParams: function getParams() {
            var me = this;
            var data = assign_default()({}, me.pagination, {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703cc0fd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks.vue
var Tasks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row workorder"},[_c('div',{staticClass:"col-md-2 first-col filter d-none d-md-inline-block"},[_c('datepicker',{attrs:{"monday-first":true,"language":"hr","full-month-name":true,"format":"dd.MM.yyyy","inline":true},model:{value:(_vm.pagination.selectedDate),callback:function ($$v) {_vm.$set(_vm.pagination, "selectedDate", $$v)},expression:"pagination.selectedDate"}}),_vm._v(" "),_c('div',{staticClass:"block tasks-filter"},[_c('h3',[_vm._v(_vm._s(_vm.$t('FILTERTASKS')))]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('NAME')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('TASKFROM')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('TASKTO')))])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{class:(_vm.pagination.userFrom == false || _vm.pagination.userTo == false) ? 'selected' : ''},[_vm._v(_vm._s(_vm.$t('ALLWORKERS')))]),_vm._v(" "),_c('td',[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":false},model:{value:(_vm.pagination.userFrom),callback:function ($$v) {_vm.$set(_vm.pagination, "userFrom", $$v)},expression:"pagination.userFrom"}})],1),_vm._v(" "),_c('td',[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":false},model:{value:(_vm.pagination.userTo),callback:function ($$v) {_vm.$set(_vm.pagination, "userTo", $$v)},expression:"pagination.userTo"}})],1)]),_vm._v(" "),_vm._l((_vm.taskUsers.root),function(user){return _c('tr',[_c('td',{class:(user.userId == _vm.pagination.userFrom || user.userId == _vm.pagination.userTo) ? 'selected' : ''},[_vm._v(_vm._s(user.nameSurname))]),_vm._v(" "),_c('td',[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":user.userId},model:{value:(_vm.pagination.userFrom),callback:function ($$v) {_vm.$set(_vm.pagination, "userFrom", $$v)},expression:"pagination.userFrom"}})],1),_vm._v(" "),_c('td',[_c('b-form-checkbox',{staticClass:"grey",attrs:{"value":user.userId,"checked":_vm.pagination.userTo == user.userId},model:{value:(_vm.pagination.userTo),callback:function ($$v) {_vm.$set(_vm.pagination, "userTo", $$v)},expression:"pagination.userTo"}})],1)])})],2)])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-12 last-col"},[_c('div',{staticClass:"table-responsive"},[_c('div',{staticClass:"header-info"},[_c('div',{staticClass:"col-md-12"},[_c('b',[_vm._v(_vm._s(_vm.$t('ALLTASKSFOR'))+" "+_vm._s(_vm.formatedDate))])])]),_vm._v(" "),_c('table',{staticClass:"maintable smaller nopadding"},[_c('thead',[_c('tr',[_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('TASKFROM')))]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('TASKTO')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('PACIENT')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('TIME')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('NOTICE')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('FINISHED')))]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('OPENEDON')))]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t('LASTCHANGE')))]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell center"},[_vm._v(_vm._s(_vm.$t('WORKFORM')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.tasks.root),function(task){return _c('tr',[_c('td',{staticClass:"d-none d-md-table-cell"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.startChatByUserId(task.userId, task.workOrderId)}}},[_c('img',{attrs:{"src":__webpack_require__("eX+1"),"alt":""}}),_vm._v(" "+_vm._s(task.name)+" "+_vm._s(task.surname))])]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.startChatByUserId(task.toUserId, task.workOrderId)}}},[_c('img',{attrs:{"src":__webpack_require__("eX+1"),"alt":""}}),_vm._v(" "+_vm._s(task.toName)+" "+_vm._s(task.toSurname))])]),_vm._v(" "),_c('td',[(task.workOrderId)?_c('router-link',{attrs:{"to":{ path: '/workorders/'+task.workOrderId, query: { open: 'tasks' }}}},[_vm._v(_vm._s(task.patientName)+" "+_vm._s(task.patientSurname))]):_vm._e(),_vm._v(" "),(task.dentalSolutionId)?_c('router-link',{attrs:{"to":{ path: '/dentalsolutions/'+task.dentalSolutionId, query: { open: 'tasks' }}}},[_vm._v(_vm._s(task.dentalSolutionId))]):_vm._e()],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(task.deadline)))]),_vm._v(" "),_c('td',[(task.workOrderId)?_c('router-link',{attrs:{"to":{ path: '/workorders/'+task.workOrderId, query: { open: 'tasks' }}}},[_vm._v(_vm._s(task.text))]):_vm._e(),_vm._v(" "),(task.dentalSolutionId)?_c('router-link',{attrs:{"to":{ path: '/dentalsolutions/'+task.dentalSolutionId, query: { open: 'tasks' }}}},[_vm._v(_vm._s(task.text))]):_vm._e()],1),_vm._v(" "),_c('td',[_c('input-switch',{attrs:{"checked":task.status == 'finished',"id":task.workOrderTaskId},on:{"change":_vm.toggleTask}})],1),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.formatDate(task.insertDateTime)))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.formatDate(task.updateDateTime)))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell center"},[(task.workOrderId)?_c('router-link',{attrs:{"to":{ path: '/workorders/'+task.workOrderId, query: { open: 'tasks' }}}},[_c('img',{attrs:{"src":__webpack_require__("yA9E")}})]):_vm._e(),_vm._v(" "),(task.dentalSolutionId)?_c('router-link',{attrs:{"to":{ path: '/dentalsolutions/'+task.dentalSolutionId, query: { open: 'tasks' }}}},[_c('img',{attrs:{"src":__webpack_require__("yA9E")}})]):_vm._e()],1)])}))])]),_vm._v(" "),(_vm.tasks.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.tasks.totalCount,"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e()],1)])}
var Tasks_staticRenderFns = []
var Tasks_esExports = { render: Tasks_render, staticRenderFns: Tasks_staticRenderFns }
/* harmony default export */ var components_Tasks = (Tasks_esExports);
// CONCATENATED MODULE: ./src/components/Tasks.vue
var Tasks_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Tasks___vue_template_functional__ = false
/* styles */
var Tasks___vue_styles__ = null
/* scopeId */
var Tasks___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Tasks___vue_module_identifier__ = null
var Tasks_Component = Tasks_normalizeComponent(
  Tasks,
  components_Tasks,
  Tasks___vue_template_functional__,
  Tasks___vue_styles__,
  Tasks___vue_scopeId__,
  Tasks___vue_module_identifier__
)

/* harmony default export */ var src_components_Tasks = (Tasks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProfileChat.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ProfileChat = ({
  name: "Talks",
  data: function data() {
    return {
      talks: {},
      pagination: {
        query: "",
        currentPage: 1,
        limit: 20
      }
    };
  },
  created: function created() {
    var me = this;
    me.getTalks();
  },
  methods: {
    getDesc: function getDesc(talk) {
      if (talk.patientName != null) {
        return talk.patientName + " " + talk.patientSurname;
      }
      return talk.dentalSolutionId;
    },
    startChat: function startChat(talk) {
      var _this = this;

      var me = this;

      me.chatUserId = talk.chatUserId;

      setTimeout(function () {
        if (talk.workOrderId != null) {
          _this.$store.commit("setChatData", {
            chatUserId: talk.chatUserId,
            workOrderId: talk.workOrderId
          });
        } else {
          _this.$store.commit("setChatData", {
            chatUserId: talk.chatUserId,
            dentalSolutionId: talk.dentalSolutionId
          });
        }
      }, 0);
    },

    getTalks: function getTalks() {
      var me = this;
      me.tasks = {};
      workordertalks.selectMyChats(me.getParams, function (data) {
        if (data.error && data.error == true) {
          me.$notify.error(data.notice);
          return;
        }

        me.talks = data;
      });
    }
  },
  watch: {
    "pagination.query": function paginationQuery() {
      var me = this;
      me.getTalks();
    },
    "pagination.currentPage": function paginationCurrentPage(val) {
      var me = this;
      me.getTalks();
      me.$refs.chatTable.scrollIntoView(true);
    }
  },
  computed: {
    getParams: function getParams() {
      var me = this;
      var data = assign_default()({}, me.pagination, {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8fdf5f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileChat.vue
var ProfileChat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row workorder chat-width"},[_c('div',{staticClass:"last-col"},[_c('div',{staticClass:"table-responsive"},[_c('table',{ref:"chatTable",staticClass:"maintable smaller"},[_c('thead',[_c('tr',[_c('th',[_vm._v("!")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("PACIENT")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("FROM")))]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(_vm.$t("TO")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("TIME")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("MESSAGE")))]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell center"},[_vm._v("\n              "+_vm._s(_vm.$t("WORKFORM"))+"\n            ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.talks.root),function(talk){return _c('tr',{key:talk.workOrderTalkId,class:{
              read: talk.unread == 0,
              to_respond: talk.chatUserId !== talk.toUserId,
            },on:{"click":function($event){$event.preventDefault();_vm.startChat(talk)}}},[_vm._m(0,true,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDesc(talk)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(talk.name)+" "+_vm._s(talk.surname))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v("\n              "+_vm._s(talk.toName)+" "+_vm._s(talk.toSurname)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatDate(talk.dateTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(talk.text))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell center"},[(talk.workOrderId)?_c('router-link',{attrs:{"to":{
                  path: '/workorders/' + talk.workOrderId,
                  query: { open: 'chat' },
                }}},[_c('img',{attrs:{"src":__webpack_require__("yA9E")}})]):_vm._e(),_vm._v(" "),(talk.dentalSolutionId)?_c('router-link',{attrs:{"to":{
                  path: '/dentalsolutions/' + talk.dentalSolutionId,
                  query: { open: 'chat' },
                }}},[_c('img',{attrs:{"src":__webpack_require__("yA9E")}})]):_vm._e()],1)])}))])]),_vm._v(" "),(_vm.talks.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.talks.totalCount,"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e()],1)])}
var ProfileChat_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"notification"},[_c('div')])}]
var ProfileChat_esExports = { render: ProfileChat_render, staticRenderFns: ProfileChat_staticRenderFns }
/* harmony default export */ var components_ProfileChat = (ProfileChat_esExports);
// CONCATENATED MODULE: ./src/components/ProfileChat.vue
var ProfileChat_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ProfileChat___vue_template_functional__ = false
/* styles */
var ProfileChat___vue_styles__ = null
/* scopeId */
var ProfileChat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProfileChat___vue_module_identifier__ = null
var ProfileChat_Component = ProfileChat_normalizeComponent(
  ProfileChat,
  components_ProfileChat,
  ProfileChat___vue_template_functional__,
  ProfileChat___vue_styles__,
  ProfileChat___vue_scopeId__,
  ProfileChat___vue_module_identifier__
)

/* harmony default export */ var src_components_ProfileChat = (ProfileChat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProfileUser.vue
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var ProfileUser = ({
  name: 'ProfileUser',
  data: function data() {
    return {
      formData: {
        id: '',
        name: '',
        surname: '',
        userEmail: '',
        username: '',
        password: '',
        userGroup: '',
        status: ''
      },
      formError: {}
    };
  },
  components: {
    'employee-form': src_components_EmployeeForm
  },
  created: function created() {
    var me = this;
    me.selectMyData();
  },
  methods: {
    selectMyData: function selectMyData() {
      var me = this;
      employees.selectMyData({}, function (data) {
        me.formData = data.root;
      });
    },
    saveEmployee: function saveEmployee() {
      var me = this;
      employees.saveEmployee(me.formData, function (val) {
        if (val.error) {
          me.formError = val;
        } else {
          me.formError = {};
          me.$notify.success(val.notice);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44029bac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileUser.vue
var ProfileUser_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('BASICDATA')))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('employee-form',{attrs:{"formData":_vm.formData,"formError":_vm.formError,"simple":true}}),_vm._v(" "),_c('div',{staticClass:"col-md-4 action"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.saveEmployee($event)}}},[_c('img',{attrs:{"src":__webpack_require__("T1Gp"),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t('SAVECHANGES')))])])],1)])])}
var ProfileUser_staticRenderFns = []
var ProfileUser_esExports = { render: ProfileUser_render, staticRenderFns: ProfileUser_staticRenderFns }
/* harmony default export */ var components_ProfileUser = (ProfileUser_esExports);
// CONCATENATED MODULE: ./src/components/ProfileUser.vue
var ProfileUser_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ProfileUser___vue_template_functional__ = false
/* styles */
var ProfileUser___vue_styles__ = null
/* scopeId */
var ProfileUser___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ProfileUser___vue_module_identifier__ = null
var ProfileUser_Component = ProfileUser_normalizeComponent(
  ProfileUser,
  components_ProfileUser,
  ProfileUser___vue_template_functional__,
  ProfileUser___vue_styles__,
  ProfileUser___vue_scopeId__,
  ProfileUser___vue_module_identifier__
)

/* harmony default export */ var src_components_ProfileUser = (ProfileUser_Component.exports);

// CONCATENATED MODULE: ./src/api/notifications.js


/* harmony default export */ var notifications = ({
  getNotifications: function getNotifications(params, cb) {
    AxApi.get('/rest/Notifications/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Notifications.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Notifications = ({
    name: 'Notifications',
    data: function data() {
        return {
            notifications: {},
            pagination: {
                query: '',
                currentPage: 1,
                limit: 20,
                startDate: moment_default()().subtract(31, 'days').format(),
                endDate: new Date()
            }
        };
    },
    created: function created() {
        var me = this;
        me.getNotifications();
    },
    methods: {
        getNotifications: function getNotifications() {
            var me = this;
            me.tasks = {};
            notifications.getNotifications(me.getParams, function (data) {
                if (data.error && data.error == true) {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.notifications = data;
            });
        },
        formatDateDay: function formatDateDay(day) {
            return moment_default()(day).format('DD.MM.YYYY.');
        }
    },
    watch: {
        'pagination.startDate': function paginationStartDate(newValue, oldValue) {
            var me = this;
            me.getNotifications();
        },
        'pagination.endDate': function paginationEndDate(newValue, oldValue) {
            var me = this;
            me.getNotifications();
        },
        'pagination.currentPage': function paginationCurrentPage(newValue, oldValue) {
            var me = this;
            me.getNotifications();
        }
    },
    computed: {
        getParams: function getParams() {
            var me = this;
            var data = assign_default()({}, me.pagination, {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ad4d9ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
var Notifications_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row workorder"},[_c('div',{staticClass:"col-md-2 first-col d-none d-md-inline-block"},[_c('div',{staticClass:"block"},[_c('h3',[_vm._v(_vm._s(_vm.$t('FILTERNOTIFICATIONS')))]),_vm._v(" "),_c('form',{attrs:{"method":"get","action":""}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('STARTDATE')))]),_vm._v(" "),_c('datepicker',{attrs:{"input-class":"secondary","bootstrapStyling":true,"format":"dd.MM.yyyy","placeholder":_vm.$t('STARTDATE')},model:{value:(_vm.pagination.startDate),callback:function ($$v) {_vm.$set(_vm.pagination, "startDate", $$v)},expression:"pagination.startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('ENDDATE')))]),_vm._v(" "),_c('datepicker',{attrs:{"input-class":"secondary","bootstrapStyling":true,"format":"dd.MM.yyyy","placeholder":_vm.$t('ENDDATE')},model:{value:(_vm.pagination.endDate),callback:function ($$v) {_vm.$set(_vm.pagination, "endDate", $$v)},expression:"pagination.endDate"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-12 last-col enable-scroll"},[_c('div',{staticClass:"row header-info notif"},[_c('div',{staticClass:"col-md-12"},[_vm._v(_vm._s(_vm.$t('NOTIFICATIONSFROM'))+" "),_c('b',[_vm._v(_vm._s(_vm.formatDate(_vm.pagination.startDate)))]),_vm._v(" "+_vm._s(_vm.$t('NOTIFICATIONSTO'))+" "),_c('b',[_vm._v(_vm._s(_vm.formatDate(_vm.pagination.endDate)))])])]),_vm._v(" "),_vm._l((_vm.notifications.root),function(notification,day){return _c('div',{staticClass:"notifications"},[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatDateDay(day)))]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},_vm._l((notification),function(notif){return _c('li',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[(notif.type == 'task')?_c('img',{attrs:{"src":__webpack_require__("PobS")}}):_vm._e(),_vm._v(" "),(notif.type == 'chat')?_c('img',{attrs:{"src":__webpack_require__("d5YL")}}):_vm._e(),_vm._v(" "),(notif.type == 'workorder' || notif.type == 'dentalsolution')?_c('img',{attrs:{"src":__webpack_require__("ykL/")}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_vm._v(_vm._s(notif.notice))]),_vm._v(" "),_c('div',{staticClass:"col-2"},[(notif.workOrderId)?_c('router-link',{attrs:{"to":{ path: '/workorders/'+notif.workOrderId, query: { open: (notif.type == 'task' ? 'tasks' : (notif.type == 'task' ? 'chat' : 'workorder')) }}}},[_c('img',{attrs:{"src":__webpack_require__("yA9E")}})]):_vm._e(),_vm._v(" "),(notif.dentalSolutionId)?_c('router-link',{attrs:{"to":{ path: '/dentalsolutions/'+notif.dentalSolutionId, query: { open: (notif.type == 'task' ? 'tasks' : (notif.type == 'task' ? 'chat' : 'dentalsolution')) }}}},[_c('img',{attrs:{"src":__webpack_require__("yA9E")}})]):_vm._e()],1)])])}))])}),_vm._v(" "),(_vm.notifications.totalCount > 20)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.notifications.totalCount,"per-page":_vm.pagination.limit},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}}):_vm._e()],2)])}
var Notifications_staticRenderFns = []
var Notifications_esExports = { render: Notifications_render, staticRenderFns: Notifications_staticRenderFns }
/* harmony default export */ var components_Notifications = (Notifications_esExports);
// CONCATENATED MODULE: ./src/components/Notifications.vue
var Notifications_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Notifications___vue_template_functional__ = false
/* styles */
var Notifications___vue_styles__ = null
/* scopeId */
var Notifications___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Notifications___vue_module_identifier__ = null
var Notifications_Component = Notifications_normalizeComponent(
  Notifications,
  components_Notifications,
  Notifications___vue_template_functional__,
  Notifications___vue_styles__,
  Notifications___vue_scopeId__,
  Notifications___vue_module_identifier__
)

/* harmony default export */ var src_components_Notifications = (Notifications_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




























vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    routes: [{
        path: '/login',
        name: 'Login',
        component: src_components_Login
    }, {
        path: '/login/:verifyCode',
        name: 'Login',
        component: src_components_Login
    }, {
        path: '/controlpanel/basic',
        name: 'ControlPanel',
        component: src_components_ControlPanel
    }, {
        path: '/controlpanel/connection',
        name: 'ConnectionPanel',
        component: src_components_ConnectionPanel
    }, {
        path: '/patients',
        name: 'Patients',
        component: src_components_Patients
    }, {
        path: '/patients/:patientId',
        name: 'WorkOrders',
        component: src_components_WorkOrders
    }, {
        path: '/ordinationsandlabs',
        name: 'Ordinationsandlabs',
        component: src_components_Ordinations
    }, {
        path: '/workorders/:workOrderId',
        name: 'WorkOrder',
        component: src_components_WorkOrder
    }, {
        path: '/printworkorder/:workOrderId',
        name: 'PrintWorkOrder',
        component: src_components_PrintWorkOrder
    }, {
        path: '/protetics',
        name: 'Protetics',
        component: src_components_Protetics
    }, {
        path: '/employees',
        name: 'Employees',
        component: src_components_Employees
    }, {
        path: '/reports',
        name: 'Reports',
        component: src_components_Reports
    }, {
        path: '/dentalsolutions',
        name: 'DentalSolutions',
        component: src_components_DentalSolutions
    }, {
        path: '/dentalsolutions/:dentalSolutionId',
        name: 'DentalSolution',
        component: src_components_DentalSolution
    }, {
        path: '/profile',
        name: 'Profile',
        component: src_components_Profile,
        children: [{
            path: 'tasks',
            name: 'Tasks',
            component: src_components_Tasks
        }, {
            path: 'chat',
            name: 'Chat',
            component: src_components_ProfileChat
        }, {
            path: 'notifications',
            name: 'Notifications',
            component: src_components_Notifications
        }, {
            path: 'user',
            name: 'User',
            component: src_components_ProfileUser
        }]
    }, {
        path: '/printdsdailyreport',
        name: 'PrintDsDaily',
        component: src_components_PrintDsDaily
    }, {
        path: '/printdsmonthlyreport',
        name: 'PrintDsMonthly',
        component: src_components_PrintDsMonthly
    }, {
        path: '/printdsclientreport',
        name: 'PrintDsClient',
        component: src_components_PrintDsClient
    }, {
        path: '/reportsds',
        name: 'ReportsDs',
        component: src_components_ReportDsHolder,
        children: [{
            path: 'daily',
            name: 'ReportsDsDaily',
            component: src_components_ReportsDsDaily
        }, {
            path: 'monthly',
            name: 'ReportsDsMonthly',
            component: src_components_ReportsDsMonthly
        }, {
            path: 'client',
            name: 'ReportsDsClient',
            component: src_components_ReportsDsClient
        }]
    }]
}));
// CONCATENATED MODULE: ./src/store/modules/globals.js


var _mutations;



// initial state
var globals_state = {
  globals: { auth: 0 },
  menuActive: false,
  loginResponse: false,
  translation: {},
  langInitialized: false,
  modalAlert: false,
  chatData: false,
  messageCount: 0,
  taskCount: 0,
  notificationCount: 0

  // getters
};var getters = {
  globals: function globals(state) {
    return state.globals;
  },
  menuActive: function menuActive(state) {
    return state.menuActive;
  },
  loginResponse: function loginResponse(state) {
    return state.loginResponse;
  },
  translation: function translation(state) {
    return state.translation;
  },
  langInitialized: function langInitialized(state) {
    return state.langInitialized;
  },
  modalAlert: function modalAlert(state) {
    return state.modalAlert;
  },
  chatData: function chatData(state) {
    return state.chatData;
  },
  messageCount: function messageCount(state) {
    return state.messageCount;
  },
  taskCount: function taskCount(state) {
    return state.taskCount;
  },
  notificationCount: function notificationCount(state) {
    return state.notificationCount;
  }

  // actions
};var actions = {
  getGlobals: function getGlobals(_ref) {
    var commit = _ref.commit;

    globals.getGlobals(function (globals) {
      commit('RECEIVE_GLOBALS', { globals: globals });
    });
  },
  selectMyMessageCount: function selectMyMessageCount(_ref2) {
    var commit = _ref2.commit;

    globals.selectMyMessageCount(function (data) {
      commit('RECEIVE_MSG_COUNT', { data: data });
    });
  },
  selectMyTasksCount: function selectMyTasksCount(_ref3) {
    var commit = _ref3.commit;

    globals.selectMyTasksCount(function (data) {
      commit('RECEIVE_TASK_COUNT', { data: data });
    });
  },
  selectMyNotificationsCount: function selectMyNotificationsCount(_ref4) {
    var commit = _ref4.commit;

    globals.selectMyNotificationsCount(function (data) {
      commit('RECEIVE_NOTIFICATION_COUNT', { data: data });
    });
  },

  fetchLanguage: function fetchLanguage(context, data) {
    globals.fetchLanguage(data, function (translation) {
      context.commit('RECEIVE_LANGUAGE', { translation: translation });
    });
  },
  login: function login(context, data) {
    globals.login(data, function (loginResponse) {
      context.commit('LOGIN_RESPONSE', { loginResponse: loginResponse });
      globals.getGlobals(function (globals) {
        context.commit('RECEIVE_GLOBALS', { globals: globals });
      });
    });
  },
  logout: function logout(_ref5) {
    var commit = _ref5.commit;

    globals.logout(function (context) {
      globals.getGlobals(function (globals) {
        commit('RECEIVE_GLOBALS', { globals: globals });
      });
    });
  }
};

// mutations
var mutations = (_mutations = {}, defineProperty_default()(_mutations, 'RECEIVE_GLOBALS', function RECEIVE_GLOBALS(state, _ref6) {
  var globals = _ref6.globals;

  state.globals = globals;
}), defineProperty_default()(_mutations, 'RECEIVE_LANGUAGE', function RECEIVE_LANGUAGE(state, _ref7) {
  var translation = _ref7.translation;

  state.langInitialized = true;
  state.translation = translation;
}), defineProperty_default()(_mutations, 'LOGIN_RESPONSE', function LOGIN_RESPONSE(state, _ref8) {
  var loginResponse = _ref8.loginResponse;

  state.loginResponse = loginResponse;
}), defineProperty_default()(_mutations, 'RECEIVE_MSG_COUNT', function RECEIVE_MSG_COUNT(state, _ref9) {
  var data = _ref9.data;

  state.messageCount = data.totalCount;
}), defineProperty_default()(_mutations, 'RECEIVE_TASK_COUNT', function RECEIVE_TASK_COUNT(state, _ref10) {
  var data = _ref10.data;

  state.taskCount = data.totalCount;
}), defineProperty_default()(_mutations, 'RECEIVE_NOTIFICATION_COUNT', function RECEIVE_NOTIFICATION_COUNT(state, _ref11) {
  var data = _ref11.data;

  state.notificationCount = data.totalCount;
}), defineProperty_default()(_mutations, 'setModalAlert', function setModalAlert(state, modalAlert) {
  state.modalAlert = modalAlert;
}), defineProperty_default()(_mutations, 'setChatData', function setChatData(state, chatData) {
  state.chatData = chatData;
}), defineProperty_default()(_mutations, 'toggleMenu', function toggleMenu(state) {
  return state.menuActive = !state.menuActive;
}), defineProperty_default()(_mutations, 'hideMenu', function hideMenu(state) {
  return state.menuActive = false;
}), defineProperty_default()(_mutations, 'hideChatMenu', function hideChatMenu(state) {
  return state.chatData = false;
}), _mutations);

/* harmony default export */ var modules_globals = ({
  state: globals_state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/store/modules/patients.js


var patients__mutations;




// initial state
var patients_state = {
  patients: { root: [], totalCount: 0 },
  patient: { root: [], totalCount: 0 },
  savePatientResponse: false,
  deletePatientResponse: false

  // getters
};var patients_getters = {
  patients: function patients(state) {
    return state.patients;
  },
  patient: function patient(state) {
    return state.patient;
  },
  savePatientResponse: function savePatientResponse(state) {
    return state.savePatientResponse;
  },
  deletePatientResponse: function deletePatientResponse(state) {
    return state.deletePatientResponse;
  }

  // actions
};var patients_actions = {
  getPatients: function getPatients(context, data) {
    patients.getPatients(data, function (patients) {
      context.commit('RECEIVE_PATIENTS', { patients: patients });
    });
  },
  getPatient: function getPatient(context, data) {
    patients.getPatient(data, function (patient) {
      context.commit('RECEIVE_PATIENT', { patient: patient });
    });
  },
  savePatient: function savePatient(context, data) {
    patients.savePatient(data, function (savePatientResponse) {
      context.commit('SAVE_RESPONSE', { savePatientResponse: savePatientResponse });
    });
  },
  deletePatient: function deletePatient(context, data) {
    patients.deletePatient(data, function (deletePatientResponse) {
      context.commit('DELETE_RESPONSE', { deletePatientResponse: deletePatientResponse });
    });
  }

  // mutations
};var patients_mutations = (patients__mutations = {}, defineProperty_default()(patients__mutations, 'RECEIVE_PATIENTS', function RECEIVE_PATIENTS(state, _ref) {
  var patients = _ref.patients;

  patients.totalCount = parseInt(patients.totalCount);
  state.patients = patients;
}), defineProperty_default()(patients__mutations, 'RECEIVE_PATIENT', function RECEIVE_PATIENT(state, _ref2) {
  var patient = _ref2.patient;

  patient.totalCount = parseInt(patient.totalCount);
  state.patient = patient;
}), defineProperty_default()(patients__mutations, 'SAVE_RESPONSE', function SAVE_RESPONSE(state, _ref3) {
  var savePatientResponse = _ref3.savePatientResponse;

  state.savePatientResponse = savePatientResponse;
}), defineProperty_default()(patients__mutations, 'DELETE_RESPONSE', function DELETE_RESPONSE(state, _ref4) {
  var deletePatientResponse = _ref4.deletePatientResponse;

  if (deletePatientResponse.error == true) vue_esm["default"].$notify.error(deletePatientResponse.notice);else vue_esm["default"].$notify.success(deletePatientResponse.notice);
  state.deletePatientResponse = deletePatientResponse;
}), patients__mutations);

/* harmony default export */ var modules_patients = ({
  state: patients_state,
  getters: patients_getters,
  actions: patients_actions,
  mutations: patients_mutations
});
// CONCATENATED MODULE: ./src/store/modules/patientsgallery.js


var patientsgallery__mutations;




// initial state
var patientsgallery_state = {
  patientsgallery: { root: [], totalCount: 0 },
  savePatientsGalleryResponse: false,
  deletePatientsGalleryResponse: false

  // getters
};var patientsgallery_getters = {
  patientsgallery: function patientsgallery(state) {
    return state.patientsgallery;
  },
  savePatientsGalleryResponse: function savePatientsGalleryResponse(state) {
    return state.savePatientsGalleryResponse;
  },
  deletePatientsGalleryResponse: function deletePatientsGalleryResponse(state) {
    return state.deletePatientsGalleryResponse;
  }

  // actions
};var patientsgallery_actions = {
  getPatientsGallery: function getPatientsGallery(context, data) {
    api_patientsgallery.getPatientsGallery(data, function (patientsgallery) {
      context.commit('RECEIVE_PATIENTS_GALLERY', { patientsgallery: patientsgallery });
    });
  },
  savePatientsGallery: function savePatientsGallery(context, data) {
    api_patientsgallery.savePatientsGallery(data, function (savePatientsGalleryResponse) {
      context.commit('SAVE_PACIENTS_GALLERY_RESPONSE', { savePatientsGalleryResponse: savePatientsGalleryResponse });
    });
  },
  deletePatientsGallery: function deletePatientsGallery(context, data) {
    api_patientsgallery.deletePatientsGallery(data, function (deletePatientsGalleryResponse) {
      context.commit('DELETE_PACIENTS_GALLERY_RESPONSE', { deletePatientsGalleryResponse: deletePatientsGalleryResponse });
    });
  }

  // mutations
};var patientsgallery_mutations = (patientsgallery__mutations = {}, defineProperty_default()(patientsgallery__mutations, 'RECEIVE_PATIENTS_GALLERY', function RECEIVE_PATIENTS_GALLERY(state, _ref) {
  var patientsgallery = _ref.patientsgallery;

  patientsgallery.totalCount = parseInt(patientsgallery.totalCount);
  state.patientsgallery = patientsgallery;
}), defineProperty_default()(patientsgallery__mutations, 'SAVE_PACIENTS_GALLERY_RESPONSE', function SAVE_PACIENTS_GALLERY_RESPONSE(state, _ref2) {
  var savePatientsGalleryResponse = _ref2.savePatientsGalleryResponse;

  state.savePatientsGalleryResponse = savePatientsGalleryResponse;
}), defineProperty_default()(patientsgallery__mutations, 'DELETE_PACIENTS_GALLERY_RESPONSE', function DELETE_PACIENTS_GALLERY_RESPONSE(state, _ref3) {
  var deletePatientsGalleryResponse = _ref3.deletePatientsGalleryResponse;

  if (deletePatientsGalleryResponse.error == true) vue_esm["default"].$notify.error(deletePatientsGalleryResponse.notice);else vue_esm["default"].$notify.success(deletePatientsGalleryResponse.notice);
  state.deletePatientsGalleryResponse = deletePatientsGalleryResponse;
}), patientsgallery__mutations);

/* harmony default export */ var modules_patientsgallery = ({
  state: patientsgallery_state,
  getters: patientsgallery_getters,
  actions: patientsgallery_actions,
  mutations: patientsgallery_mutations
});
// CONCATENATED MODULE: ./src/store/modules/ordinations.js


var ordinations__mutations;




// initial state
var ordinations_state = {
  ordinations: { root: [], totalCount: 0 },
  saveOrdinationResponse: false,
  deleteOrdinationResponse: false

  // getters
};var ordinations_getters = {
  ordinations: function ordinations(state) {
    return state.ordinations;
  },
  saveOrdinationResponse: function saveOrdinationResponse(state) {
    return state.saveOrdinationResponse;
  },
  deleteOrdinationResponse: function deleteOrdinationResponse(state) {
    return state.deleteOrdinationResponse;
  }

  // actions
};var ordinations_actions = {
  getOrdinations: function getOrdinations(context, data) {
    ordinations.getOrdinations(data, function (ordinations) {
      context.commit('RECEIVE_ORDINATION', { ordinations: ordinations });
    });
  },
  saveOrdination: function saveOrdination(context, data) {
    ordinations.saveOrdination(data, function (saveOrdinationResponse) {
      context.commit('SAVE_RESPONSE', { saveOrdinationResponse: saveOrdinationResponse });
    });
  },
  deleteOrdination: function deleteOrdination(context, data) {
    ordinations.deleteOrdination(data, function (deleteOrdinationResponse) {
      context.commit('DELETE_RESPONSE', { deleteOrdinationResponse: deleteOrdinationResponse });
    });
  }

  // mutations
};var ordinations_mutations = (ordinations__mutations = {}, defineProperty_default()(ordinations__mutations, 'RECEIVE_ORDINATION', function RECEIVE_ORDINATION(state, _ref) {
  var ordinations = _ref.ordinations;

  ordinations.totalCount = parseInt(ordinations.totalCount);
  state.ordinations = ordinations;
}), defineProperty_default()(ordinations__mutations, 'SAVE_RESPONSE', function SAVE_RESPONSE(state, _ref2) {
  var saveOrdinationResponse = _ref2.saveOrdinationResponse;

  state.saveOrdinationResponse = saveOrdinationResponse;
}), defineProperty_default()(ordinations__mutations, 'DELETE_RESPONSE', function DELETE_RESPONSE(state, _ref3) {
  var deleteOrdinationResponse = _ref3.deleteOrdinationResponse;

  if (deleteOrdinationResponse.error == true) vue_esm["default"].$notify.error(deleteOrdinationResponse.notice);else vue_esm["default"].$notify.success(deleteOrdinationResponse.notice);
  state.deleteOrdinationResponse = deleteOrdinationResponse;
}), ordinations__mutations);

/* harmony default export */ var modules_ordinations = ({
  state: ordinations_state,
  getters: ordinations_getters,
  actions: ordinations_actions,
  mutations: ordinations_mutations
});
// CONCATENATED MODULE: ./src/api/tehnicallabs.js


/* harmony default export */ var tehnicallabs = ({
  getTehnicalLabs: function getTehnicalLabs(params, cb) {
    params.type = 'technicallab';
    AxApi.get('/rest/User_companies/selectRow', {
      params: params
    }).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  },
  saveTehnicalLab: function saveTehnicalLab(params, cb) {
    params.type = 'technicallab';
    if (typeof params.id != 'undefined' && params.id != '') {
      AxApi.post('/rest/User_companies/updateRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    } else {
      AxApi.post('/rest/User_companies/insertRow', params).then(function (response) {
        cb(response.data);
      }).catch(function (e) {
        //TODO
      });
    }
  },
  deleteTehnicalLab: function deleteTehnicalLab(params, cb) {
    AxApi.post('/rest/User_companies/deleteRow', params).then(function (response) {
      cb(response.data);
    }).catch(function (e) {
      //TODO
    });
  }
});
// CONCATENATED MODULE: ./src/store/modules/tehnicallabs.js


var tehnicallabs__mutations;




// initial state
var tehnicallabs_state = {
  tehnicallabs: { root: [], totalCount: 0 },
  saveTehnicalLabResponse: false,
  deleteTehnicalLabResponse: false

  // getters
};var tehnicallabs_getters = {
  tehnicallabs: function tehnicallabs(state) {
    return state.tehnicallabs;
  },
  saveTehnicalLabResponse: function saveTehnicalLabResponse(state) {
    return state.saveTehnicalLabResponse;
  },
  deleteTehnicalLabResponse: function deleteTehnicalLabResponse(state) {
    return state.deleteTehnicalLabResponse;
  }

  // actions
};var tehnicallabs_actions = {
  getTehnicalLabs: function getTehnicalLabs(context, data) {
    tehnicallabs.getTehnicalLabs(data, function (tehnicallabs) {
      context.commit('RECEIVE_LAB', { tehnicallabs: tehnicallabs });
    });
  },
  saveTehnicalLab: function saveTehnicalLab(context, data) {
    tehnicallabs.saveTehnicalLab(data, function (saveTehnicalLabResponse) {
      context.commit('SAVE_RESPONSE', { saveTehnicalLabResponse: saveTehnicalLabResponse });
    });
  },
  deleteTehnicalLab: function deleteTehnicalLab(context, data) {
    tehnicallabs.deleteTehnicalLab(data, function (deleteTehnicalLabResponse) {
      context.commit('DELETE_RESPONSE', { deleteTehnicalLabResponse: deleteTehnicalLabResponse });
    });
  }

  // mutations
};var tehnicallabs_mutations = (tehnicallabs__mutations = {}, defineProperty_default()(tehnicallabs__mutations, 'RECEIVE_LAB', function RECEIVE_LAB(state, _ref) {
  var tehnicallabs = _ref.tehnicallabs;

  tehnicallabs.totalCount = parseInt(tehnicallabs.totalCount);
  state.tehnicallabs = tehnicallabs;
}), defineProperty_default()(tehnicallabs__mutations, 'SAVE_RESPONSE', function SAVE_RESPONSE(state, _ref2) {
  var saveTehnicalLabResponse = _ref2.saveTehnicalLabResponse;

  state.saveTehnicalLabResponse = saveTehnicalLabResponse;
}), defineProperty_default()(tehnicallabs__mutations, 'DELETE_RESPONSE', function DELETE_RESPONSE(state, _ref3) {
  var deleteTehnicalLabResponse = _ref3.deleteTehnicalLabResponse;

  if (deleteTehnicalLabResponse.error == true) vue_esm["default"].$notify.error(deleteTehnicalLabResponse.notice);else vue_esm["default"].$notify.success(deleteTehnicalLabResponse.notice);
  state.deleteTehnicalLabResponse = deleteTehnicalLabResponse;
}), tehnicallabs__mutations);

/* harmony default export */ var modules_tehnicallabs = ({
  state: tehnicallabs_state,
  getters: tehnicallabs_getters,
  actions: tehnicallabs_actions,
  mutations: tehnicallabs_mutations
});
// CONCATENATED MODULE: ./src/store/modules/workorders.js


var workorders__mutations;




// initial state
var workorders_state = {
  workorders: { root: [], totalCount: 0 },
  saveWorkOrderResponse: false,
  deleteWorkOrderResponse: false

  // getters
};var workorders_getters = {
  workorders: function workorders(state) {
    return state.workorders;
  },
  saveWorkOrderResponse: function saveWorkOrderResponse(state) {
    return state.saveWorkOrderResponse;
  },
  deleteWorkOrderResponse: function deleteWorkOrderResponse(state) {
    return state.deleteWorkOrderResponse;
  }

  // actions
};var workorders_actions = {
  getWorkOrders: function getWorkOrders(context, data) {
    workorders.getWorkOrders(data, function (workorders) {
      context.commit('RECEIVE_WORK_ORDERS', { workorders: workorders });
    });
  },
  saveWorkOrder: function saveWorkOrder(context, data) {
    workorders.saveWorkOrder(data, function (saveWorkOrderResponse) {
      context.commit('SAVE_WORK_ORDER_RESPONSE', { saveWorkOrderResponse: saveWorkOrderResponse });
    });
  },
  deleteWorkOrder: function deleteWorkOrder(context, data) {
    workorders.deleteWorkOrder(data, function (deleteWorkOrderResponse) {
      context.commit('DELETE_WORK_ORDER_RESPONSE', { deleteWorkOrderResponse: deleteWorkOrderResponse });
    });
  }

  // mutations
};var workorders_mutations = (workorders__mutations = {}, defineProperty_default()(workorders__mutations, 'RECEIVE_WORK_ORDERS', function RECEIVE_WORK_ORDERS(state, _ref) {
  var workorders = _ref.workorders;

  workorders.totalCount = parseInt(workorders.totalCount);
  state.workorders = workorders;
}), defineProperty_default()(workorders__mutations, 'SAVE_WORK_ORDER_RESPONSE', function SAVE_WORK_ORDER_RESPONSE(state, _ref2) {
  var saveWorkOrderResponse = _ref2.saveWorkOrderResponse;

  state.saveWorkOrderResponse = saveWorkOrderResponse;
}), defineProperty_default()(workorders__mutations, 'DELETE_WORK_ORDER_RESPONSE', function DELETE_WORK_ORDER_RESPONSE(state, _ref3) {
  var deleteWorkOrderResponse = _ref3.deleteWorkOrderResponse;

  if (deleteWorkOrderResponse.error == true) vue_esm["default"].$notify.error(deleteWorkOrderResponse.notice);else vue_esm["default"].$notify.success(deleteWorkOrderResponse.notice);
  state.deleteWorkOrderResponse = deleteWorkOrderResponse;
}), workorders__mutations);

/* harmony default export */ var modules_workorders = ({
  state: workorders_state,
  getters: workorders_getters,
  actions: workorders_actions,
  mutations: workorders_mutations
});
// CONCATENATED MODULE: ./src/store/modules/users.js




// initial state
var users_state = {
  users: { root: [], totalCount: 0 }

  // getters
};var users_getters = {
  users: function users(state) {
    return state.users;
  }

  // actions
};var users_actions = {
  getUsersByCompanyId: function getUsersByCompanyId(context, data) {
    users.getUsersByCompanyId(data, function (users) {
      context.commit('RECEIVE_USERS', { users: users });
    });
  }

  // mutations
};var users_mutations = defineProperty_default()({}, 'RECEIVE_USERS', function RECEIVE_USERS(state, _ref) {
  var users = _ref.users;

  users.totalCount = parseInt(users.totalCount);
  state.users = users;
});

/* harmony default export */ var modules_users = ({
  state: users_state,
  getters: users_getters,
  actions: users_actions,
  mutations: users_mutations
});
// CONCATENATED MODULE: ./src/api/dentalsolutioncompanies.js


/* harmony default export */ var dentalsolutioncompanies = ({
    getDentalSolutionCompanies: function getDentalSolutionCompanies(params, cb) {
        params.type = 'dentalsolutions';
        AxApi.get('/rest/User_companies/selectRow', {
            params: params
        }).then(function (response) {
            cb(response.data);
        }).catch(function (e) {
            //TODO
        });
    }
});
// CONCATENATED MODULE: ./src/store/modules/dentalsolutioncompanies.js


// initial state
var dentalsolutioncompanies_state = {
    dentalSolutionCompanies: {
        root: [],
        totalCount: 0
    },
    saveOrdinationResponse: false,
    deleteOrdinationResponse: false

    // getters
};var dentalsolutioncompanies_getters = {
    dentalSolutionCompanies: function dentalSolutionCompanies(state) {
        return state.dentalSolutionCompanies;
    }

    // actions
};var dentalsolutioncompanies_actions = {
    getDentalSolutionCompanies: function getDentalSolutionCompanies(context, data) {
        dentalsolutioncompanies.getDentalSolutionCompanies(data, function (companies) {
            context.commit('receiveCompanies', companies);
        });
    }

    // mutations
};var dentalsolutioncompanies_mutations = {
    receiveCompanies: function receiveCompanies(state, companies) {
        companies.totalCount = parseInt(companies.totalCount);
        state.dentalSolutionCompanies = companies;
    }
};

/* harmony default export */ var modules_dentalsolutioncompanies = ({
    state: dentalsolutioncompanies_state,
    getters: dentalsolutioncompanies_getters,
    actions: dentalsolutioncompanies_actions,
    mutations: dentalsolutioncompanies_mutations
});
// CONCATENATED MODULE: ./src/store/index.js











vue_esm["default"].use(vuex_esm["a" /* default */]);

// the root, initial state object
var store = new vuex_esm["a" /* default */].Store({
    modules: {
        globals: modules_globals,
        patients: modules_patients,
        patientsgallery: modules_patientsgallery,
        ordinations: modules_ordinations,
        tehnicallabs: modules_tehnicallabs,
        workorders: modules_workorders,
        users: modules_users,
        dentalsolutioncompanies: modules_dentalsolutioncompanies
    }
});

// create the Vuex instance by combining the state and mutations objects
// then export the Vuex store for use by our components
/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 116 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__("Jmt5");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// EXTERNAL MODULE: ./src/assets/css/style.less
var style = __webpack_require__("PijW");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/index.js + 786 modules
var icons = __webpack_require__("D/PP");

// EXTERNAL MODULE: ./node_modules/vue-awesome/components/Icon.vue + 2 modules
var Icon = __webpack_require__("D4uH");

// EXTERNAL MODULE: ./node_modules/vue2-notify/dist/build.js
var build = __webpack_require__("1kLA");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/Autocomplete.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Autocomplete = ({
  name: 'Autocomplete',
  props: ['setvalue', 'value', 'placeholder', 'values', 'initdata'],
  data: function data() {
    return { initialText: '', timer: false, nochange: false, optionValues: [], optionset: false };
  },
  created: function created() {
    var me = this;
  },
  watch: {
    value: function value(val) {
      var me = this;
      if (val != '' && me.nochange == false) me.initdata({ query: val, initialId: me.value, start: 0, limit: 20 });
    },
    initialText: function initialText(val) {
      var me = this;

      if (me.timer != false) {
        clearTimeout(me.timer);
        me.timer = false;
      }
      if (me.nochange == false) {
        me.timer = setTimeout(function () {
          me.optionValues = [];
          me.initdata({ query: val, initialId: me.value, start: 0, limit: 20 });
        }, 300);
      }
      me.nochange = false;
    },
    values: function values(val) {
      var me = this;

      if (me.optionset == false && me.value != '') {
        for (var i = 0; i < val.length; i++) {
          if (val[i].value == me.value) {
            me.setValue(val[i]);
          }
        }
        me.optionset = true;
      } else {
        me.optionValues = [];
        for (var i = 0; i < val.length; i++) {
          me.optionValues.push(val[i]);
        }
      }
    }
  },
  methods: {
    hideSelector: function hideSelector() {
      var me = this;
      console.log('click outside');
      me.optionValues = [];
    },
    setValue: function setValue(value) {
      var me = this;
      me.setvalue(value.value);
      me.initialText = value.text;
      me.optionValues = [];
      me.nochange = true;
    },

    openselector: function openselector() {
      var me = this;
      me.optionValues = [];
      me.initdata({ initialId: me.value, start: 0, limit: 20 });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c6186c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/Autocomplete.vue
var Autocomplete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideSelector),expression:"hideSelector"}],staticClass:"autocomplete"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.initialText),expression:"initialText"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.initialText)},on:{"click":_vm.openselector,"input":function($event){if($event.target.composing){ return; }_vm.initialText=$event.target.value}}}),_vm._v(" "),(_vm.optionValues.length > 0)?_c('div',{staticClass:"list-container"},[_c('ul',_vm._l((_vm.optionValues),function(value){return _c('li',{on:{"click":function($event){_vm.setValue(value)}}},[_vm._v(_vm._s(value.text))])}))]):_vm._e()])}
var Autocomplete_staticRenderFns = []
var Autocomplete_esExports = { render: Autocomplete_render, staticRenderFns: Autocomplete_staticRenderFns }
/* harmony default export */ var lib_Autocomplete = (Autocomplete_esExports);
// CONCATENATED MODULE: ./src/components/lib/Autocomplete.vue
var Autocomplete_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Autocomplete___vue_template_functional__ = false
/* styles */
var Autocomplete___vue_styles__ = null
/* scopeId */
var Autocomplete___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Autocomplete___vue_module_identifier__ = null
var Autocomplete_Component = Autocomplete_normalizeComponent(
  Autocomplete,
  lib_Autocomplete,
  Autocomplete___vue_template_functional__,
  Autocomplete___vue_styles__,
  Autocomplete___vue_scopeId__,
  Autocomplete___vue_module_identifier__
)

/* harmony default export */ var components_lib_Autocomplete = (Autocomplete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/Autocompletesimple.vue

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Autocompletesimple = ({
  name: 'Autocompletesimple',
  props: ['valuekey', 'text', 'placeholder', 'data', 'value'],
  data: function data() {
    return { optionValues: [], initialText: '', nochange: false, enabled: false };
  },
  created: function created() {
    var me = this;
    me.$emit('query', { query: '', initialId: me.value, start: 0, limit: 20 });
  },
  watch: {
    initialText: function initialText(val) {
      var me = this;
      if (!me.nochange) me.$emit('query', { query: val, start: 0, limit: 20 });
      me.nochange = false;
    },
    data: function data() {
      var me = this;
      me.optionValues = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(me.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var val = _step.value;

          var text = '';
          if (typeof me.text != 'string') {
            var tmp = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(me.text), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                tmp.push(val[key]);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            text = tmp.join(' ', tmp);
          } else {
            text = val[me.text];
          }

          if (me.value == val[me.valuekey]) {
            me.nochange = true;
            me.initialText = text;
          }

          me.optionValues.push({ value: val[me.valuekey], text: text });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  methods: {
    setValue: function setValue(val) {
      var me = this;
      me.$emit('input', val.value);
      me.nochange = true;
      me.initialText = val.text;
      me.optionValues = [];
    },
    hideSelector: function hideSelector() {
      var me = this;
      me.optionValues = [];
    },
    enable: function enable() {
      this.enabled = true;
    },
    disable: function disable() {
      this.enabled = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9cc1a54","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/Autocompletesimple.vue
var Autocompletesimple_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.disable),expression:"disable"}],staticClass:"autocomplete"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.initialText),expression:"initialText"}],staticClass:"form-control secondary",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.initialText)},on:{"click":_vm.enable,"input":function($event){if($event.target.composing){ return; }_vm.initialText=$event.target.value}}}),_vm._v(" "),(_vm.optionValues.length > 0 && _vm.enabled)?_c('div',{staticClass:"list-container"},[_c('ul',_vm._l((_vm.optionValues),function(value){return _c('li',{on:{"click":function($event){_vm.setValue(value)}}},[_vm._v(_vm._s(value.text))])}))]):_vm._e()])}
var Autocompletesimple_staticRenderFns = []
var Autocompletesimple_esExports = { render: Autocompletesimple_render, staticRenderFns: Autocompletesimple_staticRenderFns }
/* harmony default export */ var lib_Autocompletesimple = (Autocompletesimple_esExports);
// CONCATENATED MODULE: ./src/components/lib/Autocompletesimple.vue
var Autocompletesimple_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Autocompletesimple___vue_template_functional__ = false
/* styles */
var Autocompletesimple___vue_styles__ = null
/* scopeId */
var Autocompletesimple___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Autocompletesimple___vue_module_identifier__ = null
var Autocompletesimple_Component = Autocompletesimple_normalizeComponent(
  Autocompletesimple,
  lib_Autocompletesimple,
  Autocompletesimple___vue_template_functional__,
  Autocompletesimple___vue_styles__,
  Autocompletesimple___vue_scopeId__,
  Autocompletesimple___vue_module_identifier__
)

/* harmony default export */ var components_lib_Autocompletesimple = (Autocompletesimple_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/Switch.vue
//
//
//
//
//
//
//
//


/* harmony default export */ var Switch = ({
  name: 'Switch',
  props: ['checked', 'id'],
  methods: {
    click: function click() {
      var me = this;
      me.$emit('change', !me.checked, me.id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24826a9f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/Switch.vue
var Switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-switch",on:{"click":function($event){$event.preventDefault();_vm.click($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox","id":_vm._uid},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_c('label',{attrs:{"for":_vm._uid}},[_vm._v("Toggle")]),_vm._v(" "),_c('span',{staticClass:"no"},[_vm._v("Ne")]),_vm._v(" "),_c('span',{staticClass:"yes"},[_vm._v("Da")])])}
var Switch_staticRenderFns = []
var Switch_esExports = { render: Switch_render, staticRenderFns: Switch_staticRenderFns }
/* harmony default export */ var lib_Switch = (Switch_esExports);
// CONCATENATED MODULE: ./src/components/lib/Switch.vue
var Switch_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Switch___vue_template_functional__ = false
/* styles */
var Switch___vue_styles__ = null
/* scopeId */
var Switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Switch___vue_module_identifier__ = null
var Switch_Component = Switch_normalizeComponent(
  Switch,
  lib_Switch,
  Switch___vue_template_functional__,
  Switch___vue_styles__,
  Switch___vue_scopeId__,
  Switch___vue_module_identifier__
)

/* harmony default export */ var components_lib_Switch = (Switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/InputValidation.vue
//
//
//
//
//
//
//
//


/* harmony default export */ var InputValidation = ({
  name: 'InputValidation',
  props: ['formerror', 'name', 'label']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b4f7f9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/InputValidation.vue
var InputValidation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:(_vm.formerror.notice && _vm.formerror.notice[_vm.name]) ? 'has-danger' :''},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.formerror.notice && _vm.formerror.notice[_vm.name])?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.formerror.notice[_vm.name]))]):_vm._e()],2)}
var InputValidation_staticRenderFns = []
var InputValidation_esExports = { render: InputValidation_render, staticRenderFns: InputValidation_staticRenderFns }
/* harmony default export */ var lib_InputValidation = (InputValidation_esExports);
// CONCATENATED MODULE: ./src/components/lib/InputValidation.vue
var InputValidation_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var InputValidation___vue_template_functional__ = false
/* styles */
var InputValidation___vue_styles__ = null
/* scopeId */
var InputValidation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var InputValidation___vue_module_identifier__ = null
var InputValidation_Component = InputValidation_normalizeComponent(
  InputValidation,
  lib_InputValidation,
  InputValidation___vue_template_functional__,
  InputValidation___vue_styles__,
  InputValidation___vue_scopeId__,
  InputValidation___vue_module_identifier__
)

/* harmony default export */ var components_lib_InputValidation = (InputValidation_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var dist_build = __webpack_require__("XILU");
var dist_build_default = /*#__PURE__*/__webpack_require__.n(dist_build);

// EXTERNAL MODULE: ./node_modules/vue2-timepicker/index.js
var vue2_timepicker = __webpack_require__("SVjV");
var vue2_timepicker_default = /*#__PURE__*/__webpack_require__.n(vue2_timepicker);

// EXTERNAL MODULE: ./node_modules/vue-click-outside/index.js
var vue_click_outside = __webpack_require__("dDoS");
var vue_click_outside_default = /*#__PURE__*/__webpack_require__.n(vue_click_outside);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





















vue_esm["default"].use(build_default.a, {
    position: 'top-right'
});
vue_esm["default"].use(es["a" /* default */]);
vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

vue_esm["default"].component('icon', Icon["a" /* default */]);
vue_esm["default"].component('autocomplete', components_lib_Autocomplete);
vue_esm["default"].component('autocompletesimple', components_lib_Autocompletesimple);
vue_esm["default"].component('inputvalidation', components_lib_InputValidation);
vue_esm["default"].component('input-switch', components_lib_Switch);
vue_esm["default"].component('datepicker', dist_build_default.a);
vue_esm["default"].component('timepicker', vue2_timepicker_default.a);

vue_esm["default"].config.productionTip = false;

var i18n = new vue_i18n_esm["a" /* default */]({});

vue_esm["default"].directive('click-outside', vue_click_outside_default.a);

vue_esm["default"].directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function inserted(el) {
        // Focus the element
        el.focus();
    }
});

vue_esm["default"].mixin({
    methods: {
        back: function back() {
            window.history.back();
        },
        formatDate: function formatDate(date) {
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY. HH:mm';

            if (date == null) return '';
            return moment_default()(date).format(format);
        },
        startChatByUserId: function startChatByUserId(userId, workOrderId) {
            var me = this;
            this.$store.commit('setChatData', {
                chatUserId: userId,
                workOrderId: workOrderId
            });
        },
        startChatByUserIdDental: function startChatByUserIdDental(userId, dentalSolutionId) {
            var me = this;
            this.$store.commit('setChatData', {
                chatUserId: userId,
                dentalSolutionId: dentalSolutionId
            });
        }
    }
});

/* eslint-disable no-new */
new vue_esm["default"]({
    el: '#app',
    store: src_store,
    router: router,
    i18n: i18n,
    template: '<App/>',
    components: {
        App: src_App
    }
});

/***/ }),

/***/ "NNP2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Oogi":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".b-form-file.custom-file .custom-file-input.focus~.custom-file-control,.b-form-file.custom-file .custom-file-input:focus~.custom-file-control{color:#495057;background-color:#fff;border-color:#80bdff;-webkit-box-shadow:0 0 0 .2rem rgba(0,123,255,.25);box-shadow:0 0 0 .2rem rgba(0,123,255,.25);outline:none}.b-form-file.custom-file .custom-file-input.is-invalid.focus~.custom-file-control,.b-form-file.custom-file .custom-file-input.is-invalid:focus~.custom-file-control,.was-validated .b-form-file.custom-file .custom-file-input:invalid.focus~.custom-file-control,.was-validated .b-form-file.custom-file .custom-file-input:invalid:focus~.custom-file-control{-webkit-box-shadow:0 0 0 .2rem rgba(220,53,69,.25);box-shadow:0 0 0 .2rem rgba(220,53,69,.25);border-color:#dc3545}.b-form-file.custom-file .custom-file-input.is-valid.focus~.custom-file-control,.b-form-file.custom-file .custom-file-input.is-valid:focus~.custom-file-control,.was-validated .b-form-file.custom-file .custom-file-input:valid.focus~.custom-file-control,.was-validated .b-form-file.custom-file .custom-file-input:valid:focus~.custom-file-control{-webkit-box-shadow:0 0 0 .2rem rgba(40,167,69,.25);box-shadow:0 0 0 .2rem rgba(40,167,69,.25);border-color:#28a745}.form-control-file.is-invalid~.invalid-feedback,.form-control-file.is-valid~.valid-feedback,.was-validated .form-control-file:invalid~.invalid-feedback,.was-validated .form-control-file:valid~.valid-feedback{display:block}.b-form-file.custom-file .custom-file-control{overflow:hidden}.b-form-file.custom-file .custom-file-control.dragging{overflow:hidden;-webkit-filter:blur(3px);filter:blur(3px)}.b-form-file.custom-file .custom-file-control[data-selected]:after{content:attr(data-selected)}.b-form-file.custom-file .custom-file-control[data-choose]:before{content:attr(data-choose)}.b-form-file.custom-file .drop-here{position:absolute;left:0;right:0;top:0;bottom:0;background-color:rgba(0,0,0,.5);border-radius:3px;z-index:99999;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.b-form-file.custom-file .drop-here:before{color:#fff;content:attr(data-drop)}", ""]);

// exports


/***/ }),

/***/ "OzIM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".modal-dialog-centered{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:calc(100% - 30px)}.modal-dialog-centered .modal-content{width:100%}", ""]);

// exports


/***/ }),

/***/ "PijW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PobS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE4IDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0IwQjVDMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cGF0aCBkPSJNMTIgMmgyYTIgMiAwIDAgMSAyIDJ2MTRhMiAyIDAgMCAxLTIgMkgyYTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDIiLz4NCiAgICAgICAgPHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iNCIgeD0iNCIgcng9IjEiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "Pt3z":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE4IDE0Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMTcgN0gxTTcgMTNMMSA3bDYtNiIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "QUmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/pagination/pagination.vue
//
//
//
//
//
//
//
//
//
//
//





var props = {
  perPage: {
    type: Number,
    default: 20
  },
  totalRows: {
    type: Number,
    default: 20
  },
  ariaControls: {
    type: String,
    default: null
  }

  // Our render function is brought in from the pagination mixin
};/* harmony default export */ var pagination = ({
  mixins: [mixins["k" /* paginationMixin */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  },
  methods: {
    // These methods are used by the render function
    onClick: function onClick(num, evt) {
      var _this = this;

      // Handle edge cases where number of pages has changed (i.e. if perPage changes)
      if (num > this.numberOfPages) {
        num = this.numberOfPages;
      } else if (num < 1) {
        num = 1;
      }
      this.currentPage = num;
      this.$nextTick(function () {
        // Keep the current button focused if possible
        var target = evt.target;
        if (Object(dom["m" /* isVisible */])(target) && _this.$el.contains(target) && target.focus) {
          target.focus();
        } else {
          _this.focusCurrent();
        }
      });
      this.$emit('change', this.currentPage);
    },
    makePage: function makePage(pagenum) {
      return pagenum;
    },
    linkProps: function linkProps(pagenum) {
      return { href: '#' };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/pagination/pagination.vue
function injectStyle (ssrContext) {
  __webpack_require__("WJuF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pagination,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pagination_pagination = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qc8t":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Y5lL");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("743429d6", content, true);

/***/ }),

/***/ "SsFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-row.js
var form_row = __webpack_require__("I7Xz");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-text.js
var form_text = __webpack_require__("tDPY");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-invalid-feedback.js
var form_invalid_feedback = __webpack_require__("q32r");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-valid-feedback.js
var form_valid_feedback = __webpack_require__("x7Qz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-group/form-group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var form_group = ({
    mixins: [mixins["i" /* idMixin */], mixins["h" /* formStateMixin */]],
    components: { bFormRow: form_row["a" /* default */], bFormText: form_text["a" /* default */], bFormInvalidFeedback: form_invalid_feedback["a" /* default */], bFormValidFeedback: form_valid_feedback["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Label
        var legend = h(false);
        if (t.label || $slots.label || t.horizontal) {
            legend = h('legend', { class: t.labelClasses, attrs: { id: t.labelId } }, [$slots.label || h('span', { domProps: { innerHTML: t.label || '' } })]);
        }

        // Invalid feeback text
        var invalidFeedback = h(false);
        if (t.feedback || $slots['invalid-feedback'] || $slots['feedback']) {
            invalidFeedback = h('b-form-invalid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback']),
                    expression: "Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback'])"
                }],
                attrs: {
                    id: t.feedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === false ? $slots['invalid-feedback'] || $slots['feedback'] || h('span', { domProps: { innerHTML: t.feedback || '' } }) : h(false)]);
        }

        // Valid feeback text
        var validFeedback = h(false);
        if (t.validFeedback || $slots['valid-feedback']) {
            validFeedback = h('b-form-valid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.validFeedback || $slots['valid-feedback']),
                    expression: "Boolean(t.validFeedback || $slots['valid-feedback'])"
                }],
                attrs: {
                    id: t.validFeedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === true ? $slots['valid-feedback'] || h('span', { domProps: { innerHTML: t.validFeedback || '' } }) : h(false)]);
        }

        // Form help text (description)
        var description = h(false);
        if (t.description || $slots['description']) {
            description = h('b-form-text', { attrs: { id: t.descriptionId } }, [$slots['description'] || h('span', { domProps: { innerHTML: t.description || '' } })]);
        }

        // Build layout
        var content = h('div', { ref: 'content', class: t.inputLayoutClasses }, [$slots.default, invalidFeedback, validFeedback, description]);

        // Generate fieldset wrapper
        return h('fieldset', {
            class: t.groupClasses,
            attrs: { id: t.safeId(), 'aria-describedby': t.describedByIds }
        }, [h('b-form-row', {}, [legend, content])]);
    },

    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        labelCols: {
            type: Number,
            default: 3,
            validator: function validator(value) {
                if (value >= 1 && value <= 11) {
                    return true;
                }
                Object(utils["n" /* warn */])('b-form-group: label-cols must be a value between 1 and 11');
                return false;
            }
        },
        breakpoint: {
            type: String,
            default: 'sm'
        },
        labelTextAlign: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        labelSrOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        validFeedback: {
            type: String,
            default: null
        },
        validated: {
            type: Boolean,
            value: false
        }
    },
    computed: {
        inputState: function inputState() {
            return this.stateClass;
        },
        groupClasses: function groupClasses() {
            return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.inputState];
        },
        labelClasses: function labelClasses() {
            return [this.labelSrOnly ? 'sr-only' : 'col-form-legend', this.labelLayout, this.labelAlignClass];
        },
        labelLayout: function labelLayout() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : 'col-12';
        },
        labelAlignClass: function labelAlignClass() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.labelTextAlign ? 'text-' + this.labelTextAlign : null;
        },
        inputLayoutClasses: function inputLayoutClasses() {
            return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - this.labelCols) : 'col-12'];
        },
        labelId: function labelId() {
            return this.label || this.$slots['label'] ? this.safeId('_BV_label_') : null;
        },
        descriptionId: function descriptionId() {
            if (this.description || this.$slots['description']) {
                return this.safeId('_BV_description_');
            }
            return null;
        },
        feedbackId: function feedbackId() {
            if (this.feedback || this.$slots['invalid-feedback'] || this.$slots['feedback']) {
                return this.safeId('_BV_feedback_invalid_');
            }
            return null;
        },
        validFeedbackId: function validFeedbackId() {
            if (this.validFeedback || this.$slots['valid-feedback']) {
                return this.safeId('_BV_feedback_valid_');
            }
            return null;
        },
        describedByIds: function describedByIds() {
            return [this.labelId, this.descriptionId, this.computedState === false ? this.feedbackId : null, this.computedState === true ? this.validFeedbackId : null].filter(function (i) {
                return i;
            }).join(' ') || null;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-group/form-group.vue
function injectStyle (ssrContext) {
  __webpack_require__("mITa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_group,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_group_form_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1Gp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIwIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMSAxNnYzYTIgMiAwIDAgMCAyIDJoMTRhMiAyIDAgMCAwIDItMnYtM002IDExbDQgNCA0LTRNMTAgMXYxNCIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "TB/a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/teeth.dd8fc55.svg";

/***/ }),

/***/ "UD2X":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NiIgaGVpZ2h0PSI4MSIgdmlld0JveD0iMCAwIDY2IDgxIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0IwQjVDMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjYiPg0KICAgICAgICA8cGF0aCBkPSJNNDAuNSAzaC0zMEE3LjUgNy41IDAgMCAwIDMgMTAuNXY2MGE3LjUgNy41IDAgMCAwIDcuNSA3LjVoNDVhNy41IDcuNSAwIDAgMCA3LjUtNy41di00NUw0MC41IDN6Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik00MC41IDN2MjIuNUg2M00zMyA2M1Y0MC41TTIxLjc1IDUxLjc1aDIyLjUiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "UyeT":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE4IDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cGF0aCBkPSJNMTIgMmgyYTIgMiAwIDAgMSAyIDJ2MTRhMiAyIDAgMCAxLTIgMkgyYTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDIiLz4NCiAgICAgICAgPHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iNCIgeD0iNCIgcng9IjEiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "V0G1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "WJuF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("FHvo");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9f367c5a", content, true);

/***/ }),

/***/ "X4qH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3o1N");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("43c76c49", content, true);

/***/ }),

/***/ "XRQe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDM0IDE4Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMSA5aDMyTTEgMWgzMk0xIDE3aDMyIi8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "Y5lL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, "input.form-control[type=color],input.form-control[type=range]{height:2.25rem}input.form-control.form-control-sm[type=color],input.form-control.form-control-sm[type=range]{height:1.9375rem}input.form-control.form-control-lg[type=color],input.form-control.form-control-lg[type=range]{height:3rem}input.form-control[type=color]{padding:.25rem}input.form-control.form-control-sm[type=color]{padding:.125rem}", ""]);

// exports


/***/ }),

/***/ "afNG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4NCiAgICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0yMSAxNkgxYTMgMyAwIDAgMCAzLTNWOGE3IDcgMCAwIDEgMTQgMHY1YTMgMyAwIDAgMCAzIDN6bS04LjI3IDRhMiAyIDAgMCAxLTMuNDYgMGgzLjQ2eiIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ "b6QW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8Zz4NCiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05NDUgLTE1OSkgdHJhbnNsYXRlKDk0NSAxNTkpIj4NCiAgICAgICAgICAgICAgICA8Y2lyY2xlIGN4PSIyNCIgY3k9IjI0IiByPSIyNCIgZmlsbD0iIzMzMzMzRCIgb3BhY2l0eT0iLjgiLz4NCiAgICAgICAgICAgICAgICA8ZyBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTIwIDFMMjAgNyAxNCA3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNCAxNSkiLz4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTE3LjQ5IDEyYy0xLjMzNSAzLjc4LTUuMDEgNi4yMi05LjAxMiA1Ljk4N0M0LjQ3NyAxNy43NTIgMS4xMTIgMTQuOS4yMjYgMTAuOTljLS44ODUtMy45MS45MjItNy45MzQgNC40MzItOS44N0M4LjE2OC0uODE0IDEyLjUzNi0uMTk1IDE1LjM3IDIuNjRMMjAgNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQgMTUpIi8+DQogICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "cCjy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIwIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0Y3NDU0NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNOCAyMUgzYTIgMiAwIDAgMS0yLTJWM2EyIDIgMCAwIDEgMi0yaDVNMTUgMTVsNC00LTQtNE0xOSAxMUg3Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "d5YL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0IwQjVDMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xOSAxM2EyIDIgMCAwIDEtMiAySDVsLTQgNFYzYTIgMiAwIDAgMSAyLTJoMTRhMiAyIDAgMCAxIDIgMnYxMHoiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "dKw+":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("z6Gc");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("dd36953e", content, true);

/***/ }),

/***/ "eNdh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIwIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzBBQTFFNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMSAxNnYzYTIgMiAwIDAgMCAyIDJoMTRhMiAyIDAgMCAwIDItMnYtM002IDExbDQgNCA0LTRNMTAgMXYxNCIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "eX+1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4NCiAgICA8cGF0aCBmaWxsPSIjMEFBMUU2IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCA5LjMzM2MwIC44Ni0uNjk2IDEuNTU2LTEuNTU2IDEuNTU2SDMuMTExTDAgMTRWMS41NTZDMCAuNjk2LjY5NiAwIDEuNTU2IDBoMTAuODg4QzEzLjMwNCAwIDE0IC42OTYgMTQgMS41NTZ2Ny43Nzd6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "g1nH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("k9oS");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0ec2af4b", content, true);

/***/ }),

/***/ "gCMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ "gnEX":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzBBQTFFNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIvPg0KICAgICAgICA8cGF0aCBkPSJNMTAgNnY4TTYgMTBoOCIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "j9IK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("CO9d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b098cc6a", content, true);

/***/ }),

/***/ "k9oS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".progress-bar{-webkit-transition:width .6s ease;transition:width .6s ease}", ""]);

// exports


/***/ }),

/***/ "m4mk":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI2ZmZmZmZiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIi8+DQogICAgICAgIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMS41Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik0xOCAxMmwtNS01TDIgMTgiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "mITa":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("B4c4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("311a441d", content, true);

/***/ }),

/***/ "phsg":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI4IDI0Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzBBQTFFNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cGF0aCBkPSJNMjYgMTkuNTU2QzI2IDIwLjkwNiAyNC45NDIgMjIgMjMuNjM2IDIySDIuMzY0QzEuMDU4IDIyIDAgMjAuOTA2IDAgMTkuNTU2VjYuMTFjMC0xLjM1IDEuMDU4LTIuNDQ0IDIuMzY0LTIuNDQ0SDcuMDlMOS40NTUgMGg3LjA5bDIuMzY0IDMuNjY3aDQuNzI3QzI0Ljk0MiAzLjY2NyAyNiA0Ljc2IDI2IDYuMTF2MTMuNDQ1eiIvPg0KICAgICAgICA8ZWxsaXBzZSBjeD0iMTMiIGN5PSIxMi4yMjIiIHJ4PSI0LjcyNyIgcnk9IjQuODg5Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "qmq2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIwIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0Y3NDU0NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMSA1aDE4TTE3IDV2MTRhMiAyIDAgMCAxLTIgMkg1YTIgMiAwIDAgMS0yLTJWNW0zIDBWM2EyIDIgMCAwIDEgMi0yaDRhMiAyIDAgMCAxIDIgMnYyIi8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress-bar.js
var progress_bar = __webpack_require__("KpFv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/progress/progress.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var progress = ({
    components: { bProgressBar: progress_bar["a" /* default */] },
    render: function render(h) {
        var t = this;
        var childNodes = t.$slots.default;
        if (!childNodes) {
            childNodes = h('b-progress-bar', {
                props: {
                    value: t.value,
                    max: t.max,
                    precision: t.precision,
                    variant: t.variant,
                    animated: t.animated,
                    striped: t.striped,
                    showProgress: t.showProgress,
                    showValue: t.showValue
                }
            });
        }
        return h('div', { class: ['progress'], style: t.progressHeight }, [childNodes]);
    },

    props: {
        // These props can be inherited via the child b-progress-bar(s)
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: null
        },
        precision: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },
        // This prop is not inherited by child b-progress-bar(s)
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        progressHeight: function progressHeight() {
            return { height: this.height || null };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress.vue
function injectStyle (ssrContext) {
  __webpack_require__("g1nH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  progress,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var progress_progress = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rlmj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MiIgaGVpZ2h0PSI1MiIgdmlld0JveD0iMCAwIDUyIDUyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9Im5vbnplcm8iPg0KICAgICAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNMjguNjA3IDExLjA3OGExMC45NDEgMTAuOTQxIDAgMCAwLTIuNTkzLTEuOTI0cy0uMTkzLS4xMS0uNDk3LS4yNDdjLS42NjItLjMzLTEuOTAzLS44MjUtMy4wMDctLjgyNS0yLjcwMyAwLTMuNzc5IDEuNjIyLTYuNTEgMS42MjJzLTMuODM0LTEuNjIyLTYuNTEtMS42MjJjLTEuMTA0IDAtMi4zNDUuNDk1LTMuMDA3LjgyNS0uMzA0LjEzNy0uNDk3LjI0Ny0uNDk3LjI0N2ExMi40MjYgMTIuNDI2IDAgMCAwLTIuNTkzIDEuOTI0Yy00LjgyNyA0LjgzNy00LjQ0MSAxMy4wNTMuODgzIDE4LjM1N2ExNS41MDIgMTUuNTAyIDAgMCAwIDMuNTU4IDIuNjM4Yy0uMzAzIDQuMzctMS4wMiA4LjQxLTIuMDk2IDExLjg3MmExOC4xIDE4LjEgMCAwIDAgOS4yNDEtMTAuMjVjLjMzMS0uMDI4LjY5LS4wNTUgMS4wMjEtLjExIDQuMDI4LjU1IDguNDQxLS44NTIgMTEuNzI0LTQuMTUgNS4zMjQtNS4zMDQgNS43MzgtMTMuNTIuODgzLTE4LjM1N3oiLz4NCiAgICAgICAgPHBhdGggZmlsbD0iIzhGRENGRiIgZD0iTTIzLjM2NiAzMy41ODVhMTQuNDU1IDE0LjQ1NSAwIDAgMS01LjY1NiAxLjE1NGgtLjMwM2MxLjcxIDQuMDQgNC44ODMgNy4zMzcgOC44NTUgOS4yMzQtLjk2NS0zLjE2LTEuNjU1LTYuODQzLTIuMDE0LTEwLjgtLjMwMy4xMzctLjU3OS4yNzQtLjg4Mi40MTJ6TTQ1ICIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "sE/t":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzBBQTFFNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHJ4PSIyIi8+DQogICAgICAgIDxjaXJjbGUgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMS41Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik0xOCAxMmwtNS01TDIgMTgiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "tKQo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MSIgaGVpZ2h0PSI0NyIgdmlld0JveD0iMCAwIDQxIDQ3Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9Im5vbnplcm8iPg0KICAgICAgICA8cGF0aCBmaWxsPSIjMEFBMUU2IiBkPSJNMzYuNjUzIDMuOTI2YTE0LjA1IDE0LjA1IDAgMCAwLTMuMzI0LTIuNTIxcy0uMjQ4LS4xNDQtLjYzNy0uMzI1QzMxLjg0NC42NDggMzAuMjUyIDAgMjguODM4IDBjLTMuNDY1IDAtNC44NDQgMi4xMjUtOC4zNDUgMi4xMjUtMy41IDAtNC45MTUtMi4xMjUtOC4zNDUtMi4xMjUtMS40MTUgMC0zLjAwNi42NDgtMy44NTUgMS4wOC0uMzg4LjE4LS42MzYuMzI1LS42MzYuMzI1YTE1Ljk1NyAxNS45NTcgMCAwIDAtMy4zMjQgMi41MmMtNi4xODggNi4zNC01LjY5MyAxNy4xMDggMS4xMzIgMjQuMDU5YTE5LjkwNyAxOS45MDcgMCAwIDAgNC41NjEgMy40NTdDOS42MzcgMzcuMTY4IDguNzE4IDQyLjQ2MiA3LjM0IDQ3YzUuNTE2LTIuNzAxIDkuNzk1LTcuNTI3IDExLjg0Ni0xMy40MzQuNDI0LS4wMzYuODg0LS4wNzIgMS4zMDgtLjE0NCA1LjE2My43MiAxMC44Mi0xLjExNiAxNS4wMjgtNS40MzggNi44MjUtNi45NTEgNy4zNTUtMTcuNzIgMS4xMzItMjQuMDU4eiIvPg0KICAgICAgICA8cGF0aCBmaWxsPSIjMkZDQ0EyIiBkPSJNMjkuNDAyIDMzLjUzNGExNy4zMTMgMTcuMzEzIDAgMCAxLTcuMDI1IDEuNDk3SDIyYzIuMTI1IDUuMjM2IDYuMDY1IDkuNTExIDExIDExLjk2OS0xLjItNC4wOTctMi4wNTYtOC44Ny0yLjUwMi0xNC0uMzc3LjE3OC0uNzIuMzU2LTEuMDk2LjUzNHoiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vCtq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzBBQTFFNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMTkgMTMuNjZWMTlhMiAyIDAgMCAxLTIgMkgzYTIgMiAwIDAgMS0yLTJWNWEyIDIgMCAwIDEgMi0yaDUuMzQiLz4NCiAgICAgICAgPHBhdGggZD0iTTE3IDFsNCA0LTEwIDEwSDd2LTR6Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "vI8d":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8cGF0aCBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xOSAxM2EyIDIgMCAwIDEtMiAySDVsLTQgNFYzYTIgMiAwIDAgMSAyLTJoMTRhMiAyIDAgMCAxIDIgMnYxMHoiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "wa5x":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8Zz4NCiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04ODEgLTE1OSkgdHJhbnNsYXRlKDg4MSAxNTkpIj4NCiAgICAgICAgICAgICAgICA8Y2lyY2xlIGN4PSIyNCIgY3k9IjI0IiByPSIyNCIgZmlsbD0iIzMzMzMzRCIgb3BhY2l0eT0iLjgiLz4NCiAgICAgICAgICAgICAgICA8ZyBzdHJva2U9IiNGRkYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAgMUwwIDcgNiA3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNCAxNCkiLz4NCiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTIuNTEgMTJjMS4zMzIgMy43OCA1LjAwNCA2LjIyNSA5LjAwNiA1Ljk5NCA0LjAwMi0uMjMgNy4zNjktMy4wOCA4LjI1OC02Ljk4OC44OS0zLjkwOC0uOTEzLTcuOTM0LTQuNDIxLTkuODczQzExLjg0NS0uODA3IDcuNDc3LS4xOTIgNC42NCAyLjY0TDAgNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQgMTQpIi8+DQogICAgICAgICAgICAgICAgPC9nPg0KICAgICAgICAgICAgPC9nPg0KICAgICAgICA8L2c+DQogICAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "y/Pd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4NCiAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCA5LjMzM2MwIC44Ni0uNjk2IDEuNTU2LTEuNTU2IDEuNTU2SDMuMTExTDAgMTRWMS41NTZDMCAuNjk2LjY5NiAwIDEuNTU2IDBoMTAuODg4QzEzLjMwNCAwIDE0IC42OTYgMTQgMS41NTZ2Ny43Nzd6Ii8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "yA9E":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE4IDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzBBQTFFNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMTEgMUgzYTIgMiAwIDAgMC0yIDJ2MTZhMiAyIDAgMCAwIDIgMmgxMmEyIDIgMCAwIDAgMi0yVjdsLTYtNnoiLz4NCiAgICAgICAgPHBhdGggZD0iTTExIDF2Nmg2TTEzIDEySDVNMTMgMTZINU03IDhINSIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "ykL/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE4IDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0IwQjVDMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPg0KICAgICAgICA8cGF0aCBkPSJNMTEgMUgzYTIgMiAwIDAgMC0yIDJ2MTZhMiAyIDAgMCAwIDIgMmgxMmEyIDIgMCAwIDAgMi0yVjdsLTYtNnoiLz4NCiAgICAgICAgPHBhdGggZD0iTTExIDF2Nmg2TTEzIDEySDVNMTMgMTZINU03IDhINSIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "z4tm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDI0IDIwIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iIzA0Y2Y4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8cGF0aCBkPSJNMTUgMTh2LTJhNCA0IDAgMCAwLTQtNEg0YTQgNCAwIDAgMC00IDR2MiIvPg0KICAgICAgICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSI0IiByPSI0Ii8+DQogICAgICAgIDxwYXRoIGQ9Ik0xOSA1djZNMjIgOGgtNiIvPg0KICAgIDwvZz4NCjwvc3ZnPg0K"

/***/ }),

/***/ "z6Az":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0Y3NDU0NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIvPg0KICAgICAgICA8cGF0aCBkPSJNMTMgN2wtNiA2TTcgN2w2IDYiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ "z6Gc":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(undefined);
// imports


// module
exports.push([module.i, ".time-picker{display:inline-block;position:relative;font-size:1em;width:10em;font-family:sans-serif;vertical-align:middle}.time-picker *{-webkit-box-sizing:border-box;box-sizing:border-box}.time-picker input.display-time{border:1px solid #d2d2d2;width:10em;height:2.2em;padding:.3em .5em;font-size:1em}.time-picker .clear-btn{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;top:0;right:0;bottom:0;margin-top:-.15em;z-index:3;font-size:1.1em;line-height:1em;vertical-align:middle;width:1.3em;color:#d2d2d2;background:hsla(0,0%,100%,0);text-align:center;font-style:normal;-webkit-transition:color .2s;transition:color .2s}.time-picker .clear-btn:hover{color:#797979;cursor:pointer}.time-picker .time-picker-overlay{z-index:2;position:fixed;top:0;left:0;right:0;bottom:0}.time-picker .dropdown{position:absolute;z-index:5;top:calc(2.2em + 2px);left:0;background:#fff;-webkit-box-shadow:0 1px 6px rgba(0,0,0,.15);box-shadow:0 1px 6px rgba(0,0,0,.15);width:10em;height:10em;font-weight:400}.time-picker .dropdown .select-list{width:10em;height:10em;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.time-picker .dropdown ul{padding:0;margin:0;list-style:none;-webkit-box-flex:1;-ms-flex:1;flex:1;overflow-x:hidden;overflow-y:auto}.time-picker .dropdown ul.apms,.time-picker .dropdown ul.minutes,.time-picker .dropdown ul.seconds{border-left:1px solid #fff}.time-picker .dropdown ul li{text-align:center;padding:.3em 0;color:#161616}.time-picker .dropdown ul li:not(.hint):hover{background:rgba(0,0,0,.08);color:#161616;cursor:pointer}.time-picker .dropdown ul li.active,.time-picker .dropdown ul li.active:hover{background:#41b883;color:#fff}.time-picker .dropdown .hint{color:#a5a5a5;cursor:default;font-size:.8em}", ""]);

// exports


/***/ }),

/***/ "zEzL":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OzIM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6caa07c7", content, true);

/***/ }),

/***/ "zsfH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDExIDExIj4NCiAgICA8cGF0aCBmaWxsPSIjMzMzMzNEIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjQ2MyAxLjU4OEwxMC40NSA1LjUgNC40NjMgOS40MTJ6Ii8+DQo8L3N2Zz4NCg=="

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.64a8b3440e5023a73a36.js